/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lv_lv/watersystems/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 335);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(35);
var hide = __webpack_require__(21);
var redefine = __webpack_require__(22);
var ctx = __webpack_require__(30);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(76);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(636)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(24);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(99)('wks');
var uid = __webpack_require__(56);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(205);
var toPrimitive = __webpack_require__(36);
var dP = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(38);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMProperty = __webpack_require__(80);
var ReactDOMComponentFlags = __webpack_require__(242);

var invariant = __webpack_require__(2);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(37);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default.a(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default.a(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default.a(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default.a(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default.a(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var createDesc = __webpack_require__(55);
module.exports = __webpack_require__(12) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(21);
var has = __webpack_require__(25);
var SRC = __webpack_require__(56)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(35).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(7);
var defined = __webpack_require__(37);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87);
var defined = __webpack_require__(37);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(88);
var createDesc = __webpack_require__(55);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(36);
var has = __webpack_require__(25);
var IE8_DOM_DEFINE = __webpack_require__(205);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(25);
var toObject = __webpack_require__(16);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationMessages = exports.formatTranslationMessages = exports.lang = exports.localeFormatted = exports.configuratorType = exports.locale = undefined;

var _reactIntl = __webpack_require__(18);

var _locale = __webpack_require__(709);

var _configuratorType = __webpack_require__(289);

var _en = __webpack_require__(710);

var _en2 = _interopRequireDefault(_en);

var _de = __webpack_require__(711);

var _de2 = _interopRequireDefault(_de);

var _nl = __webpack_require__(712);

var _nl2 = _interopRequireDefault(_nl);

var _fr = __webpack_require__(713);

var _fr2 = _interopRequireDefault(_fr);

var _be = __webpack_require__(714);

var _be2 = _interopRequireDefault(_be);

var _tr = __webpack_require__(715);

var _tr2 = _interopRequireDefault(_tr);

var _uk = __webpack_require__(716);

var _uk2 = _interopRequireDefault(_uk);

var _it = __webpack_require__(717);

var _it2 = _interopRequireDefault(_it);

var _da = __webpack_require__(718);

var _da2 = _interopRequireDefault(_da);

var _hu = __webpack_require__(719);

var _hu2 = _interopRequireDefault(_hu);

var _sk = __webpack_require__(720);

var _sk2 = _interopRequireDefault(_sk);

var _cs = __webpack_require__(721);

var _cs2 = _interopRequireDefault(_cs);

var _ru = __webpack_require__(722);

var _ru2 = _interopRequireDefault(_ru);

var _es = __webpack_require__(723);

var _es2 = _interopRequireDefault(_es);

var _pl = __webpack_require__(724);

var _pl2 = _interopRequireDefault(_pl);

var _cy = __webpack_require__(725);

var _cy2 = _interopRequireDefault(_cy);

var _ar = __webpack_require__(726);

var _ar2 = _interopRequireDefault(_ar);

var _lv = __webpack_require__(727);

var _lv2 = _interopRequireDefault(_lv);

var _et = __webpack_require__(728);

var _et2 = _interopRequireDefault(_et);

var _lt = __webpack_require__(729);

var _lt2 = _interopRequireDefault(_lt);

var _no = __webpack_require__(730);

var _no2 = _interopRequireDefault(_no);

var _ro = __webpack_require__(731);

var _ro2 = _interopRequireDefault(_ro);

var _pt = __webpack_require__(732);

var _pt2 = _interopRequireDefault(_pt);

var _hr = __webpack_require__(733);

var _hr2 = _interopRequireDefault(_hr);

var _bg = __webpack_require__(734);

var _bg2 = _interopRequireDefault(_bg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var locale = exports.locale =  true ? "lv_lv" : _locale.DEFAULT_LOCALE; // eslint-disable-line
/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
var configuratorType = exports.configuratorType =  true ? "water" : _configuratorType.DEFAULT_CONFIGURATOR_TYPE;

//import enTranslationMessages from './translations/shower.en_gb.json';
var enTranslationMessages = __webpack_require__(290)("./" + configuratorType + '.' + locale + '.json');

(0, _reactIntl.addLocaleData)(_en2.default);
(0, _reactIntl.addLocaleData)(_de2.default);
(0, _reactIntl.addLocaleData)(_nl2.default);
(0, _reactIntl.addLocaleData)(_fr2.default);
(0, _reactIntl.addLocaleData)(_be2.default);
(0, _reactIntl.addLocaleData)(_tr2.default);
(0, _reactIntl.addLocaleData)(_uk2.default);
(0, _reactIntl.addLocaleData)(_da2.default);
(0, _reactIntl.addLocaleData)(_hu2.default);
(0, _reactIntl.addLocaleData)(_it2.default);
(0, _reactIntl.addLocaleData)(_sk2.default);
(0, _reactIntl.addLocaleData)(_cs2.default);
(0, _reactIntl.addLocaleData)(_ru2.default);
(0, _reactIntl.addLocaleData)(_es2.default);
(0, _reactIntl.addLocaleData)(_pl2.default);
(0, _reactIntl.addLocaleData)(_cy2.default);
(0, _reactIntl.addLocaleData)(_en2.default);
(0, _reactIntl.addLocaleData)(_ar2.default);
(0, _reactIntl.addLocaleData)(_lv2.default);
(0, _reactIntl.addLocaleData)(_et2.default);
(0, _reactIntl.addLocaleData)(_lt2.default);
(0, _reactIntl.addLocaleData)(_no2.default);
(0, _reactIntl.addLocaleData)(_ro2.default);
(0, _reactIntl.addLocaleData)(_pt2.default);
(0, _reactIntl.addLocaleData)(_hr2.default);
(0, _reactIntl.addLocaleData)(_bg2.default);

var localeFormatted = exports.localeFormatted = locale.replace(/_(.*)/gm, function (x) {
  return x.toUpperCase();
});
var lang = exports.lang = locale.substr(0, 2);

var formatTranslationMessages = exports.formatTranslationMessages = function formatTranslationMessages(locale, messages) {
  var defaultFormattedMessages = locale !== _locale.DEFAULT_LOCALE.substr(0, 2) ? formatTranslationMessages(_locale.DEFAULT_LOCALE.substr(0, 2), enTranslationMessages) : {};
  var formattedMessages = {};
  var messageKeys = Object.keys(messages);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = messageKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var messageKey = _step.value;

      if (locale === _locale.DEFAULT_LOCALE) {
        formattedMessages[messageKey] = messages[messageKey];
      } else {
        formattedMessages[messageKey] = messages[messageKey] || defaultFormattedMessages[messageKey];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return formattedMessages;
};

var translationMessages = exports.translationMessages = {
  current: formatTranslationMessages(lang, __webpack_require__(290)("./" + configuratorType + '.' + locale + '.json')),
  en: formatTranslationMessages('en', enTranslationMessages)
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(35);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(30);
var IObject = __webpack_require__(87);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(14);
var asc = __webpack_require__(150);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(246);
var PooledClass = __webpack_require__(66);
var ReactFeatureFlags = __webpack_require__(247);
var ReactReconciler = __webpack_require__(81);
var Transaction = __webpack_require__(113);

var invariant = __webpack_require__(2);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(12)) {
  var LIBRARY = __webpack_require__(57);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(109);
  var $buffer = __webpack_require__(156);
  var ctx = __webpack_require__(30);
  var anInstance = __webpack_require__(63);
  var propertyDesc = __webpack_require__(55);
  var hide = __webpack_require__(21);
  var redefineAll = __webpack_require__(65);
  var toInteger = __webpack_require__(38);
  var toLength = __webpack_require__(14);
  var toIndex = __webpack_require__(231);
  var toAbsoluteIndex = __webpack_require__(59);
  var toPrimitive = __webpack_require__(36);
  var has = __webpack_require__(25);
  var classof = __webpack_require__(89);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(16);
  var isArrayIter = __webpack_require__(147);
  var create = __webpack_require__(60);
  var getPrototypeOf = __webpack_require__(28);
  var gOPN = __webpack_require__(61).f;
  var getIterFn = __webpack_require__(149);
  var uid = __webpack_require__(56);
  var wks = __webpack_require__(10);
  var createArrayMethod = __webpack_require__(40);
  var createArrayIncludes = __webpack_require__(100);
  var speciesConstructor = __webpack_require__(107);
  var ArrayIterators = __webpack_require__(152);
  var Iterators = __webpack_require__(74);
  var $iterDetect = __webpack_require__(104);
  var setSpecies = __webpack_require__(62);
  var arrayFill = __webpack_require__(151);
  var arrayCopyWithin = __webpack_require__(221);
  var $DP = __webpack_require__(13);
  var $GOPD = __webpack_require__(27);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(226);
var $export = __webpack_require__(0);
var shared = __webpack_require__(99)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(229))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(66);

var emptyFunction = __webpack_require__(24);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(634);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(314);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(56)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(25);
var setDesc = __webpack_require__(13).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(10)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(207);
var enumBugKeys = __webpack_require__(134);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(38);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(208);
var enumBugKeys = __webpack_require__(134);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(131)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(135).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(207);
var hiddenKeys = __webpack_require__(134).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(12);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(219);
var isArrayIter = __webpack_require__(147);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(14);
var getIterFn = __webpack_require__(149);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(22);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(54);

var _Actions = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n = __webpack_require__(34);

exports.default = {
  event: function event(label, action, category) {
    var trackingConfType = _i18n.configuratorType === 'water' ? 'Watersystem' : 'Showersystem';
    var newLabel = _i18n.translationMessages.en[label];
    if (!newLabel) {
      console.log('could not translate', label); // eslint-disable-line no-console
    }
    // eslint-disable-next-line no-undef
    dataLayer.push({
      'event': 'event',
      'eventCategory': category ? category : trackingConfType + ' Configurator',
      'eventAction': action ? action : '',
      'eventLabel': newLabel ? newLabel : label
    });
  },
  page: function page(url) {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      'event': 'page',
      'pageName': url
    });
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(971),
    getValue = __webpack_require__(976);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(13).f;
var has = __webpack_require__(25);
var TAG = __webpack_require__(10)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(37);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(137);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactChildren = __webpack_require__(538);
var ReactComponent = __webpack_require__(158);
var ReactPureComponent = __webpack_require__(543);
var ReactClass = __webpack_require__(544);
var ReactDOMFactories = __webpack_require__(546);
var ReactElement = __webpack_require__(78);
var ReactPropTypes = __webpack_require__(547);
var ReactVersion = __webpack_require__(551);

var onlyChild = __webpack_require__(552);
var warning = __webpack_require__(6);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

// TODO: Fix tests so that this deprecation warning doesn't cause failures.
if (false) {
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });
  }
}

module.exports = React;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(44);

var warning = __webpack_require__(6);
var canDefineProperty = __webpack_require__(239);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(240);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(561);
var ReactInstrumentation = __webpack_require__(33);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(167);
var setInnerHTML = __webpack_require__(115);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);
var setTextContent = __webpack_require__(250);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(125),
    getRawTag = __webpack_require__(972),
    objectToString = __webpack_require__(973);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(10)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(553);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(92);
var EventPluginUtils = __webpack_require__(161);

var accumulateInto = __webpack_require__(243);
var forEachAccumulated = __webpack_require__(244);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(160);
var EventPluginUtils = __webpack_require__(161);
var ReactErrorUtils = __webpack_require__(162);

var accumulateInto = __webpack_require__(243);
var forEachAccumulated = __webpack_require__(244);
var invariant = __webpack_require__(2);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

var getEventTarget = __webpack_require__(163);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([route, __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](route)]);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initState = initState;
exports.initData = initData;
exports.saveSelected = saveSelected;
exports.getSelected = getSelected;
exports.restartConfigurator = restartConfigurator;
exports.pushResult = pushResult;
exports.resetConfigurator = resetConfigurator;
exports.setScrollIndicator = setScrollIndicator;
exports.setLastQuestionId = setLastQuestionId;

var _actionTypes = __webpack_require__(708);

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function initState(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.INIT_STATE,
      payload: payload
    });
  };
}
function initData(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.INIT_DATA,
      payload: payload
    });
  };
}
function saveSelected(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SAVE_SELECTED,
      payload: payload
    });
  };
}

function getSelected() {
  return {
    type: types.GET_SELECTED
  };
}

function restartConfigurator() {
  return function (dispatch) {
    return dispatch({
      type: types.SAVE_SELECTED
    });
  };
}

function pushResult(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.PUSH_RESULT,
      payload: payload
    });
  };
}

function resetConfigurator(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.RESET_CONFIGURATOR,
      payload: payload
    });
  };
}

function setScrollIndicator(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SET_SCROLL_INDICATOR,
      payload: payload
    });
  };
}

function setLastQuestionId(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SET_LAST_QUESTION_ID,
      payload: payload
    });
  };
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(14);
var toAbsoluteIndex = __webpack_require__(59);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(10)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(10)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(21);
var redefine = __webpack_require__(22);
var fails = __webpack_require__(7);
var defined = __webpack_require__(37);
var wks = __webpack_require__(10);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(10)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var redefineAll = __webpack_require__(65);
var meta = __webpack_require__(49);
var forOf = __webpack_require__(64);
var anInstance = __webpack_require__(63);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(104);
var setToStringTag = __webpack_require__(72);
var inheritIfRequired = __webpack_require__(138);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(21);
var uid = __webpack_require__(56);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(57) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var ctx = __webpack_require__(30);
var forOf = __webpack_require__(64);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(93);
var ViewportMetrics = __webpack_require__(249);

var getEventModifierState = __webpack_require__(165);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);
var DOMNamespaces = __webpack_require__(167);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventPluginRegistry = __webpack_require__(160);
var ReactEventEmitterMixin = __webpack_require__(582);
var ViewportMetrics = __webpack_require__(249);

var getVendorPrefixedEventName = __webpack_require__(583);
var isEventSupported = __webpack_require__(164);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["MediaQuery"] = factory(require("react"));
	else
		root["MediaQuery"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchmediaquery = __webpack_require__(11);
	
	var _matchmediaquery2 = _interopRequireDefault(_matchmediaquery);
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _toQuery = __webpack_require__(9);
	
	var _toQuery2 = _interopRequireDefault(_toQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultTypes = {
	  component: _propTypes2.default.node,
	  query: _propTypes2.default.string,
	  values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  onChange: _propTypes2.default.func,
	  onBeforeChange: _propTypes2.default.func
	};
	var mediaKeys = Object.keys(_mediaQuery2.default.all);
	var excludedQueryKeys = Object.keys(defaultTypes);
	var excludedPropKeys = excludedQueryKeys.concat(mediaKeys);
	
	function omit(object, keys) {
	  var newObject = _extends({}, object);
	  keys.forEach(function (key) {
	    return delete newObject[key];
	  });
	  return newObject;
	}
	
	var MediaQuery = function (_React$Component) {
	  _inherits(MediaQuery, _React$Component);
	
	  function MediaQuery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MediaQuery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = { matches: false }, _this.updateMatches = function () {
	      if (_this._mql.matches === _this.state.matches) {
	        return;
	      }
	      _this.setState({
	        matches: _this._mql.matches
	      });
	    }, _this.removeMql = function () {
	      if (_this._mql) {
	        _this._mql.removeListener(_this.updateMatches);
	        _this._mql.dispose();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MediaQuery, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateQuery(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateQuery(nextProps);
	    }
	  }, {
	    key: 'updateQuery',
	    value: function updateQuery(props) {
	      var values = void 0;
	      if (props.query) {
	        this.query = props.query;
	      } else {
	        this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys));
	      }
	
	      if (!this.query) {
	        throw new Error('Invalid or missing MediaQuery!');
	      }
	
	      if (props.values) {
	        values = Object.keys(props.values).reduce(function (result, key) {
	          result[(0, _hyphenateStyleName2.default)(key)] = props.values[key];
	          return result;
	        }, {});
	      }
	
	      this.removeMql();
	
	      this._mql = (0, _matchmediaquery2.default)(this.query, values);
	      this._mql.addListener(this.updateMatches);
	      this.updateMatches();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(_, nextState) {
	      if (this.props.onBeforeChange && this.state.matches !== nextState.matches) {
	        this.props.onBeforeChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      if (this.props.onChange && prevState.matches !== this.state.matches) {
	        this.props.onChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeMql();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.children === 'function') {
	        return this.props.children(this.state.matches);
	      }
	
	      if (this.state.matches === false) {
	        return null;
	      }
	      var props = omit(this.props, excludedPropKeys);
	      var hasMergeProps = Object.keys(props).length > 0;
	      var childrenCount = _react2.default.Children.count(this.props.children);
	      var wrapChildren = this.props.component || childrenCount > 1 || typeof this.props.children === 'string' || Array.isArray(this.props.children) && childrenCount == 1 || this.props.children === undefined;
	      if (wrapChildren) {
	        return _react2.default.createElement(this.props.component || 'div', props, this.props.children);
	      } else if (hasMergeProps) {
	        return _react2.default.cloneElement(this.props.children, props);
	      } else if (childrenCount) {
	        return this.props.children;
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return MediaQuery;
	}(_react2.default.Component);
	
	MediaQuery.displayName = 'MediaQuery';
	MediaQuery.defaultProps = {
	  values: {}
	};
	exports.default = MediaQuery;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	// properties that match media queries
	var matchers = {
	  orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),
	
	  scan: _propTypes2.default.oneOf(['progressive', 'interlace']),
	
	  aspectRatio: _propTypes2.default.string,
	  deviceAspectRatio: _propTypes2.default.string,
	
	  height: stringOrNumber,
	  deviceHeight: stringOrNumber,
	
	  width: stringOrNumber,
	  deviceWidth: stringOrNumber,
	
	  color: _propTypes2.default.bool,
	
	  colorIndex: _propTypes2.default.bool,
	
	  monochrome: _propTypes2.default.bool,
	  resolution: stringOrNumber
	
	  // media features
	};var features = _extends({
	  minAspectRatio: _propTypes2.default.string,
	  maxAspectRatio: _propTypes2.default.string,
	  minDeviceAspectRatio: _propTypes2.default.string,
	  maxDeviceAspectRatio: _propTypes2.default.string,
	
	  minHeight: stringOrNumber,
	  maxHeight: stringOrNumber,
	  minDeviceHeight: stringOrNumber,
	  maxDeviceHeight: stringOrNumber,
	
	  minWidth: stringOrNumber,
	  maxWidth: stringOrNumber,
	  minDeviceWidth: stringOrNumber,
	  maxDeviceWidth: stringOrNumber,
	
	  minColor: _propTypes2.default.number,
	  maxColor: _propTypes2.default.number,
	
	  minColorIndex: _propTypes2.default.number,
	  maxColorIndex: _propTypes2.default.number,
	
	  minMonochrome: _propTypes2.default.number,
	  maxMonochrome: _propTypes2.default.number,
	
	  minResolution: stringOrNumber,
	  maxResolution: stringOrNumber
	
	}, matchers);
	
	// media types
	var types = {
	  all: _propTypes2.default.bool,
	  grid: _propTypes2.default.bool,
	  aural: _propTypes2.default.bool,
	  braille: _propTypes2.default.bool,
	  handheld: _propTypes2.default.bool,
	  print: _propTypes2.default.bool,
	  projection: _propTypes2.default.bool,
	  screen: _propTypes2.default.bool,
	  tty: _propTypes2.default.bool,
	  tv: _propTypes2.default.bool,
	  embossed: _propTypes2.default.bool
	};
	
	var all = _extends({}, types, features);
	
	// add the type property
	matchers.type = Object.keys(types);
	
	exports.default = {
	  all: all,
	  types: types,
	  matchers: matchers,
	  features: features
	};
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  var rules = [];
	  Object.keys(_mediaQuery2.default.all).forEach(function (k) {
	    var v = obj[k];
	    if (v != null) {
	      rules.push(keyVal(k, v));
	    }
	  });
	  return join(rules);
	};
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var negate = function negate(cond) {
	  return 'not ' + cond;
	};
	
	function keyVal(k, v) {
	  var realKey = (0, _hyphenateStyleName2.default)(k);
	
	  // px shorthand
	  if (typeof v === 'number') {
	    v = v + 'px';
	  }
	  if (v === true) {
	    return k;
	  }
	  if (v === false) {
	    return negate(k);
	  }
	  return '(' + realKey + ': ' + v + ')';
	}
	
	function join(conds) {
	  return conds.join(' and ');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	'use strict';
	
	exports.match = matchQuery;
	exports.parse = parseQuery;
	
	// -----------------------------------------------------------------------------
	
	var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
	    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
	    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
	    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
	    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	
	function matchQuery(mediaQuery, values) {
	    return parseQuery(mediaQuery).some(function (query) {
	        var inverse = query.inverse;
	
	        // Either the parsed or specified `type` is "all", or the types must be
	        // equal for a match.
	        var typeMatch = query.type === 'all' || values.type === query.type;
	
	        // Quit early when `type` doesn't match, but take "not" into account.
	        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
	            return false;
	        }
	
	        var expressionsMatch = query.expressions.every(function (expression) {
	            var feature  = expression.feature,
	                modifier = expression.modifier,
	                expValue = expression.value,
	                value    = values[feature];
	
	            // Missing or falsy values don't match.
	            if (!value) { return false; }
	
	            switch (feature) {
	                case 'orientation':
	                case 'scan':
	                    return value.toLowerCase() === expValue.toLowerCase();
	
	                case 'width':
	                case 'height':
	                case 'device-width':
	                case 'device-height':
	                    expValue = toPx(expValue);
	                    value    = toPx(value);
	                    break;
	
	                case 'resolution':
	                    expValue = toDpi(expValue);
	                    value    = toDpi(value);
	                    break;
	
	                case 'aspect-ratio':
	                case 'device-aspect-ratio':
	                case /* Deprecated */ 'device-pixel-ratio':
	                    expValue = toDecimal(expValue);
	                    value    = toDecimal(value);
	                    break;
	
	                case 'grid':
	                case 'color':
	                case 'color-index':
	                case 'monochrome':
	                    expValue = parseInt(expValue, 10) || 1;
	                    value    = parseInt(value, 10) || 0;
	                    break;
	            }
	
	            switch (modifier) {
	                case 'min': return value >= expValue;
	                case 'max': return value <= expValue;
	                default   : return value === expValue;
	            }
	        });
	
	        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
	    });
	}
	
	function parseQuery(mediaQuery) {
	    return mediaQuery.split(',').map(function (query) {
	        query = query.trim();
	
	        var captures    = query.match(RE_MEDIA_QUERY),
	            modifier    = captures[1],
	            type        = captures[2],
	            expressions = captures[3] || '',
	            parsed      = {};
	
	        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
	        parsed.type    = type ? type.toLowerCase() : 'all';
	
	        // Split expressions into a list.
	        expressions = expressions.match(/\([^\)]+\)/g) || [];
	
	        parsed.expressions = expressions.map(function (expression) {
	            var captures = expression.match(RE_MQ_EXPRESSION),
	                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	
	            return {
	                modifier: feature[1],
	                feature : feature[2],
	                value   : captures[2]
	            };
	        });
	
	        return parsed;
	    });
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function toDecimal(ratio) {
	    var decimal = Number(ratio),
	        numbers;
	
	    if (!decimal) {
	        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
	        decimal = numbers[1] / numbers[2];
	    }
	
	    return decimal;
	}
	
	function toDpi(resolution) {
	    var value = parseFloat(resolution),
	        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
	
	    switch (units) {
	        case 'dpcm': return value / 2.54;
	        case 'dppx': return value * 96;
	        default    : return value;
	    }
	}
	
	function toPx(length) {
	    var value = parseFloat(length),
	        units = String(length).match(RE_LENGTH_UNIT)[1];
	
	    switch (units) {
	        case 'em' : return value * 16;
	        case 'rem': return value * 16;
	        case 'cm' : return value * 96 / 2.54;
	        case 'mm' : return value * 96 / 2.54 / 10;
	        case 'in' : return value * 96;
	        case 'pt' : return value * 72;
	        case 'pc' : return value * 72 / 12;
	        default   : return value;
	    }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var staticMatch = __webpack_require__(10).match;
	var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
	
	// our fake MediaQueryList
	function Mql(query, values){
	  var self = this;
	  if(dynamicMatch){
	    var mql = dynamicMatch.call(window, query);
	    this.matches = mql.matches;
	    this.media = mql.media;
	    // TODO: is there a time it makes sense to remove this listener?
	    mql.addListener(update);
	  } else {
	    this.matches = staticMatch(query, values);
	    this.media = query;
	  }
	
	  this.addListener = addListener;
	  this.removeListener = removeListener;
	  this.dispose = dispose;
	
	  function addListener(listener){
	    if(mql){
	      mql.addListener(listener);
	    }
	  }
	
	  function removeListener(listener){
	    if(mql){
	      mql.removeListener(listener);
	    }
	  }
	
	  // update ourselves!
	  function update(evt){
	    self.matches = evt.matches;
	    self.media = evt.media;
	  }
	
	  function dispose(){
	    if(mql){
	      mql.removeListener(update);
	    }
	  }
	}
	
	function matchMedia(query, values){
	  return new Mql(query, values);
	}
	
	module.exports = matchMedia;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(3);
	  var warning = __webpack_require__(6);
	  var ReactPropTypesSecret = __webpack_require__(4);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(4);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(4);
	var checkPropTypes = __webpack_require__(12);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=react-responsive.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(90);

var animateScroll = __webpack_require__(193);
var scrollSpy = __webpack_require__(303);
var defaultScroller = __webpack_require__(304);
var assign = __webpack_require__(194);
var PropTypes = __webpack_require__(3);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool
};

var Helpers = {

  Scroll: function Scroll(Component, customScroller) {

    var scroller = customScroller || defaultScroller;

    var _ = function (_React$Component) {
      _inherits(_, _React$Component);

      function _(props) {
        _classCallCheck(this, _);

        var _this = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));

        _this.scrollTo = _this.scrollTo.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.spyHandler = _this.spyHandler.bind(_this);

        return _this;
      }

      _createClass(_, [{
        key: 'scrollTo',
        value: function scrollTo(to, props) {
          scroller.scrollTo(to, props);
        }
      }, {
        key: 'handleClick',
        value: function handleClick(event) {

          /*
           * give the posibility to override onClick
           */

          if (this.props.onClick) {
            this.props.onClick(event);
          }

          /*
           * dont bubble the navigation
           */

          if (event.stopPropagation) event.stopPropagation();
          if (event.preventDefault) event.preventDefault();

          /*
           * do the magic!
           */
          this.scrollTo(this.props.to, this.props);
        }
      }, {
        key: 'spyHandler',
        value: function spyHandler(y) {
          var element = scroller.get(this.props.to);
          if (!element) return;
          var cords = element.getBoundingClientRect();
          var topBound = cords.top + y;
          var bottomBound = topBound + cords.height;
          var offsetY = y - this.props.offset;
          var to = this.props.to;
          var isInside = offsetY >= topBound && offsetY <= bottomBound;
          var isOutside = offsetY < topBound || offsetY > bottomBound;
          var activeLink = scroller.getActiveLink();

          if (isOutside && activeLink === to) {
            scroller.setActiveLink(void 0);
            this.setState({ active: false });

            if (this.props.onSetInactive) {
              this.props.onSetInactive();
            }
          } else if (isInside && activeLink != to) {
            scroller.setActiveLink(to);
            this.setState({ active: true });

            if (this.props.onSetActive) {
              this.props.onSetActive(to);
            }

            scrollSpy.updateStates();
          }
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

          var containerId = this.props.containerId;
          var container = this.props.container;

          var scrollSpyContainer;

          if (containerId) {
            scrollSpyContainer = document.getElementById(containerId);
          } else if (container && container.nodeType) {
            scrollSpyContainer = container;
          } else {
            scrollSpyContainer = document;
          }

          if (!scrollSpy.isMounted(scrollSpyContainer)) {
            scrollSpy.mount(scrollSpyContainer);
          }

          if (this.props.spy) {
            var to = this.props.to;
            var element = null;
            var elemTopBound = 0;
            var elemBottomBound = 0;

            this._stateHandler = function () {
              if (scroller.getActiveLink() != to) {
                if (this.state !== null && this.state.active && this.props.onSetInactive) {
                  this.props.onSetInactive();
                }
                this.setState({ active: false });
              }
            }.bind(this);

            scrollSpy.addStateHandler(this._stateHandler);

            this._spyHandler = function (y) {

              var containerTop = 0;
              if (scrollSpyContainer.getBoundingClientRect) {
                var containerCords = scrollSpyContainer.getBoundingClientRect();
                containerTop = containerCords.top;
              }

              if (!element || this.props.isDynamic) {
                element = scroller.get(to);
                if (!element) {
                  return;
                }

                var cords = element.getBoundingClientRect();
                elemTopBound = cords.top - containerTop + y;
                elemBottomBound = elemTopBound + cords.height;
              }

              var offsetY = y - this.props.offset;
              var isInside = offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound);
              var isOutside = offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound);
              var activeLink = scroller.getActiveLink();

              if (isOutside && activeLink === to) {
                scroller.setActiveLink(void 0);
                this.setState({ active: false });

                if (this.props.onSetInactive) {
                  this.props.onSetInactive();
                }
              } else if (isInside && activeLink != to) {
                scroller.setActiveLink(to);
                this.setState({ active: true });

                if (this.props.onSetActive) {
                  this.props.onSetActive(to);
                }

                scrollSpy.updateStates();
              }
            }.bind(this);

            scrollSpy.addSpyHandler(this._spyHandler, scrollSpyContainer);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this._stateHandler, this._spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {

          var className = "";
          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = assign({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return _;
    }(React.Component);

    ;
    _.propTypes = protoTypes;
    _.defaultProps = { offset: 0 };
    return _;
  },

  Element: function Element(Component) {
    var _ = function (_React$Component2) {
      _inherits(_, _React$Component2);

      function _(props) {
        _classCallCheck(this, _);

        var _this2 = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));

        _this2.registerElems = _this2.registerElems.bind(_this2);
        _this2.childBindings = {
          domNode: null
        };
        return _this2;
      }

      _createClass(_, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.name !== nextProps.name) {
            this.registerElems(nextProps.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return _;
    }(React.Component);

    ;
    _.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };
    return _;
  }
};

module.exports = Helpers;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(961),
    listCacheDelete = __webpack_require__(962),
    listCacheGet = __webpack_require__(963),
    listCacheHas = __webpack_require__(964),
    listCacheSet = __webpack_require__(965);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(312);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(985);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(129);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(35);
var LIBRARY = __webpack_require__(57);
var wksExt = __webpack_require__(206);
var defineProperty = __webpack_require__(13).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(99)('keys');
var uid = __webpack_require__(56);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(136).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(38);
var defined = __webpack_require__(37);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(38);
var defined = __webpack_require__(37);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(57);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(74);
var $iterCreate = __webpack_require__(144);
var setToStringTag = __webpack_require__(72);
var getPrototypeOf = __webpack_require__(28);
var ITERATOR = __webpack_require__(10)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(60);
var descriptor = __webpack_require__(55);
var setToStringTag = __webpack_require__(72);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(21)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(103);
var defined = __webpack_require__(37);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(10)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(74);
var ITERATOR = __webpack_require__(10)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(13);
var createDesc = __webpack_require__(55);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(89);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(74);
module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(427);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(59);
var toLength = __webpack_require__(14);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(50);
var step = __webpack_require__(222);
var Iterators = __webpack_require__(74);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(143)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var invoke = __webpack_require__(212);
var html = __webpack_require__(135);
var cel = __webpack_require__(131);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(153).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(12);
var LIBRARY = __webpack_require__(57);
var $typed = __webpack_require__(109);
var hide = __webpack_require__(21);
var redefineAll = __webpack_require__(65);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(63);
var toInteger = __webpack_require__(38);
var toLength = __webpack_require__(14);
var toIndex = __webpack_require__(231);
var gOPN = __webpack_require__(61).f;
var dP = __webpack_require__(13).f;
var arrayFill = __webpack_require__(151);
var setToStringTag = __webpack_require__(72);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(77);

var ReactNoopUpdateQueue = __webpack_require__(159);

var canDefineProperty = __webpack_require__(239);
var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactErrorUtils = __webpack_require__(162);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(82);
var Danger = __webpack_require__(567);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(33);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(168);
var setInnerHTML = __webpack_require__(115);
var setTextContent = __webpack_require__(250);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(585);
var propTypesFactory = __webpack_require__(586);

var React = __webpack_require__(76);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(44);
var ReactInstanceMap = __webpack_require__(94);
var ReactInstrumentation = __webpack_require__(33);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var emptyFunction = __webpack_require__(24);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
  displayName: 'RouterContext',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */]('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */](route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */](element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(649);

var _runTransitionHook = __webpack_require__(182);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(67);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(182);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(651);

var _PathUtils = __webpack_require__(54);

var _runTransitionHook = __webpack_require__(182);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(96);

var _LocationUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(67);

var _DOMUtils = __webpack_require__(97);

var _DOMStateStorage = __webpack_require__(276);

var _PathUtils = __webpack_require__(54);

var _ExecutionEnvironment = __webpack_require__(119);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(674);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */](value) || __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */](value) != objectTag) {
    return false;
  }
  var proto = __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */](value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shower_conditions_cs_cz.json": 790,
	"./shower_conditions_da_dk.json": 791,
	"./shower_conditions_de_at.json": 792,
	"./shower_conditions_de_ch.json": 793,
	"./shower_conditions_de_de.json": 794,
	"./shower_conditions_en_cy.json": 795,
	"./shower_conditions_en_eg.json": 796,
	"./shower_conditions_en_gb.json": 291,
	"./shower_conditions_en_sa.json": 797,
	"./shower_conditions_es_es.json": 798,
	"./shower_conditions_fr_be.json": 799,
	"./shower_conditions_fr_ch.json": 800,
	"./shower_conditions_fr_fr.json": 801,
	"./shower_conditions_hu_hu.json": 802,
	"./shower_conditions_it_ch.json": 803,
	"./shower_conditions_it_it.json": 804,
	"./shower_conditions_nl_be.json": 805,
	"./shower_conditions_nl_nl.json": 806,
	"./shower_conditions_pl_pl.json": 807,
	"./shower_conditions_ru_ru.json": 808,
	"./shower_conditions_sk_sk.json": 809,
	"./shower_conditions_tr_tr.json": 810,
	"./shower_conditions_uk_ua.json": 811,
	"./shower_products_ar_sa.json": 812,
	"./shower_products_cs_cz.json": 813,
	"./shower_products_da_dk.json": 814,
	"./shower_products_de_at.json": 815,
	"./shower_products_de_ch.json": 816,
	"./shower_products_de_de.json": 817,
	"./shower_products_en_cy.json": 818,
	"./shower_products_en_eg.json": 819,
	"./shower_products_en_gb.json": 292,
	"./shower_products_en_sa.json": 820,
	"./shower_products_es_es.json": 821,
	"./shower_products_fr_be.json": 822,
	"./shower_products_fr_ch.json": 823,
	"./shower_products_fr_fr.json": 824,
	"./shower_products_hu_hu.json": 825,
	"./shower_products_it_ch.json": 826,
	"./shower_products_it_it.json": 827,
	"./shower_products_nl_be.json": 828,
	"./shower_products_nl_nl.json": 829,
	"./shower_products_pl_pl.json": 830,
	"./shower_products_ru_ru.json": 831,
	"./shower_products_sk_sk.json": 832,
	"./shower_products_tr_tr.json": 833,
	"./shower_products_uk_ua.json": 834,
	"./shower_questions.json": 293,
	"./water_conditions_ar_sa.json": 835,
	"./water_conditions_bg_bg.json": 836,
	"./water_conditions_cs_cz.json": 837,
	"./water_conditions_da_dk.json": 838,
	"./water_conditions_de_at.json": 839,
	"./water_conditions_de_ch.json": 840,
	"./water_conditions_de_de.json": 841,
	"./water_conditions_en_cy.json": 842,
	"./water_conditions_en_gb.json": 294,
	"./water_conditions_es_es.json": 843,
	"./water_conditions_et_ee.json": 844,
	"./water_conditions_fr_be.json": 845,
	"./water_conditions_fr_ch.json": 846,
	"./water_conditions_hr_hr.json": 847,
	"./water_conditions_hu_hu.json": 848,
	"./water_conditions_it_ch.json": 849,
	"./water_conditions_it_it.json": 850,
	"./water_conditions_lt_ltu.json": 851,
	"./water_conditions_lv_lv.json": 852,
	"./water_conditions_nl_be.json": 853,
	"./water_conditions_nl_nl.json": 854,
	"./water_conditions_no_no.json": 855,
	"./water_conditions_pl_pl.json": 856,
	"./water_conditions_pt_pt.json": 857,
	"./water_conditions_ro_ro.json": 858,
	"./water_conditions_ru_ru.json": 859,
	"./water_conditions_sk_sk.json": 860,
	"./water_conditions_tr_tr.json": 861,
	"./water_conditions_uk_ua.json": 862,
	"./water_products_cs_cz.json": 863,
	"./water_products_da_dk.json": 864,
	"./water_products_de_at.json": 865,
	"./water_products_de_ch.json": 866,
	"./water_products_de_de.json": 867,
	"./water_products_en_cy.json": 868,
	"./water_products_en_gb.json": 295,
	"./water_products_es_es.json": 869,
	"./water_products_fr_be.json": 870,
	"./water_products_fr_ch.json": 871,
	"./water_products_hr_hr.json": 872,
	"./water_products_hu_hu.json": 873,
	"./water_products_it_ch.json": 874,
	"./water_products_it_it.json": 875,
	"./water_products_lv_lv.json": 876,
	"./water_products_nl_be.json": 877,
	"./water_products_nl_nl.json": 878,
	"./water_products_pl_pl.json": 879,
	"./water_products_ru_ru.json": 880,
	"./water_products_sk_sk.json": 881,
	"./water_questions.json": 296,
	"./water_questions_ar_sa.json": 882,
	"./water_questions_bg_bg.json": 883,
	"./water_questions_cs_cz.json": 884,
	"./water_questions_da_dk.json": 885,
	"./water_questions_de_at.json": 886,
	"./water_questions_de_ch.json": 887,
	"./water_questions_de_de.json": 888,
	"./water_questions_en_cy.json": 889,
	"./water_questions_en_gb.json": 890,
	"./water_questions_es_es.json": 891,
	"./water_questions_et_ee.json": 892,
	"./water_questions_fr_be.json": 893,
	"./water_questions_fr_ch.json": 894,
	"./water_questions_hr_hr.json": 895,
	"./water_questions_hu_hu.json": 896,
	"./water_questions_it_ch.json": 897,
	"./water_questions_it_it.json": 898,
	"./water_questions_lt_ltu.json": 899,
	"./water_questions_lv_lv.json": 900,
	"./water_questions_nl_be.json": 901,
	"./water_questions_nl_nl.json": 902,
	"./water_questions_no_no.json": 903,
	"./water_questions_pl_pl.json": 904,
	"./water_questions_pt_pt.json": 905,
	"./water_questions_ro_ro.json": 906,
	"./water_questions_ru_ru.json": 907,
	"./water_questions_sk_sk.json": 908,
	"./water_questions_tr_tr.json": 909,
	"./water_questions_uk_ua.json": 910
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( true ) {
		// AMD support
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return picturefill; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement(
  'svg',
  { className: 'button__icon', width: '29', height: '26', viewBox: '0 0 29 26', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-location-a01-shower'
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--strokeBased' },
    _react2.default.createElement('path', { d: 'M13.438 18c0-1.105.893-2 1.998-2s2.002.895 2.002 2c0 1.104-.897 2-2.002 2-1.105 0-1.998-.896-1.998-2M5.438 18c0-1.105.893-2 1.998-2s2.002.895 2.002 2c0 1.104-.897 2-2.002 2-1.105 0-1.998-.896-1.998-2M6.438 12c0-1.104.893-2 1.998-2s2.002.896 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.896-1.998-2M4.438 24c0-1.105.896-2 1.998-2 1.105 0 2.002.895 2.002 2s-.897 2-2.002 2c-1.102 0-1.998-.895-1.998-2M21.438 18c0-1.105.896-2 2-2 1.105 0 2 .895 2 2 0 1.104-.895 2-2 2-1.104 0-2-.896-2-2M20.438 12c0-1.104.895-2 2-2 1.104 0 2 .896 2 2s-.896 2-2 2c-1.105 0-2-.896-2-2M22.438 24c0-1.105.896-2 2-2 1.103 0 2 .895 2 2s-.897 2-2 2c-1.104 0-2-.895-2-2M13.438 24c0-1.105.893-2 1.998-2s2.002.895 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.895-1.998-2M13.438 12c0-1.104.893-2 1.998-2s2.002.896 2.002 2-.897 2-2.002 2c-1.105 0-1.998-.896-1.998-2', fill: '#3784C0' })
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--fillBased' },
    _react2.default.createElement('path', { d: 'M26.584 4.678c.835-.014 1.668-.73 1.668-1.61 0-.843-.734-1.424-1.614-1.57-.46-.043-.657-.067-.887-.08-1.21-.07-2.42-.128-3.632-.17-2.42-.083-4.84-.116-7.265-.116-2.42 0-4.843.033-7.265.117-1.142.04-2.284.09-3.424.155-.388.023-.865.038-1.164.07-.955.07-1.562.748-1.562 1.593 0 .854.72 1.58 1.608 1.632.375.017.69-.004.9 0l3.634.064c2.424.036 4.847.055 7.27.055 2.423 0 4.845-.02 7.266-.056L25.75 4.7l.834-.022z', stroke: '#3784C0' })
  )
);

var _ref3 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--fillBased', width: '36', height: '27', viewBox: '0 0 36 27', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-location-a02-bath'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M30.876 11.126c1.923-.012 3.095.074 2.826 2.237-.657 2.71-2.217 7.094-5.68 7.28l.354.52 1.558 2.482c.545.868.27 1.992-.363 2.31-1.012.504-2.048-.19-2.6-1.057l-2.686-4.215-7.113.006-6.974-.007-2.687 4.215c-.547.87-1.587 1.56-2.6 1.056-.634-.317-.91-1.44-.363-2.31l1.558-2.482.354-.518c-3.465-.187-5.023-4.572-5.682-7.28-.268-2.164.904-2.24 2.828-2.238l13.542.005 13.728-.004zM30.74 1.125c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4' })
  )
);

var _ref4 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', width: '27', height: '38', viewBox: '0 0 27 38', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-installation-type-a01-exposed'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M.998 11.922v21.634l6.895 3.442 18.577-9.506-.19-21.307-6.704-2.622z' }),
    _react2.default.createElement('path', { d: 'M7.893 36.834v-21.47l18.386-9.18' }),
    _react2.default.createElement('path', { d: 'M.998 11.922v21.634l6.895 3.442 18.577-9.506-.19-21.307-6.704-2.622zM7.893 15.363l-6.895-3.44' }),
    _react2.default.createElement('path', { d: 'M16.333 23.81s1.468-1.85 3.1-1.633c-.086-.116-.19-.225-.31-.325-2.012-1.657-4.217 1.126-4.217 1.126-1.682 2.302-2.045 5.272-.18 5.917.17.06.342.083.513.093-.72-1.19-.217-3.384 1.093-5.178z' }),
    _react2.default.createElement('path', { d: 'M14.802 28.84c.202.338.496.6.904.74 1.845.646 3.71-1.958 3.71-1.958s2.53-3.518.64-5.094c-.364-.304-.737-.457-1.102-.506l.015.02M8.278 8.265v-6.92C8.625.85 9.318.6 10.358.6s1.733.248 2.08.742v5.26' })
  )
);

var _ref5 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', width: '28', height: '36', viewBox: '0 0 28 36', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-installation-type-a02-exposed-with-concealed'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1.09 9.5v22L7.987 35l18.577-9.667-.19-21.666L19.668 1z' }),
    _react2.default.createElement('path', { d: 'M7.986 34.833V13l18.386-9.333' }),
    _react2.default.createElement('path', { d: 'M1.09 9.5v22L7.987 35l18.577-9.667-.19-21.666L19.668 1zM7.986 13L1.09 9.5' }),
    _react2.default.createElement('path', { d: 'M17.313 20.527s1.468-1.883 3.1-1.66c-.087-.12-.19-.23-.312-.332-2.01-1.685-4.215 1.146-4.215 1.146-1.68 2.34-2.045 5.362-.18 6.017.17.06.342.085.513.095-.72-1.21-.216-3.44 1.095-5.265z' }),
    _react2.default.createElement('path', { d: 'M15.78 25.642c.203.344.497.61.905.754 1.845.656 3.71-1.993 3.71-1.993s2.532-3.577.642-5.18c-.366-.31-.738-.464-1.103-.515l.015.02' })
  )
);

var _ref6 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', width: '21', height: '34', viewBox: '0 0 21 34', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-installation-type-a03-concealed'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M.72 10.537v22.087l18.854-9.872L19.38 1z' }),
    _react2.default.createElement('path', { d: 'M9.95 18.47s1.49-1.89 3.148-1.667c-.09-.118-.193-.23-.318-.332-2.04-1.69-4.28 1.15-4.28 1.15-1.705 2.35-2.074 5.383-.182 6.04.174.062.348.086.52.096-.73-1.214-.218-3.455 1.112-5.286z' }),
    _react2.default.createElement('path', { d: 'M8.396 23.605c.205.345.503.612.917.757 1.873.658 3.766-2 3.766-2s2.568-3.592.65-5.2c-.37-.31-.75-.467-1.12-.518l.015.02' })
  )
);

var _ref7 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', width: '30', height: '30', viewBox: '0 0 30 30', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-shape-a01-square'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(.5)' },
    _react2.default.createElement('circle', { cx: '14.5', cy: '22.5', r: '4.5' }),
    _react2.default.createElement('path', { d: 'M.5.5h28v29H.5z' })
  )
);

var _ref8 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', width: '32', height: '32', viewBox: '0 0 32 32', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-shape-a02-round'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(1 1)' },
    _react2.default.createElement('path', { d: 'M15 27c2.485 0 4.5-2.015 4.5-4.5S17.485 18 15 18s-4.5 2.015-4.5 4.5S12.515 27 15 27z' }),
    _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' })
  )
);

var _ref9 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '30', height: '30', viewBox: '0 0 30 30' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-functionality-a01-square'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('circle', { cx: '15', cy: '22.5', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '6.923', cy: '11.053', r: '3' }),
    _react2.default.createElement('circle', { cx: '15.035', cy: '11.053', r: '3' }),
    _react2.default.createElement('circle', { cx: '23.094', cy: '11.053', r: '3' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1 .5h28v29H1z' })
  )
);

var _ref10 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '32', viewBox: '0 0 32 32' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-functionality-a01-round'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(1 1)' },
    _react2.default.createElement('circle', { cx: '15', cy: '22.5', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }),
    _react2.default.createElement('circle', { cx: '6.923', cy: '11.053', r: '3' }),
    _react2.default.createElement('circle', { cx: '15.035', cy: '11.053', r: '3' }),
    _react2.default.createElement('circle', { cx: '23.094', cy: '11.053', r: '3' })
  )
);

var _ref11 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '30', height: '30', viewBox: '0 0 30 30' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-functionality-a02-square'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(0 -.555)' },
    _react2.default.createElement('circle', { cx: '15', cy: '23.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '12', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '12', r: '3' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1 1.055h28v29H1z' })
  )
);

var _ref12 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '32', viewBox: '0 0 32 32' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-functionality-a02-round'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(1 1.445)' },
    _react2.default.createElement('circle', { cx: '15', cy: '22.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '11', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '11', r: '3' })
  )
);

var _ref13 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '30', height: '30', viewBox: '0 0 30 30' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-functionality-a03-square'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M15 27c2.485 0 4.5-2.015 4.5-4.5S17.485 18 15 18s-4.5 2.015-4.5 4.5S12.515 27 15 27z' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('circle', { cx: '15', cy: '12', r: '3' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1 .5h28v29H1z' })
  )
);

var _ref14 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '30', height: '30', viewBox: '0 0 30 30' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-with-holder-a01-square'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(0 -.555)' },
    _react2.default.createElement('circle', { cx: '15', cy: '23.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '12', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '12', r: '3' }),
    _react2.default.createElement('path', { d: 'M1 1.055h28v29H1z' })
  )
);

var _ref15 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '32', viewBox: '0 0 32 32' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-with-holder-a01-round'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(1 1.445)' },
    _react2.default.createElement('circle', { cx: '15', cy: '22.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '11', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '11', r: '3' })
  )
);

var _ref16 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '35', height: '31', viewBox: '0 0 35 31' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-with-holder-a02-square'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(-.5)' },
    _react2.default.createElement('circle', { cx: '15', cy: '23.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '12', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '12', r: '3' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1 1.055h28v29H1z' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('rect', { x: '30.5', y: '15.5', width: '4', height: '11', rx: '2' })
  )
);

var _ref17 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '37', height: '32', viewBox: '0 0 37 32' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-with-holder-a02-round'
  ),
  _react2.default.createElement(
    'g',
    { transform: 'translate(.72 .675)' },
    _react2.default.createElement('circle', { cx: '15', cy: '22.469', r: '4.5' }),
    _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '11', r: '3' }),
    _react2.default.createElement('circle', { cx: '20.5', cy: '11', r: '3' })
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('rect', { x: '31.281', y: '15.5', width: '4', height: '11', rx: '2' })
  )
);

var _ref18 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '34', height: '28', viewBox: '0 0 34 28' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-rail-holder-a01-railset'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M31.58 13.893c.33.586 1.075.792 1.66.46.586-.33.793-1.074.46-1.66-.33-.586-1.072-.792-1.66-.46-.585.33-.79 1.074-.46 1.66M29.508 11.383c.35.62 1.138.84 1.76.488.62-.35.838-1.137.487-1.758-.35-.62-1.14-.84-1.76-.488-.62.35-.84 1.14-.487 1.76M28.684 9.29c.62-.352.84-1.14.49-1.76-.352-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.49 1.76.352.62 1.14.84 1.76.49M26.925 17.193c.35.622 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.488-.62.35-.84 1.14-.488 1.758M24.988 13.966c.35.62 1.138.84 1.76.49.62-.353.838-1.14.487-1.762-.35-.62-1.138-.84-1.76-.487-.62.35-.838 1.138-.487 1.76M23.05 10.738c.35.62 1.138.84 1.76.488.62-.35.84-1.14.488-1.76-.35-.62-1.138-.838-1.76-.488-.62.35-.838 1.14-.487 1.76M21.76 19.776c.35.62 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.35-.84 1.14-.488 1.76M20.47 16.548c.35.62 1.137.84 1.758.49.62-.352.84-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.487 1.76M19.823 13.32c.35.62 1.138.84 1.76.488.62-.35.838-1.138.487-1.76-.35-.62-1.138-.838-1.76-.487-.62.35-.838 1.14-.487 1.76' }),
    _react2.default.createElement('path', { d: 'M6.122 25.696s-1.06-.452-.252-2.136c.81-1.685 7.217-15.236 20.734-20.1 0 0 2.017-1.045 2.07.645 0 0-.062.786-.237 1.265-.175.48-.166.41-1.473.93-1.308.523-12.084 4.687-17.583 19.247 0 0-.526 2.16-1.974.998l-1.284-.85z' }),
    _react2.default.createElement('path', { d: 'M3.62 17.243h5.74L11 15H3.62V1H1.38v26H3.62v-9.757z' })
  )
);

var _ref19 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '26', viewBox: '0 0 32 26' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-rail-holder-a02-holderset'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: '#3784C0', d: 'M29.22 11.893c.33.586 1.075.792 1.66.46.587-.33.793-1.074.462-1.66-.33-.586-1.074-.792-1.66-.46-.587.33-.793 1.074-.462 1.66M27.148 9.383c.35.62 1.138.84 1.76.488.62-.35.838-1.137.487-1.758-.35-.62-1.138-.84-1.76-.488-.62.35-.838 1.14-.487 1.76M26.324 7.29c.62-.352.84-1.14.49-1.76-.352-.62-1.14-.84-1.76-.49-.62.352-.84 1.14-.49 1.76.352.62 1.14.84 1.76.49M24.565 15.193c.35.622 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.138-.84-1.76-.488-.62.35-.84 1.14-.488 1.758M22.628 11.966c.35.62 1.14.84 1.76.49.62-.353.84-1.14.488-1.762-.35-.62-1.14-.84-1.76-.487-.62.35-.84 1.138-.488 1.76M20.692 8.738c.35.62 1.137.84 1.76.488.62-.35.838-1.14.487-1.76-.35-.62-1.14-.838-1.76-.488-.62.35-.84 1.14-.488 1.76M19.4 17.776c.35.62 1.138.84 1.76.49.62-.352.838-1.14.488-1.76-.35-.62-1.14-.84-1.76-.49-.62.35-.84 1.14-.488 1.76M18.11 14.548c.35.62 1.137.84 1.758.49.62-.352.84-1.14.488-1.76-.35-.62-1.138-.84-1.76-.49-.62.352-.838 1.14-.487 1.76M17.463 11.32c.35.62 1.14.84 1.76.488.62-.35.84-1.138.488-1.76-.35-.62-1.138-.838-1.76-.487-.62.35-.838 1.14-.487 1.76' }),
    _react2.default.createElement('path', { d: 'M3.762 23.696s-1.06-.452-.25-2.136c.808-1.685 7.216-15.236 20.732-20.1 0 0 2.018-1.045 2.07.645 0 0-.06.786-.237 1.265-.175.48-.165.41-1.472.93-1.31.523-12.084 4.687-17.583 19.247 0 0-.527 2.16-1.976.998l-1.284-.85z' }),
    _react2.default.createElement('path', { d: 'M7 15.243H.72V13H9' })
  )
);

var _ref20 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '31', height: '24', viewBox: '0 0 31 24' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-head-mounted-a01-wallmounted'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M15.833 16.257c0-.99.806-1.794 1.804-1.794.997 0 1.806.803 1.806 1.794 0 .99-.81 1.796-1.806 1.796-.998 0-1.804-.805-1.804-1.796M8.61 16.257c0-.99.808-1.794 1.805-1.794.998 0 1.807.803 1.807 1.794 0 .99-.81 1.796-1.807 1.796-.997 0-1.804-.805-1.804-1.796M9.514 10.873c0-.99.807-1.795 1.804-1.795s1.806.804 1.806 1.795c0 .99-.81 1.795-1.806 1.795-.997 0-1.804-.805-1.804-1.795M7.708 21.745c0-.992.81-1.795 1.805-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.807 1.795-.996 0-1.805-.803-1.805-1.795M23.054 16.257c0-.99.81-1.794 1.807-1.794.998 0 1.805.803 1.805 1.794 0 .99-.807 1.796-1.804 1.796s-1.806-.805-1.806-1.796M22.15 10.873c0-.99.81-1.795 1.807-1.795.997 0 1.805.804 1.805 1.795 0 .99-.808 1.795-1.805 1.795-.997 0-1.806-.805-1.806-1.795M24.054 21.745c0-.992.81-1.795 1.807-1.795.996 0 1.805.803 1.805 1.795 0 .992-.81 1.795-1.804 1.795-.997 0-1.806-.803-1.806-1.795M15.833 21.745c0-.992.806-1.795 1.804-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.806 1.795-.998 0-1.804-.803-1.804-1.795M15.833 10.873c0-.99.806-1.795 1.804-1.795.997 0 1.806.804 1.806 1.795 0 .99-.81 1.795-1.806 1.795-.998 0-1.804-.805-1.804-1.795' }),
    _react2.default.createElement('path', { d: 'M28.7 4.3c.754-.012 1.506-.654 1.506-1.445 0-.755-.663-1.277-1.458-1.41-.414-.036-.593-.058-.8-.07-1.093-.063-2.184-.115-3.28-.152-2.185-.075-4.37-.105-6.557-.105-2.185 0-4.37.03-6.558.105-1.03.036-2.062.082-3.09.14-.35.02-.782.035-1.05.064C6.547 1.49 6 2.097 6 2.857c0 .766.65 1.417 1.452 1.464.34.016.622-.003.814 0l3.28.058c2.187.032 4.375.05 6.563.05 2.185 0 4.37-.018 6.557-.05l3.28-.058.753-.02z' }),
    _react2.default.createElement('path', { d: 'M6.708 3.894H1.23V1.65h5.478' })
  )
);

var _ref21 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '26', height: '28', viewBox: '0 0 26 28' },
  _react2.default.createElement(
    'title',
    null,
    'icon-shower-head-mounted-a02-ceilingmounted'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M10.833 20.257c0-.99.806-1.794 1.804-1.794.997 0 1.806.803 1.806 1.794 0 .99-.81 1.796-1.806 1.796-.998 0-1.804-.805-1.804-1.796M3.61 20.257c0-.99.808-1.794 1.805-1.794.998 0 1.807.803 1.807 1.794 0 .99-.81 1.796-1.807 1.796-.997 0-1.804-.805-1.804-1.796M4.514 14.873c0-.99.807-1.795 1.804-1.795s1.806.804 1.806 1.795c0 .99-.81 1.795-1.806 1.795-.997 0-1.804-.805-1.804-1.795M2.708 25.745c0-.992.81-1.795 1.805-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.807 1.795-.996 0-1.805-.803-1.805-1.795M18.054 20.257c0-.99.81-1.794 1.807-1.794.998 0 1.805.803 1.805 1.794 0 .99-.807 1.796-1.804 1.796s-1.806-.805-1.806-1.796M17.15 14.873c0-.99.81-1.795 1.807-1.795.997 0 1.805.804 1.805 1.795 0 .99-.808 1.795-1.805 1.795-.997 0-1.806-.805-1.806-1.795M19.054 25.745c0-.992.81-1.795 1.807-1.795.996 0 1.805.803 1.805 1.795 0 .992-.81 1.795-1.804 1.795-.997 0-1.806-.803-1.806-1.795M10.833 25.745c0-.992.806-1.795 1.804-1.795.997 0 1.806.803 1.806 1.795 0 .992-.81 1.795-1.806 1.795-.998 0-1.804-.803-1.804-1.795M10.833 14.873c0-.99.806-1.795 1.804-1.795.997 0 1.806.804 1.806 1.795 0 .99-.81 1.795-1.806 1.795-.998 0-1.804-.805-1.804-1.795' }),
    _react2.default.createElement('path', { d: 'M23.7 8.3c.754-.012 1.506-.654 1.506-1.445 0-.755-.663-1.277-1.458-1.41-.414-.036-.593-.058-.8-.07-1.093-.063-2.184-.115-3.28-.152-2.185-.075-4.37-.105-6.557-.105-2.185 0-4.37.03-6.558.105-1.03.036-2.062.082-3.09.14-.35.02-.782.035-1.05.064C1.547 5.49 1 6.097 1 6.857c0 .766.65 1.417 1.452 1.464.34.016.622-.003.814 0l3.28.058c2.187.032 4.375.05 6.563.05 2.185 0 4.37-.018 6.557-.05l3.28-.058.753-.02zM11 5.04V.54h4v4.5' }),
    _react2.default.createElement('path', { d: 'M11 5.04V.54h4v4.5' })
  )
);

var _ref22 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '19', height: '35', viewBox: '0 0 19 35', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-answer-boiling'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1 11.826l2.126 18.628C3.356 32.474 5.066 34 7.1 34h4.8c2.032 0 3.742-1.526 3.973-3.546L18 11.826' }),
    _react2.default.createElement('path', { d: 'M3.217 15.94c1.893-1.286 3.785-1.5 5.677-.643 2.838 1.285 4.73 1.285 6.15 0M7.652 0c1.15 1.314 1.396 3.12.74 5.42-.658 2.3-.41 3.942.738 4.928M10.61.74c1.148 1.313 1.395 3.12.738 5.42s-.41 3.94.74 4.927' })
  )
);

var _ref23 = _react2.default.createElement(
  'svg',
  { className: 'button__icon', xmlns: 'http://www.w3.org/2000/svg', width: '21', height: '37', viewBox: '0 0 21 37', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-answer-chill-and-spark'
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--strokeBased' },
    _react2.default.createElement('path', { d: 'M1 12l2.37 20.46C3.602 34.478 5.31 36 7.342 36h5.98c2.03 0 3.74-1.522 3.974-3.54L19.667 12' }),
    _react2.default.createElement('path', { d: 'M3.667 15.733c2.133-1.066 4.266-1.244 6.4-.533 3.2 1.067 5.333 1.067 6.933 0' })
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--fillBased', transform: 'translate(5.267 17.933)' },
    _react2.default.createElement('circle', { cx: '6.767', cy: '12.567', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '2', cy: '8.867', r: '2' }),
    _react2.default.createElement('circle', { cx: '6.3', cy: '6.767', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '6.867', cy: '3.067', r: '1' }),
    _react2.default.createElement('circle', { cx: '3.667', cy: '1', r: '1' }),
    _react2.default.createElement('circle', { cx: '2.067', cy: '13.2', r: '1' })
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--strokeBased' },
    _react2.default.createElement('path', { d: 'M10.582 1v12M8.613 2.548l1.887 1.55 1.887-1.55M8.613 11.84l1.887-1.55 1.887 1.55' }),
    _react2.default.createElement('path', { d: 'M15.737 4.08l-10.392 6M13.412 3.15l-.398 2.408 2.285.86M5.366 7.795l2.284.86-.397 2.41' }),
    _react2.default.createElement('path', { d: 'M15.655 10.08l-10.392-6M15.3 7.6l-2.286.862.398 2.408M7.253 2.956l.397 2.41-2.284.86' })
  )
);

var _ref24 = _react2.default.createElement(
  'svg',
  { className: 'button__icon', xmlns: 'http://www.w3.org/2000/svg', width: '21', height: '37', viewBox: '0 0 21 37', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-answer-chill-and-spark-and-boiling'
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--strokeBased' },
    _react2.default.createElement('path', { d: 'M1 12l2.37 20.46C3.602 34.478 5.31 36 7.342 36h5.98c2.03 0 3.74-1.522 3.974-3.54L19.667 12' }),
    _react2.default.createElement('path', { d: 'M3.667 15.733c2.133-1.066 4.266-1.244 6.4-.533 3.2 1.067 5.333 1.067 6.933 0' })
  ),
  _react2.default.createElement(
    'g',
    { className: 'button__icon--fillBased', transform: 'translate(5.267 17.933)' },
    _react2.default.createElement('circle', { cx: '6.767', cy: '12.567', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '2', cy: '8.867', r: '2' }),
    _react2.default.createElement('circle', { cx: '6.3', cy: '6.767', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '6.867', cy: '3.067', r: '1' }),
    _react2.default.createElement('circle', { cx: '3.667', cy: '1', r: '1' }),
    _react2.default.createElement('circle', { cx: '2.067', cy: '13.2', r: '1' })
  )
);

var _ref25 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '32', viewBox: '0 0 32 32', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-answer-new-required'
  ),
  _react2.default.createElement('path', { d: 'M16 31C7.73 31 1 24.27 1 16S7.73 1 16 1s15 6.73 15 15-6.73 15-15 15zM15.49 7.04v17.926M7.036 16H24.96' })
);

var _ref26 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '31', height: '29', viewBox: '0 0 31 29', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-answer-existing'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M28.188 11.057c-1.6-5.61-6.716-9.71-12.715-9.71-5.998 0-11.053 4.1-12.652 9.71' }),
    _react2.default.createElement('path', { d: 'M30.01 6.258l-1.822 4.8-4.526-1.8M2.86 18.617c1.6 5.61 6.717 9.71 12.716 9.71 5.998 0 11.052-4.1 12.65-9.71' }),
    _react2.default.createElement('path', { d: 'M1.04 23.416l1.82-4.8 4.527 1.8' })
  )
);

var _ref27 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '12', height: '17', viewBox: '0 0 12 17', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-result-button-location'
  ),
  _react2.default.createElement('path', { d: 'M6.143 17C2.713 11.655 1 8.036 1 6.143 1 3.303 3.303 1 6.143 1s5.143 2.303 5.143 5.143c0 1.893-1.715 5.512-5.143 10.857zm0-8C7.72 9 9 7.72 9 6.143c0-1.578-1.28-2.857-2.857-2.857-1.578 0-2.857 1.28-2.857 2.857C3.286 7.72 4.566 9 6.143 9z' })
);

var _ref28 = _react2.default.createElement(
  'svg',
  { className: 'button__icon button__icon--strokeBased', xmlns: 'http://www.w3.org/2000/svg', width: '18', height: '18', viewBox: '0 0 18 18', 'aria-labelledby': 'title' },
  _react2.default.createElement(
    'title',
    { id: 'title' },
    'icon-result-button-online-shop'
  ),
  _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.153 15.182c0-.804.66-1.455 1.474-1.455s1.473.65 1.473 1.455c0 .803-.66 1.454-1.473 1.454-.814 0-1.474-.65-1.474-1.454zM4.788 15.182c0-.804.66-1.455 1.473-1.455.815 0 1.474.65 1.474 1.455 0 .803-.66 1.454-1.473 1.454-.813 0-1.472-.65-1.472-1.454zM.368 1.364h2.21l1.855 9.155c.206 1.02 1.113 1.753 2.166 1.753h8.5' }),
    _react2.default.createElement('path', { d: 'M3.315 3.545h13.258l-.575 4.544c-.092.727-.72 1.274-1.462 1.274H4.42' })
  )
);

var _ref29 = _react2.default.createElement(
  'svg',
  { height: '20', width: '100' },
  _react2.default.createElement(
    'text',
    { x: '0', y: '15', fill: 'red' },
    'No icon'
  )
);

var Icon = function Icon(_ref) {
  var name = _ref.name;

  // icons optimized with https://jakearchibald.github.io/svgomg/
  // use button__icon--fillBased and button__icon--strokeBased classes instead of inline attributes

  switch (name) {

    case "icon-shower-location-a01-shower":
      {
        return _ref2;
      }

    case "icon-shower-location-a02-bath":
      {
        return _ref3;
      }

    case "icon-shower-installation-type-a01-exposed":
      {
        return _ref4;
      }

    case "icon-shower-installation-type-a02-exposed-with-concealed":
      {
        return _ref5;
      }

    case "icon-shower-installation-type-a03-concealed":
      {
        return _ref6;
      }

    case "icon-shower-shape-a01-square":
      {
        return _ref7;
      }

    case "icon-shower-shape-a02-round":
      {
        return _ref8;
      }

    case "icon-shower-functionality-a01-square":
      {
        return _ref9;
      }

    case "icon-shower-functionality-a01-round":
      {
        return _ref10;
      }

    case "icon-shower-functionality-a02-square":
      {
        return _ref11;
      }

    case "icon-shower-functionality-a02-round":
      {
        return _ref12;
      }

    case "icon-shower-functionality-a03-square":
      {
        return _ref13;
      }

    case "icon-shower-with-holder-a01-square":
      {
        return _ref14;
      }

    case "icon-shower-with-holder-a01-round":
      {
        return _ref15;
      }

    case "icon-shower-with-holder-a02-square":
      {
        return _ref16;
      }

    case "icon-shower-with-holder-a02-round":
      {
        return _ref17;
      }

    case "icon-shower-rail-holder-a01-railset":
      {
        return _ref18;
      }

    case "icon-shower-rail-holder-a02-holderset":
      {
        return _ref19;
      }

    case "icon-shower-head-mounted-a01-wallmounted":
      {
        return _ref20;
      }

    case "icon-shower-head-mounted-a02-ceilingmounted":
      {
        return _ref21;
      }

    case "icon-answer-boiling":
      {
        return _ref22;
      }
    case "icon-answer-chill-and-spark":
      {
        return _ref23;
      }
    case "icon-answer-chill-and-spark-and-boiling":
      {
        return _ref24;
      }

    case "icon-answer-new-required":
      {
        return _ref25;
      }
    case "icon-answer-existing":
      {
        return _ref26;
      }
    case "icon-result-button-location":
      {
        return _ref27;
      }
    case "icon-result-button-online-shop":
      {
        return _ref28;
      }
    default:
      {
        return _ref29;
      }
  }
};

exports.default = Icon;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.Link = __webpack_require__(927);
exports.Button = __webpack_require__(930);
exports.Element = __webpack_require__(931);
exports.Helpers = __webpack_require__(122);
exports.scroller = __webpack_require__(304);
exports.Events = __webpack_require__(195);
exports.scrollSpy = __webpack_require__(303);
exports.animateScroll = __webpack_require__(193);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(194);

var smooth = __webpack_require__(928);

var cancelEvents = __webpack_require__(929);

var events = __webpack_require__(195);

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return smooth[options.smooth] || smooth.defaultEasing;
};

/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};

/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var __currentPositionY = 0;
var __startPositionY = 0;
var __targetPositionY = 0;
var __progress = 0;
var __duration = 0;
var __cancel = false;

var __target;
var __containerElement;
var __to;
var __start;
var __deltaTop;
var __percent;
var __delayTimeout;

var currentPositionY = function currentPositionY() {
  if (__containerElement) {
    return __containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight() {
  if (__containerElement) {
    return Math.max(__containerElement.scrollHeight, __containerElement.offsetHeight, __containerElement.clientHeight);
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateTopScroll = function animateTopScroll(easing, timestamp) {

  // Cancel on specific events
  if (__cancel) {
    if (events.registered['end']) {
      events.registered['end'](__to, __target, __currentPositionY);
    }
    return;
  };

  __deltaTop = Math.round(__targetPositionY - __startPositionY);

  if (__start === null) {
    __start = timestamp;
  }

  __progress = timestamp - __start;

  __percent = __progress >= __duration ? 1 : easing(__progress / __duration);

  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);

  if (__containerElement) {
    __containerElement.scrollTop = __currentPositionY;
  } else {
    window.scrollTo(0, __currentPositionY);
  }

  if (__percent < 1) {
    var easedAnimate = animateTopScroll.bind(null, easing);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (events.registered['end']) {
    events.registered['end'](__to, __target, __currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  if (!options || !options.containerId && (!options.container || !options.container.nodeType)) {
    __containerElement = null;
    return;
  }

  __containerElement = options.containerId ? document.getElementById(options.containerId) : options.container;
};

var startAnimateTopScroll = function startAnimateTopScroll(y, options, to, target) {

  window.clearTimeout(__delayTimeout);

  if (!options.ignoreCancelEvents) {
    /*
     * Sets the cancel trigger
     */

    cancelEvents.register(function () {
      __cancel = true;
    });
  }

  setContainer(options);

  __start = null;
  __cancel = false;
  __startPositionY = currentPositionY();
  __targetPositionY = options.absolute ? y : y + __startPositionY;
  __deltaTop = Math.round(__targetPositionY - __startPositionY);

  __duration = functionWrapper(options.duration)(__deltaTop);
  __duration = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
  __to = to;
  __target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateTopScroll.bind(null, easing);

  if (options && options.delay > 0) {
    __delayTimeout = window.setTimeout(function animate() {
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  requestAnimationFrameHelper.call(window, easedAnimate);
};

var scrollToTop = function scrollToTop(options) {
  startAnimateTopScroll(0, assign(options || {}, { absolute: true }));
};

var scrollTo = function scrollTo(toY, options) {
  startAnimateTopScroll(toY, assign(options || {}, { absolute: true }));
};

var scrollToBottom = function scrollToBottom(options) {
  setContainer(options);
  startAnimateTopScroll(scrollContainerHeight(), assign(options || {}, { absolute: true }));
};

var scrollMore = function scrollMore(toY, options) {
  setContainer(options);
  startAnimateTopScroll(currentPositionY() + toY, assign(options || {}, { absolute: true }));
};

module.exports = {
  animateTopScroll: startAnimateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

module.exports = Events;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(977),
    mapCacheDelete = __webpack_require__(984),
    mapCacheGet = __webpack_require__(986),
    mapCacheHas = __webpack_require__(987),
    mapCacheSet = __webpack_require__(988);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1004),
    baseKeys = __webpack_require__(1010),
    isArrayLike = __webpack_require__(200);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(313),
    isLength = __webpack_require__(199);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(48),
    isSymbol = __webpack_require__(129);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(336);

__webpack_require__(533);

__webpack_require__(534);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(12) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(131)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(25);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(100)(false);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(58);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(61).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(58);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(88);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(87);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(19);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(212);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(73).trim;
var ws = __webpack_require__(137);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(73).trim;

module.exports = 1 / $parseFloat(__webpack_require__(137) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(31);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(140);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(87);
var toLength = __webpack_require__(14);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(59);
var toLength = __webpack_require__(14);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(13).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(105)
});


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(155);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(227);
var validate = __webpack_require__(75);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(108)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(13).f;
var create = __webpack_require__(60);
var redefineAll = __webpack_require__(65);
var ctx = __webpack_require__(30);
var anInstance = __webpack_require__(63);
var forOf = __webpack_require__(64);
var $iterDefine = __webpack_require__(143);
var step = __webpack_require__(222);
var setSpecies = __webpack_require__(62);
var DESCRIPTORS = __webpack_require__(12);
var fastKey = __webpack_require__(49).fastKey;
var validate = __webpack_require__(75);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(227);
var validate = __webpack_require__(75);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(108)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(40)(0);
var redefine = __webpack_require__(22);
var meta = __webpack_require__(49);
var assign = __webpack_require__(210);
var weak = __webpack_require__(230);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var validate = __webpack_require__(75);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(108)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(65);
var getWeak = __webpack_require__(49).getWeak;
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(63);
var forOf = __webpack_require__(64);
var createArrayMethod = __webpack_require__(40);
var $has = __webpack_require__(25);
var validate = __webpack_require__(75);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(38);
var toLength = __webpack_require__(14);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(61);
var gOPS = __webpack_require__(101);
var anObject = __webpack_require__(4);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(102);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(14);
var ctx = __webpack_require__(30);
var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(14);
var repeat = __webpack_require__(139);
var defined = __webpack_require__(37);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(58);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(88).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(89);
var from = __webpack_require__(237);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(64);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(66);

var invariant = __webpack_require__(2);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);
var escapeTextContentForBrowser = __webpack_require__(116);
var setInnerHTML = __webpack_require__(115);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(80);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(33);

var quoteAttributeValueForBrowser = __webpack_require__(581);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var ReactCompositeComponent = __webpack_require__(594);
var ReactEmptyComponent = __webpack_require__(257);
var ReactHostComponent = __webpack_require__(258);

var getNextDebugID = __webpack_require__(595);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(76);

var invariant = __webpack_require__(2);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(596);

var getIteratorFn = __webpack_require__(597);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(173);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(77);

var ReactCurrentOwner = __webpack_require__(44);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(24);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(609);

var containsNode = __webpack_require__(611);
var focusNode = __webpack_require__(251);
var getActiveElement = __webpack_require__(263);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(82);
var DOMProperty = __webpack_require__(80);
var React = __webpack_require__(76);
var ReactBrowserEventEmitter = __webpack_require__(117);
var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMContainerInfo = __webpack_require__(626);
var ReactDOMFeatureFlags = __webpack_require__(627);
var ReactFeatureFlags = __webpack_require__(247);
var ReactInstanceMap = __webpack_require__(94);
var ReactInstrumentation = __webpack_require__(33);
var ReactMarkupChecksum = __webpack_require__(628);
var ReactReconciler = __webpack_require__(81);
var ReactUpdateQueue = __webpack_require__(174);
var ReactUpdates = __webpack_require__(41);

var emptyObject = __webpack_require__(79);
var instantiateReactComponent = __webpack_require__(255);
var invariant = __webpack_require__(2);
var setInnerHTML = __webpack_require__(115);
var shouldUpdateReactComponent = __webpack_require__(172);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(256);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(641);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */](),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */](location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */](routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */](state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */](nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */](routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */](state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(179);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default.a({
  displayName: 'Link',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */]('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(95);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */](element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */](route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */](pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default.a(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default.a(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default.a(createHistory))(options);
  return history;
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(67);

var _PathUtils = __webpack_require__(54);

var _createHistory = __webpack_require__(184);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default.a(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default.a(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(119);

var _BrowserProtocol = __webpack_require__(185);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(654);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(97);

var _createHistory = __webpack_require__(184);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(274);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */](createHistory)();
  return history;
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(119);

var _DOMUtils = __webpack_require__(97);

var _HashProtocol = __webpack_require__(656);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(184);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(279);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default.a(Connect, WrappedComponent);
  };
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(675);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(668);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(286);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(186);



function verifyPlainObject(value, displayName, methodName) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](value)) {
    __WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */](methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(689)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(696);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_CONFIGURATOR_TYPE = exports.DEFAULT_CONFIGURATOR_TYPE = 'shower';

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de_at.json": 735,
	"./hu_hu.json": 736,
	"./shower.ar_sa.json": 737,
	"./shower.cs_cz.json": 738,
	"./shower.da_dk.json": 739,
	"./shower.de_at.json": 740,
	"./shower.de_ch.json": 741,
	"./shower.de_de.json": 742,
	"./shower.en_cy.json": 743,
	"./shower.en_eg.json": 744,
	"./shower.en_gb.json": 745,
	"./shower.en_sa.json": 746,
	"./shower.es_es.json": 747,
	"./shower.fr_be.json": 748,
	"./shower.fr_ch.json": 749,
	"./shower.fr_fr.json": 750,
	"./shower.hu_hu.json": 751,
	"./shower.it_ch.json": 752,
	"./shower.it_it.json": 753,
	"./shower.nl_be.json": 754,
	"./shower.nl_nl.json": 755,
	"./shower.pl_pl.json": 756,
	"./shower.ru_ru.json": 757,
	"./shower.sk_sk.json": 758,
	"./shower.tr_tr.json": 759,
	"./shower.uk_ua.json": 760,
	"./water.ar_sa.json": 761,
	"./water.bg_bg.json": 762,
	"./water.cs_cz.json": 763,
	"./water.da_dk.json": 764,
	"./water.de_at.json": 765,
	"./water.de_ch.json": 766,
	"./water.de_de.json": 767,
	"./water.en_cy.json": 768,
	"./water.en_gb.json": 769,
	"./water.es_es.json": 770,
	"./water.et_ee.json": 771,
	"./water.fr_be.json": 772,
	"./water.fr_ch.json": 773,
	"./water.hr_hr.json": 774,
	"./water.hu_hu.json": 775,
	"./water.it_ch.json": 776,
	"./water.it_it.json": 777,
	"./water.lt_ltu.json": 778,
	"./water.lv_lv.json": 779,
	"./water.nl_be.json": 780,
	"./water.nl_nl.json": 781,
	"./water.no_no.json": 782,
	"./water.pl_pl.json": 783,
	"./water.pt_pt.json": 784,
	"./water.ro_ro.json": 785,
	"./water.ru_ru.json": 786,
	"./water.sk_sk.json": 787,
	"./water.tr_tr.json": 788,
	"./water.uk_ua.json": 789
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt1 && control_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt1 && control_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt1 && control_opt2 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt2 && control_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt2 && control_opt2 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt3 && control_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && operation_opt3 && control_opt2 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34283001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Combi shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower (white spray plate) and 115mm hand shower with four  sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Combi shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower and 115mm hand shower with four  sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower (white spray plate) and 115mm hand shower with four  sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi shower system with termostat. Chrome, eco-friendly and made in Germany: 360mm head shower with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower (white spray plate) with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi thermostatic shower mixer <br />with 3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi shower thermostat with three valves. Chrome with white tray, German engineered.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi thermostatic shower mixer <br />with 2 valves, exposed/concealed",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi shower thermostat with two valves. Chrome with white tray, German engineered.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat amd side showers",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and body jets",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and bath spout",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Hand Shower 4+ sprays",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, hand shower, 4+ sprays",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan set with hand shower (130 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (130 mm), shower rail (600 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan set with hand shower (160 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (130 mm), shower rail (600 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (160 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (115 mm), shower rail (900 mm) and shower hose (1,750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wall holder set 2 sprays",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan set with hand shower (115 mm), shower hose (1,250 mm) and hand shower holder",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wall holder set 2 sprays",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (115 mm), shower hose (1,250 mm) and hand shower holder",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet-, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand Shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with diverter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand Shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet-, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany, 360mm head shower with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower and 115mm hand shower with four  sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow, 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube Shower outlet elbow with wall holder, chrome finish and German engineered.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect Shower Set, including thermostatic tap",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 600 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 900 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 210mm metal head shower, Euphoria 110mm hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan comfort shower set, concealed thermostat included",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set with Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect shower set with Rainshower Allure 230mm head shower, Euphoria Cube hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany, 360mm head shower (white spray plate) with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl head shower set with three spray zones. 260mm shower head and GROHE Rainshower arm (380mm) with chrome finish. Easy to fit and clean. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set ceiling 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl head shower set with three spray zones. 260mm shower head and GROHE Rainshower ceiling arm (142mm) with chrome finish. Easy to fit and clean. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm wall-mounted showerhead with 400mm shower arm, chrome finish and white spray plate, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish and white spray plate, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm wall-mounted showerhead with 400mm shower arm, chrome finish and white spray plate, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish and white spray plate, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat for bathtubs, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with single lever mixer, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with single lever mixer, water-saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bath/Shower System with thermostat for bathtubs, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO head shower set. Chrome, made in Germany: 360mm head shower and 450mm shower arm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO head shower set. Chrome, made in Germany: 360mm head shower (white spray plate) and 450mm shower arm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Flex shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE Euphoria XXL Shower System with thermostat; chrome and German engineered with 310mm metal head shower and 110mm three-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, wall-mounted head shower set with 286 mm long shower arm, 9.5 L / min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, head shower set, ceiling shower arm 142 mm, 9.5 L / min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with <br />2 valves and integrated shower holder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves valves and integrated shower union. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with <br />2 valves and integrated shower holder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves and integrated shower union. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28995000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28995000/640/28995000.jpg",
		"headline": "Talentofill",
		"subheadline": "Connection set 3/4\"",
		"textblock_1st_text": "28995000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/28995000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (130 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with diverter. Water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Shower set with thermostat, for concealed installation with three valves, head shower, hand shower, shower arm, hose. Square shape. Chrome finish, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Shower set with thermostat, for concealed installation with three valves, head shower, hand shower, shower arm, hose. Round shape. Chrome finish, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate white",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Hand shower 2 sprays, spray plate white",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "location_a01_ZZH_T34706C01_000_01.jpg",
					"buttonIcon": "icon-shower-location-a01-shower"
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T32114C07_000_01_BATH_first question.jpg",
					"buttonIcon": "icon-shower-location-a02-bath"
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "installation-type",
			"additionalClass": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "installation-type_a01_ZZH_T26250C05_000_01.jpg",
					"buttonIcon": "icon-shower-installation-type-a01-exposed",
					"conditions": "location",
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a01_ZZH_T27641A02_000_01.jpg"
						}
					]
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-shower-installation-type-a02-exposed-with-concealed",
					"conditions": [
						"!da_dk && !fr_be && !nl_be && !fr_fr && location",
						"nl_be && location_opt0",
						"fr_be && location_opt0"
					],
					"image": "installation-type_a02_ZZH_T26443C18_000_01.jpg",
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a02_ZZH_T26443C01_000_01.jpg"
						}
					]
				},
				{
					"text": "question2.option3.text",
					"image": "installation-type_a03_ZZH_T34706C01_000_01.jpg",
					"buttonIcon": "icon-shower-installation-type-a03-concealed",
					"conditions": [
						"location_opt0",
						"location && !nl_be && !fr_be",
						"nl_be && location_opt1",
						"fr_be && location_opt1"
					],
					"images": [
						{
							"conditions": "location_opt1",
							"image": "installation-type_a03_ZZH_T29125C01_000_03.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": true,
			"slug": "operation",
			"additionalClass": "",
			"conditions": "location_opt0 && !installation-type_opt1",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "operation_a01_ZZH_T26250C13_000_01.jpg",
					"images": [
						{
							"image": "operation_a01_29126000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt2"
					]
				},
				{
					"text": "question3.option2.text",
					"buttonIcon": "",
					"image": "operation_a02_ZZH_T27922C04_000_01.jpg",
					"images": [
						{
							"image": "operation_a02_19959000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt2"
					]
				},
				{
					"text": "question3.option3.text",
					"image": "operation_a03_ZZH_T23147A02_000_01.jpg",
					"images": [
						{
							"image": "operation_a03_19896000.jpg",
							"conditions": "installation-type_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0 && nl_be",
						"location_opt0 && installation-type_opt2 && nl_be",
						"location_opt0 && installation-type_opt0 && fr_be",
						"location_opt0 && installation-type_opt2 && fr_be",
						"location_opt0 && installation-type_opt0 && en_gb",
						"location_opt0 && installation-type_opt0 && da_dk",
						"location_opt0 && installation-type_opt2 && da_dk",
						"location_opt0 && installation-type_opt0 && sk_sk",
						"location_opt0 && installation-type_opt2 && sk_sk",
						"location_opt0 && installation-type_opt0 && cs_cz",
						"location_opt0 && installation-type_opt2 && cs_cz",
						"location_opt0 && installation-type_opt0 && es_es",
						"location_opt0 && installation-type_opt2 && es_es",
						"location_opt0 && installation-type_opt0 && it_it",
						"location_opt0 && installation-type_opt2 && it_it",
						"location_opt0 && installation-type_opt0 && ru_ru",
						"location_opt0 && installation-type_opt2 && ru_ru",
						"location_opt0 && installation-type_opt0 && uk_ua",
						"location_opt0 && installation-type_opt2 && uk_ua",
						"location_opt0 && installation-type_opt0 && pl_pl",
						"location_opt0 && installation-type_opt2 && pl_pl",
						"location_opt0 && installation-type_opt0 && hu_hu",
						"location_opt0 && installation-type_opt2 && hu_hu",
						"location_opt0 && installation-type_opt0 && fr_fr",
						"location_opt0 && installation-type_opt2 && fr_fr",
						"location_opt0 && installation-type_opt0 && en_eg",
						"location_opt0 && installation-type_opt0 && en_sa",
						"location_opt0 && installation-type_opt0 && en_cy",
						"location_opt0 && installation-type_opt0 && tr_tr",
						"location_opt0 && installation-type_opt0 && de_de",
						"location_opt0 && installation-type_opt2 && !de_de && !de_ch && !de_at && !fr_ch && !it_ch && !en_gb && !nl_nl",
						"location_opt0 && installation-type_opt0 && de_ch",
						"location_opt0 && installation-type_opt0 && de_at",
						"location_opt0 && installation-type_opt0 && fr_ch",
						"location_opt0 && installation-type_opt0 && it_ch",
						"location_opt0 && installation-type_opt0 && ar_sa",
						"location_opt0 && installation-type_opt2 && ar_sa"
					]
				},
				{
					"text": "question3.option4.text",
					"image": "operation_a04_ZZH_X27058000_003_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt0 && installation-type_opt0"
				}
			]
		},
		{
			"question": "question4.question",
			"swipeable": true,
			"slug": "control",
			"additionalClass": "",
			"conditions": [
				"operation_opt1",
				"operation_opt2 && !da_dk && !sk_sk && !it_it && !cs_cz && es_es && !de_de && !hu_hu && !fr_fr && !es_es && !pl_pl && !en_eg && !en_sa && !en_cy && !tr_tr && !ru_ru && !uk_ua && !nl_be && !fr_be && !de_at && !de_ch",
				"operation_opt2 && da_dk && installation-type_opt0",
				"operation_opt2 && sk_sk && installation-type_opt0",
				"operation_opt2 && cs_cz && installation-type_opt0",
				"operation_opt2 && de_de && installation-type_opt0",
				"operation_opt2 && hu_hu && installation-type_opt0",
				"operation_opt2 && fr_fr && installation-type_opt0",
				"operation_opt2 && es_es && installation-type_opt0",
				"operation_opt2 && pl_pl && installation-type_opt0",
				"operation_opt2 && en_eg && installation-type_opt0",
				"operation_opt2 && it_it && installation-type_opt0",
				"operation_opt2 && en_sa && installation-type_opt0",
				"operation_opt2 && en_cy && installation-type_opt0",
				"operation_opt2 && tr_tr && installation-type_opt0",
				"operation_opt2 && ru_ru && installation-type_opt0",
				"operation_opt2 && uk_ua && installation-type_opt0",
				"operation_opt2 && nl_be && installation-type_opt0",
				"operation_opt2 && fr_be && installation-type_opt0",
				"operation_opt2 && fr_ch && installation-type_opt0",
				"operation_opt2 && it_ch && installation-type_opt0",
				"operation_opt2 && de_ch && installation-type_opt0",
				"operation_opt2 && de_at && installation-type_opt0",
				"operation_opt2 && ar_sa && installation-type_opt0",
				"operation_opt2 && en_gb",
				"location_opt1 && installation-type_opt0",
				"operation_opt3"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "control_a01_34195001.jpg",
					"buttonIcon": "",
					"conditions": "installation-type_opt0 && operation_opt1"
				},
				{
					"text": "question4.option2.text",
					"buttonIcon": "",
					"image": "control_a02_27922001.jpg",
					"images": [
						{
							"image": "control_a02_26381001.jpg",
							"conditions": "installation-type_opt0 && operation_opt3"
						},
						{
							"image": "control_a02_ZZH_26408000_000_01.jpg",
							"conditions": "installation-type_opt2 && operation_opt1"
						},
						{
							"image": "control_a02_26224001.jpg",
							"conditions": "installation-type_opt0 && operation_opt2"
						}
					],
					"conditions": [
						"operation_opt1",
						"operation_opt2",
						"operation_opt3"
					]
				},
				{
					"text": "question4.option3.text",
					"image": "control_a03_27296002.jpg",
					"images": [
						{
							"image": "control_a03_27421002.jpg",
							"conditions": "installation-type_opt0 && operation_opt3"
						},
						{
							"image": "control_a03_ZZH_28778000_001_01.jpg",
							"conditions": "installation-type_opt2 && operation_opt1"
						},
						{
							"image": "control_a03_27473001.jpg",
							"conditions": "installation-type_opt0 && operation_opt2"
						}
					],
					"buttonIcon": "",
					"conditions": [
						"operation_opt1",
						"operation_opt2 && !nl_nl && !fr_be && !nl_be",
						"operation_opt3"
					]
				},
				{
					"text": "question4.option4.text",
					"image": "control_a04_ZZH_26408000_000_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt1 && installation-type_opt0"
				},
				{
					"text": "question4.option5.text",
					"image": "control_a05_ZZH_26455000_000_01.jpg",
					"buttonIcon": "",
					"conditions": "location_opt1 && installation-type_opt0 && !en_gb"
				}
			]
		},
		{
			"question": "question5.question",
			"swipeable": true,
			"slug": "shape",
			"conditions": [
				"location_opt0 && installation-type_opt2 && operation_opt0",
				"location_opt1 && installation-type_opt2"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-shape-a01-square",
					"conditions": "installation-type_opt2",
					"images": [
						{
							"conditions": [
								"location_opt0",
								"location_opt1"
							],
							"image": "ZZH_T29126C08_000_01.jpg"
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-shape-a02-round",
					"conditions": "installation-type_opt2",
					"images": [
						{
							"conditions": [
								"location_opt0",
								"location_opt1"
							],
							"image": "ZZH_T29121C08_000_01.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "functionality",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"installation-type_opt0",
				"installation-type_opt1",
				"installation-type_opt2 && shape"
			],
			"options": [
				{
					"id": "functionality_opt0",
					"text": "question6.option1.text",
					"image": "functionality_a01_ZZH_T26250C16_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt0 && operation_opt0",
						"location_opt0 && installation-type_opt1 && !en_gb"
					],
					"images": [
						{
							"conditions": "installation-type_opt1",
							"image": "functionality_a01_ZZH_T26443C13_000_01.jpg"
						}
					]
				},
				{
					"id": "functionality_opt3",
					"text": "question6.option2.text",
					"image": "ZZH_29126000_021_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt2 && operation_opt0"
					],
					"images": [
						{
							"image": "functionality_a04_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt4",
					"text": "question6.option3.text",
					"image": "functionality_a05_ZZH_T26443C13_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt1 && installation-type_opt1 && !de_de",
						"location_opt1 && installation-type_opt2"
					],
					"images": [
						{
							"image": "ZZH_29126000_021_01.jpg",
							"conditions": "shape_opt0"
						},
						{
							"image": "functionality_a05_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt7",
					"text": "question6.option4.text",
					"image": "ZZH_29126000_021_01.jpg",
					"buttonIcon": "icon-shower-functionality-a01-square",
					"conditions": [
						"location_opt0 && installation-type_opt2 && operation_opt0"
					],
					"images": [
						{
							"image": "functionality_a08_ZZH_29121000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt1",
					"text": "question6.option5.text",
					"image": "functionality_a02_ZZH_T26361C15_000_01.jpg",
					"images": [
						{
							"conditions": "location_opt0 && shape_opt0",
							"image": "functionality_a02_ZZH_29124000_003_01.jpg"
						},
						{
							"conditions": "location_opt0 && shape_opt1",
							"image": "functionality_a02_ZZH_29119000_001_01.jpg"
						},
						{
							"conditions": "location_opt0 && installation-type_opt1",
							"image": "functionality_a02_ZZH_T26446C11_000_01.jpg"
						}
					],
					"buttonIcon": "icon-shower-functionality-a02-square",
					"conditions": [
						"location_opt0 && installation-type_opt0 && operation_opt0 && !en_eg && !en_sa && !en_cy && !tr_tr",
						"!de_de && !de_at && !it_ch && !fr_ch && !de_ch && !en_eg && !en_sa && !en_cy && !tr_tr && !nl_be && !fr_be && !fr_be && location_opt0 && installation-type_opt1",
						"location_opt0 && shape"
					]
				},
				{
					"id": "functionality_opt5",
					"text": "question6.option6.text",
					"image": "functionality_a06_ZZH_T26446C11_000_01.jpg",
					"buttonIcon": "icon-shower-functionality-a02-square",
					"conditions": [
						"location_opt1 && installation-type_opt2",
						"location_opt1 && installation-type_opt1"
					],
					"images": [
						{
							"image": "functionality_a06_ZZH_29124000_003_01.jpg",
							"conditions": "shape_opt0"
						},
						{
							"image": "functionality_a06_ZZH_29119000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt2",
					"text": "question6.option7.text",
					"image": "functionality_a03_ZZH_29123000_005_01.jpg",
					"buttonIcon": "icon-shower-functionality-a03-square",
					"conditions": [
						"location_opt0 && installation-type_opt2"
					],
					"images": [
						{
							"image": "functionality_a03_ZZH_29118000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				},
				{
					"id": "functionality_opt6",
					"text": "question6.option8.text",
					"image": "functionality_a07_ZZH_29123000_005_01.jpg",
					"buttonIcon": "icon-shower-functionality-a03-square",
					"conditions": [
						"location_opt1 && installation-type_opt2 && !en_eg && !en_sa && !en_cy && !tr_tr && !de_de && !de_at && !de_ch && !it_ch && !fr_ch",
						"location_opt1 && installation-type_opt2 && shape_opt1 && !de_de && !de_at && !de_ch && !it_ch && !fr_ch"
					],
					"images": [
						{
							"image": "functionality_a07_ZZH_29118000_001_01.jpg",
							"conditions": "shape_opt1"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "color",
			"swipeable": true,
			"conditions": [
				"functionality"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question7.option1.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"installation-type_opt0 && functionality_opt0",
						"installation-type_opt0 && functionality_opt1",
						"installation-type_opt1 && functionality_opt0",
						"installation-type_opt1 && functionality_opt1",
						"installation-type_opt2 && functionality_opt0",
						"installation-type_opt2 && functionality_opt2",
						"shape_opt1 && functionality_opt1",
						"functionality_opt3",
						"installation-type_opt1 && functionality_opt4",
						"shape_opt1 && functionality_opt4",
						"functionality_opt5 && installation-type_opt2",
						"functionality_opt6"
					],
					"images": [
						{
							"conditions": "functionality_opt0",
							"image": "color_a01_ZZH_26254000_001_01.jpg"
						},
						{
							"conditions": "functionality_opt0",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt1 && functionality_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt0 && functionality_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "installation-type_opt2 && functionality_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt0",
							"image": "color_a01_29123000.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt1",
							"image": "color_a01_29118000.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt0",
							"image": "color_a01_29126000.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt1",
							"image": "color_a01_29121000.jpg"
						},
						{
							"conditions": "functionality_opt4 && installation-type_opt1",
							"image": "color_a01_ZZH_26361000_001_01.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1",
							"image": "color_a01_29121000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "color_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "color_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt0",
							"image": "color_a01_29123000.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt1",
							"image": "color_a01_29118000.jpg"
						}
					]
				},
				{
					"text": "question7.option2.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"location_opt0 && installation-type_opt0",
						"location_opt0 && installation-type_opt1",
						"installation-type_opt1 && functionality_opt4"
					],
					"images": [
						{
							"conditions": "functionality_opt0",
							"image": "color_a02_ZZH_26254LS0_001_01.jpg"
						},
						{
							"conditions": "functionality_opt1",
							"image": "color_a02_ZZH_26450LS0_001_01.jpg"
						},
						{
							"conditions": "functionality_opt4",
							"image": "color_a02_ZZH_26450LS0_001_01.jpg"
						}
					]
				},
				{
					"text": "question7.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": [
						"!nl_nl && shape_opt1 && functionality_opt1",
						"shape_opt1 && functionality_opt2",
						"shape_opt1 && functionality_opt3",
						"shape_opt0 && functionality_opt2",
						"shape_opt0 && functionality_opt3",
						"functionality_opt5 && installation-type_opt2",
						"functionality_opt6",
						"shape_opt1 && installation-type_opt1 && functionality_opt4",
						"shape_opt1 && functionality_opt4 && location_opt0",
						"shape_opt1 && functionality_opt4 && !nl_nl"
					],
					"images": [
						{
							"conditions": "functionality_opt2 && shape_opt0",
							"image": "color_a03_29153LS0.jpg"
						},
						{
							"conditions": "functionality_opt2 && shape_opt1",
							"image": "color_a03_29150LS0.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt0",
							"image": "color_a03_29157LS0.jpg"
						},
						{
							"conditions": "functionality_opt3 && shape_opt1",
							"image": "color_a03_29904LS0.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "color_a03_29151LS0.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt0",
							"image": "color_a03_29153LS0.jpg"
						},
						{
							"conditions": "functionality_opt6 && shape_opt1",
							"image": "color_a03_29150LS0.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "color_a03_29156LS0.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "color_a03_29151LS0.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1",
							"image": "color_a03_29904LS0.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "with-holder",
			"swipeable": false,
			"additionalClass": "",
			"options": [
				{
					"id": "with-holder_opt1",
					"text": "question8.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-with-holder-a02-square",
					"conditions": [
						"installation-type_opt2 && shape_opt0 && functionality_opt1",
						"installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0",
						"installation-type_opt2 && functionality_opt5 && color_opt0"
					],
					"images": [
						{
							"conditions": "functionality_opt1 && shape_opt0",
							"image": "with-holder_a02_29125000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "with-holder_a02_29120000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "with-holder_a02_29125000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "with-holder_a02_29120000.jpg"
						}
					]
				},
				{
					"id": "with-holder_opt0",
					"text": "question8.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-with-holder-a01-square",
					"conditions": [
						"installation-type_opt2 && shape_opt0 && functionality_opt1",
						"installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0",
						"installation-type_opt2 && functionality_opt5 && color_opt0"
					],
					"images": [
						{
							"conditions": "functionality_opt1 && shape_opt0",
							"image": "with-holder_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt1 && shape_opt1",
							"image": "with-holder_a01_29119000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt0",
							"image": "with-holder_a01_29124000.jpg"
						},
						{
							"conditions": "functionality_opt5 && shape_opt1",
							"image": "with-holder_a01_29119000.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "rail-holder",
			"swipeable": true,
			"additionalClass": "",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-rail-holder-a01-railset",
					"conditions": [
						"functionality_opt2 && color",
						"functionality_opt5 && color_opt2",
						"functionality_opt5 && color_opt0 && with-holder_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt2",
							"image": "27700000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt0",
							"image": "rail-holder_a01_27747000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt2",
							"image": "rail-holder_a01_27368000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt5",
							"image": "rail-holder_a01_27700000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt5",
							"image": "rail-holder_a01_27368000.jpg"
						}
					]
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-rail-holder-a02-holderset",
					"conditions": [
						"functionality_opt2 && color",
						"functionality_opt5 && color_opt2",
						"functionality_opt5 && color_opt0 && with-holder_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt2",
							"image": "26405000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt0",
							"image": "rail-holder_a02_27839000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt2 && color_opt2",
							"image": "rail-holder_a02_27369000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt5",
							"image": "rail-holder_a02_26405000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt5",
							"image": "rail-holder_a02_27369000.jpg"
						}
					]
				}
			]
		},
		{
			"question": "question10.question",
			"slug": "head-mounted",
			"swipeable": true,
			"additionalClass": "",
			"options": [
				{
					"text": "question10.option1.text",
					"image": "",
					"buttonIcon": "icon-shower-head-mounted-a01-wallmounted",
					"conditions": [
						"functionality_opt3 && color",
						"functionality_opt7",
						"functionality_opt1 && color_opt2",
						"functionality_opt1 && with-holder",
						"functionality_opt4 && shape_opt0",
						"functionality_opt4 && shape_opt1 && color",
						"functionality_opt7 && location_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt1",
							"image": "head-mounted_a01_26054000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a01_26479000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a01_26479LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt7",
							"image": "head-mounted_a01_26255000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt0",
							"image": "head-mounted_a01_26056000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt2",
							"image": "head-mounted_a01_26171LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a01_26475000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a01_26475LS0.jpg"
						},
						{
							"conditions": "functionality_opt7 && shape_opt0",
							"image": "head-mounted_a01_26060000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt4",
							"image": "head-mounted_a01_26054000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt4 && color_opt0",
							"image": "head-mounted_a01_26056000.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1 && color_opt2",
							"image": "head-mounted_a01_26171LS0.jpg"
						}
					]
				},
				{
					"text": "question10.option2.text",
					"image": "",
					"buttonIcon": "icon-shower-head-mounted-a02-ceilingmounted",
					"conditions": [
						"functionality_opt3 && color",
						"functionality_opt7",
						"functionality_opt1 && color_opt2",
						"functionality_opt1 && with-holder",
						"functionality_opt4 && shape_opt0",
						"functionality_opt4 && shape_opt1 && color",
						"functionality_opt7 && location_opt0"
					],
					"images": [
						{
							"conditions": "shape_opt0 && functionality_opt1",
							"image": "head-mounted_a02_26055000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a02_26481000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a02_26481LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt7",
							"image": "head-mounted_a02_26256000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt0",
							"image": "head-mounted_a02_26057000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt1 && color_opt2",
							"image": "head-mounted_a02_26053LS0.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt0",
							"image": "head-mounted_a02_26477000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt3 && color_opt2",
							"image": "head-mounted_a02_26477LS0.jpg"
						},
						{
							"conditions": "functionality_opt7 && shape_opt0",
							"image": "head-mounted_a02_26061000.jpg"
						},
						{
							"conditions": "shape_opt0 && functionality_opt4",
							"image": "head-mounted_a02_26055000.jpg"
						},
						{
							"conditions": "shape_opt1 && functionality_opt4 && color_opt0",
							"image": "head-mounted_a02_26057000.jpg"
						},
						{
							"conditions": "functionality_opt4 && shape_opt1 && color_opt2",
							"image": "head-mounted_a02_26053LS0.jpg"
						}
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && mono-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30329001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30060001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30341001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30340001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30341DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30340DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30058001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30058DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && mono-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30329001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30060001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && mono-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30329001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30060001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt1 && mono-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30329001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt1 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30060001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30341001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30340001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30341DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30340DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30058001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30058DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30341DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30341DC1/640/30341DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30341DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30341DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30341001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30341001/640/30341001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30341001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30341001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30340DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30340DC1/640/30340DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30340DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30340DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30340001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30340001/640/30340001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30340001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30340001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30329001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30329001/640/30329001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30329001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30329001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30328DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30328DC1/640/30328DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30328DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30328DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30328001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30328001/640/30328001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30328001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30328001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30060001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30060001/640/30060001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30060001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30060001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30058DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30058DC1/640/30058DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30058DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30058DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30058001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30058001/640/30058001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30058001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30058001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat amd side showers",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and body jets",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and bath spout",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with diverter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect Shower Set, including thermostatic tap",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 600 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 900 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 210mm metal head shower, Euphoria 110mm hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan comfort shower set, concealed thermostat included",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set with Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect shower set with Rainshower Allure 230mm head shower, Euphoria Cube hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat for bathtubs, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with single lever mixer, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with single lever mixer, water-saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bath/Shower System with thermostat for bathtubs, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Flex shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE Euphoria XXL Shower System with thermostat; chrome and German engineered with 310mm metal head shower and 110mm three-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with diverter. Water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "q01_water-type_a01_boiling.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_02.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "q01_water-type_a03_chill-spark-boiling.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "q02_tap_a01_existing.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "q02_tap_a02_new-required.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap_opt1",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt2 && main-faucet"
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && duo-spout",
				"tap_opt0"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt2 && main-faucet_opt0 && duo-spout",
						"water-type_opt0 && tap_opt0"
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt0",
						"water-type_opt2 && main-faucet_opt0 && duo-spout",
						"water-type_opt2 && main-faucet_opt1 && duo-spout",
						"water-type_opt1 && tap_opt0"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"mono-spout",
				"duo-spout",
				"water-type_opt2 && mono-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T31454B10_000_02.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt0",
						"water-type_opt0 && mono-spout",
						"water-type_opt1 && mono-spout",
						"water-type_opt1 && duo-spout",
						"water-type_opt0 && duo-spout",
						"water-type_opt2 && mono-spout"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt1 && mono-spout",
						"water-type_opt1 && duo-spout",
						"water-type_opt2 && main-faucet_opt1 && mono-spout"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && finish_opt0 && mono-spout",
						"water-type_opt0 && duo-spout && finish",
						"water-type_opt2 && mono-spout && finish"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && duo-spout && finish",
						"water-type_opt2 && main-faucet_opt1 && finish"
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "asdfghjkl",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Thumbs = exports.Carousel = undefined;

var _Carousel = __webpack_require__(923);

var _Carousel2 = _interopRequireDefault(_Carousel);

var _Thumbs = __webpack_require__(301);

var _Thumbs2 = _interopRequireDefault(_Thumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Carousel = _Carousel2.default;
exports.Thumbs = _Thumbs2.default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classnames = __webpack_require__(120);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    CAROUSEL: function CAROUSEL(isSlider) {
        return (0, _classnames2.default)({
            "carousel": true,
            "carousel-slider": isSlider
        });
    },

    WRAPPER: function WRAPPER(isSlider, axis) {
        return (0, _classnames2.default)({
            "thumbs-wrapper": !isSlider,
            "slider-wrapper": isSlider,
            "axis-horizontal": axis === "horizontal",
            "axis-vertical": axis !== "horizontal"
        });
    },

    SLIDER: function SLIDER(isSlider, isSwiping) {
        return (0, _classnames2.default)({
            "thumbs": !isSlider,
            "slider": isSlider,
            "animated": !isSwiping
        });
    },

    ITEM: function ITEM(isSlider, selected) {
        return (0, _classnames2.default)({
            "thumb": !isSlider,
            "slide": isSlider,
            "selected": selected
        });
    },

    ARROW_PREV: function ARROW_PREV(disabled) {
        return (0, _classnames2.default)({
            "control-arrow control-prev": true,
            "control-disabled": disabled
        });
    },

    ARROW_NEXT: function ARROW_NEXT(disabled) {
        return (0, _classnames2.default)({
            "control-arrow control-next": true,
            "control-disabled": disabled
        });
    },

    DOT: function DOT(selected) {
        return (0, _classnames2.default)({
            "dot": true,
            'selected': selected
        });
    }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (position, axis) {
    var positionCss = axis === 'horizontal' ? [position, 0, 0] : [0, position, 0];
    var transitionProp = 'translate3d';

    var translatedPosition = '(' + positionCss.join(',') + ')';

    return transitionProp + translatedPosition;
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(924)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./react-swipe'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reactSwipe);
    global.index = mod.exports;
  }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cssClasses = __webpack_require__(298);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _dimensions = __webpack_require__(925);

var _CSSTranslate = __webpack_require__(299);

var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);

var _reactEasySwipe = __webpack_require__(300);

var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Thumbs = function (_Component) {
    _inherits(Thumbs, _Component);

    function Thumbs(props) {
        _classCallCheck(this, Thumbs);

        var _this = _possibleConstructorReturn(this, (Thumbs.__proto__ || Object.getPrototypeOf(Thumbs)).call(this, props));

        _this.updateSizes = function () {
            if (!_this.state.initialized) {
                return;
            }

            var total = _this.props.children.length;
            _this.wrapperSize = _this.itemsWrapper.clientWidth;
            _this.itemSize = (0, _dimensions.outerWidth)(_this.refs.thumb0);
            _this.visibleItems = Math.floor(_this.wrapperSize / _this.itemSize);
            _this.lastPosition = total - _this.visibleItems;
            _this.showArrows = _this.visibleItems < total;
        };

        _this.setMountState = function () {
            _this.setState({ hasMount: true });
            _this.updateSizes();
        };

        _this.handleClickItem = function (index, item) {
            var handler = _this.props.onSelectItem;

            if (typeof handler === 'function') {
                handler(index, item);
            }
        };

        _this.onSwipeStart = function () {
            _this.setState({
                swiping: true
            });
        };

        _this.onSwipeEnd = function () {
            _this.setState({
                swiping: false
            });
        };

        _this.onSwipeMove = function (deltaX) {
            var leftBoundry = 0;
            var list = _reactDom2.default.findDOMNode(_this.itemList);
            var wrapperSize = list.clientWidth;
            var visibleItems = Math.floor(wrapperSize / _this.itemSize);

            var currentPosition = -_this.state.firstItem * _this.itemSize;
            var lastLeftBoundry = -_this.visibleItems * _this.itemSize;

            // prevent user from swiping left out of boundaries
            if (currentPosition === leftBoundry && deltaX > 0) {
                deltaX = 0;
            }

            // prevent user from swiping right out of boundaries
            if (currentPosition === lastLeftBoundry && deltaX < 0) {
                deltaX = 0;
            }

            var position = currentPosition + 100 / (wrapperSize / deltaX) + '%';

            // if 3d isn't available we will use left to move
            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
                list.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
            });
        };

        _this.slideRight = function (positions) {
            _this.moveTo(_this.state.firstItem - (typeof positions === 'Number' ? positions : 1));
        };

        _this.slideLeft = function (positions) {
            _this.moveTo(_this.state.firstItem + (typeof positions === 'Number' ? positions : 1));
        };

        _this.moveTo = function (position) {
            // position can't be lower than 0
            position = position < 0 ? 0 : position;
            // position can't be higher than last postion
            position = position >= _this.lastPosition ? _this.lastPosition : position;

            _this.setState({
                firstItem: position,
                // if it's not a slider, we don't need to set position here
                selectedItem: _this.state.selectedItem
            });
        };

        _this.state = {
            initialized: false,
            selectedItem: props.selectedItem,
            hasMount: false,
            firstItem: _this.getFirstItem(props.selectedItem),
            images: []
        };
        return _this;
    }

    _createClass(Thumbs, [{
        key: 'componentDidMount',
        value: function componentDidMount(nextProps) {
            if (!this.props.children) {
                return;
            }

            this.setupThumbs();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props, state) {
            if (props.selectedItem !== this.state.selectedItem) {
                this.setState({
                    selectedItem: props.selectedItem,
                    firstItem: this.getFirstItem(props.selectedItem)
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.children && this.props.children && !this.state.initialized) {
                this.setupThumbs();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.destroyThumbs();
        }
    }, {
        key: 'setupThumbs',
        value: function setupThumbs() {
            // as the widths are calculated, we need to resize
            // the carousel when the window is resized
            window.addEventListener("resize", this.updateSizes);
            // issue #2 - image loading smaller
            window.addEventListener("DOMContentLoaded", this.updateSizes);

            var images = this.getImages();

            if (!images) {
                return;
            }

            this.setState({
                initialized: true,
                images: images
            });

            // when the component is rendered we need to calculate
            // the container size to adjust the responsive behaviour
            this.updateSizes();
        }
    }, {
        key: 'destroyThumbs',
        value: function destroyThumbs() {
            // removing listeners
            window.removeEventListener("resize", this.updateSizes);
            window.removeEventListener("DOMContentLoaded", this.updateSizes);
        }
    }, {
        key: 'getImages',
        value: function getImages() {
            var images = _react2.default.Children.map(this.props.children, function (item, index) {
                var img = item;

                // if the item is not an image, try to find the first image in the item's children.
                if (item.type !== "img") {
                    img = _react2.default.Children.toArray(item.props.children).filter(function (children) {
                        return children.type === "img";
                    })[0];
                }

                if (!img || img.length === 0) {
                    return null;
                }

                return img;
            });

            if (images.filter(function (image) {
                return image !== null;
            }).length === 0) {
                console.warn('No images found! Can\'t build the thumb list without images. If you don\'t need thumbs, set showThumbs={false} in the Carousel. Note that it\'s not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md');

                return null;
            }

            return images;
        }
    }, {
        key: 'getFirstItem',
        value: function getFirstItem(selectedItem) {
            if (!this.showArrows) {
                return 0;
            }

            var firstItem = selectedItem;

            if (selectedItem >= this.lastPosition) {
                firstItem = this.lastPosition;
            }

            if (selectedItem < this.state.firstItem + this.visibleItems) {
                firstItem = this.state.firstItem;
            }

            if (selectedItem < this.state.firstItem) {
                firstItem = selectedItem;
            }

            return firstItem;
        }
    }, {
        key: 'renderItems',
        value: function renderItems() {
            var _this2 = this;

            return this.state.images.map(function (img, index) {
                var itemClass = _cssClasses2.default.ITEM(false, index === _this2.state.selectedItem && _this2.state.hasMount);

                var thumbProps = {
                    key: index,
                    ref: 'thumb' + index,
                    className: itemClass,
                    onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index])
                };

                if (index === 0) {
                    img = _react2.default.cloneElement(img, {
                        onLoad: _this2.setMountState
                    });
                }

                return _react2.default.createElement(
                    'li',
                    thumbProps,
                    img
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.children || this.state.images.length === 0) {
                return null;
            }

            // show left arrow?
            var hasPrev = this.showArrows && this.state.firstItem > 0;
            // show right arrow
            var hasNext = this.showArrows && this.state.firstItem < this.lastPosition;
            // obj to hold the transformations and styles
            var itemListStyles = {};

            var currentPosition = -this.state.firstItem * this.itemSize + 'px';

            var transformProp = (0, _CSSTranslate2.default)(currentPosition, this.props.axis);

            var transitionTime = this.props.transitionTime + 'ms';

            itemListStyles = {
                'WebkitTransform': transformProp,
                'MozTransform': transformProp,
                'MsTransform': transformProp,
                'OTransform': transformProp,
                'transform': transformProp,
                'msTransform': transformProp,
                'WebkitTransitionDuration': transitionTime,
                'MozTransitionDuration': transitionTime,
                'MsTransitionDuration': transitionTime,
                'OTransitionDuration': transitionTime,
                'transitionDuration': transitionTime,
                'msTransitionDuration': transitionTime
            };

            return _react2.default.createElement(
                'div',
                { className: _cssClasses2.default.CAROUSEL(false) },
                _react2.default.createElement(
                    'div',
                    { className: _cssClasses2.default.WRAPPER(false), ref: function ref(node) {
                            return _this3.itemsWrapper = node;
                        } },
                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.slideRight }),
                    _react2.default.createElement(
                        _reactEasySwipe2.default,
                        { tagName: 'ul',
                            selectedItem: this.state.selectedItem,
                            className: _cssClasses2.default.SLIDER(false, this.state.swiping),
                            onSwipeLeft: this.slideLeft,
                            onSwipeRight: this.slideRight,
                            onSwipeMove: this.onSwipeMove,
                            onSwipeStart: this.onSwipeStart,
                            onSwipeEnd: this.onSwipeEnd,
                            style: itemListStyles,
                            ref: function ref(node) {
                                return _this3.itemList = node;
                            } },
                        this.renderItems()
                    ),
                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.slideLeft })
                )
            );
        }
    }]);

    return Thumbs;
}(_react.Component);

Thumbs.displayName = 'Thumbs';
Thumbs.propsTypes = {
    children: _propTypes2.default.element.isRequired,
    transitionTime: _propTypes2.default.number,
    selectedItem: _propTypes2.default.number
};
Thumbs.defaultProps = {
    selectedItem: 0,
    transitionTime: 350,
    axis: 'horizontal'
};
exports.default = Thumbs;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var supportsPassiveOption = function () {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('test', null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();

    target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

module.exports = addPassiveEventListener;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addPassiveEventListener = __webpack_require__(302);

var eventThrottler = function eventThrottler(eventHandler) {
  var eventHandlerTimeout;
  return function (event) {
    // ignore events as long as an eventHandler execution is in the queue
    if (!eventHandlerTimeout) {
      eventHandlerTimeout = setTimeout(function () {
        eventHandlerTimeout = null;
        eventHandler(event);
        // The eventHandler will execute at a rate of 15fps
      }, 66);
    }
  };
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    var t = this;
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        t.scrollHandler(scrollSpyContainer);
      });
      this.scrollSpyContainers.push(scrollSpyContainer);
      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
    }
  },

  isMounted: function isMounted(scrollSpyContainer) {
    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },

  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },

  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
    if (callbacks) {
      for (var i = 0; i < callbacks.length; i++) {
        var position = this.currentPositionY(scrollSpyContainer);
        callbacks[i](this.currentPositionY(scrollSpyContainer));
      }
    }
  },

  addStateHandler: function addStateHandler(handler) {
    this.spySetState.push(handler);
  },

  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }
    container.spyCallbacks.push(handler);
  },

  updateStates: function updateStates() {
    var length = this.spySetState.length;

    for (var i = 0; i < length; i++) {
      this.spySetState[i]();
    }
  },

  unmount: function unmount(stateHandler, spyHandler) {
    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
      if (callbacks && callbacks.length) {
        callbacks.splice(callbacks.indexOf(spyHandler), 1);
      }
    }

    if (this.spySetState && this.spySetState.length) {
      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', this.scrollHandler);
  },

  update: function update() {
    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
      this.scrollHandler(this.scrollSpyContainers[i]);
    }
  }
};

module.exports = scrollSpy;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(194);

var animateScroll = __webpack_require__(193);
var events = __webpack_require__(195);

var __mapped = {};
var __activeLink;

module.exports = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name);
  },

  setActiveLink: function setActiveLink(link) {
    __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    /*
    * get the mapped DOM element
    */

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = assign({}, props, { absolute: false });

    if (events.registered['begin']) {
      events.registered['begin'](to, target);
    }

    var containerId = props.containerId;
    var container = props.container;

    var containerElement;

    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = null;
    }

    var scrollOffset;

    if ((containerId || container) && containerElement) {
      props.absolute = true;
      if (containerElement !== target.offsetParent) {
        if (!containerElement.contains(target)) {
          throw new Error('Container with ID ' + (containerId || container) + ' is not a parent of target ' + to);
        } else {
          throw new Error('Container with ID ' + (containerId || container) + ' is not a positioned element');
        }
      }

      scrollOffset = target.offsetTop;
    } else {
      var coordinates = target.getBoundingClientRect();
      scrollOffset = coordinates.top;
    }

    scrollOffset += props.offset || 0;

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if ((containerId || container) && containerElement) {
        containerElement.scrollTop = scrollOffset;
      } else {
        // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
        var bodyRect = document.body.getBoundingClientRect();
        window.scrollTo(0, scrollOffset - bodyRect.top);
      }

      if (events.registered['end']) {
        events.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    animateScroll.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flap = function (_React$Component) {
  _inherits(Flap, _React$Component);

  function Flap(props) {
    _classCallCheck(this, Flap);

    var _this = _possibleConstructorReturn(this, (Flap.__proto__ || Object.getPrototypeOf(Flap)).call(this, props));

    _this.state = { height: '0px ' };
    return _this;
  }

  _createClass(Flap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.updateState(this.props.open);
      setTimeout(function () {
        return _this2.updateState(_this2.props.open);
      }, 800);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var open = nextProps.open;

      this.updateState(open);
    }
  }, {
    key: 'updateState',
    value: function updateState(open) {
      var _this3 = this;

      clearTimeout(this.timeout);
      this.setState({ height: !open ? '0' : this.getFlapHeight() });
      // remove maxHeight after css animation is done
      if (this.props.resetHeight) {
        this.timeout = setTimeout(function () {
          if (_this3.props.open) {
            _this3.setState({ height: '' });
          }
        }, 500);
      }
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(el) {
      this.wrapper = el;
    }
  }, {
    key: 'getFlapHeight',
    value: function getFlapHeight() {
      return this.wrapper ? this.wrapper.getBoundingClientRect().height + 'px' : '10000px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          children = _props.children,
          headline = _props.headline,
          onChange = _props.onChange,
          index = _props.index,
          open = _props.open;

      return _react2.default.createElement(
        'div',
        { className: open ? 'flap' : 'flap flap--collapsed' },
        _react2.default.createElement(
          'button',
          { className: 'flap__headline', onClick: function onClick() {
              return onChange ? onChange(index, open) : null;
            } },
          _react2.default.createElement(
            'h4',
            { className: 'headline headline--h4 ' },
            headline
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'flap__content', style: { maxHeight: this.state.height } },
          _react2.default.createElement(
            'div',
            { className: 'flap__content-inner', ref: function ref(el) {
                return _this4.setWrapperRef(el);
              } },
            children
          )
        )
      );
    }
  }]);

  return Flap;
}(_react2.default.Component);

exports.default = Flap;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _Icon = __webpack_require__(190);

var _Icon2 = _interopRequireDefault(_Icon);

var _HatchBuyButton = __webpack_require__(937);

var _HatchBuyButton2 = _interopRequireDefault(_HatchBuyButton);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _reactResponsive = __webpack_require__(121);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement('br', null);

var Product = function Product(_ref) {
  var data = _ref.data;
  return _react2.default.createElement(
    'div',
    { className: 'product-item' },
    _react2.default.createElement('h2', { className: 'headline headline--h2', dangerouslySetInnerHTML: { __html: data.headline } }),
    _react2.default.createElement(
      _reactResponsive2.default,
      { maxWidth: 767 },
      _react2.default.createElement(
        'div',
        { className: 'product-image-mobile' },
        _react2.default.createElement('img', { src: data.imageMedium, alt: '', className: 'product-image-mobile__img' })
      )
    ),
    _react2.default.createElement(
      'h3',
      { className: 'headline headline--h3' },
      _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: data.subheadline } }),
      _ref2,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.number', values: { number: data.id } })
    ),
    data.textblock_list && _react2.default.createElement(
      'ul',
      { className: 'list list--mb' },
      data.textblock_list.map(function (item, j) {
        return _react2.default.createElement(
          'li',
          { key: j },
          item.item
        );
      })
    ),
    _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.textblock_2nd_text }, className: 'text text--mbButtonsFollow' }),
    data.links.map(function (link, j) {
      return _react2.default.createElement(
        'span',
        { onClick: function onClick() {
            return _Tracking2.default.event(data.headline, link.track_action);
          }, key: j },
        _react2.default.createElement(
          'a',
          { target: '_blank', className: 'btn btn-block btn-primary button button--result ' + link.additionalClass, href: link.deeplink },
          link.icon && _react2.default.createElement(_Icon2.default, { name: link.icon }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: link.text, defaultMessage: link.text })
        )
      );
    }),
    _react2.default.createElement(_HatchBuyButton2.default, { data: data, additionalClass: '' })
  );
};

exports.default = Product;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Effect = undefined;

var _Modal = __webpack_require__(938);

var _loop = function _loop(_key2) {
  if (_key2 === "default") return 'continue';
  Object.defineProperty(exports, _key2, {
    enumerable: true,
    get: function get() {
      return _Modal[_key2];
    }
  });
};

for (var _key2 in _Modal) {
  var _ret = _loop(_key2);

  if (_ret === 'continue') continue;
}

var _Effect2 = __webpack_require__(950);

var _Effect = _interopRequireWildcard(_Effect2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Effect = exports.Effect = _Effect;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(942),
    isArguments = __webpack_require__(943),
    isArray = __webpack_require__(944);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(959),
    baseMatchesProperty = __webpack_require__(1020),
    identity = __webpack_require__(203),
    isArray = __webpack_require__(48),
    property = __webpack_require__(1030);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123),
    stackClear = __webpack_require__(966),
    stackDelete = __webpack_require__(967),
    stackGet = __webpack_require__(968),
    stackHas = __webpack_require__(969),
    stackSet = __webpack_require__(970);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObject = __webpack_require__(126);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 315 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(989),
    isObjectLike = __webpack_require__(71);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(318),
    arraySome = __webpack_require__(992),
    cacheHas = __webpack_require__(319);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(197),
    setCacheAdd = __webpack_require__(990),
    setCacheHas = __webpack_require__(991);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1006),
    isObjectLike = __webpack_require__(71);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(47),
    stubFalse = __webpack_require__(1007);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(322)(module)))

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1008),
    baseUnary = __webpack_require__(325),
    nodeUtil = __webpack_require__(1009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(126);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(329),
    toKey = __webpack_require__(130);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(48),
    isKey = __webpack_require__(201),
    stringToPath = __webpack_require__(1022),
    toString = __webpack_require__(1025);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(332);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(333);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1052);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1053);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: {
    products: []
  },
  configurator: {
    showResults: false,
    showScrollIndicator: false,
    lastQuestionId: '',
    questions: [],
    results: [
      /* shower systems 
      [{
        "products": ["30328001", "31498000"],
        "bundle": [""]
      }, {
        "products": ["29123000", "27746000"],
        "bundle": ["27704000", "27704000","26458000","27704000"]
      }, {
        "products": ["29123000", "27732000"],
        "bundle": ["26458000","27732000", "27704000"]
      }, {
        "products": ["29123000", "27734000","26458000","26073000"],
        "bundle": []
      }, {
        "products": ["29123000"],
        "bundle": ["35600000", "27704000"]
      }, {
        "products": ["29123000", "27700000"],
        "bundle": ["35600000" ]
      }]
      water systems */
      /*[{
        "products": ["30341DC1"],
        "bundle": ["30341001"]
      },{
        "products": ["30329001"],
        "bundle": ["30328DC1"]        
      }]*/
    ]
  }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
module.exports = __webpack_require__(537);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(337);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(152);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(223);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(226);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
module.exports = __webpack_require__(35);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(12);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var META = __webpack_require__(49).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(99);
var setToStringTag = __webpack_require__(72);
var uid = __webpack_require__(56);
var wks = __webpack_require__(10);
var wksExt = __webpack_require__(206);
var wksDefine = __webpack_require__(132);
var enumKeys = __webpack_require__(338);
var isArray = __webpack_require__(102);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(36);
var createDesc = __webpack_require__(55);
var _create = __webpack_require__(60);
var gOPNExt = __webpack_require__(209);
var $GOPD = __webpack_require__(27);
var $DP = __webpack_require__(13);
var $keys = __webpack_require__(58);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(61).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(88).f = $propertyIsEnumerable;
  __webpack_require__(101).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(57)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(58);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(88);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(60) });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(13).f });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(208) });


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(39)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(16);
var $getPrototypeOf = __webpack_require__(28);

__webpack_require__(39)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16);
var $keys = __webpack_require__(58);

__webpack_require__(39)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(39)('getOwnPropertyNames', function () {
  return __webpack_require__(209).f;
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(39)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(39)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(49).onFreeze;

__webpack_require__(39)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(39)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(39)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(39)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(210) });


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(354) });


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(136).set });


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(89);
var test = {};
test[__webpack_require__(10)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(22)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(211) });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(28);
var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(13).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(213);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(214);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(25);
var cof = __webpack_require__(31);
var inheritIfRequired = __webpack_require__(138);
var toPrimitive = __webpack_require__(36);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(61).f;
var gOPD = __webpack_require__(27).f;
var dP = __webpack_require__(13).f;
var $trim = __webpack_require__(73).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(60)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(22)(global, NUMBER, $Number);
}


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(38);
var aNumberValue = __webpack_require__(215);
var repeat = __webpack_require__(139);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(215);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(216) });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(216);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(214);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(213);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(217);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(140);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(141);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(218) });


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(217) });


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(140) });


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(141);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(141);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(59);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(14);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(73)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(142)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(143)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(142)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(14);
var context = __webpack_require__(145);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(146)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(145);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(146)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(139)
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(14);
var context = __webpack_require__(145);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(146)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(23)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(23)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(23)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(23)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(23)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(23)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(23)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(23)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(23)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(23)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(23)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(23)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(23)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(36);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(416);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(22)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(21)(proto, TO_PRIMITIVE, __webpack_require__(419));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(36);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(102) });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(30);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var call = __webpack_require__(219);
var isArrayIter = __webpack_require__(147);
var toLength = __webpack_require__(14);
var createProperty = __webpack_require__(148);
var getIterFn = __webpack_require__(149);

$export($export.S + $export.F * !__webpack_require__(104)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(148);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(87) != Object || !__webpack_require__(32)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(135);
var cof = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(59);
var toLength = __webpack_require__(14);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(16);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(32)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(40)(0);
var STRICT = __webpack_require__(32)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(102);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(40)(1);

$export($export.P + $export.F * !__webpack_require__(32)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(40)(2);

$export($export.P + $export.F * !__webpack_require__(32)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(40)(3);

$export($export.P + $export.F * !__webpack_require__(32)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(40)(4);

$export($export.P + $export.F * !__webpack_require__(32)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(220);

$export($export.P + $export.F * !__webpack_require__(32)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(220);

$export($export.P + $export.F * !__webpack_require__(32)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(100)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(32)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toInteger = __webpack_require__(38);
var toLength = __webpack_require__(14);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(32)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(221) });

__webpack_require__(50)('copyWithin');


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(151) });

__webpack_require__(50)('fill');


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(40)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(50)(KEY);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(40)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(50)(KEY);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('Array');


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(138);
var dP = __webpack_require__(13).f;
var gOPN = __webpack_require__(61).f;
var isRegExp = __webpack_require__(103);
var $flags = __webpack_require__(105);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(10)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(22)(global, 'RegExp', $RegExp);
}

__webpack_require__(62)('RegExp');


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(223);
var anObject = __webpack_require__(4);
var $flags = __webpack_require__(105);
var DESCRIPTORS = __webpack_require__(12);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(22)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(106)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(106)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(106)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(106)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(103);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(57);
var global = __webpack_require__(5);
var ctx = __webpack_require__(30);
var classof = __webpack_require__(89);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(63);
var forOf = __webpack_require__(64);
var speciesConstructor = __webpack_require__(107);
var task = __webpack_require__(153).set;
var microtask = __webpack_require__(154)();
var newPromiseCapabilityModule = __webpack_require__(155);
var perform = __webpack_require__(224);
var promiseResolve = __webpack_require__(225);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(65)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(72)($Promise, PROMISE);
__webpack_require__(62)(PROMISE);
Wrapper = __webpack_require__(35)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(104)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(230);
var validate = __webpack_require__(75);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(108)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(109);
var buffer = __webpack_require__(156);
var anObject = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(59);
var toLength = __webpack_require__(14);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(107);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(62)(ARRAY_BUFFER);


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(109).ABV, {
  DataView: __webpack_require__(156).DataView
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(60);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(211);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(13);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(36);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(27).f;
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(144)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(27);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(28);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(232) });


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(13);
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(55);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(136);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(100)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(50)('includes');


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(233);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(14);
var aFunction = __webpack_require__(19);
var arraySpeciesCreate = __webpack_require__(150);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(50)('flatMap');


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(233);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(14);
var toInteger = __webpack_require__(38);
var arraySpeciesCreate = __webpack_require__(150);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(50)('flatten');


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(142)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(234);
var userAgent = __webpack_require__(157);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(234);
var userAgent = __webpack_require__(157);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(73)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(73)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(37);
var toLength = __webpack_require__(14);
var isRegExp = __webpack_require__(103);
var getFlags = __webpack_require__(105);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(144)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132)('asyncIterator');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132)('observable');


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(232);
var toIObject = __webpack_require__(26);
var gOPD = __webpack_require__(27);
var createProperty = __webpack_require__(148);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(235)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(235)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(13);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(110), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(13);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(110), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(110), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(110), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(236)('Map') });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(236)('Set') });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(111)('Map');


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(111)('Set');


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(111)('WeakMap');


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(111)('WeakSet');


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(112)('Map');


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(112)('Set');


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(112)('WeakMap');


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(112)('WeakSet');


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(31);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(238);
var fround = __webpack_require__(218);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(238) });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(35);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(107);
var promiseResolve = __webpack_require__(225);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(155);
var perform = __webpack_require__(224);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(228);
var from = __webpack_require__(237);
var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(43);
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(19);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(154)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(31)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(35);
var microtask = __webpack_require__(154)();
var OBSERVABLE = __webpack_require__(10)('observable');
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(4);
var anInstance = __webpack_require__(63);
var redefineAll = __webpack_require__(65);
var hide = __webpack_require__(21);
var forOf = __webpack_require__(64);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(62)('Observable');


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(157);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(153);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(152);
var getKeys = __webpack_require__(58);
var redefine = __webpack_require__(22);
var global = __webpack_require__(5);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(74);
var wks = __webpack_require__(10);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(535);
module.exports = __webpack_require__(35).RegExp.escape;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(536)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(204);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactRouter = __webpack_require__(51);

var _reactHotLoader = __webpack_require__(657);

var _Root = __webpack_require__(661);

var _Root2 = _interopRequireDefault(_Root);

var _configureStore = __webpack_require__(1045);

var _configureStore2 = _interopRequireDefault(_configureStore);

__webpack_require__(1075);

__webpack_require__(1076);

var _reactRouterRedux = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1077); // Tell webpack to load favicon.ico

// Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.


var store = (0, _configureStore2.default)();

// Create an enhanced history that syncs navigation events with the store
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

if (!global.Intl) {
  global.Intl = __webpack_require__(1078);
}

(0, _reactDom.render)(_react2.default.createElement(
  _reactHotLoader.AppContainer,
  null,
  _react2.default.createElement(_Root2.default, { store: store, history: history })
), document.getElementById('app'));

if (false) {

  module.hot.accept('./components/Root', function () {
    var NewRoot = require('./components/Root').default;
    (0, _reactDom.render)(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(NewRoot, { store: store, history: history })
    ), document.getElementById('app'));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(539);
var ReactElement = __webpack_require__(78);

var emptyFunction = __webpack_require__(24);
var traverseAllChildren = __webpack_require__(540);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(77);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(77);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(240);

var getIteratorFn = __webpack_require__(541);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(542);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactComponent = __webpack_require__(158);
var ReactNoopUpdateQueue = __webpack_require__(159);

var emptyObject = __webpack_require__(79);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(77),
    _assign = __webpack_require__(11);

var ReactComponent = __webpack_require__(158);
var ReactElement = __webpack_require__(78);
var ReactPropTypeLocationNames = __webpack_require__(545);
var ReactNoopUpdateQueue = __webpack_require__(159);

var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

var didWarnDeprecated = false;

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
      didWarnDeprecated = true;
    }

    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(78);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(78),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(548);

module.exports = factory(isValidElement);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(549);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(24);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(241);
var checkPropTypes = __webpack_require__(550);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(77);

var ReactElement = __webpack_require__(78);

var invariant = __webpack_require__(2);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(15);
var ReactDefaultInjection = __webpack_require__(554);
var ReactMount = __webpack_require__(264);
var ReactReconciler = __webpack_require__(81);
var ReactUpdates = __webpack_require__(41);
var ReactVersion = __webpack_require__(630);

var findDOMNode = __webpack_require__(631);
var getHostComponentFromComposite = __webpack_require__(265);
var renderSubtreeIntoContainer = __webpack_require__(632);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(555);
var BeforeInputEventPlugin = __webpack_require__(556);
var ChangeEventPlugin = __webpack_require__(560);
var DefaultEventPluginOrder = __webpack_require__(563);
var EnterLeaveEventPlugin = __webpack_require__(564);
var HTMLDOMPropertyConfig = __webpack_require__(565);
var ReactComponentBrowserEnvironment = __webpack_require__(566);
var ReactDOMComponent = __webpack_require__(572);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMEmptyComponent = __webpack_require__(601);
var ReactDOMTreeTraversal = __webpack_require__(602);
var ReactDOMTextComponent = __webpack_require__(603);
var ReactDefaultBatchingStrategy = __webpack_require__(604);
var ReactEventListener = __webpack_require__(605);
var ReactInjection = __webpack_require__(607);
var ReactReconcileTransaction = __webpack_require__(608);
var SVGDOMPropertyConfig = __webpack_require__(614);
var SelectEventPlugin = __webpack_require__(615);
var SimpleEventPlugin = __webpack_require__(616);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(91);
var ExecutionEnvironment = __webpack_require__(20);
var FallbackCompositionState = __webpack_require__(557);
var SyntheticCompositionEvent = __webpack_require__(558);
var SyntheticInputEvent = __webpack_require__(559);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(66);

var getTextContentAccessor = __webpack_require__(245);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(92);
var EventPropagators = __webpack_require__(91);
var ExecutionEnvironment = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);
var SyntheticEvent = __webpack_require__(45);

var getEventTarget = __webpack_require__(163);
var isEventSupported = __webpack_require__(164);
var isTextInputElement = __webpack_require__(248);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(562);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticMouseEvent = __webpack_require__(114);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(80);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(166);
var ReactDOMIDOperations = __webpack_require__(571);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(82);
var ExecutionEnvironment = __webpack_require__(20);

var createNodesFromMarkup = __webpack_require__(568);
var emptyFunction = __webpack_require__(24);
var invariant = __webpack_require__(2);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(20);

var createArrayFromMixed = __webpack_require__(569);
var getMarkupWrap = __webpack_require__(570);
var invariant = __webpack_require__(2);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(2);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(20);

var invariant = __webpack_require__(2);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(166);
var ReactDOMComponentTree = __webpack_require__(15);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var AutoFocusUtils = __webpack_require__(573);
var CSSPropertyOperations = __webpack_require__(574);
var DOMLazyTree = __webpack_require__(82);
var DOMNamespaces = __webpack_require__(167);
var DOMProperty = __webpack_require__(80);
var DOMPropertyOperations = __webpack_require__(253);
var EventPluginHub = __webpack_require__(92);
var EventPluginRegistry = __webpack_require__(160);
var ReactBrowserEventEmitter = __webpack_require__(117);
var ReactDOMComponentFlags = __webpack_require__(242);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMInput = __webpack_require__(584);
var ReactDOMOption = __webpack_require__(590);
var ReactDOMSelect = __webpack_require__(254);
var ReactDOMTextarea = __webpack_require__(591);
var ReactInstrumentation = __webpack_require__(33);
var ReactMultiChild = __webpack_require__(592);
var ReactServerRenderingTransaction = __webpack_require__(599);

var emptyFunction = __webpack_require__(24);
var escapeTextContentForBrowser = __webpack_require__(116);
var invariant = __webpack_require__(2);
var isEventSupported = __webpack_require__(164);
var shallowEqual = __webpack_require__(171);
var validateDOMNesting = __webpack_require__(175);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(15);

var focusNode = __webpack_require__(251);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(252);
var ExecutionEnvironment = __webpack_require__(20);
var ReactInstrumentation = __webpack_require__(33);

var camelizeStyleName = __webpack_require__(575);
var dangerousStyleValue = __webpack_require__(577);
var hyphenateStyleName = __webpack_require__(578);
var memoizeStringOnly = __webpack_require__(580);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(576);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(252);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(579);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(116);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(92);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMPropertyOperations = __webpack_require__(253);
var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        // eslint-disable-next-line
        if (value != valueAsNumber) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
        // eslint-disable-next-line
      } else if (value != node.value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(587);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(24);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(588);
var checkPropTypes = __webpack_require__(589);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var React = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMSelect = __webpack_require__(254);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactComponentEnvironment = __webpack_require__(170);
var ReactInstanceMap = __webpack_require__(94);
var ReactInstrumentation = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(44);
var ReactReconciler = __webpack_require__(81);
var ReactChildReconciler = __webpack_require__(593);

var emptyFunction = __webpack_require__(24);
var flattenChildren = __webpack_require__(598);
var invariant = __webpack_require__(2);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(81);

var instantiateReactComponent = __webpack_require__(255);
var KeyEscapeUtils = __webpack_require__(173);
var shouldUpdateReactComponent = __webpack_require__(172);
var traverseAllChildren = __webpack_require__(259);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(260);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var React = __webpack_require__(76);
var ReactComponentEnvironment = __webpack_require__(170);
var ReactCurrentOwner = __webpack_require__(44);
var ReactErrorUtils = __webpack_require__(162);
var ReactInstanceMap = __webpack_require__(94);
var ReactInstrumentation = __webpack_require__(33);
var ReactNodeTypes = __webpack_require__(256);
var ReactReconciler = __webpack_require__(81);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(2);
var shallowEqual = __webpack_require__(171);
var shouldUpdateReactComponent = __webpack_require__(172);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(173);
var traverseAllChildren = __webpack_require__(259);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(260);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(66);
var Transaction = __webpack_require__(113);
var ReactInstrumentation = __webpack_require__(33);
var ReactServerUpdateQueue = __webpack_require__(600);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(174);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(15);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMChildrenOperations = __webpack_require__(166);
var DOMLazyTree = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(15);

var escapeTextContentForBrowser = __webpack_require__(116);
var invariant = __webpack_require__(2);
var validateDOMNesting = __webpack_require__(175);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactUpdates = __webpack_require__(41);
var Transaction = __webpack_require__(113);

var emptyFunction = __webpack_require__(24);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventListener = __webpack_require__(261);
var ExecutionEnvironment = __webpack_require__(20);
var PooledClass = __webpack_require__(66);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var getEventTarget = __webpack_require__(163);
var getUnboundedScrollPosition = __webpack_require__(606);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(80);
var EventPluginHub = __webpack_require__(92);
var EventPluginUtils = __webpack_require__(161);
var ReactComponentEnvironment = __webpack_require__(170);
var ReactEmptyComponent = __webpack_require__(257);
var ReactBrowserEventEmitter = __webpack_require__(117);
var ReactHostComponent = __webpack_require__(258);
var ReactUpdates = __webpack_require__(41);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(246);
var PooledClass = __webpack_require__(66);
var ReactBrowserEventEmitter = __webpack_require__(117);
var ReactInputSelection = __webpack_require__(262);
var ReactInstrumentation = __webpack_require__(33);
var Transaction = __webpack_require__(113);
var ReactUpdateQueue = __webpack_require__(174);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(20);

var getNodeForCharacterOffset = __webpack_require__(610);
var getTextContentAccessor = __webpack_require__(245);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(612);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(613);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(91);
var ExecutionEnvironment = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInputSelection = __webpack_require__(262);
var SyntheticEvent = __webpack_require__(45);

var getActiveElement = __webpack_require__(263);
var isTextInputElement = __webpack_require__(248);
var shallowEqual = __webpack_require__(171);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var EventListener = __webpack_require__(261);
var EventPropagators = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticAnimationEvent = __webpack_require__(617);
var SyntheticClipboardEvent = __webpack_require__(618);
var SyntheticEvent = __webpack_require__(45);
var SyntheticFocusEvent = __webpack_require__(619);
var SyntheticKeyboardEvent = __webpack_require__(620);
var SyntheticMouseEvent = __webpack_require__(114);
var SyntheticDragEvent = __webpack_require__(622);
var SyntheticTouchEvent = __webpack_require__(623);
var SyntheticTransitionEvent = __webpack_require__(624);
var SyntheticUIEvent = __webpack_require__(93);
var SyntheticWheelEvent = __webpack_require__(625);

var emptyFunction = __webpack_require__(24);
var getEventCharCode = __webpack_require__(176);
var invariant = __webpack_require__(2);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(93);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(93);

var getEventCharCode = __webpack_require__(176);
var getEventKey = __webpack_require__(621);
var getEventModifierState = __webpack_require__(165);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(176);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(114);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(93);

var getEventModifierState = __webpack_require__(165);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(114);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(175);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(629);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstanceMap = __webpack_require__(94);

var getHostComponentFromComposite = __webpack_require__(265);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(264);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */](history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

    return __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */](history, __WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */](routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */](_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(635);

var emptyObject = __webpack_require__(79);
var _invariant = __webpack_require__(2);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(24);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(241);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(84);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */](route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(177);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(84);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */](pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(267);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */](nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](indexRoute)[0]);
    });

    if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */](pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(84);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */](route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(269);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default.a({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(180);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
    displayName: 'WithRouter',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */]('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default.a(WithRouter, WrappedComponent);
}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(95);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(95);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */](element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(95);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(268);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(false) : void 0;

  history = history ? history : __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */](options);
  var transitionManager = __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */](history, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */](history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(650);
var objectAssign = __webpack_require__(11);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(277);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(185);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(67);

var _PathUtils = __webpack_require__(54);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(277);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(185);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(67);

var _DOMUtils = __webpack_require__(97);

var _DOMStateStorage = __webpack_require__(276);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(658);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AppContainer = __webpack_require__(659);

module.exports = function warnAboutIncorrectUsage(arg) {
  if (this && this.callback) {
    throw new Error('React Hot Loader: The Webpack loader is now exported separately. ' + 'If you use Babel, we recommend that you remove "react-hot-loader" ' + 'from the "loaders" section of your Webpack configuration altogether, ' + 'and instead add "react-hot-loader/babel" to the "plugins" section ' + 'of your .babelrc file. ' + 'If you prefer not to use Babel, replace "react-hot-loader" or ' + '"react-hot" with "react-hot-loader/webpack" in the "loaders" section ' + 'of your Webpack configuration.');
  } else if (arg && arg.types && arg.types.IfStatement) {
    throw new Error('React Hot Loader: The Babel plugin is exported separately. ' + 'Replace "react-hot-loader" with "react-hot-loader/babel" ' + 'in the "plugins" section of your .babelrc file. ' + 'While we recommend the above, if you prefer not to use Babel, ' + 'you may remove "react-hot-loader" from the "plugins" section of ' + 'your .babelrc file altogether, and instead add ' + '"react-hot-loader/webpack" to the "loaders" section of your Webpack ' + 'configuration.');
  } else {
    throw new Error('React Hot Loader does not have a default export. ' + 'If you use the import statement, make sure to include the ' + 'curly braces: import { AppContainer } from "react-hot-loader". ' + 'If you use CommonJS, make sure to read the named export: ' + 'require("react-hot-loader").AppContainer.');
  }
};

module.exports.AppContainer = AppContainer;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(660);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(68);

var _routes = __webpack_require__(685);

var _routes2 = _interopRequireDefault(_routes);

var _reactRouter = __webpack_require__(51);

var _reactIntl = __webpack_require__(18);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import i18n messages


var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    _classCallCheck(this, Root);

    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
  }

  _createClass(Root, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history;

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          _reactIntl.IntlProvider,
          { locale: _i18n.lang, key: _i18n.lang, messages: _i18n.translationMessages.current },
          _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default })
        )
      );
    }
  }]);

  return Root;
}(_react.Component);

exports.default = Root;

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(186);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */]('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(683);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(285);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"](mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(671);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */](value)
    : __WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */](value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(669);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(282);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(673);


/** Built-in value references. */
var getPrototype = __WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */](Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(677);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */](root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29), __webpack_require__(676)(module)))

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(283);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */](inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(284);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(285);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(286);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(684);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(186);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */]('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(51);

var _App = __webpack_require__(686);

var _App2 = _interopRequireDefault(_App);

var _Start = __webpack_require__(913);

var _Start2 = _interopRequireDefault(_Start);

var _ConfiguratorPage = __webpack_require__(918);

var _ConfiguratorPage2 = _interopRequireDefault(_ConfiguratorPage);

var _ResultPage = __webpack_require__(934);

var _ResultPage2 = _interopRequireDefault(_ResultPage);

var _NotFoundPage = __webpack_require__(1042);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _history = __webpack_require__(1043);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basepath = '/lv_lv/watersystems/';

var history = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
  basename: basepath
});

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { onChange: function onChange() {
      return window.scrollTo(0, 0);
    }, history: history, path: basepath, component: _App2.default },
  _react2.default.createElement(_reactRouter.IndexRoute, { component: _Start2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'configurator(/:reset)', component: _ConfiguratorPage2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'result', component: _ResultPage2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFoundPage2.default })
);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _header = __webpack_require__(687);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(707);

var _footer2 = _interopRequireDefault(_footer);

var _reactRedux = __webpack_require__(68);

var _redux = __webpack_require__(85);

var _actions = __webpack_require__(98);

var _configuratorType = __webpack_require__(289);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line


var questions = function () {
  try {
    return __webpack_require__(188)("./" + _i18n.configuratorType + '_questions' + (_i18n.locale ? '_' + _i18n.locale : '') + '.json');
  } catch (error) {
    return __webpack_require__(911)("./" + _i18n.configuratorType + '_questions.json');
    console.warn('Warning: using default questions config.', error); // eslint-disable-line no-console
  }
}();

var products = function () {
  try {
    return __webpack_require__(188)("./" + _i18n.configuratorType + '_products' + (_i18n.locale ? '_' + _i18n.locale : '') + '.json');
  } catch (error) {
    console.log('error: ', error); // eslint-disable-line no-console
    return __webpack_require__(912)("./" + _i18n.configuratorType + '_products_en_gb.json');
  }
}();

var _ref = _react2.default.createElement(_header2.default, null);

var _ref2 = _react2.default.createElement(_footer2.default, null);

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.loadInitialState();

    return _this;
  }

  _createClass(App, [{
    key: 'loadInitialState',
    value: function loadInitialState() {
      /* this became commented due to approval server 401 / basic auth probelmatic with ajax.
         Until this is fixed (eg. by using aws only) we should reuse it.
       const _loadQuestions = () => {
        return fetch('/lv_lv/watersystems/data/shower_questions.json')
          .then((response) => {
            return response.json();
          });
      };
       const _loadProducts = () => {
        return fetch('/lv_lv/watersystems/data/shower_products.json')
          .then((response) => {
            return response.json();
          });
      };
       _loadQuestions()
        .then((questions) => {
          this.props.actions.initState(
            questions
          );
        });
      
      _loadProducts().then((products) => {
        this.props.actions.initData({products});
       });
      */
      var _props = this.props,
          initData = _props.initData,
          initState = _props.initState;


      initState(questions);
      initData({ products: products });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _ref,
        _react2.default.createElement(
          'main',
          { className: 'main' },
          this.props.children
        ),
        _ref2
      );
    }
  }]);

  return App;
}(_react2.default.Component);

function mapStateToProps(state) {
  return {
    data: state.data,
    configurator: state.configurator
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ initState: _actions.initState, initData: _actions.initData }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(51);

var _reactIntl = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement(
  'svg',
  { className: 'logo', width: '170', height: '66', viewBox: '0 0 170 66', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', { fill: '#0F243F', d: 'M0 65.768h85.404V.124H0' }),
    _react2.default.createElement('path', { d: 'M73.066 36.776c-1.06.172-1.65.234-2.232.234-1.39 0-3.38-.404-5.466-1.108l-3.126-1.057c-1.656-.56-4.118-1.017-5.47-1.017-1.34 0-3.81.46-5.46 1.017l-3.125 1.057c-2.085.704-4.077 1.108-5.47 1.108-1.39 0-3.383-.404-5.467-1.108l-3.127-1.057c-1.65-.558-4.12-1.018-5.462-1.017-1.348 0-3.813.46-5.465 1.017l-3.126 1.057c-2.087.704-4.077 1.108-5.468 1.108-.58 0-1.173-.062-2.232-.234l.13.217c.3.5.46.715.865 1.18.548.076.768.092 1.207.092 1.395 0 3.674-.434 5.497-1.047l3.125-1.052c2.12-.715 4.066-1.11 5.467-1.11 1.182 0 3.25.38 4.684.858l3.904 1.304c1.842.615 4.102 1.047 5.47 1.047 1.368 0 3.626-.432 5.467-1.047l3.903-1.304c1.435-.48 3.504-.857 4.685-.857 1.403 0 3.344.394 5.467 1.11l3.126 1.05c1.822.614 4.102 1.048 5.495 1.048.438 0 .66-.016 1.213-.09.437-.517.568-.697.86-1.182l.13-.217M68.403 41.162l-4.55-1.394c-2.047-.627-2.838-.846-3.93-1.086-1.154-.256-2.31-.404-3.15-.404-1.32 0-3.837.47-5.46 1.018l-3.126 1.057c-2.116.714-4.064 1.108-5.485 1.108-1.427 0-3.357-.39-5.483-1.107l-3.127-1.057c-1.62-.547-4.147-1.018-5.468-1.018-.832 0-2 .15-3.147.404-1.078.237-1.933.474-3.93 1.086l-4.545 1.394c.486.44.614.542 1.16.91l2.526-.767 2.088-.615.838-.247c2.22-.654 3.727-.935 5.012-.935 1.166 0 3.275.386 4.683.858l3.91 1.307c1.83.612 4.096 1.043 5.483 1.043 1.38 0 3.67-.435 5.484-1.043l3.903-1.307c1.402-.47 3.524-.858 4.685-.858 1.29 0 2.784.28 5.01.935l.84.247 2.088.615 2.53.766c.543-.37.672-.47 1.16-.908M63.31 44.115l-.287-.104-.78-.26c-2.27-.68-4.084-1.02-5.47-1.02-1.16 0-3.125.332-4.683.792l-.777.23c-.395.128-.658.215-.786.26l-.782.267-.776.263-.783.265c-2.374.765-4.064 1.108-5.47 1.108-1.208 0-3-.33-4.686-.862l-.78-.246-.782-.265-.777-.264-.78-.27-.787-.26c-2.264-.68-4.083-1.02-5.462-1.02-1.166 0-3.128.33-4.688.792l-.777.23c-.553.177-.668.217-1.07.363l1.573.814.352-.11c1.833-.563 3.41-.857 4.616-.857 1.012 0 2.595.257 3.898.632l.782.225.777.252.786.26.78.268.778.264.782.26c2.347.717 4.073 1.048 5.47 1.048 1.198 0 3.03-.32 4.685-.815l.782-.233.782-.26.775-.264.782-.27.786-.258.777-.252c1.994-.59 3.464-.858 4.685-.857 1.205 0 2.78.295 4.61.857l.353.11 1.572-.815M18.67 25.7v3.413c-.78.326-1.56.49-2.34.49-2.004 0-3.413-1.544-3.413-3.74 0-2.37 1.684-4.017 4.102-4.017 1.35 0 2.69.375 4.312 1.21v-2.27c-2.074-.845-3.098-1.084-4.63-1.084-4.232 0-6.935 2.387-6.935 6.124 0 3.556 2.623 5.92 6.566 5.92 1.76 0 3.843-.562 5.364-1.447v-4.6H18.67M24.206 20.034v11.382h2.98V22.18h1.284c1.684 0 2.44.537 2.44 1.73 0 1.22-.846 1.916-2.327 1.916l-.656-.017h-.334l4.138 5.606h3.81l-3.796-4.576c1.41-.634 2.16-1.76 2.16-3.24 0-2.41-1.566-3.566-4.835-3.566h-4.864M51.925 20.034v11.382h2.978V26.55h5.263v4.866h2.98V20.034h-2.98v4.208h-5.263v-4.208h-2.978M66.323 20.034v11.382h8.567v-2.23h-5.592V26.48h4.11v-2.143H69.3v-2.074h4.94v-2.23h-7.915M38.9 25.727c0-2.35 1.594-3.988 3.882-3.988 2.287 0 3.88 1.638 3.88 3.988 0 2.344-1.6 3.987-3.88 3.987-2.283 0-3.883-1.644-3.883-3.988zm-3.14 0c0 3.537 2.97 6.13 7.02 6.13 4.052 0 7.023-2.594 7.022-6.13 0-3.544-2.965-6.135-7.02-6.135-4.057 0-7.022 2.592-7.022 6.136z', fill: '#FFFFFE' }),
    _react2.default.createElement('path', { d: 'M165.726 28.05s-.483-.472-.483-1.245c0-.848.375-1.233.878-1.26.377-.023.834.17.834.744 0 .937-1.228 1.76-1.228 1.76zm-5.31.462c-.346.632-.78.98-1.217.98-.464 0-.602-.385-.61-.642-.035-1.063 1.205-2.27 1.934-2.27.375 0 .435.127.435.127-.048.565-.258 1.286-.543 1.805zm-13.9-2.57c.27-.318.63-.522.923-.522.12 0 .226.038.303.106.153.14.186.38.106.634-.174.545-.87 1.15-1.76 1.437-.16-.832.212-1.404.427-1.656zm22.89.772c-.034-.002-.106-.003-.106.015-.034.65-.882 2.235-2.174 2.235-.483 0-.74-.237-.737-.234l-.004-.002c.84-.757 1.496-1.697 1.448-2.918v-.003c0-.682-.46-1.552-1.505-1.552-1.277 0-2.113 1.156-2.113 2.664 0 1.078.495 1.72.495 1.72s-.368.21-.81.27c-.083.008-.164.014-.245.014-1.922-.024-1.536-3.194-1.536-3.194.506-1.703.672-2.825.672-3.562 0-.656-.153-1.42-.85-1.42-.64 0-1.157 1.148-1.157 3.147 0 .497.073 1.116.166 1.544 0 0-.12-.012-.22-.012-1.33.006-2.732 1.333-3.192 2.654-.437.484-.876.743-1.272.743-1.57 0-1.357-2.418-1.207-3.04-.042-.18-.228-.246-.392-.246-.25 0-.566.14-.706.452-.117.625-.363 1.296-.66 1.796-.372.632-.8.966-1.235.966-.142 0-.264-.06-.363-.18-.47-.562-.287-2.274-.214-2.682-.005-.25-.225-.428-.525-.428-.193 0-.394.074-.568.21-.11.078-.75 1.094-.823 1.206v.002c-.49.744-1.076 1.555-1.736 1.876-.175.08-.362.124-.543.124-.388 0-.778-.273-.906-.628 1.004-.398 1.61-1.074 1.906-1.52.38-.576.576-1.144.48-1.753-.087-.548-.603-.92-1.31-.92 0 0-.403-.004-.722.124-1.564.62-1.874 1.91-1.874 2.837 0 .415 0 .368.075.862-.968.186-2.058-.176-2.496-.494-.063.35 0 .65.186.893.29.38.862.597 1.57.597.294 0 .67-.058.96-.133.543.998 1.502 1.293 2.075 1.293 1.272 0 2.142-1.247 2.45-1.897 0 0 .126-.27.198-.356.066-.084.142-.142.223-.15.124-.01.147.067.147.067.023.042.004.247.005.247-.036.698.12 1.37.5 1.8.26.3.59.456.952.456 1.523-.002 2.37-1.798 2.37-1.798 0 .795.704 1.72 1.623 1.72.405 0 1.115-.158 1.708-.883.073 1.01.706 1.624 1.53 1.624.95 0 1.934-.957 2.506-2.437l.082-.212c.147 1.02.85 1.864 1.857 1.864.677.02 1.354-.193 1.968-.554 0 0 .63.75 2.112.615 1.44-.13 2.446-1.505 2.446-2.673 0-.35-.202-.744-.51-.756zM108.82 42.166c-.395.154-.723.896-1.01 1.55-.315.708-.585 1.32-.96 1.32-.164 0-.448-.087-.516-.663-.057-.49.078-1.174.322-1.754.298-.708.746-1.268 1.367-1.268.69 0 .888.778.888.778l-.09.036zm9.797 3.082c-.43-.812-.396-2.108-.388-2.257.05-.98-.39-1.648-1.132-1.648-.862 0-1.707.864-2.064 1.444l-.205.334.014-.39c.02-.562-.11-1.005-.38-1.282-.2-.206-.475-.32-.775-.32-.187 0-.37.046-.5.126-.637.386-.964 1.13-1.28 1.85-.055.125-.11.26-.167.4-.302.745-.645 1.588-1.275 1.588-.143 0-.263-.053-.357-.16-.338-.377-.273-1.36-.18-2.174.02-.158.036-.307.047-.444-.027-.13-.294-.354-.524-.398l-.014-.064c-.18-.772-.802-1.31-1.516-1.31-.223 0-.448.05-.668.15-.97.442-1.77 1.71-1.946 3.08-.152 1.192.042 2.26.508 2.787.298.337.703.456 1.192.35.324-.07.698-1.018.972-1.71.32-.806.483-1.195.703-1.195.082 0 .146.057.146.057l-.004.064c-.058.83.163 1.622.576 2.063.222.236.482.357.77.357.933 0 1.778-1.55 2.394-2.682.392-.722.606-1.1.79-1.14.103-.025.192.003.255.075.225.264.078 1.136-.027 1.77-.04.235-.072.57-.072.57-.03.536.015 1.098.448 1.263.087.033.22.05.376.05.112 0 .23-.008.315-.025.048-.01.05-.06.05-.075-.15-1.7.515-2.725.84-3.163.302-.408.61-.55.87-.55.655 0 .69.923.725 1.814.03.763.062 1.548.457 1.742.327.16.808-.094 1.004-.334.14-.168.163-.35.023-.614zm34.188-1.38c-.238-.33-.354-1.313-.065-1.88.16-.315.402-.51.69-.48.36.036.602.45.425 1.11-.14.516-.654 1.01-1.05 1.25zm-9.054 1.328c-.412.026-.822-.233-.967-.593-.182-.49-.032-.964.14-1.514.126-.4.255-.81.272-1.274l.005-.158c.742.232 1.553 1.384 1.626 2.246.05.537-.238 1.24-1.076 1.292zm-6.293-.003c-.097 0-.24-.038-.335-.234-.455-.95.295-2.834.295-2.834.515.01 1.29-.075 1.76-.214 0 0-.697 3.28-1.72 3.28zm24.272-1.006c-.024-.042-.068-.068-.133-.08-.25-.02-.377.19-.54.463-.03.052-.065.115-.1.182-.167.308-.493.81-.862.81-.403 0-.503-.504-.5-.94.004-.556.15-1.25.264-1.767.143-.64.277-1.244.16-1.515-.284-.668-1.127-.807-1.784-.807-.253 0-.477.02-.62.04l-.13.015-.004-.13c-.022-.715-.525-.976-.99-.98h-.01c-.405 0-.873.222-.906.625-.055.674.48.993.744 1.163.15.098.24.157.24.264-.006.514-.173 1.362-.532 2.1-.302.618-.854 1.354-1.707 1.354h-.008c-.687 0-1.016-.414-1.018-.418 0 0 1.672-.914 1.617-2.66-.03-.97-.62-1.526-1.505-1.526h-.002c-.45 0-.926.252-1.245.66-.695.886-.523 2.476-.13 3.268-.422.195-.97.344-.97.344.003.034 0-.014 0-.014-.162-2.962-2.28-4.294-2.912-4.294-.466 0-.56.506-.614.683-.196.64-.55 1.666-1.03 2.48-.356.6-.687.82-.687.82l-.01-.665c-.056-.815-.45-1.708-1.082-2.45-.6-.706-1.31-1.14-1.84-1.115 0 0-.416-.025-.593.276-.106.18-.052.49-.026.804.022.276.038.563.015.856-.12 1.5-.74 2.68-1.408 2.68-.706 0-.812-1.146-.782-1.613.03-.48.165-.875.24-1.036.04-.083.11-.182.11-.247-.014-.175-.357-.364-.478-.418l-.027-.013-.007-.03c-.116-.473-.552-.985-1.233-.985-.792 0-1.352.37-1.74.832-1.026-.1-1.403-.586-1.403-.586l.005-.04c.228-1.676-.15-3.34-.647-4.026-.26-.36-.94-.443-1.122.354-.22.96-.154 2.745.537 4.32v.006c-.004.424-.355 1.53-.87 2.502-.464.88-1.204 1.926-2.088 1.926-2.03 0-2.354-3.26-2.3-4.522.02-.52.083-1.008.178-1.43.198-.672.493-1.054.455-1.258-.074-.252-.704-.415-1.303-.165-.36.15-.67.734-.915 1.423-.217.572-.417 1.254-.618 1.904-.105.33-.2.672-.292 1.003-.36 1.294-.673 2.41-1.16 2.41-.07 0-.13-.035-.187-.094-.594-.615-.65-2.197-.383-4.007.283-1.914.745-3.327 1.172-4.453.374-.988.11-1.38-.52-1.43-.493-.04-.98.25-.96.492.083.903-.456 2.388-.77 4.6-.53 3.722.32 5.406.62 5.995.325.64.745.966 1.247.966.893 0 1.212-2 1.515-3.45.44-2.107.916-1.857.916-1.857s-.364 5.184 3.27 5.184c1.262 0 2.32-1.12 2.878-2.06.687-1.157 1.056-2.544 1.142-3.047.48.162 1.14.195 1.14.195l-.04.085c-.004.01-.455.997-.57 1.7-.07.34-.22 1.736.34 2.433.194.24.458.364.785.367h.005c.635 0 1.656-1.3 2.15-2.12l.177-.293.042.34c.09.735.586 1.526 1.458 1.526.067 0 .136-.005.206-.014.642-.085.916-.586 1.033-.992l.122-.422c.16 1.25 1.208 1.834 1.972 1.834 2.4 0 3.83-3.97 4-4.673.012-.047.06-.045.135-.007 1.466.73 2.194 2.01 1.73 2.947-.064.128-.61.186-1.132.096-.513-.09-.886-.3-1.093.072-.296.53.562 1.65 1.68 1.65 1.25 0 1.53-1.144 1.53-1.144s.83-.12 1.428-.423c.413.487.94.947 1.91.947.207 0 .424-.026.646-.078.834-.2 1.498-.875 1.976-2.01.262-.62.455-1.352.576-2.176l.01-.066.062-.026c.234-.097.475-.153.68-.15.636.006.66.446.66.446.02.447-.12.907-.252 1.352v.005c-.046.148-.092.3-.13.452l-.076.275c-.105.385-.204.75-.207 1.05-.028.7.277 1.486 1.21 1.612.06.01.123.013.183.013 1.326 0 1.998-2.055 2.004-2.076.064-.182.072-.324.025-.403zm-18.334-19.84c-1.482 0-2.566 1.4-2.898 2.423l-.05-.435c-.054-.48-.274-.765-.62-.97-1.063-.625-4.38-.32-4.39-.32-.05.004-.062-.043-.062-.043-.104-.356-.203-1.38-.217-2.236-.016-1.058.11-1.7.412-1.834.866-.386 4.694-.038 5.455.21.1.032.236.012.308-.09.15-.215.042-.476-.03-.642-.16-.366-.514-.69-.88-.806-.373-.132-.943-.196-1.75-.196-1.017 0-2.26.1-3.58.204-1.393.112-2.834.227-4.084.227-.858 0-1.535-.056-2.07-.166-.09.204-.314 1.073.234 1.438.764.495 2.598.2 3.22.12.464-.06 1.44-.148 1.44-.148s-.064 1.43.25 2.84c.072.318.236.997.152 1.128-.022.034-.054.057-.093.065-.223.047-.54.07-.94.07-1.202 0-2.85-.22-2.887-.22-.216 0-.467.118-.467.45 0 .613.985 1.506 1.776 2.223.228.207.443.402.613.572.972.943 1.516 1.65 1.875 2.12.45.587.62.823 1.015.823.45 0 .674-.205.715-.65.064-.674-.156-2.424-.18-3.006-.02-.585-.077-1.36-.077-1.36.007 0 .93-.138 1.873-.102 1.594.06 2.612.497 2.172 2.39-.113.488-.27.982-.2 1.317l.002.004c.065.406.54.45.744.45.11 0 .227-.012.33-.035-.02-1.692.48-2.956 1.248-3.74.557-.565 1.185-.9 2.07-.895.255.002.577-.03.577-.32 0-.523-.395-.862-1.005-.862zm-8.928 3.91c-.088.267-.232.403-.428.403-.545 0-2.07-1.312-2.07-1.914 0-.517 1.16-.573 1.66-.573.247 0 .507.017.774.035.035.002.065.025.084.057.136.243.166 1.44-.02 1.993zm-13.494-1.26c.015-.664.167-1.18.472-1.6.263-.367.62-.594.927-.594.217 0 .415.19.415.495v.004c.027 1.388-1.717 2.468-1.717 2.468s-.108-.305-.097-.774zm4.327.88c-.853.782-1.9 1.325-2.87 1.335-.418.004-.734-.296-.908-.59 1.416-.916 2.73-1.986 2.73-3.55 0-1.295-1.042-1.71-1.83-1.71-1.362 0-2.595 1.194-2.595 3.49 0 .504.063 1.038.204 1.443 0 0-1.848 1.014-2.39.255-.368-.516.013-1.814.288-2.735.285-.954.425-1.423.134-1.758-.55-.634-2.668-.59-2.668-.59-.048-.627-.476-.96-1.046-.96-.487 0-.766.404-.766.9 0 .59.388.892.57 1.002.22.13.313.424.294.74-.054.898-.754 3.265-1.852 3.265-.57 0-1.045-.433-1.045-1.534 0-.32.046-.617.102-.793.13-.388.147-.642.05-.773-.065-.093-.196-.138-.4-.138-.902 0-1.1 1.15-1.246 1.642-.217.733-.56 1.72-1.25 1.72-.518 0-.68-.653-.68-1.126 0-1.26.32-1.94.276-2.226-.042-.27-.372-.42-.814-.42-.368 0-.62.085-.62.085.017-.012.918-1.043.918-2.903 0-3.542-2.628-5.14-5.55-5.14-3.362 0-6.018 2.044-6.018 5.676.06 2.383 1.654 4.506 3.6 4.428.254-.01.317-.205.316-.207-.272-.16-2.597-1.133-2.286-4.7.192-2.286 2.05-4.104 4.146-4.104 3.258 0 4.455 2.127 4.455 4.32 0 .802-.298 3.13-1.626 3.316-.065.01-.132.013-.197.013-.382 0-.752-.15-1.042-.424-.257-.24-.416-.55-.416-.806 0-1.296.152-1.797.266-2.114-.102-.022-.198-.033-.288-.033-.295 0-.534.122-.75.386-.555.655-.638 2.117-.638 2.93 0 2.066.317 4.24.752 5.172.226.483.63.797 1.028.797.153 0 .287-.05.387-.142.214-.187.208-.436-.017-.76l-.01-.015-.004-.013c-.35-1.074-.562-2.368-.667-4.073l-.018-.283c.556.63 1.075.734 1.466.734.624 0 1.196-.38 1.583-.944 0 0 .36-.252.607-.252.51 0 .093.922.033 2.053-.065 1.214.34 2.535 1.446 2.535.616 0 1.645-.616 2.082-2.853.18 2.05 1.224 2.553 1.976 2.553.595 0 1.39-.397 2.137-2.16.69-1.635.677-3.05.677-3.05s.137-.09.495-.09c.39 0 1.08.12 1.187.572.064.3-.064.63-.24 1.09-.194.508-.437 1.14-.54 2.02-.07.582.058 1.092.36 1.433.27.3.67.46 1.157.46.678 0 1.63-.32 2.67-.98.363.62.948.936 1.637.936.856 0 1.484-.3 2.184-.8.642-.457 1.166-1.11 1.212-1.49 0-.135-.1-.123-.14-.062z', fill: '#0F243F' })
  )
);

var Header = function Header(_ref) {
  var intl = _ref.intl;
  return _react2.default.createElement(
    'header',
    { className: 'header' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        _reactRouter.Link,
        { title: intl.formatMessage({ id: 'header.logo.title' }), to: '/lv_lv/watersystems/configurator' },
        _ref2
      )
    )
  );
};

exports.default = (0, _reactIntl.injectIntl)(Header);

/***/ }),
/* 688 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(690), src$en$$ = __webpack_require__(695);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(288), src$es5$$ = __webpack_require__(691), src$compiler$$ = __webpack_require__(692), intl$messageformat$parser$$ = __webpack_require__(693);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(288);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(694)['default'];
exports['default'] = exports;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(698)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(703);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(699), src$en$$ = __webpack_require__(702);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(287), src$diff$$ = __webpack_require__(700), src$es5$$ = __webpack_require__(701);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(705)['default'];
exports['default'] = exports;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(706);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement(
  'div',
  { className: 'footer__copyright' },
  _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col' },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'footer.copyright' })
      )
    )
  )
);

var _ref3 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.privacy.text' });

var _ref4 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'footer.disclaimer.text' });

var _ref5 = _react2.default.createElement(
  'div',
  { className: 'col col-12 col-md-4 pull-right footer__logo' },
  _react2.default.createElement(
    'a',
    { href: 'http://www.lixil.com/', target: '_blank' },
    _react2.default.createElement(
      'svg',
      { width: '104', height: '18', viewBox: '0 0 104 18', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M53.676 12.607c-.41 0-.746-.316-.746-.706V2H49v10.56c0 1.9 1.628 3.44 3.637 3.44H58v-3.393h-4.324M99.676 12.607c-.41 0-.745-.316-.745-.706V2H95v10.56c0 1.9 1.628 3.44 3.637 3.44H104v-3.393h-4.324M61 16h4V2h-4M87 16h4V2h-4', fill: '#DF572A' }),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement(
            'mask',
            { id: 'b', fill: '#fff' },
            _react2.default.createElement('path', { id: 'a', d: 'M41.494.276H.022V18h82.944V.276z' })
          ),
          _react2.default.createElement('path', { d: 'M78.194 8.623l4.772-6.24L79.913.277l-4.445 5.812L71.024.276 67.97 2.384l4.772 6.24c.216.282.216.745 0 1.03l-4.77 6.238L71.023 18l4.444-5.812L79.913 18l3.053-2.108-4.772-6.24c-.216-.283-.216-.746 0-1.03', fill: '#DF572A', mask: 'url(#b)' }),
          _react2.default.createElement('path', { d: 'M1.784 6.288h.957c.88 0 1.32-.418 1.32-1.253s-.44-1.253-1.32-1.253h-.956v2.506zM0 11.25V2.382h2.573c2.198 0 3.27.983 3.27 2.653s-1.072 2.653-3.27 2.653h-.79v3.562H0z', fill: '#4B4F50', mask: 'url(#b)' })
        ),
        _react2.default.createElement('path', { d: 'M8.602 7.585h1.81l-.886-3.64H9.5l-.898 3.64zM6 11l2.364-9h2.338L13 11h-1.743l-.463-1.894H8.272L7.757 11H6zM15.754 5.914h.903c.775 0 1.245-.374 1.245-1.246 0-.873-.47-1.247-1.245-1.247h-.903v2.494zM18.118 11l-1.525-3.665h-.84V11H14V2h2.542c2.11 0 3.115.998 3.115 2.693 0 1.122-.407 1.932-1.386 2.293L20 11h-1.882zM27 2v1.52h-2.1V11h-1.8V3.52H21V2h6M32.816 8.283c0 .97.46 1.238 1.184 1.238s1.184-.266 1.184-1.237V4.717c0-.97-.46-1.237-1.184-1.237s-1.184.267-1.184 1.237v3.566zM31 4.935C31 2.775 32.237 2 34 2s3 .776 3 2.935v3.13C37 10.225 35.763 11 34 11s-3-.776-3-2.935v-3.13zM38 11V2h5v1.52h-3.083v2.07h2.416v1.52h-2.416V11H38', fill: '#4B4F50' })
      )
    )
  )
);

var Footer = function Footer(_ref) {
  var intl = _ref.intl;
  return _react2.default.createElement(
    'footer',
    { className: 'footer' },
    _ref2,
    _react2.default.createElement(
      'div',
      { className: 'footer__navigation' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col col-12 col-md-8' },
            _react2.default.createElement(
              'div',
              { className: 'footer__links' },
              _react2.default.createElement(
                'a',
                { className: 'footer__link', href: intl.formatMessage({ id: 'footer.privacy.url' }), target: '_blank' },
                _ref3
              ),
              _react2.default.createElement(
                'a',
                { className: 'footer__link', href: intl.formatMessage({ id: 'footer.disclaimer.url' }), target: '_blank' },
                _ref4
              )
            )
          ),
          _ref5
        )
      )
    )
  );
};

exports.default = (0, _reactIntl.injectIntl)(Footer);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SAVE_SELECTED = exports.SAVE_SELECTED = 'SAVE_SELECTED';
var GET_SELECTED = exports.GET_SELECTED = 'GET_SELECTED';
var RESET_CONFIGURATOR = exports.RESET_CONFIGURATOR = 'RESET_CONFIGURATOR';
var PUSH_RESULT = exports.PUSH_RESULT = 'PUSH_RESULT';
var INIT_STATE = exports.INIT_STATE = 'INIT_STATE';
var INIT_DATA = exports.INIT_DATA = 'INIT_DATA';
var SET_SCROLL_INDICATOR = exports.SET_SCROLL_INDICATOR = 'SET_SCROLL_INDICATOR';
var SET_LAST_QUESTION_ID = exports.SET_LAST_QUESTION_ID = 'SET_LAST_QUESTION_ID';

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en_gb';

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.nl=n())}(this,function(){"use strict";return[{locale:"nl",pluralRuleFunction:function(e,n){var a=!String(e).split(".")[1];return n?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"jaar",relative:{0:"dit jaar",1:"volgend jaar","-1":"vorig jaar"},relativeTime:{future:{one:"over {0} jaar",other:"over {0} jaar"},past:{one:"{0} jaar geleden",other:"{0} jaar geleden"}}},month:{displayName:"maand",relative:{0:"deze maand",1:"volgende maand","-1":"vorige maand"},relativeTime:{future:{one:"over {0} maand",other:"over {0} maanden"},past:{one:"{0} maand geleden",other:"{0} maanden geleden"}}},day:{displayName:"dag",relative:{0:"vandaag",1:"morgen",2:"overmorgen","-2":"eergisteren","-1":"gisteren"},relativeTime:{future:{one:"over {0} dag",other:"over {0} dagen"},past:{one:"{0} dag geleden",other:"{0} dagen geleden"}}},hour:{displayName:"uur",relative:{0:"binnen een uur"},relativeTime:{future:{one:"over {0} uur",other:"over {0} uur"},past:{one:"{0} uur geleden",other:"{0} uur geleden"}}},minute:{displayName:"minuut",relative:{0:"binnen een minuut"},relativeTime:{future:{one:"over {0} minuut",other:"over {0} minuten"},past:{one:"{0} minuut geleden",other:"{0} minuten geleden"}}},second:{displayName:"seconde",relative:{0:"nu"},relativeTime:{future:{one:"over {0} seconde",other:"over {0} seconden"},past:{one:"{0} seconde geleden",other:"{0} seconden geleden"}}}}},{locale:"nl-AW",parentLocale:"nl"},{locale:"nl-BE",parentLocale:"nl"},{locale:"nl-BQ",parentLocale:"nl"},{locale:"nl-CW",parentLocale:"nl"},{locale:"nl-SR",parentLocale:"nl"},{locale:"nl-SX",parentLocale:"nl"}]});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.be=t())}(this,function(){"use strict";return[{locale:"be",pluralRuleFunction:function(e,t){var a=String(e).split("."),n=Number(a[0])==e,o=n&&a[0].slice(-1),r=n&&a[0].slice(-2);return t?2!=o&&3!=o||12==r||13==r?"other":"few":1==o&&11!=r?"one":o>=2&&o<=4&&(r<12||r>14)?"few":n&&0==o||o>=5&&o<=9||r>=11&&r<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"у гэтым годзе",1:"у наступным годзе","-1":"у мінулым годзе"},relativeTime:{future:{one:"праз {0} год",few:"праз {0} гады",many:"праз {0} гадоў",other:"праз {0} года"},past:{one:"{0} год таму",few:"{0} гады таму",many:"{0} гадоў таму",other:"{0} года таму"}}},month:{displayName:"месяц",relative:{0:"у гэтым месяцы",1:"у наступным месяцы","-1":"у мінулым месяцы"},relativeTime:{future:{one:"праз {0} месяц",few:"праз {0} месяцы",many:"праз {0} месяцаў",other:"праз {0} месяца"},past:{one:"{0} месяц таму",few:"{0} месяцы таму",many:"{0} месяцаў таму",other:"{0} месяца таму"}}},day:{displayName:"дзень",relative:{0:"сёння",1:"заўтра",2:"паслязаўтра","-2":"пазаўчора","-1":"учора"},relativeTime:{future:{one:"праз {0} дзень",few:"праз {0} дні",many:"праз {0} дзён",other:"праз {0} дня"},past:{one:"{0} дзень таму",few:"{0} дні таму",many:"{0} дзён таму",other:"{0} дня таму"}}},hour:{displayName:"гадзіна",relative:{0:"у гэту гадзіну"},relativeTime:{future:{one:"праз {0} гадзіну",few:"праз {0} гадзіны",many:"праз {0} гадзін",other:"праз {0} гадзіны"},past:{one:"{0} гадзіну таму",few:"{0} гадзіны таму",many:"{0} гадзін таму",other:"{0} гадзіны таму"}}},minute:{displayName:"хвіліна",relative:{0:"у гэту хвіліну"},relativeTime:{future:{one:"праз {0} хвіліну",few:"праз {0} хвіліны",many:"праз {0} хвілін",other:"праз {0} хвіліны"},past:{one:"{0} хвіліну таму",few:"{0} хвіліны таму",many:"{0} хвілін таму",other:"{0} хвіліны таму"}}},second:{displayName:"секунда",relative:{0:"цяпер"},relativeTime:{future:{one:"праз {0} секунду",few:"праз {0} секунды",many:"праз {0} секунд",other:"праз {0} секунды"},past:{one:"{0} секунду таму",few:"{0} секунды таму",many:"{0} секунд таму",other:"{0} секунды таму"}}}}}]});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.tr=a())}(this,function(){"use strict";return[{locale:"tr",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},month:{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},day:{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},hour:{displayName:"saat",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} saat sonra",other:"{0} saat sonra"},past:{one:"{0} saat önce",other:"{0} saat önce"}}},minute:{displayName:"dakika",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dakika sonra",other:"{0} dakika sonra"},past:{one:"{0} dakika önce",other:"{0} dakika önce"}}},second:{displayName:"saniye",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} saniye sonra",other:"{0} saniye sonra"},past:{one:"{0} saniye önce",other:"{0} saniye önce"}}}}},{locale:"tr-CY",parentLocale:"tr"}]});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.uk=t())}(this,function(){"use strict";return[{locale:"uk",pluralRuleFunction:function(e,t){var a=String(e).split("."),n=a[0],o=!a[1],r=Number(a[0])==e,i=r&&a[0].slice(-1),l=r&&a[0].slice(-2),f=n.slice(-1),m=n.slice(-2);return t?3==i&&13!=l?"few":"other":o&&1==f&&11!=m?"one":o&&f>=2&&f<=4&&(m<12||m>14)?"few":o&&0==f||o&&f>=5&&f<=9||o&&m>=11&&m<=14?"many":"other"},fields:{year:{displayName:"рік",relative:{0:"цього року",1:"наступного року","-1":"торік"},relativeTime:{future:{one:"через {0} рік",few:"через {0} роки",many:"через {0} років",other:"через {0} року"},past:{one:"{0} рік тому",few:"{0} роки тому",many:"{0} років тому",other:"{0} року тому"}}},month:{displayName:"місяць",relative:{0:"цього місяця",1:"наступного місяця","-1":"минулого місяця"},relativeTime:{future:{one:"через {0} місяць",few:"через {0} місяці",many:"через {0} місяців",other:"через {0} місяця"},past:{one:"{0} місяць тому",few:"{0} місяці тому",many:"{0} місяців тому",other:"{0} місяця тому"}}},day:{displayName:"день",relative:{0:"сьогодні",1:"завтра",2:"післязавтра","-2":"позавчора","-1":"учора"},relativeTime:{future:{one:"через {0} день",few:"через {0} дні",many:"через {0} днів",other:"через {0} дня"},past:{one:"{0} день тому",few:"{0} дні тому",many:"{0} днів тому",other:"{0} дня тому"}}},hour:{displayName:"година",relative:{0:"цієї години"},relativeTime:{future:{one:"через {0} годину",few:"через {0} години",many:"через {0} годин",other:"через {0} години"},past:{one:"{0} годину тому",few:"{0} години тому",many:"{0} годин тому",other:"{0} години тому"}}},minute:{displayName:"хвилина",relative:{0:"цієї хвилини"},relativeTime:{future:{one:"через {0} хвилину",few:"через {0} хвилини",many:"через {0} хвилин",other:"через {0} хвилини"},past:{one:"{0} хвилину тому",few:"{0} хвилини тому",many:"{0} хвилин тому",other:"{0} хвилини тому"}}},second:{displayName:"секунда",relative:{0:"зараз"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунди",many:"через {0} секунд",other:"через {0} секунди"},past:{one:"{0} секунду тому",few:"{0} секунди тому",many:"{0} секунд тому",other:"{0} секунди тому"}}}}}]});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,o){var t=!String(e).split(".")[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.da=t())}(this,function(){"use strict";return[{locale:"da",pluralRuleFunction:function(e,t){var r=String(e).split("."),n=r[0],o=Number(r[0])==e;return t?"other":1!=e&&(o||0!=n&&1!=n)?"other":"one"},fields:{year:{displayName:"år",relative:{0:"i år",1:"næste år","-1":"sidste år"},relativeTime:{future:{one:"om {0} år",other:"om {0} år"},past:{one:"for {0} år siden",other:"for {0} år siden"}}},month:{displayName:"måned",relative:{0:"denne måned",1:"næste måned","-1":"sidste måned"},relativeTime:{future:{one:"om {0} måned",other:"om {0} måneder"},past:{one:"for {0} måned siden",other:"for {0} måneder siden"}}},day:{displayName:"dag",relative:{0:"i dag",1:"i morgen",2:"i overmorgen","-2":"i forgårs","-1":"i går"},relativeTime:{future:{one:"om {0} dag",other:"om {0} dage"},past:{one:"for {0} dag siden",other:"for {0} dage siden"}}},hour:{displayName:"time",relative:{0:"i den kommende time"},relativeTime:{future:{one:"om {0} time",other:"om {0} timer"},past:{one:"for {0} time siden",other:"for {0} timer siden"}}},minute:{displayName:"minut",relative:{0:"i det kommende minut"},relativeTime:{future:{one:"om {0} minut",other:"om {0} minutter"},past:{one:"for {0} minut siden",other:"for {0} minutter siden"}}},second:{displayName:"sekund",relative:{0:"nu"},relativeTime:{future:{one:"om {0} sekund",other:"om {0} sekunder"},past:{one:"for {0} sekund siden",other:"for {0} sekunder siden"}}}}},{locale:"da-GL",parentLocale:"da"}]});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.hu=t())}(this,function(){"use strict";return[{locale:"hu",pluralRuleFunction:function(e,t){return t?1==e||5==e?"one":"other":1==e?"one":"other"},fields:{year:{displayName:"év",relative:{0:"ez az év",1:"következő év","-1":"előző év"},relativeTime:{future:{one:"{0} év múlva",other:"{0} év múlva"},past:{one:"{0} évvel ezelőtt",other:"{0} évvel ezelőtt"}}},month:{displayName:"hónap",relative:{0:"ez a hónap",1:"következő hónap","-1":"előző hónap"},relativeTime:{future:{one:"{0} hónap múlva",other:"{0} hónap múlva"},past:{one:"{0} hónappal ezelőtt",other:"{0} hónappal ezelőtt"}}},day:{displayName:"nap",relative:{0:"ma",1:"holnap",2:"holnapután","-2":"tegnapelőtt","-1":"tegnap"},relativeTime:{future:{one:"{0} nap múlva",other:"{0} nap múlva"},past:{one:"{0} nappal ezelőtt",other:"{0} nappal ezelőtt"}}},hour:{displayName:"óra",relative:{0:"ebben az órában"},relativeTime:{future:{one:"{0} óra múlva",other:"{0} óra múlva"},past:{one:"{0} órával ezelőtt",other:"{0} órával ezelőtt"}}},minute:{displayName:"perc",relative:{0:"ebben a percben"},relativeTime:{future:{one:"{0} perc múlva",other:"{0} perc múlva"},past:{one:"{0} perccel ezelőtt",other:"{0} perccel ezelőtt"}}},second:{displayName:"másodperc",relative:{0:"most"},relativeTime:{future:{one:"{0} másodperc múlva",other:"{0} másodperc múlva"},past:{one:"{0} másodperccel ezelőtt",other:"{0} másodperccel ezelőtt"}}}}}]});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.sk=o())}(this,function(){"use strict";return[{locale:"sk",pluralRuleFunction:function(e,o){var a=String(e).split("."),t=a[0],i=!a[1];return o?"other":1==e&&i?"one":t>=2&&t<=4&&i?"few":i?"other":"many"},fields:{year:{displayName:"rok",relative:{0:"tento rok",1:"budúci rok","-1":"minulý rok"},relativeTime:{future:{one:"o {0} rok",few:"o {0} roky",many:"o {0} roka",other:"o {0} rokov"},past:{one:"pred {0} rokom",few:"pred {0} rokmi",many:"pred {0} roka",other:"pred {0} rokmi"}}},month:{displayName:"mesiac",relative:{0:"tento mesiac",1:"budúci mesiac","-1":"minulý mesiac"},relativeTime:{future:{one:"o {0} mesiac",few:"o {0} mesiace",many:"o {0} mesiaca",other:"o {0} mesiacov"},past:{one:"pred {0} mesiacom",few:"pred {0} mesiacmi",many:"pred {0} mesiaca",other:"pred {0} mesiacmi"}}},day:{displayName:"deň",relative:{0:"dnes",1:"zajtra",2:"pozajtra","-2":"predvčerom","-1":"včera"},relativeTime:{future:{one:"o {0} deň",few:"o {0} dni",many:"o {0} dňa",other:"o {0} dní"},past:{one:"pred {0} dňom",few:"pred {0} dňami",many:"pred {0} dňa",other:"pred {0} dňami"}}},hour:{displayName:"hodina",relative:{0:"v tejto hodine"},relativeTime:{future:{one:"o {0} hodinu",few:"o {0} hodiny",many:"o {0} hodiny",other:"o {0} hodín"},past:{one:"pred {0} hodinou",few:"pred {0} hodinami",many:"pred {0} hodinou",other:"pred {0} hodinami"}}},minute:{displayName:"minúta",relative:{0:"v tejto minúte"},relativeTime:{future:{one:"o {0} minútu",few:"o {0} minúty",many:"o {0} minúty",other:"o {0} minút"},past:{one:"pred {0} minútou",few:"pred {0} minútami",many:"pred {0} minúty",other:"pred {0} minútami"}}},second:{displayName:"sekunda",relative:{0:"teraz"},relativeTime:{future:{one:"o {0} sekundu",few:"o {0} sekundy",many:"o {0} sekundy",other:"o {0} sekúnd"},past:{one:"pred {0} sekundou",few:"pred {0} sekundami",many:"pred {0} sekundy",other:"pred {0} sekundami"}}}}}]});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.cs=a())}(this,function(){"use strict";return[{locale:"cs",pluralRuleFunction:function(e,a){var n=String(e).split("."),t=n[0],o=!n[1];return a?"other":1==e&&o?"one":t>=2&&t<=4&&o?"few":o?"other":"many"},fields:{year:{displayName:"rok",relative:{0:"tento rok",1:"příští rok","-1":"minulý rok"},relativeTime:{future:{one:"za {0} rok",few:"za {0} roky",many:"za {0} roku",other:"za {0} let"},past:{one:"před {0} rokem",few:"před {0} lety",many:"před {0} roku",other:"před {0} lety"}}},month:{displayName:"měsíc",relative:{0:"tento měsíc",1:"příští měsíc","-1":"minulý měsíc"},relativeTime:{future:{one:"za {0} měsíc",few:"za {0} měsíce",many:"za {0} měsíce",other:"za {0} měsíců"},past:{one:"před {0} měsícem",few:"před {0} měsíci",many:"před {0} měsíce",other:"před {0} měsíci"}}},day:{displayName:"den",relative:{0:"dnes",1:"zítra",2:"pozítří","-2":"předevčírem","-1":"včera"},relativeTime:{future:{one:"za {0} den",few:"za {0} dny",many:"za {0} dne",other:"za {0} dní"},past:{one:"před {0} dnem",few:"před {0} dny",many:"před {0} dne",other:"před {0} dny"}}},hour:{displayName:"hodina",relative:{0:"tuto hodinu"},relativeTime:{future:{one:"za {0} hodinu",few:"za {0} hodiny",many:"za {0} hodiny",other:"za {0} hodin"},past:{one:"před {0} hodinou",few:"před {0} hodinami",many:"před {0} hodiny",other:"před {0} hodinami"}}},minute:{displayName:"minuta",relative:{0:"tuto minutu"},relativeTime:{future:{one:"za {0} minutu",few:"za {0} minuty",many:"za {0} minuty",other:"za {0} minut"},past:{one:"před {0} minutou",few:"před {0} minutami",many:"před {0} minuty",other:"před {0} minutami"}}},second:{displayName:"sekunda",relative:{0:"nyní"},relativeTime:{future:{one:"za {0} sekundu",few:"za {0} sekundy",many:"za {0} sekundy",other:"za {0} sekund"},past:{one:"před {0} sekundou",few:"před {0} sekundami",many:"před {0} sekundy",other:"před {0} sekundami"}}}}}]});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";return[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&n<=4&&(l<12||l>14)?"few":o&&0==n||o&&n>=5&&n<=9||o&&l>=11&&l<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дня"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},hour:{displayName:"час",relative:{0:"в этом часе"},relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},minute:{displayName:"минута",relative:{0:"в эту минуту"},relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}]});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pl=t())}(this,function(){"use strict";return[{locale:"pl",pluralRuleFunction:function(e,t){var a=String(e).split("."),i=a[0],n=!a[1],m=i.slice(-1),u=i.slice(-2);return t?"other":1==e&&n?"one":n&&m>=2&&m<=4&&(u<12||u>14)?"few":n&&1!=i&&(0==m||1==m)||n&&m>=5&&m<=9||n&&u>=12&&u<=14?"many":"other"},fields:{year:{displayName:"rok",relative:{0:"w tym roku",1:"w przyszłym roku","-1":"w zeszłym roku"},relativeTime:{future:{one:"za {0} rok",few:"za {0} lata",many:"za {0} lat",other:"za {0} roku"},past:{one:"{0} rok temu",few:"{0} lata temu",many:"{0} lat temu",other:"{0} roku temu"}}},month:{displayName:"miesiąc",relative:{0:"w tym miesiącu",1:"w przyszłym miesiącu","-1":"w zeszłym miesiącu"},relativeTime:{future:{one:"za {0} miesiąc",few:"za {0} miesiące",many:"za {0} miesięcy",other:"za {0} miesiąca"},past:{one:"{0} miesiąc temu",few:"{0} miesiące temu",many:"{0} miesięcy temu",other:"{0} miesiąca temu"}}},day:{displayName:"dzień",relative:{0:"dzisiaj",1:"jutro",2:"pojutrze","-2":"przedwczoraj","-1":"wczoraj"},relativeTime:{future:{one:"za {0} dzień",few:"za {0} dni",many:"za {0} dni",other:"za {0} dnia"},past:{one:"{0} dzień temu",few:"{0} dni temu",many:"{0} dni temu",other:"{0} dnia temu"}}},hour:{displayName:"godzina",relative:{0:"ta godzina"},relativeTime:{future:{one:"za {0} godzinę",few:"za {0} godziny",many:"za {0} godzin",other:"za {0} godziny"},past:{one:"{0} godzinę temu",few:"{0} godziny temu",many:"{0} godzin temu",other:"{0} godziny temu"}}},minute:{displayName:"minuta",relative:{0:"ta minuta"},relativeTime:{future:{one:"za {0} minutę",few:"za {0} minuty",many:"za {0} minut",other:"za {0} minuty"},past:{one:"{0} minutę temu",few:"{0} minuty temu",many:"{0} minut temu",other:"{0} minuty temu"}}},second:{displayName:"sekunda",relative:{0:"teraz"},relativeTime:{future:{one:"za {0} sekundę",few:"za {0} sekundy",many:"za {0} sekund",other:"za {0} sekundy"},past:{one:"{0} sekundę temu",few:"{0} sekundy temu",many:"{0} sekund temu",other:"{0} sekundy temu"}}}}}]});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.cy=n())}(this,function(){"use strict";return[{locale:"cy",pluralRuleFunction:function(e,n){return n?0==e||7==e||8==e||9==e?"zero":1==e?"one":2==e?"two":3==e||4==e?"few":5==e||6==e?"many":"other":0==e?"zero":1==e?"one":2==e?"two":3==e?"few":6==e?"many":"other"},fields:{year:{displayName:"blwyddyn",relative:{0:"eleni",1:"blwyddyn nesaf","-1":"llynedd"},relativeTime:{future:{zero:"ymhen {0} mlynedd",one:"ymhen blwyddyn",two:"ymhen {0} flynedd",few:"ymhen {0} blynedd",many:"ymhen {0} blynedd",other:"ymhen {0} mlynedd"},past:{zero:"{0} o flynyddoedd yn ôl",one:"blwyddyn yn ôl",two:"{0} flynedd yn ôl",few:"{0} blynedd yn ôl",many:"{0} blynedd yn ôl",other:"{0} o flynyddoedd yn ôl"}}},month:{displayName:"mis",relative:{0:"y mis hwn",1:"mis nesaf","-1":"mis diwethaf"},relativeTime:{future:{zero:"ymhen {0} mis",one:"ymhen mis",two:"ymhen deufis",few:"ymhen {0} mis",many:"ymhen {0} mis",other:"ymhen {0} mis"},past:{zero:"{0} mis yn ôl",one:"{0} mis yn ôl",two:"{0} fis yn ôl",few:"{0} mis yn ôl",many:"{0} mis yn ôl",other:"{0} mis yn ôl"}}},day:{displayName:"dydd",relative:{0:"heddiw",1:"yfory",2:"drennydd","-2":"echdoe","-1":"ddoe"},relativeTime:{future:{zero:"ymhen {0} diwrnod",one:"ymhen diwrnod",two:"ymhen deuddydd",few:"ymhen tridiau",many:"ymhen {0} diwrnod",other:"ymhen {0} diwrnod"},past:{zero:"{0} diwrnod yn ôl",one:"{0} diwrnod yn ôl",two:"{0} ddiwrnod yn ôl",few:"{0} diwrnod yn ôl",many:"{0} diwrnod yn ôl",other:"{0} diwrnod yn ôl"}}},hour:{displayName:"awr",relative:{0:"yr awr hon"},relativeTime:{future:{zero:"ymhen {0} awr",one:"ymhen awr",two:"ymhen {0} awr",few:"ymhen {0} awr",many:"ymhen {0} awr",other:"ymhen {0} awr"},past:{zero:"{0} awr yn ôl",one:"awr yn ôl",two:"{0} awr yn ôl",few:"{0} awr yn ôl",many:"{0} awr yn ôl",other:"{0} awr yn ôl"}}},minute:{displayName:"munud",relative:{0:"y funud hon"},relativeTime:{future:{zero:"ymhen {0} munud",one:"ymhen munud",two:"ymhen {0} funud",few:"ymhen {0} munud",many:"ymhen {0} munud",other:"ymhen {0} munud"},past:{zero:"{0} munud yn ôl",one:"{0} munud yn ôl",two:"{0} funud yn ôl",few:"{0} munud yn ôl",many:"{0} munud yn ôl",other:"{0} munud yn ôl"}}},second:{displayName:"eiliad",relative:{0:"nawr"},relativeTime:{future:{zero:"ymhen {0} eiliad",one:"ymhen eiliad",two:"ymhen {0} eiliad",few:"ymhen {0} eiliad",many:"ymhen {0} eiliad",other:"ymhen {0} eiliad"},past:{zero:"{0} eiliad yn ôl",one:"eiliad yn ôl",two:"{0} eiliad yn ôl",few:"{0} eiliad yn ôl",many:"{0} eiliad yn ôl",other:"{0} eiliad yn ôl"}}}}}]});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var r=String(e).split("."),o=Number(r[0])==e&&r[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":o>=3&&o<=10?"few":o>=11&&o<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.lv=a())}(this,function(){"use strict";return[{locale:"lv",pluralRuleFunction:function(e,a){var i=String(e).split("."),t=i[1]||"",n=t.length,m=Number(i[0])==e,r=m&&i[0].slice(-1),s=m&&i[0].slice(-2),o=t.slice(-2),p=t.slice(-1);return a?"other":m&&0==r||s>=11&&s<=19||2==n&&o>=11&&o<=19?"zero":1==r&&11!=s||2==n&&1==p&&11!=o||2!=n&&1==p?"one":"other"},fields:{year:{displayName:"gads",relative:{0:"šajā gadā",1:"nākamajā gadā","-1":"pagājušajā gadā"},relativeTime:{future:{zero:"pēc {0} gadiem",one:"pēc {0} gada",other:"pēc {0} gadiem"},past:{zero:"pirms {0} gadiem",one:"pirms {0} gada",other:"pirms {0} gadiem"}}},month:{displayName:"mēnesis",relative:{0:"šajā mēnesī",1:"nākamajā mēnesī","-1":"pagājušajā mēnesī"},relativeTime:{future:{zero:"pēc {0} mēnešiem",one:"pēc {0} mēneša",other:"pēc {0} mēnešiem"},past:{zero:"pirms {0} mēnešiem",one:"pirms {0} mēneša",other:"pirms {0} mēnešiem"}}},day:{displayName:"diena",relative:{0:"šodien",1:"rīt",2:"parīt","-2":"aizvakar","-1":"vakar"},relativeTime:{future:{zero:"pēc {0} dienām",one:"pēc {0} dienas",other:"pēc {0} dienām"},past:{zero:"pirms {0} dienām",one:"pirms {0} dienas",other:"pirms {0} dienām"}}},hour:{displayName:"stundas",relative:{0:"šajā stundā"},relativeTime:{future:{zero:"pēc {0} stundām",one:"pēc {0} stundas",other:"pēc {0} stundām"},past:{zero:"pirms {0} stundām",one:"pirms {0} stundas",other:"pirms {0} stundām"}}},minute:{displayName:"minūtes",relative:{0:"šajā minūtē"},relativeTime:{future:{zero:"pēc {0} minūtēm",one:"pēc {0} minūtes",other:"pēc {0} minūtēm"},past:{zero:"pirms {0} minūtēm",one:"pirms {0} minūtes",other:"pirms {0} minūtēm"}}},second:{displayName:"sekundes",relative:{0:"tagad"},relativeTime:{future:{zero:"pēc {0} sekundēm",one:"pēc {0} sekundes",other:"pēc {0} sekundēm"},past:{zero:"pirms {0} sekundēm",one:"pirms {0} sekundes",other:"pirms {0} sekundēm"}}}}}]});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.et=t())}(this,function(){"use strict";return[{locale:"et",pluralRuleFunction:function(e,t){var a=!String(e).split(".")[1];return t?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"aasta",relative:{0:"käesolev aasta",1:"järgmine aasta","-1":"eelmine aasta"},relativeTime:{future:{one:"{0} aasta pärast",other:"{0} aasta pärast"},past:{one:"{0} aasta eest",other:"{0} aasta eest"}}},month:{displayName:"kuu",relative:{0:"käesolev kuu",1:"järgmine kuu","-1":"eelmine kuu"},relativeTime:{future:{one:"{0} kuu pärast",other:"{0} kuu pärast"},past:{one:"{0} kuu eest",other:"{0} kuu eest"}}},day:{displayName:"päev",relative:{0:"täna",1:"homme",2:"ülehomme","-2":"üleeile","-1":"eile"},relativeTime:{future:{one:"{0} päeva pärast",other:"{0} päeva pärast"},past:{one:"{0} päeva eest",other:"{0} päeva eest"}}},hour:{displayName:"tund",relative:{0:"praegusel tunnil"},relativeTime:{future:{one:"{0} tunni pärast",other:"{0} tunni pärast"},past:{one:"{0} tunni eest",other:"{0} tunni eest"}}},minute:{displayName:"minut",relative:{0:"praegusel minutil"},relativeTime:{future:{one:"{0} minuti pärast",other:"{0} minuti pärast"},past:{one:"{0} minuti eest",other:"{0} minuti eest"}}},second:{displayName:"sekund",relative:{0:"nüüd"},relativeTime:{future:{one:"{0} sekundi pärast",other:"{0} sekundi pärast"},past:{one:"{0} sekundi eest",other:"{0} sekundi eest"}}}}}]});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.lt=i())}(this,function(){"use strict";return[{locale:"lt",pluralRuleFunction:function(e,i){var n=String(e).split("."),a=n[1]||"",t=Number(n[0])==e,o=t&&n[0].slice(-1),r=t&&n[0].slice(-2);return i?"other":1==o&&(r<11||r>19)?"one":o>=2&&o<=9&&(r<11||r>19)?"few":0!=a?"many":"other"},fields:{year:{displayName:"metai",relative:{0:"šiais metais",1:"kitais metais","-1":"praėjusiais metais"},relativeTime:{future:{one:"po {0} metų",few:"po {0} metų",many:"po {0} metų",other:"po {0} metų"},past:{one:"prieš {0} metus",few:"prieš {0} metus",many:"prieš {0} metų",other:"prieš {0} metų"}}},month:{displayName:"mėnuo",relative:{0:"šį mėnesį",1:"kitą mėnesį","-1":"praėjusį mėnesį"},relativeTime:{future:{one:"po {0} mėnesio",few:"po {0} mėnesių",many:"po {0} mėnesio",other:"po {0} mėnesių"},past:{one:"prieš {0} mėnesį",few:"prieš {0} mėnesius",many:"prieš {0} mėnesio",other:"prieš {0} mėnesių"}}},day:{displayName:"diena",relative:{0:"šiandien",1:"rytoj",2:"poryt","-2":"užvakar","-1":"vakar"},relativeTime:{future:{one:"po {0} dienos",few:"po {0} dienų",many:"po {0} dienos",other:"po {0} dienų"},past:{one:"prieš {0} dieną",few:"prieš {0} dienas",many:"prieš {0} dienos",other:"prieš {0} dienų"}}},hour:{displayName:"valanda",relative:{0:"šią valandą"},relativeTime:{future:{one:"po {0} valandos",few:"po {0} valandų",many:"po {0} valandos",other:"po {0} valandų"},past:{one:"prieš {0} valandą",few:"prieš {0} valandas",many:"prieš {0} valandos",other:"prieš {0} valandų"}}},minute:{displayName:"minutė",relative:{0:"šią minutę"},relativeTime:{future:{one:"po {0} minutės",few:"po {0} minučių",many:"po {0} minutės",other:"po {0} minučių"},past:{one:"prieš {0} minutę",few:"prieš {0} minutes",many:"prieš {0} minutės",other:"prieš {0} minučių"}}},second:{displayName:"sekundė",relative:{0:"dabar"},relativeTime:{future:{one:"po {0} sekundės",few:"po {0} sekundžių",many:"po {0} sekundės",other:"po {0} sekundžių"},past:{one:"prieš {0} sekundę",few:"prieš {0} sekundes",many:"prieš {0} sekundės",other:"prieš {0} sekundžių"}}}}}]});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.no=t())}(this,function(){"use strict";return[{locale:"no",pluralRuleFunction:function(e,t){return t?"other":1==e?"one":"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}}]});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ro=t())}(this,function(){"use strict";return[{locale:"ro",pluralRuleFunction:function(e,t){var a=String(e).split("."),u=!a[1],n=Number(a[0])==e&&a[0].slice(-2);return t?1==e?"one":"other":1==e&&u?"one":!u||0==e||1!=e&&n>=1&&n<=19?"few":"other"},fields:{year:{displayName:"an",relative:{0:"anul acesta",1:"anul viitor","-1":"anul trecut"},relativeTime:{future:{one:"peste {0} an",few:"peste {0} ani",other:"peste {0} de ani"},past:{one:"acum {0} an",few:"acum {0} ani",other:"acum {0} de ani"}}},month:{displayName:"lună",relative:{0:"luna aceasta",1:"luna viitoare","-1":"luna trecută"},relativeTime:{future:{one:"peste {0} lună",few:"peste {0} luni",other:"peste {0} de luni"},past:{one:"acum {0} lună",few:"acum {0} luni",other:"acum {0} de luni"}}},day:{displayName:"zi",relative:{0:"azi",1:"mâine",2:"poimâine","-2":"alaltăieri","-1":"ieri"},relativeTime:{future:{one:"peste {0} zi",few:"peste {0} zile",other:"peste {0} de zile"},past:{one:"acum {0} zi",few:"acum {0} zile",other:"acum {0} de zile"}}},hour:{displayName:"oră",relative:{0:"ora aceasta"},relativeTime:{future:{one:"peste {0} oră",few:"peste {0} ore",other:"peste {0} de ore"},past:{one:"acum {0} oră",few:"acum {0} ore",other:"acum {0} de ore"}}},minute:{displayName:"minut",relative:{0:"minutul acesta"},relativeTime:{future:{one:"peste {0} minut",few:"peste {0} minute",other:"peste {0} de minute"},past:{one:"acum {0} minut",few:"acum {0} minute",other:"acum {0} de minute"}}},second:{displayName:"secundă",relative:{0:"acum"},relativeTime:{future:{one:"peste {0} secundă",few:"peste {0} secunde",other:"peste {0} de secunde"},past:{one:"acum {0} secundă",few:"acum {0} secunde",other:"acum {0} de secunde"}}}}},{locale:"ro-MD",parentLocale:"ro"}]});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pt=t())}(this,function(){"use strict";return[{locale:"pt",pluralRuleFunction:function(e,t){var o=String(e).split(".")[0];return t?"other":0==o||1==o?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"em {0} hora",other:"em {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"em {0} minuto",other:"em {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"em {0} segundo",other:"em {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-AO",parentLocale:"pt-PT"},{locale:"pt-PT",parentLocale:"pt",fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-CH",parentLocale:"pt-PT"},{locale:"pt-CV",parentLocale:"pt-PT"},{locale:"pt-GQ",parentLocale:"pt-PT"},{locale:"pt-GW",parentLocale:"pt-PT"},{locale:"pt-LU",parentLocale:"pt-PT"},{locale:"pt-MO",parentLocale:"pt-PT"},{locale:"pt-MZ",parentLocale:"pt-PT"},{locale:"pt-ST",parentLocale:"pt-PT"},{locale:"pt-TL",parentLocale:"pt-PT"}]});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.hr=a())}(this,function(){"use strict";return[{locale:"hr",pluralRuleFunction:function(e,a){var i=String(e).split("."),t=i[0],r=i[1]||"",n=!i[1],o=t.slice(-1),s=t.slice(-2),u=r.slice(-1),d=r.slice(-2);return a?"other":n&&1==o&&11!=s||1==u&&11!=d?"one":n&&o>=2&&o<=4&&(s<12||s>14)||u>=2&&u<=4&&(d<12||d>14)?"few":"other"},fields:{year:{displayName:"godina",relative:{0:"ove godine",1:"sljedeće godine","-1":"prošle godine"},relativeTime:{future:{one:"za {0} godinu",few:"za {0} godine",other:"za {0} godina"},past:{one:"prije {0} godinu",few:"prije {0} godine",other:"prije {0} godina"}}},month:{displayName:"mjesec",relative:{0:"ovaj mjesec",1:"sljedeći mjesec","-1":"prošli mjesec"},relativeTime:{future:{one:"za {0} mjesec",few:"za {0} mjeseca",other:"za {0} mjeseci"},past:{one:"prije {0} mjesec",few:"prije {0} mjeseca",other:"prije {0} mjeseci"}}},day:{displayName:"dan",relative:{0:"danas",1:"sutra",2:"prekosutra","-2":"prekjučer","-1":"jučer"},relativeTime:{future:{one:"za {0} dan",few:"za {0} dana",other:"za {0} dana"},past:{one:"prije {0} dan",few:"prije {0} dana",other:"prije {0} dana"}}},hour:{displayName:"sat",relative:{0:"ovaj sat"},relativeTime:{future:{one:"za {0} sat",few:"za {0} sata",other:"za {0} sati"},past:{one:"prije {0} sat",few:"prije {0} sata",other:"prije {0} sati"}}},minute:{displayName:"minuta",relative:{0:"ova minuta"},relativeTime:{future:{one:"za {0} minutu",few:"za {0} minute",other:"za {0} minuta"},past:{one:"prije {0} minutu",few:"prije {0} minute",other:"prije {0} minuta"}}},second:{displayName:"sekunda",relative:{0:"sad"},relativeTime:{future:{one:"za {0} sekundu",few:"za {0} sekunde",other:"za {0} sekundi"},past:{one:"prije {0} sekundu",few:"prije {0} sekunde",other:"prije {0} sekundi"}}}}},{locale:"hr-BA",parentLocale:"hr"}]});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.bg=t())}(this,function(){"use strict";return[{locale:"bg",pluralRuleFunction:function(e,t){return t?"other":1==e?"one":"other"},fields:{year:{displayName:"година",relative:{0:"тази година",1:"следващата година","-1":"миналата година"},relativeTime:{future:{one:"след {0} година",other:"след {0} години"},past:{one:"преди {0} година",other:"преди {0} години"}}},month:{displayName:"месец",relative:{0:"този месец",1:"следващ месец","-1":"предходен месец"},relativeTime:{future:{one:"след {0} месец",other:"след {0} месеца"},past:{one:"преди {0} месец",other:"преди {0} месеца"}}},day:{displayName:"ден",relative:{0:"днес",1:"утре",2:"вдругиден","-2":"онзи ден","-1":"вчера"},relativeTime:{future:{one:"след {0} ден",other:"след {0} дни"},past:{one:"преди {0} ден",other:"преди {0} дни"}}},hour:{displayName:"час",relative:{0:"в този час"},relativeTime:{future:{one:"след {0} час",other:"след {0} часа"},past:{one:"преди {0} час",other:"преди {0} часа"}}},minute:{displayName:"минута",relative:{0:"в тази минута"},relativeTime:{future:{one:"след {0} минута",other:"след {0} минути"},past:{one:"преди {0} минута",other:"преди {0} минути"}}},second:{displayName:"секунда",relative:{0:"сега"},relativeTime:{future:{one:"след {0} секунда",other:"след {0} секунди"},past:{one:"преди {0} секунда",other:"преди {0} секунди"}}}}}]});


/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.at/de_at/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.at/de_at/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 GROHE Gesellschaft m.b.H.",
	"homepage.headline": "GROHE SmartControl Konfigurator",
	"homepage.introtext": "Beantworten Sie einfach die unten stehenden Fragen und konfigurieren Sie Ihr persönlich auf Sie zugeschnittenes GROHE SmartControl Duschsystem.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Ergebnisse anzeigen",
	"question1.question": "Für welchen Bereich Ihres Bades suchen Sie eine Duschlösung?",
	"question1.option1.text": "Für den Duschbereich",
	"question1.option2.text": "Für die Badewanne mit Wanneneinlauf",
	"question2.question": "Welche Installationsart bevorzugen Sie? Aufputz, Unterputz oder eine Kombination aus beidem?",
	"question2.option1.text": "Aufputz: die Lösung zur einfachen Montage auf der Wand",
	"question2.option2.text": "Kombi-Lösung: versteckte Wasserleitungen hinter der Wand und ein Thermostat mit Ablage vor der Wand",
	"question2.option3.text": "Unterputz: versteckte Technologie hinter der Wand für eine minimalistische Anmutung",
	"question3.question": "Welche Form gefällt Ihnen am besten?",
	"question3.option1.text": "Eckig",
	"question3.option2.text": "Rund",
	"question4.question": "Was möchten Sie mit SmartControl steuern?",
	"question4.option1.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question4.option2.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question4.option3.text": "Eine Kopfbrause, eine Handbrause und einen Wanneneinlauf",
	"question4.option4.text": "Eine Kopfbrause, eine Handbrause und zwei Seitenbrausen",
	"question4.option5.text": "Eine Kopfbrause und eine Handbrause",
	"question4.option6.text": "Eine Handbrause und einen Wanneneinlauf",
	"question4.option7.text": "Nur eine Handbrause",
	"question4.option8.text": "Nur einen Wanneneinlauf",
	"question5.question": "Wählen Sie Ihre bevorzugte Farbe",
	"question5.option1.text": "Chrom",
	"question5.option2.text": "Weiß/Chrom",
	"question5.option3.text": "Weiß/Chrom",
	"question6.question": "Möchten Sie den Thermostat mit integriertem Handbrausehalter oder ohne?",
	"question6.option1.text": "Mit integriertem Handbrausehalter",
	"question6.option2.text": "Ohne integrierten Handbrausehalter",
	"question7.question": "Wie soll Ihre Handbrause gehalten werden?",
	"question7.option1.text": "Von einer Brausestange mit höhenverstellbarem Handbrausehalter",
	"question7.option2.text": "Von einem minimalistischen Handbrausehalter",
	"question8.question": "Möchten Sie Ihre Kopfbrause an der Wand oder an der Decke montieren?",
	"question8.option1.text": "Wandmontierte Kopfbrause",
	"question8.option2.text": "Deckenmontierte Kopfbrause",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die komplette Installation benötigen Sie auch noch:",
	"results.newConfiguration.title": "Wollen Sie ein neues Duschsystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Artikelnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellungen und Installateure",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellungen und Installateure",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Impresszum",
	"footer.privacy.url": "https://www.grohe.hu/hu_hu/company/privacy.html",
	"footer.disclaimer.text": "Jogi információk",
	"footer.disclaimer.url": "https://www.grohe.hu/hu_hu/company/legal-info.html",
	"footer.copyright": "&copy; 2017 Grohe Hungary Kft.",
	"homepage.headline": "GROHE Zuhanyrendszer Konfigurátor",
	"homepage.introtext": "Az alábbi kérdőív kitöltésével segítünk az Önhöz leginkább illő GROHE Smartcontrol zuhanyrendszer összeállításában.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Az oldal nem található",
	"404.link.goBack": "Vissza a címlapra",
	"configurator.button.seeResults": "Eredmények megtekintése",
	"question1.question": "Fürdőkádhoz vagy zuhanykabinhoz szerezne be zuhanyrendszert?",
	"question1.option1.text": "Zuhanykabinhoz",
	"question1.option2.text": "Fürdőkádhoz",
	"question2.question": "Válassza ki a kívánt kialakítást!",
	"question2.option1.text": "Felsík előtti kialakítás",
	"question2.option2.text": "Falsík előtti kialakítás a csaptelepre és falsík mögötti a zuhany további elemeire",
	"question2.option3.text": "Falsík mögötti kialakítás",
	"question3.question": "Válassza ki a kívánt formát!",
	"question3.option1.text": "Szögletes",
	"question3.option2.text": "Lekerekített",
	"question4.question": "Hány víz kimenettel számolhatunk?",
	"question4.option1.text": "Három víz kimenet: Fejzuhany normál és masszás funkcióval, illetve kézizuhany",
	"question4.option2.text": "Három víz kimenet: Kétfunkciós fejzuhany és kézizuhany",
	"question4.option3.text": "Három víz kimenet: Fejzuhany, kézizuhany és kádtöltő",
	"question4.option4.text": "Három víz kimenet: Fejzuhany, kézizuhany és oldalsó szórófej",
	"question4.option5.text": "Kettő víz kimenet: Fejzuhany és kézizuhany",
	"question4.option6.text": "Kettő víz kimenet: Kézizuhany és kádtöltő",
	"question4.option7.text": "Egyetlen víz kimenet: Kizárólag kézizuhany",
	"question4.option8.text": "Egyetlen víz kimenet: Kádtöltő",
	"question5.question": "Válassza ki a kívánt színt!",
	"question5.option1.text": "Króm",
	"question5.option2.text": "Fehér / króm",
	"question5.option3.text": "Fehér / króm",
	"question6.question": "Szeretné a szetthez tartozó kézizuhany tartót választani?",
	"question6.option1.text": "Nem, más kézizuhany tartót választok",
	"question6.option2.text": "Igen",
	"question7.question": "Kérjük, válasszon a  zuhanysínes vagy a fix falitartós kézizuhany szettek közül!",
	"question7.option1.text": "Zuhanysínes kézizuhany szett",
	"question7.option2.text": "Fix falitartós kézizuhany szett",
	"question8.question": "Kérjük, válasszon a fali vagy mennyezeti fejzuhany kivitelek között!",
	"question8.option1.text": "Fali fejzuhany",
	"question8.option2.text": "Mennyezeti fejzuhany",
	"results.title": "{productGroupsCount, plural, \none {Eredmény} \nother {Eredmény}\n}",
	"results.proposal.title": "Ajánlatunk {number}",
	"results.proposal.title.single": "Ajánlatunk",
	"results.bundle.title": "A helyes beszereléshez, az alábbi kellékekre is szükség lesz:",
	"results.newConfiguration.title": "Szeretné újrakezdeni a zuhanykonfigurátort?",
	"results.newConfiguration.buttonText": "Elölről kezdem",
	"results.product.number": "Cikkszám: #{number}",
	"results.product.button.productInformation": "Termékleírás",
	"results.product.button.dealerLocator": "Bemutatóterem keresése",
	"results.product.button.buyNow": "Online vásárlás",
	"results.product.button.downloadPDF": "Ajánlatok letöltése(PDF)",
	"results.product.information": "Termékleírás",
	"results.product.dealer": "Bemutatóterem keresése",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe-gcc.com/en_sa/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe-gcc.com/en_sa/company/legal-info.html",
	"footer.copyright": "&copy; 2018 Grome Marketing (Cyprus) Ltd.",
	"homepage.headline": "معدّ GROHE SmartControl",
	"homepage.introtext": "أجب عن بعض الأسئلة أدناه لإعداد نظام دش GROHE SmartControl الذي يلائم إحتياجاتك.",
	"homepage.buttonStart": "إبدأ",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "إطّلع على النتائج",
	"question1.question": "تحتاج إلى إعداد الدش لأي منطقة في حمامك؟",
	"question1.option1.text": "لمنطقة إستحمامي",
	"question1.option2.text": "لحوض الإستحمام بما في ذلك الحنفية",
	"question2.question": "ما هو نوع التركيب الذي تفضّله؟ المكشوف أو المخفي أو مزيج من الإثنين؟",
	"question2.option1.text": "المكشوف: حل سهل وقليل الجهد للتعديل والتحديث أمام الجدار",
	"question2.option2.text": "المزيج: أنابيب مخفية داخل الجدار ومنظم حرارة مع طبق أمام الجدار",
	"question2.option3.text": "المخفي: مظهر أنيق وبسيط مع إخفاء كل التقنيات داخل الجدار",
	"question3.question": "كيف تفضّل تشغيل الدش الخاص بك؟",
	"question3.option1.text": "مع SmartControl ومنظم للحرارة",
	"question3.option2.text": "بتشغيل تقليدي ومنظم للحرارة ",
	"question3.option3.text": "بخلاط بذراع واحدة",
	"question3.option4.text": "عبر نظام تحويل (مع إبقاء الحنفية الموجودة)",
	"question4.question": "ما الذي تريد التحكم به من خلال الدش الخاص بك؟",
	"question4.option1.text": "فقط ذراع الدش",
	"question4.option2.text": "دش رأسي كبير (150 – 250mm) وذراع الدش",
	"question4.option3.text": "دش رأسي كبير جداً  (250-400mm) وذراع الدش",
	"question4.option4.text": "دش رأسي كبير (150 – 250mm)، ذراع الدش، وحنفية حوض الإستحمام",
	"question4.option5.text": "دش رأسي كبير جداً (250-400mm)، ذراع الدش، وحنفية حوض الإستحمام",
	"question5.question": "ما هو الشكل الذي تفضّله؟",
	"question5.option1.text": "مربّع",
	"question5.option2.text": "دائري",
	"question6.question": "ما الذي تريد التحكم به من خلال SmartControl الجديد؟",
	"question6.option1.text": "الدش الرأسي مع رذاذين وذراع الدش",
	"question6.option2.text": "الدش الرأسي مع رذاذين وذراع الدش",
	"question6.option3.text": "الدش الرأسي، ذراع الدش وحنفية حوض الإستحمام",
	"question6.option4.text": "الدش الرأسي، دشين جانبيين وذراع الدش",
	"question6.option5.text": "الدش الرأسي وذراع الدش",
	"question6.option6.text": "ذراع الدش وحنفية حوض الإستحمام",
	"question6.option7.text": "فقط ذراع الدش",
	"question6.option8.text": "فقط حنفية حوض الإستحمام",
	"question7.question": "إختر اللون الخاص بك",
	"question7.option1.text": "كروم",
	"question7.option2.text": "أبيض/كروم",
	"question7.option3.text": "أبيض/كروم",
	"question8.question": "هل تودّ الحصول على منظم حرارة مع حاملة ذراع الدش؟",
	"question8.option1.text": "نعم، أريد الحصول على حاملة ذراع الدش",
	"question8.option2.text": "كلا، سأشتري حاملة ذراع الدش على حدة",
	"question9.question": "كيف تفضّل أن يتم حمل ذراع الدش؟",
	"question9.option1.text": "بواسطة سكة دش مع حاملة دش بإرتفاع قابل للتعديل",
	"question9.option2.text": "بواسطة حاملة دش بسيطة ",
	"question10.question": "هل تودّ تعليق الدش الرأسي على الجدار أو في السقف؟",
	"question10.option1.text": "دش رأسي معلّق على الجدار",
	"question10.option2.text": "دش رأسي معلّق في السقف",
	"results.title": "{productGroupsCount, plural, \none {نتائجكم} \nother {نتائجك}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "للحصول على التركيب الملائم، تحتاج إلى:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "إبدأ إعداد جديد",
	"results.product.number": "رقم المنتج: #{number}",
	"results.product.button.productInformation": "معلومات عن المنتج",
	"results.product.button.dealerLocator": "قم بإيجاد صالة عرض",
	"results.product.button.buyNow": "إشتري عبر الإنترنت",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "معلومات عن المنتج",
	"results.product.dealer": "قم بإيجاد صالة عرض",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.cz/cs_cz/spolecnost/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.cz/cs_cz/spolecnost/legal-info.html",
	"footer.copyright": "&copy; 2018 GROHE ČR s.r.o.",
	"homepage.headline": "Konfigurátor GROHE SmartControl",
	"homepage.introtext": "Jednoduše odpovězte na pár otázek níže a získejte takovou konfiguraci sprchového systému GROHE SmartControl, jaká bude dokonale vyhovovat vašim požadavkům.",
	"homepage.buttonStart": "Spustit",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobrazit výsledky",
	"question1.question": "Pro který prostor vaší koupelny hledáte sprchovou konfiguraci?",
	"question1.option1.text": "Do sprchového koutu",
	"question1.option2.text": "Do vany, tj. včetně vanové výpusti",
	"question2.question": "Jaký typ instalace upřednostňujete? Nástěnnou, podomítkovou nebo kombinaci obojího?",
	"question2.option1.text": "Nástěnná: nejjednodušší řešení pro rychlé vylepšení",
	"question2.option2.text": "Kombinace: zatímco potrubí bude ukryto ve stěně, termostatická baterie s přihrádkou budou nástěnné",
	"question2.option3.text": "Podomítková: čistý, minimalistický vzhled, při kterém bude veškerá technologie ukryta ve stěně",
	"question3.question": "Jak byste chtěli svou sprchu ovládat?",
	"question3.option1.text": "Ovladačem SmartControl s termostatickou baterií",
	"question3.option2.text": "Standardní termostatickou baterií",
	"question3.option3.text": "Standardní pákovou baterií",
	"question3.option4.text": "Pomocí přepínače (chci si ponechat stávající baterii)",
	"question4.question": "Co si přejete v rámci sprchy ovládat?",
	"question4.option1.text": "Pouze ruční sprchu",
	"question4.option2.text": "Velkou hlavovou sprchu (150–250 mm) a ruční sprchu",
	"question4.option3.text": "Extra velkou hlavovou sprchu (250–400mm) a ruční sprchu",
	"question4.option4.text": "Velkou hlavovou sprchu (150–250 mm), ruční sprchu a vanovou výpusť",
	"question4.option5.text": "Extra velkou hlavovou sprchu (250–400mm), ruční sprchu a vanovou výpusť",
	"question5.question": "Jaký tvar preferujete?",
	"question5.option1.text": "Čtvercový",
	"question5.option2.text": "Kruhový",
	"question6.question": "Co si přejete ovládat pomocí vašeho nového ovladače SmartControl?",
	"question6.option1.text": "Hlavovou sprchu se dvěma režimy proudu a ruční sprchu",
	"question6.option2.text": "Hlavovou sprchu a ruční sprchu",
	"question6.option3.text": "Pouze ruční sprchu",
	"question6.option4.text": "Hlavovou sprchu se dvěma režimy proudu a ruční sprchu",
	"question6.option5.text": "Hlavovou sprchu, dvě boční sprchy a ruční sprchu",
	"question6.option6.text": "Hlavovou sprchu, ruční sprchu a vanovou výpusť",
	"question6.option7.text": "Ruční sprchu a vanovou výpusť",
	"question6.option8.text": "Pouze vanovou výpusť",
	"question7.question": "Vyberte si barvu",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Bílá/chrom",
	"question7.option3.text": "Bílá/chrom",
	"question8.question": "Přejete si termostatickou baterii s integrovaným držákem ruční sprchy?",
	"question8.option1.text": "Ano, chci mít držák ruční sprchy integrovaný do baterie",
	"question8.option2.text": "Ne, držák ruční sprchy dokoupím zvlášť",
	"question9.question": "Kam si přejete umístit držák ruční sprchy?",
	"question9.option1.text": "Na sprchovou tyč prostřednictvím posuvného držáku",
	"question9.option2.text": "Pomocí minimalistického držáku ",
	"question10.question": "Přejete si připevnit vaši hlavovou sprchu na stěnu nebo ke stropu?",
	"question10.option1.text": "Nástěnná hlavová sprcha",
	"question10.option2.text": "Stropní hlavová sprcha",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledek} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pro správnou instalaci budete potřebovat také:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Spustit novou konfiguraci",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informace o produktu",
	"results.product.button.dealerLocator": "Najít showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informace o produktu",
	"results.product.dealer": "Najít showroom",
	"hatchModal.title": "Koupit online",
	"hatchModal.btnText": "Koupit online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Databeskyttelse",
	"footer.privacy.url": "https://www.grohe.dk/da_dk/databeskyttelse.html",
	"footer.disclaimer.text": "Juridisk information",
	"footer.disclaimer.url": "https://www.grohe.dk/da_dk/aftryk.html",
	"footer.copyright": "&copy; 2017 GROHE",
	"homepage.headline": "GROHE Brusekonfigurator",
	"homepage.introtext": "Du kan finde det rette GROHE SmartControl brusesystem for dig ved at besvare nogle spørgsmål i konfiguratoren herunder.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Siden blev desværre ikke fundet",
	"404.link.goBack": "Gå tilbage til hjemmeside",
	"configurator.button.seeResults": "Se resultatet",
	"question1.question": "Hvilken type brusesystem har du brug for?",
	"question1.option1.text": "Bruser",
	"question1.option2.text": "Bad",
	"question2.question": "Hvilken installation foretrækker du? Uden på væggen eller indbyg?",
	"question2.option1.text": "Installation af bruser og termostat på væggen",
	"question2.option2.text": "Installation af termostat på væggen med indbygget brusestang",
	"question2.option3.text": "Indbyggede installationer",
	"question3.question": "Hvordan ønsker du at kontrollere dit brusesystem?",
	"question3.option1.text": "Med SmartControl's tryk og drej system og en termostat",
	"question3.option2.text": "På almindelig vis inklusiv en termostat",
	"question3.option3.text": "Med en etgrebstermostat",
	"question3.option4.text": "Med omskiftersystem",
	"question4.question": "Hvad ønsker du at være i stand til at kontrollere når du bruser?",
	"question4.option1.text": "Kun håndbruseren",
	"question4.option2.text": "En stor hovedbruser (150-250mm) og en håndbruser",
	"question4.option3.text": "Et ekstra stort brusehoved (250-400mm) og en håndbruser",
	"question4.option4.text": "En stor hovedbruser (150-250mm), en håndbruser og en kartud",
	"question4.option5.text": "Et ekstra stort brusehoved (250-400mm), en håndbruser og en kartud",
	"question5.question": "Hvilket design foretrækker du?",
	"question5.option1.text": "Firkant",
	"question5.option2.text": "Rund",
	"question6.question": "Hvor mange vandtilførsler har du brug for?",
	"question6.option1.text": "Tre: Hovedbruser med 2 spraymønstre og en håndbruser",
	"question6.option2.text": "Tre: Hovedbruser med 2 spraymønstre og en håndbruser",
	"question6.option3.text": "Tre: Hovedbruser, håbndbruser og kartud",
	"question6.option4.text": "Tre: Hovedbruser, side- og håndbruser",
	"question6.option5.text": "To: Hovedbruser og håndbruser ",
	"question6.option6.text": "To: Håndbruser og kartud",
	"question6.option7.text": "En: Kun en håndbruser",
	"question6.option8.text": "En: Kartud",
	"question7.question": "Vælg din farve",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Hvid/krom",
	"question7.option3.text": "Hvid/krom",
	"question8.question": "Vil du have et trim-sæt med integreret holder til håndbruseren?",
	"question8.option1.text": "Ja, med integreret holder til håndbruseren",
	"question8.option2.text": "Nej, jeg vil købe en separat holder til håndbruseren",
	"question9.question": "Har du brug for en brusestang eller et vægholdersæt?",
	"question9.option1.text": "Brusestang",
	"question9.option2.text": "Vægholdersæt",
	"question10.question": "Kan du bedst lide en vægmonteret eller loftsmonteret hovedbruser?",
	"question10.option1.text": "Vægmonteret hovedbruser",
	"question10.option2.text": "Loftsmonteret hovedbruser",
	"results.title": "{productGroupsCount, plural, \none {Dit resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Forslag {number}",
	"results.proposal.title.single": "Forslag",
	"results.bundle.title": "For at installere brusesystemet korrekt har du også brug for:",
	"results.newConfiguration.title": "Vil du forsøge igen?",
	"results.newConfiguration.buttonText": "Start konfiguratoren forfra",
	"results.product.number": "Produktnummer:  #{number}",
	"results.product.button.productInformation": "Produktinformation",
	"results.product.button.dealerLocator": "Find et showroom i nærheden af dig",
	"results.product.button.buyNow": "Køb online",
	"results.product.button.downloadPDF": "Download forslag (PDF)",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Find et showroom i nærheden af dig",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.at/de_at/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.at/de_at/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2018 GROHE Gesellschaft m.b.H.",
	"homepage.headline": "GROHE SmartControl Konfigurator",
	"homepage.introtext": "Beantworten Sie einfach die unten stehenden Fragen und konfigurieren Sie Ihr persönlich auf Sie zugeschnittenes GROHE SmartControl Duschsystem.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Ergebnisse anzeigen",
	"question1.question": "Für welchen Bereich Ihres Bades suchen Sie eine Duschlösung?",
	"question1.option1.text": "Für den Duschbereich",
	"question1.option2.text": "Für die Badewanne mit Wanneneinlauf",
	"question2.question": "Welche Installationsart bevorzugen Sie? Aufputz, Unterputz oder eine Kombination aus beidem?",
	"question2.option1.text": "Aufputz: die Lösung zur einfachen Montage auf der Wand",
	"question2.option2.text": "Kombi-Lösung: versteckte Wasserleitungen hinter der Wand und ein Thermostat mit Ablage vor der Wand",
	"question2.option3.text": "Unterputz: versteckte Technologie hinter der Wand für minimalen Reinigungsaufwand und maximalen Platz ",
	"question3.question": "Mit welcher Armatur möchten Sie Ihre Dusche bedienen?",
	"question3.option1.text": "Mit Grohtherm SmartControl Thermostat",
	"question3.option2.text": "Mit einem normalen Thermostat",
	"question3.option3.text": "Mit einem Einhandmischer",
	"question3.option4.text": "Mit meiner bestehenden Armatur und separater Umstellung",
	"question4.question": "Welche Brausen möchten Sie steuern?",
	"question4.option1.text": "Nur eine Handbrause",
	"question4.option2.text": "Eine große Kopfbrause (150-220mm) und eine Handbrause",
	"question4.option3.text": "Eine extra-große Kopfbrause (250-400mm) und eine Handbrause",
	"question4.option4.text": "Eine große Kopfbrause  (150-220mm),  eine Handbrause und ein Wanneneinlauf",
	"question4.option5.text": "Eine extra-große Kopfbrause  (250-400mm), eine Handbrause und ein Wanneneinlauf",
	"question5.question": "Welche Form gefällt Ihnen am besten?",
	"question5.option1.text": "Eckig",
	"question5.option2.text": "Rund",
	"question6.question": "Was möchten Sie mit SmartControl steuern?",
	"question6.option1.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option2.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option3.text": "Eine Kopfbrause, eine Handbrause und einen Wanneneinlauf",
	"question6.option4.text": "Eine Kopfbrause, eine Handbrause und zwei Seitenbrausen",
	"question6.option5.text": "Eine Kopfbrause und eine Handbrause",
	"question6.option6.text": "Eine Handbrause und einen Wanneneinlauf",
	"question6.option7.text": "Nur eine Handbrause",
	"question6.option8.text": "Nur einen Wanneneinlauf",
	"question7.question": "Wählen Sie Ihre bevorzugte Farbe",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Weiß/Chrom",
	"question7.option3.text": "Weiß/Chrom",
	"question8.question": "Möchten Sie den Thermostat mit integriertem Handbrausehalter oder ohne?",
	"question8.option1.text": "Mit integriertem Handbrausehalter",
	"question8.option2.text": "Ohne integrierten Handbrausehalter",
	"question9.question": "Wie soll Ihre Handbrause gehalten werden?",
	"question9.option1.text": "Von einer Brausestange mit höhenverstellbarem Handbrausehalter",
	"question9.option2.text": "Von einem minimalistischen Handbrausehalter",
	"question10.question": "Möchten Sie Ihre Kopfbrause an der Wand oder an der Decke montieren?",
	"question10.option1.text": "Wandmontierte Kopfbrause",
	"question10.option2.text": "Deckenmontierte Kopfbrause",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die komplette Installation benötigen Sie auch noch:",
	"results.newConfiguration.title": "Wollen Sie ein neues Duschsystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Artikelnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellungen und Installateure",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellungen und Installateure",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.ch/de_ch/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.ch/de_ch/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2018 GROHE Switzerland SA",
	"homepage.headline": "GROHE SmartControl Konfigurator",
	"homepage.introtext": "Beantworten Sie einfach die unten stehenden Fragen und konfigurieren Sie Ihr persönlich auf Sie zugeschnittenes GROHE SmartControl Duschsystem.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Ergebnisse anzeigen",
	"question1.question": "Für welchen Bereich Ihres Bades suchen Sie eine Duschlösung?",
	"question1.option1.text": "Für den Duschbereich",
	"question1.option2.text": "Für die Badewanne mit Wanneneinlauf",
	"question2.question": "Welche Installationsart bevorzugen Sie? Aufputz, Unterputz oder eine Kombination aus beidem?",
	"question2.option1.text": "Aufputz: die Lösung zur einfachen Montage auf der Wand",
	"question2.option2.text": "Kombi-Lösung: versteckte Wasserleitungen hinter der Wand und ein Thermostat mit Ablage vor der Wand",
	"question2.option3.text": "Unterputz: versteckte Technologie hinter der Wand für minimalen Reinigungsaufwand und maximalen Platz ",
	"question3.question": "Mit welcher Armatur möchten Sie Ihre Dusche bedienen?",
	"question3.option1.text": "Mit Grohtherm SmartControl Thermostat",
	"question3.option2.text": "Mit einem normalen Thermostat",
	"question3.option3.text": "Mit einem Einhandmischer",
	"question3.option4.text": "Mit meiner bestehenden Armatur und separater Umstellung",
	"question4.question": "Welche Brausen möchten Sie steuern?",
	"question4.option1.text": "Nur eine Handbrause",
	"question4.option2.text": "Eine große Kopfbrause (150-220mm) und eine Handbrause",
	"question4.option3.text": "Eine extra-große Kopfbrause (250-400mm) und eine Handbrause",
	"question4.option4.text": "Eine große Kofdbrause  (150-220mm),  eine Handbrause und ein Wanneneinlauf",
	"question4.option5.text": "Eine extra-große Kopfbrause  (250-400mm), eine Handbrause und ein Wanneneinlauf",
	"question5.question": "Welche Form gefällt Ihnen am besten?",
	"question5.option1.text": "Eckig",
	"question5.option2.text": "Rund",
	"question6.question": "Was möchten Sie mit SmartControl steuern?",
	"question6.option1.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option2.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option3.text": "Eine Kopfbrause, eine Handbrause und einen Wanneneinlauf",
	"question6.option4.text": "Eine Kopfbrause, eine Handbrause und zwei Seitenbrausen",
	"question6.option5.text": "Eine Kopfbrause und eine Handbrause",
	"question6.option6.text": "Eine Handbrause und einen Wanneneinlauf",
	"question6.option7.text": "Nur eine Handbrause",
	"question6.option8.text": "Nur einen Wanneneinlauf",
	"question7.question": "Wählen Sie Ihre bevorzugte Farbe",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Weiß/Chrom",
	"question7.option3.text": "Weiß/Chrom",
	"question8.question": "Möchten Sie den Thermostat mit integriertem Handbrausehalter oder ohne?",
	"question8.option1.text": "Mit integriertem Handbrausehalter",
	"question8.option2.text": "Ohne integrierten Handbrausehalter",
	"question9.question": "Wie soll Ihre Handbrause gehalten werden?",
	"question9.option1.text": "Von einer Brausestange mit höhenverstellbarem Handbrausehalter",
	"question9.option2.text": "Von einem minimalistischen Handbrausehalter",
	"question10.question": "Möchten Sie Ihre Kopfbrause an der Wand oder an der Decke montieren?",
	"question10.option1.text": "Wandmontierte Kopfbrause",
	"question10.option2.text": "Deckenmontierte Kopfbrause",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die komplette Installation benötigen Sie:",
	"results.newConfiguration.title": "Wollen Sie ein neues Duschsystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Artikelnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellungen und Installateure",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellungen und Installateure",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.de/de_de/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.de/de_de/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 Grohe Deutschland Vertriebs GmbH",
	"homepage.headline": "GROHE SmartControl Konfigurator",
	"homepage.introtext": "Beantworten Sie einfach die unten stehenden Fragen und konfigurieren Sie Ihr persönlich auf Sie zugeschnittenes GROHE SmartControl Duschsystem.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Ergebnisse anzeigen",
	"question1.question": "Für welchen Bereich Ihres Bades suchen Sie eine Duschlösung?",
	"question1.option1.text": "Für die Dusche",
	"question1.option2.text": "Für die Badewanne mit Wanneneinlauf",
	"question2.question": "Welche Installationsart bevorzugen Sie? Aufputz, Unterputz oder eine Kombination aus beidem?",
	"question2.option1.text": "Aufputz: die Lösung zur einfachen Montage auf der Wand",
	"question2.option2.text": "Kombi-Lösung: versteckte Wasserleitungen hinter der Wand und ein Thermostat mit Ablage vor der Wand",
	"question2.option3.text": "Unterputz: versteckte Technologie hinter der Wand für minimalen Reinigungsaufwand und maximalen Platz ",
	"question3.question": "Mit welcher Armatur möchten Sie Ihre Dusche bedienen?",
	"question3.option1.text": "Mit Grohtherm SmartControl Thermostat",
	"question3.option2.text": "Mit einem klassischen Thermostat",
	"question3.option3.text": "Mit einem Einhandmischer",
	"question3.option4.text": "Mit meiner bestehenden Armatur und separater Umstellung",
	"question4.question": "Welche Brausen möchten Sie steuern?",
	"question4.option1.text": "Nur eine Handbrause",
	"question4.option2.text": "Eine große Kopfbrause (150-250mm) und eine Handbrause",
	"question4.option3.text": "Eine extra-große Kopfbrause (250-400mm) und eine Handbrause",
	"question4.option4.text": "Eine große Kopfbrause  (150-250mm),  eine Handbrause und ein Wanneneinlauf",
	"question4.option5.text": "Eine extra-große Kopfbrause (250-400mm), eine Handbrause und ein Wanneneinlauf",
	"question5.question": "Welche Form gefällt Ihnen am besten?",
	"question5.option1.text": "Eckig",
	"question5.option2.text": "Rund",
	"question6.question": "Was möchten Sie mit SmartControl steuern?",
	"question6.option1.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option2.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question6.option3.text": "Eine Kopfbrause, eine Handbrause und einen Wanneneinlauf",
	"question6.option4.text": "Eine Kopfbrause, eine Handbrause und zwei Seitenbrausen",
	"question6.option5.text": "Eine Kopfbrause und eine Handbrause",
	"question6.option6.text": "Eine Handbrause und einen Wanneneinlauf",
	"question6.option7.text": "Nur eine Handbrause",
	"question6.option8.text": "Nur einen Wanneneinlauf",
	"question7.question": "Wählen Sie Ihre bevorzugte Farbe",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Weiß/Chrom",
	"question7.option3.text": "Weiß/Chrom",
	"question8.question": "Möchten Sie den Thermostat mit integriertem Handbrausehalter oder ohne?",
	"question8.option1.text": "Mit integriertem Handbrausehalter",
	"question8.option2.text": "Ohne integrierten Handbrausehalter",
	"question9.question": "Wie soll Ihre Handbrause gehalten werden?",
	"question9.option1.text": "Von einer Brausestange mit höhenverstellbarem Handbrausehalter",
	"question9.option2.text": "Von einem minimalistischen Handbrausehalter",
	"question10.question": "Möchten Sie Ihre Kopfbrause an der Wand oder an der Decke montieren?",
	"question10.option1.text": "Wandmontierte Kopfbrause",
	"question10.option2.text": "Deckenmontierte Kopfbrause",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die komplette Installation benötigen Sie:",
	"results.newConfiguration.title": "Wollen Sie ein neues Duschsystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Artikelnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellungen und Installateure",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellungen und Installateure",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe-middleeast.com/en_cy/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe-middleeast.com/en_cy/company/legal-info.html",
	"footer.copyright": "&copy; 2018 Grome Marketing (Cyprus) Ltd.",
	"homepage.headline": "GROHE SmartControl Configurator",
	"homepage.introtext": "Just answer a few questions below to  configurate the GROHE SmartControl shower system that will fit your needs. ",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "For which area in your bathroom do you need a shower configuration?",
	"question1.option1.text": "For my shower area",
	"question1.option2.text": "For my bath tub including a bath spout",
	"question2.question": "What type of installation do you prefer? Exposed, Concealed  or a combination of both?",
	"question2.option1.text": "Exposed: easy & effortless solution for retrofitting in front of the wall",
	"question2.option2.text": "Combination: hidden piping inside the wall and a thermostat with tray in front of the wall",
	"question2.option3.text": "Concealed: clean minimalistic look with all technology hidden inside the wall",
	"question3.question": "Given the below options, which would you prefer to use to turn on the water flow?",
	"question3.option1.text": "With SmartControl operation and a Thermostat",
	"question3.option2.text": "With conventional operation and a thermostat",
	"question3.option3.text": "With a single lever mixer",
	"question3.option4.text": "With a diverter system (keeping existing faucet)",
	"question4.question": "What do you want to control with your Shower?",
	"question4.option1.text": "Only a hand shower",
	"question4.option2.text": "A large head shower (150-250mm) and a hand shower",
	"question4.option3.text": "An extra-large head shower (250-400mm) and a hand shower",
	"question4.option4.text": "A large head shower (150-250mm), a hand shower and a bath filler",
	"question4.option5.text": "An extra-large head shower (250-400mm), a hand shower and a bath filler",
	"question5.question": "What shape do you prefer?",
	"question5.option1.text": "Square",
	"question5.option2.text": "Round",
	"question6.question": "What do you want to control with your new SmartControl?",
	"question6.option1.text": "A head shower with two sprays and a hand shower",
	"question6.option2.text": "A head shower with two sprays and a hand shower",
	"question6.option3.text": "A head shower, a hand shower and a bath filler",
	"question6.option4.text": "A head shower, two side showers and a hand shower",
	"question6.option5.text": "A head shower and a hand shower",
	"question6.option6.text": "A hand shower and a bath filler",
	"question6.option7.text": "Only a hand shower",
	"question6.option8.text": "Only a bath filler",
	"question7.question": "Choose your colour",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "White/Chrome",
	"question7.option3.text": "White/Chrome",
	"question8.question": "Would you like a thermostat with an integrated hand shower holder?",
	"question8.option1.text": "Yes, with integrated shower holder",
	"question8.option2.text": "No, I will buy a separate hand shower holder",
	"question9.question": "How do you want your handshower to be held?",
	"question9.option1.text": "By a shower rail with height-adjustable shower holder",
	"question9.option2.text": "By a minimalistic shower holder",
	"question10.question": "Would you like to mount your head shower on the wall or on the ceiling?",
	"question10.option1.text": "Wall mounted head shower",
	"question10.option2.text": "Ceiling mounted head shower",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will need as well:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Start new configuration",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe-africa.com/en_eg/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe-africa.com/en_eg/company/legal-info.html",
	"footer.copyright": "&copy; 2018 GROME Marketing (PTY) Ltd.",
	"homepage.headline": "GROHE SmartControl Configurator",
	"homepage.introtext": "Just answer a few questions below to  configurate the GROHE SmartControl shower system that will fit your needs. ",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "For which area in your bathroom do you need a shower configuration?",
	"question1.option1.text": "For my shower area",
	"question1.option2.text": "For my bath tub including a bath spout",
	"question2.question": "What type of installation do you prefer? Exposed, Concealed  or a combination of both?",
	"question2.option1.text": "Exposed: easy & effortless solution for retrofitting in front of the wall",
	"question2.option2.text": "Combination: hidden piping inside the wall and a thermostat with tray in front of the wall",
	"question2.option3.text": "Concealed: clean minimalistic look with all technology hidden inside the wall",
	"question3.question": "Given the below options, which would you prefer to use to turn on the water flow?",
	"question3.option1.text": "With SmartControl operation and a Thermostat",
	"question3.option2.text": "With conventional operation and a thermostat",
	"question3.option3.text": "With a single lever mixer",
	"question3.option4.text": "With a diverter system (keeping existing faucet)",
	"question4.question": "What do you want to control with your Shower?",
	"question4.option1.text": "Only a hand shower",
	"question4.option2.text": "A large head shower (150-250mm) and a hand shower",
	"question4.option3.text": "An extra-large head shower (250-400mm) and a hand shower",
	"question4.option4.text": "A large head shower (150-250mm), a hand shower and a bath filler",
	"question4.option5.text": "An extra-large head shower (250-400mm), a hand shower and a bath filler",
	"question5.question": "What shape do you prefer?",
	"question5.option1.text": "Square",
	"question5.option2.text": "Round",
	"question6.question": "What do you want to control with your new SmartControl?",
	"question6.option1.text": "A head shower with two sprays and a hand shower",
	"question6.option2.text": "A head shower with two sprays and a hand shower",
	"question6.option3.text": "A head shower, a hand shower and a bath filler",
	"question6.option4.text": "A head shower, two side showers and a hand shower",
	"question6.option5.text": "A head shower and a hand shower",
	"question6.option6.text": "A hand shower and a bath filler",
	"question6.option7.text": "Only a hand shower",
	"question6.option8.text": "Only a bath filler",
	"question7.question": "Choose your colour",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "White/Chrome",
	"question7.option3.text": "White/Chrome",
	"question8.question": "Would you like a thermostat with an integrated hand shower holder?",
	"question8.option1.text": "Yes, with integrated shower holder",
	"question8.option2.text": "No, I will buy a separate hand shower holder",
	"question9.question": "How do you want your handshower to be held?",
	"question9.option1.text": "By a shower rail with height-adjustable shower holder",
	"question9.option2.text": "By a minimalistic shower holder",
	"question10.question": "Would you like to mount your head shower on the wall or on the ceiling?",
	"question10.option1.text": "Wall mounted head shower",
	"question10.option2.text": "Ceiling mounted head shower",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will need as well:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Start new configuration",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE SmartControl Configurator",
	"homepage.introtext": "Just answer a few questions below to  configurate the GROHE SmartControl shower system that will fit your needs. ",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "For which area in your bathroom do you need a shower configuration?",
	"question1.option1.text": "For my shower area",
	"question1.option2.text": "For my bath tub including a bath spout",
	"question2.question": "What type of installation do you prefer? Exposed, Concealed  or a combination of both?",
	"question2.option1.text": "Exposed: easy & effortless solution for retrofitting in front of the wall",
	"question2.option2.text": "Combination: hidden piping inside the wall and a thermostat with tray in front of the wall",
	"question2.option3.text": "Concealed: clean minimalistic look with all technology hidden inside the wall",
	"question3.question": "How would you like to operate your shower?",
	"question3.option1.text": "With SmartControl operation and a thermostat",
	"question3.option2.text": "With conventional operation and a thermostat",
	"question3.option3.text": "With a single lever mixer",
	"question3.option4.text": "With a diverter system (keeping existing faucet)",
	"question4.question": "What do you want to control with your Shower?",
	"question4.option1.text": "Only a hand shower",
	"question4.option2.text": "A large head shower (150-250mm) and a hand shower",
	"question4.option3.text": "An extra-large head shower (250-400mm) and a hand shower",
	"question4.option4.text": "A large head shower (150-250mm), a hand shower and a bath filler",
	"question4.option5.text": "An extra-large head shower (250-400mm), a hand shower and a bath filler",
	"question5.question": "What shape do you prefer?",
	"question5.option1.text": "Square",
	"question5.option2.text": "Round",
	"question6.question": "What do you want to control with your new SmartControl?",
	"question6.option1.text": "A head shower with two sprays and a hand shower",
	"question6.option2.text": "A head shower with two sprays and a hand shower",
	"question6.option3.text": "A head shower, a hand shower and a bath filler",
	"question6.option4.text": "A head shower, two side showers and a hand shower",
	"question6.option5.text": "A head shower and a hand shower",
	"question6.option6.text": "A hand shower and a bath filler",
	"question6.option7.text": "Only a hand shower",
	"question6.option8.text": "Only a bath filler",
	"question7.question": "Choose your colour",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "White/Chrome",
	"question7.option3.text": "White/Chrome",
	"question8.question": "Would you like a thermostat with an integrated hand shower holder?",
	"question8.option1.text": "Yes, with integrated shower holder",
	"question8.option2.text": "No, I will buy a separate hand shower holder",
	"question9.question": "How do you want your handshower to be held?",
	"question9.option1.text": "By a shower rail with height-adjustable shower holder",
	"question9.option2.text": "By a minimalistic shower holder",
	"question10.question": "Would you like to mount your head shower on the wall or on the ceiling?",
	"question10.option1.text": "Wall mounted head shower",
	"question10.option2.text": "Ceiling mounted head shower",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will need as well:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Start new configuration",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe-gcc.com/en_sa/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe-gcc.com/en_sa/company/legal-info.html",
	"footer.copyright": "&copy; Grome Marketing (Cyprus) Ltd.",
	"homepage.headline": "GROHE SmartControl Configurator",
	"homepage.introtext": "Just answer a few questions below to  configurate the GROHE SmartControl shower system that will fit your needs. ",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "For which area in your bathroom do you need a shower configuration?",
	"question1.option1.text": "For my shower area",
	"question1.option2.text": "For my bath tub including a bath spout",
	"question2.question": "What type of installation do you prefer? Exposed, Concealed  or a combination of both?",
	"question2.option1.text": "Exposed: easy & effortless solution for retrofitting in front of the wall",
	"question2.option2.text": "Combination: hidden piping inside the wall and a thermostat with tray in front of the wall",
	"question2.option3.text": "Concealed: clean minimalistic look with all technology hidden inside the wall",
	"question3.question": "Given the below options, which would you prefer to use to turn on the water flow?",
	"question3.option1.text": "With SmartControl operation and a Thermostat",
	"question3.option2.text": "With conventional operation and a thermostat",
	"question3.option3.text": "With a single lever mixer",
	"question3.option4.text": "With a diverter system (keeping existing faucet)",
	"question4.question": "What do you want to control with your Shower?",
	"question4.option1.text": "Only a hand shower",
	"question4.option2.text": "A large head shower (150-250mm) and a hand shower",
	"question4.option3.text": "An extra-large head shower (250-400mm) and a hand shower",
	"question4.option4.text": "A large head shower (150-250mm), a hand shower and a bath filler",
	"question4.option5.text": "An extra-large head shower (250-400mm), a hand shower and a bath filler",
	"question5.question": "What shape do you prefer?",
	"question5.option1.text": "Square",
	"question5.option2.text": "Round",
	"question6.question": "What do you want to control with your new SmartControl?",
	"question6.option1.text": "A head shower with two sprays and a hand shower",
	"question6.option2.text": "A head shower with two sprays and a hand shower",
	"question6.option3.text": "A head shower, a hand shower and a bath filler",
	"question6.option4.text": "A head shower, two side showers and a hand shower",
	"question6.option5.text": "A head shower and a hand shower",
	"question6.option6.text": "A hand shower and a bath filler",
	"question6.option7.text": "Only a hand shower",
	"question6.option8.text": "Only a bath filler",
	"question7.question": "Choose your colour",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "White/Chrome",
	"question7.option3.text": "White/Chrome",
	"question8.question": "Would you like a thermostat with an integrated hand shower holder?",
	"question8.option1.text": "Yes, with integrated shower holder",
	"question8.option2.text": "No, I will buy a separate hand shower holder",
	"question9.question": "How do you want your handshower to be held?",
	"question9.option1.text": "By a shower rail with height-adjustable shower holder",
	"question9.option2.text": "By a minimalistic shower holder",
	"question10.question": "Would you like to mount your head shower on the wall or on the ceiling?",
	"question10.option1.text": "Wall mounted head shower",
	"question10.option2.text": "Ceiling mounted head shower",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will need as well:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Start new configuration",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.es/es_es/privacidad.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.es/es_es/imprimir.html",
	"footer.copyright": "&copy; 2018 Grohe España, S.A.",
	"homepage.headline": "Configurador de GROHE SmartControl",
	"homepage.introtext": "Encuentra el sistema de ducha GROHE SmartControl que encaje mejor con tus necesidades. Tu experiencia de ducha perfecta está aquí mismo, en las puntas de tus dedos.",
	"homepage.buttonStart": "Empezar",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Ver resultados",
	"question1.question": "¿Para qué zona de tu cuarto de baño necesitas una configuración de ducha?",
	"question1.option1.text": "Para mi zona de ducha",
	"question1.option2.text": "Para mi bañera, e incluirá un caño de bañera",
	"question2.question": "¿Qué tipo de instalación prefieres? ¿Vista, empotrada o una combinación de ambas?",
	"question2.option1.text": "Instalación a la vista: solución fácil y sin esfuerzos para actualización sobre la pared",
	"question2.option2.text": "Combinación: tuberías ocultas dentro de la pared y un termostato con bandeja sobre la pared",
	"question2.option3.text": "Empotrada: aspecto limpio y minimalista con toda la tecnología oculta dentro de la pared",
	"question3.question": "¿Cómo quieres que funcione tu ducha?",
	"question3.option1.text": "Funcionamiento con SmartControl y un termostato",
	"question3.option2.text": "Funcionamiento convencional y un termostato",
	"question3.option3.text": "Con un mezclador monomando",
	"question3.option4.text": "Con un sistema inversor (manteniendo la grifería actual)",
	"question4.question": "¿Qué quieres controlar con tu ducha?",
	"question4.option1.text": "Solo una teleducha",
	"question4.option2.text": "Una ducha mural grande (150-250 mm) y una teleducha",
	"question4.option3.text": "Una ducha mural extragrande (250-400 mm) y una teleducha",
	"question4.option4.text": "Una ducha mural grande (150-250 mm), una teleducha y un llenador de bañera",
	"question4.option5.text": "Una ducha mural extragrande (250-400 mm), una teleducha y un llenador de bañera",
	"question5.question": "¿Qué forma prefieres?",
	"question5.option1.text": "Cuadrada",
	"question5.option2.text": "Redonda",
	"question6.question": "¿Qué quieres controlar con tu nuevo SmartControl?",
	"question6.option1.text": "Una ducha mural con dos chorros y una teleducha",
	"question6.option2.text": "Una ducha mural con dos chorros y una teleducha",
	"question6.option3.text": "Una ducha mural, una teleducha y un llenador de bañera",
	"question6.option4.text": "Una ducha mural, dos duchas laterales y una teleducha",
	"question6.option5.text": "Una ducha mural y una teleducha",
	"question6.option6.text": "Una teleducha y un llenador de bañera",
	"question6.option7.text": "Solo una teleducha",
	"question6.option8.text": "Solo un llenador de bañera",
	"question7.question": "Elige tu color",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Blanco/Chrome",
	"question7.option3.text": "Blanco/Chrome",
	"question8.question": "¿Te gustaría incluir un termostato con un soporte de teleducha integrado?",
	"question8.option1.text": "Sí, con un soporte de teleducha integrado",
	"question8.option2.text": "No, compraré un soporte de teleducha aparte",
	"question9.question": "¿Cómo quieres que sea el soporte de la teleducha?",
	"question9.option1.text": "Una barra de ducha con soporte de ducha regulable en altura",
	"question9.option2.text": "Un soporte de ducha minimalista",
	"question10.question": "¿Quieres montar tu ducha mural en la pared o en el techo?",
	"question10.option1.text": "Ducha mural montada sobre la pared",
	"question10.option2.text": "Ducha mural montada en el techo",
	"results.title": "{productGroupsCount, plural, \none {Tu resultado} \nother {Tus resultados}\n}",
	"results.proposal.title": "Propuesta {number}",
	"results.proposal.title.single": "Propuesta",
	"results.bundle.title": "Para que la instalación sea correcta, también necesitarás:",
	"results.newConfiguration.title": "¿Quieres configurar un nuevo sistema de ducha?",
	"results.newConfiguration.buttonText": "Empezar nueva configuración",
	"results.product.number": "Número de producto: #{number}",
	"results.product.button.productInformation": "Información del producto",
	"results.product.button.dealerLocator": "Buscar una sala de exposición y venta",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Comprar en línea",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "Aide à la décision GROHE Smart Control",
	"homepage.headline": "Aide à la décision GROHE Smart Control",
	"homepage.introtext": "Répondez à quelques questions ci-dessous pour trouver le système de douche GROHE SmartControl le plus adapté à vos besoins.",
	"homepage.buttonStart": "Démarrez",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": " https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": " https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.copyright": "© 2017 GROHE N.V.-S.A.",
	"configurator.button.seeResults": "Voir résultats",
	"question1.question": "Où souhaitez-vous prendre votre douche?",
	"question1.option1.text": "Espace de douche",
	"question1.option2.text": "Dans la baignoire",
	"question2.question": "Quel est le type que vous préférez ? Encastrable, à poser ou une combinaison des deux?",
	"question2.option1.text": "Mitigeur thermostatique et douche installés apparents",
	"question2.option2.text": "Mitigeur thermostatique installé apparent, mais avec douche encastrée",
	"question2.option3.text": "Totalement encastré",
	"question3.question": "Où souhaitez-vous prendre votre douche?",
	"question3.option1.text": "Avec le thermostatique  SmartControl",
	"question3.option2.text": "Avec un mitigeur thermostatique",
	"question3.option3.text": "Mitigeur monocommande douche",
	"question3.option4.text": "Inverseur manuel (sur un système de douche déjà existant)",
	"question4.question": "Que souhaitez-vous contrôler avec votre douche?",
	"question4.option1.text": "Uniquement la douchette à main",
	"question4.option2.text": "Une large douche de tête (150-250mm) et une douchette à main",
	"question4.option3.text": "Une douche de tête extra large (250-400mm) et une douchette à main",
	"question4.option4.text": "Une large douche de tête (150-250mm), une douchette à main et vidage baignoire",
	"question4.option5.text": "Une douche de tête extra large (250-400mm), une douchette à main et vidage baignoire",
	"question5.question": "Quelle est la forme que vous préférez?",
	"question5.option1.text": "Carré",
	"question5.option2.text": "Rond",
	"question6.question": "De combien de boutons de commande SmartControl avez-vous besoin?",
	"question6.option1.text": "Trois : douche de tête avec 2 types de jets et douchette",
	"question6.option2.text": "Trois : douche de tête avec 2 types de jets et bec de baignoire",
	"question6.option3.text": "Trois : douche de tête, douchette en bec de baignoire",
	"question6.option4.text": "Trois : douche de tête, douche latérale et douchette",
	"question6.option5.text": "Deux : douche de tête et douchette",
	"question6.option6.text": "Deux : douchette et bec de baignoire",
	"question6.option7.text": "Un : uniquement douchette",
	"question6.option8.text": "Un : bec de baignoire",
	"question7.question": "Choisissez votre couleur?",
	"question7.option1.text": "Chromée",
	"question7.option2.text": "Blanc/Chromée",
	"question7.option3.text": "Blanc/Chromée",
	"question8.question": " Voulez-vous un panneau de commande avec support pour douchette intégré?",
	"question8.option1.text": "Oui, avec support pour douchette intégré",
	"question8.option2.text": "Non, j'achète un support pour douchette séparément",
	"question9.question": "Voulez-vous une barre de douche ou un support mural avec la douchette?",
	"question9.option1.text": "Barre de douche",
	"question9.option2.text": "Support mural",
	"question10.question": "Voulez-vous une douche de tête montée sur le mur ou une douche de plafond?",
	"question10.option1.text": "Douche de tête montée sur le mur",
	"question10.option2.text": "Douche de plafond",
	"results.title": "{productGroupsCount, plural, \none {Votre résultat} \nother {Vos résultats}\n}",
	"results.bundle.title": "Pour une installation correcte, vous avez également besoin de:",
	"results.newConfiguration.buttonText": "Recommencez",
	"results.product.button.productInformation": "Informations produit",
	"results.product.button.dealerLocator": "Cherchez un point de vente",
	"results.product.button.buyNow": "Achetez en ligne",
	"results.product.information": "Informations produit",
	"results.product.dealer": "Cherchez un point de vente",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.newConfiguration.title": "Voulez-vous recommencer?",
	"results.product.number": "numéro d’article: #{number}",
	"results.product.button.downloadPDF": "Télécharger la proposition (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "404 Page introuvable",
	"404.link.goBack": "Retour à la page d’accueil"
};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "Le configurateur de douche GROHE",
	"homepage.headline": "Le configurateur de douche GROHE",
	"homepage.introtext": "Répondez à quelques questions ci-dessous pour trouver le système de douche GROHE SmartControl le plus adapté à vos besoins.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Vie privée",
	"footer.privacy.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Mentions légales",
	"footer.disclaimer.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/mentions-legales.html",
	"footer.copyright": "&copy; 2018 GROHE Switzerland SA",
	"configurator.button.seeResults": "Résultats",
	"question1.question": "Où souhaitez-vous prendre votre douche?",
	"question1.option1.text": "Douche",
	"question1.option2.text": "Bain",
	"question2.question": "Quel type d'installation préférez-vous ? Apparent ou Encastré?",
	"question2.option1.text": "Installation apparente de la douche et du thermostatique",
	"question2.option2.text": "Mitigeur thermostatique installé apparent, mais avec douche encastrée",
	"question2.option3.text": "installation encastrée",
	"question3.question": "Où souhaitez-vous prendre votre douche?",
	"question3.option1.text": "Avec le thermostatique  SmartControl",
	"question3.option2.text": "Avec un mitigeur thermostatique",
	"question3.option3.text": "Mitigeur monocommande douche",
	"question3.option4.text": "Inverseur manuel (sur un système de douche déjà existant)",
	"question4.question": "Que souhaitez-vous contrôler avec votre douche?",
	"question4.option1.text": "Uniquement la douchette à main",
	"question4.option2.text": "Une large douche de tête (150-250mm) et une douchette à main",
	"question4.option3.text": "Une douche de tête extra large (250-400mm) et une douchette à main",
	"question4.option4.text": "Une large douche de tête (150-250mm), une douchette à main et vidage baignoire",
	"question4.option5.text": "Une douche de tête extra large (250-400mm), une douchette à main et vidage baignoire",
	"question5.question": "Quel design préférez-vous?",
	"question5.option1.text": "Carré",
	"question5.option2.text": "Rond",
	"question6.question": "Combien de sortie d'eau avez-vous besoin?",
	"question6.option1.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option2.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option3.text": "Trois sorties : Douche de tête, douchette à main et  bec de remplissage",
	"question6.option4.text": "Trois sorties : Douche de tête, douchette latérale et douchette à main",
	"question6.option5.text": "Deux sorties : Douche de tête et douchette à main",
	"question6.option6.text": "Deux sorties : Douchette à main et bec de remplissage",
	"question6.option7.text": "Une sortie : seulement une douchette à main",
	"question6.option8.text": "Une sortie : Bec bain",
	"question7.question": "Choisissez votre couleur?",
	"question7.option1.text": "Chromée",
	"question7.option2.text": "Blanc/Chromé",
	"question7.option3.text": "Blanc/Chromé",
	"question8.question": "Souhaitez-vous  une façade  avec un support de douchette intégré?",
	"question8.option1.text": "Oui, avec un support de douchette intégré",
	"question8.option2.text": "Non, j'achèterai un support de douchette séparement",
	"question9.question": "Souhaitez-vous un ensemble de douche avec une barre pour la douchette à main ou simplement un support mural?",
	"question9.option1.text": "Ensemble de douche",
	"question9.option2.text": "Support de douche mural",
	"question10.question": "Préférez-vous une douche de tête avec un bras horizontal ou vertical",
	"question10.option1.text": "Douche de tête avec un bras horizontal",
	"question10.option2.text": "Douche de tête avec un bras vertical",
	"results.title": "{productGroupsCount, plural, \none {Votre résultat} \nother {Vos résultats}\n}",
	"results.bundle.title": "Pour une bonne installation, vous aurez également  besoin de:",
	"results.newConfiguration.buttonText": "Commencez une nouvelle configuration",
	"results.product.button.productInformation": "Des informations relatives au produit",
	"results.product.button.dealerLocator": "Trouvez une salle d'exposition",
	"results.product.button.buyNow": "Achetez en ligne",
	"results.product.information": "Des informations relatives au produit",
	"results.product.dealer": "Trouvez une salle d'exposition",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.newConfiguration.title": "Voulez-vous configurer un nouveau système de douche ?",
	"results.product.number": "Référence #{number}",
	"results.product.button.downloadPDF": "Télécharger la proposition (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "Erreur page 404",
	"404.link.goBack": "Retour à la page d’accueil"
};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "Le configurateur de douche GROHE",
	"homepage.headline": "Le configurateur de douche GROHE",
	"homepage.introtext": "Répondez à quelques questions ci-dessous pour trouver le système de douche GROHE SmartControl le plus adapté à vos besoins.",
	"homepage.buttonStart": "Commencez",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Vie privée",
	"footer.privacy.url": "https://www.grohe.fr/fr_fr/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Mentions légales",
	"footer.disclaimer.url": "https://www.grohe.fr/fr_fr/entreprise-grohe/mentions-legales.html",
	"footer.copyright": " © 2017 © GROHE S.A.R.L.",
	"configurator.button.seeResults": "Résultats",
	"question1.question": "Où souhaitez-vous prendre votre douche?",
	"question1.option1.text": "Douche",
	"question1.option2.text": "Bain",
	"question2.question": "Quel type d'installation préférez-vous? Apparent ou Encastré?",
	"question2.option1.text": "Installation apparente de la douche et du thermostatique",
	"question2.option2.text": "Mitigeur thermostatique installé apparent, mais avec douche encastrée",
	"question2.option3.text": "Installation encastrée",
	"question3.question": "Où souhaitez-vous prendre votre douche?",
	"question3.option1.text": "Avec le thermostatique  SmartControl",
	"question3.option2.text": "Avec un mitigeur thermostatique",
	"question3.option3.text": "Mitigeur monocommande douche",
	"question3.option4.text": "Inverseur manuel (sur un système de douche déjà existant)",
	"question4.question": "Que souhaitez-vous contrôler avec votre douche?",
	"question4.option1.text": "Uniquement la douchette à main",
	"question4.option2.text": "Une large douche de tête (150-250mm) et une douchette à main",
	"question4.option3.text": "Une douche de tête extra large (250-400mm) et une douchette à main",
	"question4.option4.text": "Une large douche de tête (150-250mm), une douchette à main et vidage baignoire",
	"question4.option5.text": "Une douche de tête extra large (250-400mm), une douchette à main et vidage baignoire",
	"question5.question": "Quel design préférez-vous?",
	"question5.option1.text": "Carré",
	"question5.option2.text": "Rond",
	"question6.question": "Combien de sortie d'eau avez-vous besoin?",
	"question6.option1.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option2.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option3.text": "Trois sorties : Douche de tête, douchette à main et  bec de remplissage",
	"question6.option4.text": "Trois sorties : Douche de tête, douchette latérale et douchette à main",
	"question6.option5.text": "Deux sorties : Douche de tête et douchette à main",
	"question6.option6.text": "Deux sorties : Douchette à main et bec de remplissage",
	"question6.option7.text": "Une sortie : seulement une douchette à main",
	"question6.option8.text": "Une sortie : Bec bain",
	"question7.question": "Choisissez votre couleur?",
	"question7.option1.text": "Chromée",
	"question7.option2.text": "Blanc/Chromée",
	"question7.option3.text": "Blanc/Chromée",
	"question8.question": "Souhaitez-vous  une façade  avec un support de douchette intégré?",
	"question8.option1.text": "Oui, avec un support de douchette intégré",
	"question8.option2.text": "Non, j'achèterai un support de douchette séparement",
	"question9.question": "Souhaitez-vous un ensemble de douche avec une barre pour la douchette à main ou simplement un support mural?",
	"question9.option1.text": "Ensemble de douche",
	"question9.option2.text": "Support de douche mural",
	"question10.question": "Préférez-vous une douche de tête avec un bras horizontal ou vertical",
	"question10.option1.text": "Douche de tête avec un bras horizontal",
	"question10.option2.text": "Douche de tête avec un bras vertical",
	"results.title": "{productGroupsCount, plural, \none {Votre résultat} \nother {Vos résultats}\n}",
	"results.bundle.title": "Pour une bonne installation, vous aurez également  besoin de:",
	"results.newConfiguration.buttonText": "Commencez une nouvelle configuration",
	"results.product.button.productInformation": "Des informations relatives au produit",
	"results.product.button.dealerLocator": "Trouvez une salle d'exposition",
	"results.product.button.buyNow": "Achetez en ligne",
	"results.product.information": "Des informations relatives au produit",
	"results.product.dealer": "Trouvez une salle d'exposition",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.newConfiguration.title": "Voulez-vous configurer un nouveau système de douche ?",
	"results.product.number": "Référence #{number}",
	"results.product.button.downloadPDF": "Télécharger la proposition (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Achetez en ligne",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "Erreur page 404",
	"404.link.goBack": "Retour à la page d’accueil"
};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Impresszum",
	"footer.privacy.url": "https://www.grohe.hu/hu_hu/company/privacy.html",
	"footer.disclaimer.text": "Jogi információk",
	"footer.disclaimer.url": "https://www.grohe.hu/hu_hu/company/legal-info.html",
	"footer.copyright": "&copy; 2017 Grohe Hungary Kft.",
	"homepage.headline": "GROHE Zuhanyrendszer Konfigurátor",
	"homepage.introtext": "Az alábbi kérdőív kitöltésével segítünk az Önhöz leginkább illő GROHE Smartcontrol zuhanyrendszer összeállításában.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Az oldal nem található",
	"404.link.goBack": "Vissza a címlapra",
	"configurator.button.seeResults": "Eredmények megtekintése",
	"question1.question": "Fürdőkádhoz vagy zuhanykabinhoz szerezne be zuhanyrendszert?",
	"question1.option1.text": "Zuhanykabinhoz",
	"question1.option2.text": "Fürdőkádhoz",
	"question2.question": "Válassza ki a kívánt kialakítást!",
	"question2.option1.text": "Felsík előtti kialakítás",
	"question2.option2.text": "Falsík előtti kialakítás a csaptelepre és falsík mögötti a zuhany további elemeire",
	"question2.option3.text": "Falsík mögötti kialakítás",
	"question3.question": "Hogyan szeretné működtetni zuhanyrendszerét?",
	"question3.option1.text": "Termosztátos módon, SmartControl vezéléssel",
	"question3.option2.text": "Hagyományos termosztátos módon",
	"question3.option3.text": "Egykaros keverővel",
	"question3.option4.text": "Diverteres rendszerrel, a meglévő kádcsaptelepem megtartásával",
	"question4.question": "Milyen felszereltségű zuhanyrendszert választana?",
	"question4.option1.text": "Csak kézizuhanyos kivitelt",
	"question4.option2.text": "Nagy fejzuhanyt (150-250mm) és kézizuhanyt",
	"question4.option3.text": "Óriási fejzuhanyt (250-400mm) és kézizuhanyt",
	"question4.option4.text": "Nagy fejzuhanyt (150-250mm) és kézizuhanyt",
	"question4.option5.text": "Óriási fejzuhanyt (250-400mm) és kézizuhanyt",
	"question5.question": "Válassza ki a kívánt formát!",
	"question5.option1.text": "Szögletes",
	"question5.option2.text": "Lekerekített",
	"question6.question": "Hány víz kimenettel számolhatunk?",
	"question6.option1.text": "Három víz kimenet: Fejzuhany normál és masszás funkcióval, illetve kézizuhany",
	"question6.option2.text": "Három víz kimenet: Kétfunkciós fejzuhany és kézizuhany",
	"question6.option3.text": "Három víz kimenet: Fejzuhany, kézizuhany és kádtöltő",
	"question6.option4.text": "Három víz kimenet: Fejzuhany, kézizuhany és oldalsó szórófej",
	"question6.option5.text": "Kettő víz kimenet: Fejzuhany és kézizuhany",
	"question6.option6.text": "Kettő víz kimenet: Kézizuhany és kádtöltő",
	"question6.option7.text": "Egyetlen víz kimenet: Kizárólag kézizuhany",
	"question6.option8.text": "Egyetlen víz kimenet: Kádtöltő",
	"question7.question": "Válassza ki a kívánt színt!",
	"question7.option1.text": "Króm",
	"question7.option2.text": "Fehér / króm",
	"question7.option3.text": "Fehér / króm",
	"question8.question": "Szeretné a szetthez tartozó kézizuhany tartót választani?",
	"question8.option1.text": "Nem, más kézizuhany tartót választok",
	"question8.option2.text": "Igen",
	"question9.question": "Kérjük, válasszon a  zuhanysínes vagy a fix falitartós kézizuhany szettek közül!",
	"question9.option1.text": "Zuhanysínes kézizuhany szett",
	"question9.option2.text": "Fix falitartós kézizuhany szett",
	"question10.question": "Kérjük, válasszon a fali vagy mennyezeti fejzuhany kivitelek között!",
	"question10.option1.text": "Fali fejzuhany",
	"question10.option2.text": "Mennyezeti fejzuhany",
	"results.title": "Your {productGroupsCount, plural, \none {Eredmény} \nother {Eredmény}\n}",
	"results.proposal.title": "Ajánlatunk {number}",
	"results.proposal.title.single": "Ajánlatunk",
	"results.bundle.title": "A helyes beszereléshez, az alábbi kellékekre is szükség lesz:",
	"results.newConfiguration.title": "Szeretné újrakezdeni a zuhanykonfigurátort?",
	"results.newConfiguration.buttonText": "Elölről kezdem",
	"results.product.number": "Cikkszám: #{number}",
	"results.product.button.productInformation": "Termékleírás",
	"results.product.button.dealerLocator": "Bemutatóterem keresése",
	"results.product.button.buyNow": "Online vásárlás",
	"results.product.button.downloadPDF": "Ajánlatok letöltése(PDF)",
	"results.product.information": "Termékleírás",
	"results.product.dealer": "Bemutatóterem keresése",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "Configuratore GROHE SmartControl.",
	"homepage.headline": "Configuratore GROHE SmartControl",
	"homepage.introtext": "Rispondi alle domande che seguono per configurare il sistema doccia GROHE SmartControl adatto alle tue esigenze.",
	"homepage.buttonStart": "Inizio",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ch/it_ch/azienda/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.ch/it_ch/azienda/note-legali.html",
	"footer.copyright": "&copy; 2018 GROHE Switzerland SA",
	"configurator.button.seeResults": "Guarda i risultati",
	"question1.question": "Per quale zona del bagno hai bisogno del configuratore doccia?",
	"question1.option1.text": "Per la mia zona doccia",
	"question1.option2.text": "Per la mia zona vasca",
	"question2.question": "Che tipo di installazione preferisci? Esterna, ad incasso o una combinazione delle due?",
	"question2.option1.text": "Esterna: soluzione semplice e veloce di fronte al muro",
	"question2.option2.text": "Combinazione: tubazioni nascoste dietro al muro e termostatico esterno con mensola portasapone di fronte al muro",
	"question2.option3.text": "Incasso: look pulito e minimale con tutta la tecnologia nascosta dietro al muro",
	"question3.question": "Come vorresti azionare la tua doccia?",
	"question3.option1.text": "Con un azionamento ed un controllo facile (SmartControl) e un miscelatore termostatico",
	"question3.option2.text": "Con un azionamento tradizionale ed un miscelatore termostatico",
	"question3.option3.text": "Con un miscelatore monocomando",
	"question3.option4.text": "Con un sistema con deviatore (per mantenere l'attuale miscelatore)",
	"question4.question": "Cosa vorresti poter gestire con la tua doccia?",
	"question4.option1.text": "Solo una manopola doccia",
	"question4.option2.text": "Un soffione grande (150-250mm) e una manopola doccia",
	"question4.option3.text": "Un soffione extra large (250-400mm) e una manopola doccia",
	"question4.option4.text": "Un soffione grande (150-250mm), una manopola doccia e una bocca vasca",
	"question4.option5.text": "Un soffione extra large (250-400mm), una manopola doccia e una bocca vasca",
	"question5.question": "Che forma preferisci?",
	"question5.option1.text": "Squadrata",
	"question5.option2.text": "Tonda",
	"question6.question": "Cosa vorresti poter gestire con la tua nuova doccia SmartControl?",
	"question6.option1.text": "Un soffione a due getti e una manopola doccia",
	"question6.option2.text": "Un soffione a due getti e una manopola doccia",
	"question6.option3.text": "Un soffione, una manopola doccia e una bocca vasca",
	"question6.option4.text": "Un soffione, due getti laterali e una manopola doccia",
	"question6.option5.text": "Un soffione e una manopola doccia",
	"question6.option6.text": "Una manopola doccia e una bocca vasca",
	"question6.option7.text": "Solo una manopola doccia",
	"question6.option8.text": "Solo una bocca vasca",
	"question7.question": "Scegli il colore",
	"question7.option1.text": "Cromo",
	"question7.option2.text": "Bianco/Cromo",
	"question7.option3.text": "Bianco/Cromo",
	"question8.question": "Vuoi un miscelatore termostatico con il supporto per la manopola doccia incluso?",
	"question8.option1.text": "No, acquisterò un supporto per la manopola doccia separatamente",
	"question8.option2.text": "Sì, con un supporto per la manopola doccia integrato",
	"question9.question": "Come vorresti  fosse tenuta la tua manopola doccia?",
	"question9.option1.text": "Da un'asta doccia con un supporto per manopola doccia regolabile",
	"question9.option2.text": "Da un suppporto minimal",
	"question10.question": "Vuoi installare il tuo soffione alla parete o al soffitto?",
	"question10.option1.text": "A parete",
	"question10.option2.text": "A soffitto",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione avrai bisogno anche di:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Inizia una nuova configurazione",
	"results.product.number": "Codice articolo: #{number}",
	"results.product.button.productInformation": "Informazione di prodotto",
	"results.product.button.dealerLocator": "Trova uno showroom",
	"results.product.button.buyNow": "Buy now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Trova uno showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "Erreur page 404",
	"404.link.goBack": "Retour à la page d’accueil"
};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.it/it_it/azienda/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.it/it_it/azienda/note-legali.html",
	"footer.copyright": "&copy; 2018 Grohe S.p.A.",
	"homepage.headline": "Configuratore GROHE SmartControl",
	"homepage.introtext": "Rispondi alle domande che seguono per configurare il sistema doccia GROHE SmartControl adatto alle tue esigenze.",
	"homepage.buttonStart": "Inizio",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Guarda i risultati",
	"question1.question": "Per quale zona del bagno hai bisogno del configuratore doccia?",
	"question1.option1.text": "Per la mia zona doccia",
	"question1.option2.text": "Per la mia zona vasca",
	"question2.question": "Che tipo di installazione preferisci? Esterna, ad incasso o una combinazione delle due?",
	"question2.option1.text": "Esterna: soluzione semplice e veloce di fronte al muro",
	"question2.option2.text": "Combinazione: tubazioni nascoste dietro al muro e termostatico esterno con mensola portasapone di fronte al muro",
	"question2.option3.text": "Incasso: look pulito e minimale con tutta la tecnologia nascosta dietro al muro",
	"question3.question": "Come vorresti azionare la tua doccia?",
	"question3.option1.text": "Con un azionamento ed un controllo facile (SmartControl) e un miscelatore termostatico",
	"question3.option2.text": "Con un azionamento tradizionale ed un miscelatore termostatico",
	"question3.option3.text": "Con un miscelatore monocomando",
	"question3.option4.text": "Con un sistema con deviatore (per mantenere l'attuale miscelatore)",
	"question4.question": "Cosa vorresti poter gestire con la tua doccia?",
	"question4.option1.text": "Solo una manopola doccia",
	"question4.option2.text": "Un soffione grande (150-250mm) e una manopola doccia",
	"question4.option3.text": "Un soffione extra large (250-400mm) e una manopola doccia",
	"question4.option4.text": "Un soffione grande (150-250mm), una manopola doccia e una bocca vasca",
	"question4.option5.text": "Un soffione extra large (250-400mm), una manopola doccia e una bocca vasca",
	"question5.question": "Che forma preferisci?",
	"question5.option1.text": "Squadrata",
	"question5.option2.text": "Tonda",
	"question6.question": "Cosa vorresti poter gestire con la tua nuova doccia SmartControl?",
	"question6.option1.text": "Un soffione a due getti e una manopola doccia",
	"question6.option2.text": "Un soffione a due getti e una manopola doccia",
	"question6.option3.text": "Un soffione, una manopola doccia e una bocca vasca",
	"question6.option4.text": "Un soffione, due getti laterali e una manopola doccia",
	"question6.option5.text": "Un soffione e una manopola doccia",
	"question6.option6.text": "Una manopola doccia e una bocca vasca",
	"question6.option7.text": "Solo una manopola doccia",
	"question6.option8.text": "Solo una bocca vasca",
	"question7.question": "Scegli il colore",
	"question7.option1.text": "Cromo",
	"question7.option2.text": "Bianco/Cromo",
	"question7.option3.text": "Bianco/Cromo",
	"question8.question": "Vuoi un miscelatore termostatico con il supporto per la manopola doccia incluso?",
	"question8.option1.text": "Sì, con un supporto per la manopola doccia integrato",
	"question8.option2.text": "No, acquisterò un supporto per la manopola doccia separatamente",
	"question9.question": "Come vorresti  fosse tenuta la tua manopola doccia?",
	"question9.option1.text": "Da un'asta doccia con un supporto per manopola doccia regolabile",
	"question9.option2.text": "Da un suppporto minimal",
	"question10.question": "Vuoi installare il tuo soffione alla parete o al soffitto?",
	"question10.option1.text": "A parete",
	"question10.option2.text": "A soffitto",
	"results.title": "{productGroupsCount, plural, \none {Il tuo risultato} \nother {I tuoi risultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione avrai bisogno anche di:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Inizia una nuova configurazione",
	"results.product.number": "Codice articolo: #{number}",
	"results.product.button.productInformation": "Informazione di prodotto",
	"results.product.button.dealerLocator": "Trova uno showroom",
	"results.product.button.buyNow": "Buy now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Trova uno showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Acquista online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE SmartControl douche-keuzehulp",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": " https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": " https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.copyright": "© 2017 GROHE N.V. – S.A.",
	"homepage.headline": "GROHE SmartControl douche-keuzehulp",
	"homepage.introtext": "Beantwoord onderstaande vragen en ontdek wat jouw ideale GROHE SmartControl douche is die voldoet aan jouw wensen.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Voor welke ruimte in je badkamer heb je een douche nodig?",
	"question1.option1.text": "Doucheruimte",
	"question1.option2.text": "Voor mijn bad, inclusief een baduitloop",
	"question2.question": "Welke type installatie heeft jouw voorkeur? Inbouw, opbouw of een combinatie daarvan? ",
	"question2.option1.text": "Opbouw: eenvoudige oplossing voor renovatie van je badkamer",
	"question2.option2.text": "Combinatie: opbouw installatie van thermostaatkraan met tray, maar met inbouwdouche",
	"question2.option3.text": "Inbouw: minimalistische look met alle techniek achter de muur verwerkt",
	"question3.question": "Hoe wil je je douche graag bedienen?",
	"question3.option1.text": "Met SmartControl-bediening en een thermostaat",
	"question3.option2.text": "Met de gewoonlijke bediening en een thermostaat",
	"question3.option3.text": "Met een eengreepsmengkraan",
	"question3.option4.text": "Met een omleidingssyteem (huidige kraan behouden)",
	"question4.question": "Wat wil je bedienen met je douche?",
	"question4.option1.text": "Enkel een handdouche",
	"question4.option2.text": "Een grote hoofddouche (150-250mm)  en een handdouche",
	"question4.option3.text": "Een extra grote hoofddouche (250-400mm) en een handdouche",
	"question4.option4.text": "Een grote hoofddouche (150-250mm),  een handdouche en een badvuller",
	"question4.option5.text": "Een extra grote hoofddocuche (250-400mm), een handdouche en een badvuller",
	"question5.question": "Welke vorm heeft jouw voorkeur?",
	"question5.option1.text": "Vierkant",
	"question5.option2.text": "Rond",
	"question6.question": "Wat wil je bedienen met je nieuwe SmartControl?",
	"question6.option1.text": "Een hoofddouche met twee straalsoorten en een handdouche",
	"question6.option2.text": "Een hoofddouche met twee straalsoorten en een handdouche",
	"question6.option3.text": "Een hoofddouche, handdouche en baduitloop",
	"question6.option4.text": "Een hoofddouche, twee zijdouches en een handdouche",
	"question6.option5.text": "Een hoofddouche en handdouche",
	"question6.option6.text": "Een handdouche en baduitloopt",
	"question6.option7.text": "Alleen handdouche",
	"question6.option8.text": "Alleen een baduitloop",
	"question7.question": "Kies de gewenste kleur",
	"question7.option1.text": "Chroom",
	"question7.option2.text": "Wit/chroom",
	"question7.option3.text": "Wit/chroom",
	"question8.question": " Wil je een thermostaatkraan met geïntegreerde handdouchehouder?",
	"question8.option1.text": "Ja, met geïntegreerde handdouchehouder",
	"question8.option2.text": "Nee ik koop een aparte handdouchehouder",
	"question9.question": "Hoe wil je je handdouche bevestigen?",
	"question9.option1.text": "Met een glijstang met verstelbare douchehouder",
	"question9.option2.text": "Met een minimalistische wandhouder",
	"question10.question": "Wil je een wandgemonteerde hoofddouche of een plafonddouche?",
	"question10.option1.text": "Wandgemonteerde hoofddouche",
	"question10.option2.text": "Plafonddouche",
	"results.title": "{productGroupsCount, plural, \none {Jouw resultaat} \nother {Jouw resultaten}\n}",
	"results.bundle.title": "Voor een correcte installatie heb je ook nodig:",
	"results.newConfiguration.buttonText": "Begin opnieuw",
	"results.product.button.productInformation": "Productinformatie",
	"results.product.button.dealerLocator": "Zoek verkooppunt",
	"results.product.button.buyNow": "Koop online",
	"results.product.information": "Productinformatie",
	"results.product.dealer": "Zoek verkooppunt",
	"results.newConfiguration.title": "Wil je opnieuw beginnen?",
	"results.product.number": "Artikelnummer: #{number}",
	"results.proposal.title": "Voorstel {number}",
	"results.proposal.title.single": "Voorstel",
	"results.product.button.downloadPDF": "Download voorstel (PDF)",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Terug naar de homepage",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl douche-keuzehulp"
};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE SmartControl douche-keuzehulp",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.nl/nl_nl/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.nl/nl_nl/privacybeleid.html",
	"footer.copyright": "© 2017 Grohe Nederland B.V.",
	"homepage.headline": "GROHE SmartControl douche-keuzehulp",
	"homepage.introtext": "Op zoek naar jouw ideale douche? Beantwoord een paar simpele vragen en vind de perfecte keuze voor jou binnen enkele seconden!",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Voor welke ruimte in je badkamer heb je een douche nodig?",
	"question1.option1.text": "Doucheruimte",
	"question1.option2.text": "Voor mijn bad, inclusief een baduitloop",
	"question2.question": "Welke type installatie heeft jouw voorkeur? Inbouw, opbouw of een combinatie daarvan? ",
	"question2.option1.text": "Opbouw: eenvoudige oplossing voor renovatie van je badkamer",
	"question2.option2.text": "Combinatie: opbouw installatie van thermostaatkraan met tray, maar met inbouwdouche",
	"question2.option3.text": "Inbouw: minimalistische look met alle techniek achter de muur verwerkt",
	"question3.question": "Hoe wil je je douche bedienen?",
	"question3.option1.text": "Met een SmartControl thermostaatkraan",
	"question3.option2.text": "Met een reguliere thermostaatkraan",
	"question3.option3.text": "Met een mengkraan",
	"question3.option4.text": "Met een omstelling (ik maak gebruik van mijn huidige douchekraan)",
	"question4.question": "Wat wil je bedienen in de douche?",
	"question4.option1.text": "Alleen een handdouche",
	"question4.option2.text": "Een grote hoofddouche (150-250 mm) en een handdouche",
	"question4.option3.text": "Een extra grote hoofddouche (250-400 mm) en een handdouche",
	"question4.option4.text": "Een grote hoofddouche (150-250 mm), een handdouche en een baduitloop",
	"question4.option5.text": "Een extra grote hoofddouche (250-400mm), een handdouche en een baduitloop",
	"question5.question": "Welke vorm heeft jouw voorkeur?",
	"question5.option1.text": "Vierkant",
	"question5.option2.text": "Rond",
	"question6.question": "Wat wil je bedienen met je nieuwe SmartControl?",
	"question6.option1.text": "Een hoofddouche met 2 straalsoorten en een handdouche",
	"question6.option2.text": "Een hoofddouche met twee straalsoorten en een handdouche",
	"question6.option3.text": "Een hoofddouche, handdouche en baduitloop",
	"question6.option4.text": "Een hoofddouche, twee zijdouches en een handdouche",
	"question6.option5.text": "Een hoofddouche en handdouche",
	"question6.option6.text": "Een handdouche en baduitloop",
	"question6.option7.text": "Alleen een handdouche",
	"question6.option8.text": "Alleen een baduitloop",
	"question7.question": "Kies de gewenste kleur",
	"question7.option1.text": "Chroom",
	"question7.option2.text": "Wit/chroom",
	"question7.option3.text": "Wit/chroom",
	"question8.question": "Wil je een thermostaatkraan met geïntegreerde handdouchehouder?",
	"question8.option1.text": "Ja, met geïntegreerde handdouchehouder",
	"question8.option2.text": "Nee ik koop separaat een handdouchehouder",
	"question9.question": "Hoe wil je je handdouche bevestigen?",
	"question9.option1.text": "Met een glijstang met verstelbare douchehouder",
	"question9.option2.text": "Met een minimalistische wandhouder",
	"question10.question": "Wil je een wandgemonteerde hoofddouche of een plafonddouche?",
	"question10.option1.text": "Wandgemonteerde hoofddouche",
	"question10.option2.text": "Plafonddouche",
	"results.title": "{productGroupsCount, plural, \none {Jouw resultaat} \nother {Jouw resultaten}\n}",
	"results.bundle.title": "Voor een correcte installatie heb je ook nodig:",
	"results.newConfiguration.buttonText": "Begin opnieuw",
	"results.product.button.productInformation": "Productinformatie",
	"results.product.button.dealerLocator": "Koop offline",
	"results.product.button.buyNow": "Koop online",
	"results.product.information": "Productinformatie",
	"results.product.dealer": "Zoek verkooppunt",
	"results.proposal.title": "Advies {number}",
	"results.proposal.title.single": "Advies",
	"results.newConfiguration.title": "Wil je opnieuw beginnen?",
	"results.product.number": "Artikelnummer: #{number}",
	"results.product.button.downloadPDF": "Download advies (PDF)",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Terug naar de homepage",
	"hatchModal.title": "Koop online",
	"hatchModal.btnText": "Nu kopen",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Niet op voorraat} \nother {Op voorraad}\n}",
	"hatchModal.buyNow": "Nu kopen",
	"app.components.HomePage.header": "GROHE SmartControl douche-keuzehulp"
};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.pl/pl_pl/grohe/ochrona-prywatnosci.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.pl/pl_pl/grohe/zastrzezenia-prawne.html",
	"footer.copyright": "&copy; 2018 Grohe Polska Sp. z o.o.",
	"homepage.headline": "Konfigurator GROHE SmartControl",
	"homepage.introtext": "Odpowiedz na kilka poniższych pytań, żeby znaleźć najbardziej odpowiedni dla Ciebie wariant systemu prysznicowego  GROHE SmartControl.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobacz wyniki",
	"question1.question": "Do którego miejsca w Twojej łazience potrzebna jest konfiguracja prysznica?",
	"question1.option1.text": "Do kabiny prysznicowej",
	"question1.option2.text": "Do wanny",
	"question2.question": "Który rodzaj instalacji wybierasz? Instalację natynkową, podtynkową czy kombinację tych dwóch opcji?",
	"question2.option1.text": "Instalacja natynkowa: łatwe i wygodne rozwiązanie z montażem na ścianie",
	"question2.option2.text": "Kombinacja: instalacja wewnątrz ściany oraz bateria termostatyczna z półką na ścianie",
	"question2.option3.text": "Instalacja podtynkowa: minimalistyczny wygląd z technologią ukrytą w ścianie",
	"question3.question": "Jaki sposób prysznica prysznica wybierasz?",
	"question3.option1.text": "Bateria SmartControl",
	"question3.option2.text": "Tradycyjna bateria termostatyczna",
	"question3.option3.text": "Bateria jednouchwytowa",
	"question3.option4.text": "System przełączników (do montażu przy istniejącej baterii)",
	"question4.question": "Co chcesz obsługiwać za pomocą swojego prysznica?",
	"question4.option1.text": "Tylko prysznic ręczny",
	"question4.option2.text": "Dużą deszczownicę (150-250mm) oraz prysznic ręczny",
	"question4.option3.text": "Dużą deszczownicę  (250-400mm) oraz prysznic ręczny",
	"question4.option4.text": "Duża deszczownica (150-250mm), prysznic ręczny i wylewka wannowa",
	"question4.option5.text": "Duża deszczownica (250-400mm), prysznic ręczny i wylewka wannowa",
	"question5.question": "Jaki kształt wolisz?",
	"question5.option1.text": "Kwadrat",
	"question5.option2.text": "Koło",
	"question6.question": "Co chcesz obsługiwać za pomocą systemu SmartControl?",
	"question6.option1.text": "Deszczownicę z dwoma rodzajami strumieni i prysznic ręczny",
	"question6.option2.text": "Deszczownicę i prysznic ręczny",
	"question6.option3.text": "Tylko prysznic ręczny",
	"question6.option4.text": "Deszczownicę z dwoma rodzajami strumieni i prysznic ręczny",
	"question6.option5.text": "Deszczownicę, dwa prysznice boczne i prysznic ręczny",
	"question6.option6.text": "Deszczownicę, prysznic ręczny i wylewkę wannową",
	"question6.option7.text": "Prysznic ręczny i wylewkę wannową",
	"question6.option8.text": "Tylko wylewkę wannową",
	"question7.question": "Wybierz kolor",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "MoonWhite",
	"question7.option3.text": "MoonWhite",
	"question8.question": "Czy chcesz baterię termostatyczną z uchwytem na prysznic ręczny?",
	"question8.option1.text": "Tak, chcę baterię z uchwytem na prysznic ręczny",
	"question8.option2.text": "Nie, uchwyt na prysznic ręczny kupię osobno",
	"question9.question": "W jakim sposób prysznic ręczny powinien być umiejscowiony?",
	"question9.option1.text": "Na drążku prysznicowym z uchwytem prysznicowym o regulowanej wysokości",
	"question9.option2.text": "Na uchwycie punktowym",
	"question10.question": "Chcesz zamontować deszczownicę na ścianie czy na suficie?",
	"question10.option1.text": "Deszczownica montowana na ścianie",
	"question10.option2.text": "Deszczownica montowana na suficie",
	"results.title": "{productGroupsCount, plural, \none {Twój wynik} \nother {Twoje wyniki}\n}",
	"results.proposal.title": "REKOMENDACJA {number}",
	"results.proposal.title.single": "REKOMENDACJA ",
	"results.bundle.title": "W celu zapewnienia prawidłowej instalacji, potrzebne będą również:",
	"results.newConfiguration.title": "Rozpocznij nową konfigurację",
	"results.newConfiguration.buttonText": "Rozpocznij nową konfigurację",
	"results.product.number": "Numer produktu: {number}",
	"results.product.button.productInformation": "Informacje o produkcie  ",
	"results.product.button.dealerLocator": "Znajdź salon sprzedaży  ",
	"results.product.button.buyNow": "Kup online  ",
	"results.product.button.downloadPDF": "Pobierz PDF",
	"results.product.information": "Informacje o produkcie  ",
	"results.product.dealer": "Znajdź salon sprzedaży  ",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ru/ru_ru/kompanija/novosti/bezopasnost.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.ru/ru_ru/kompanija/novosti/juridicheskaja-infomracija.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Конфигуратор GROHE SmartControl",
	"homepage.introtext": "Найдите самую подходящую для вас душевую систему GROHE SmartControl. Идеальный душ прямо здесь в вашем распоряжении.",
	"homepage.buttonStart": "Начать",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Смотреть результат",
	"question1.question": "Где вы хотите разместить душ? ",
	"question1.option1.text": "В выделенном пространстве для душа",
	"question1.option2.text": "В ванной для купания, включая излив в ванну",
	"question2.question": "Какой вид монтажа вы предпочитаете? Внешний, Скрытый или их комбинацию?",
	"question2.option1.text": "Внешний монтаж: простой и легкий вариант с установкой перед стеной для модификации вашего существующего душа",
	"question2.option2.text": "Комбинированный монтаж: подводка скрыта внутри стены, а термостат с полочкой расположены перед стеной",
	"question2.option3.text": "Скрытый монтаж: минималистичный утонченный дизайн, когда все коммуникации скрыты внутри стены",
	"question3.question": "Как вы предпочитаете управлять вашим душем?",
	"question3.option1.text": "С помощью системы SmartControl (интеллектуальное управление) и Термостата (современный смеситель с функцией поддержания постоянной температуры)",
	"question3.option2.text": "Посредством обычных действий и термостата",
	"question3.option3.text": "С помощью однорычажного смесителя",
	"question3.option4.text": "С помощью переключателя для настенного монтажа (сохраняя существующий смеситель)",
	"question4.question": "Какими элементами вам бы хотелось управлять с помощью вашего Душа?",
	"question4.option1.text": "Только ручной душ",
	"question4.option2.text": "Большой верхний душ (150-200 мм) и ручной душ",
	"question4.option3.text": "Сверхбольшой верхний душ (250-400 мм) и ручной душ",
	"question4.option4.text": "Большой верхний душ (150-200 мм), ручной душ и излив для ванны",
	"question4.option5.text": "Сверхбольшой верхний душ (250-400 мм), ручной душ и излив для ванны",
	"question5.question": "Какую форму вы предпочитаете?",
	"question5.option1.text": "Квадратная форма",
	"question5.option2.text": "Округлая форма",
	"question6.question": "Что бы вам хотелось контролировать посредством вашей новой системы SmartControl?",
	"question6.option1.text": "Верхний душ с 2 режимами струи и ручной душ",
	"question6.option2.text": "Верхний душ с 2 режимами струи и ручной душ",
	"question6.option3.text": "Верхний душ, ручной душ и излив для ванны",
	"question6.option4.text": "Верхний душ, два боковых душа и ручной душ",
	"question6.option5.text": "Ручной душ и излив для ванны",
	"question6.option6.text": "Ручной душ и излив для ванны",
	"question6.option7.text": "Только ручной душ",
	"question6.option8.text": "Только излив для ванны",
	"question7.question": "Выберите цвет",
	"question7.option1.text": "Хром",
	"question7.option2.text": "Белый/Хром",
	"question7.option3.text": "Белый/Хром",
	"question8.question": "Вам бы хотелось термостат со встроенным держателем для ручного душа?",
	"question8.option1.text": "Да, со встроенным держателем для ручного душа",
	"question8.option2.text": "Нет, я куплю отдельный держатель для ручного душа",
	"question9.question": "Какой способ крепления для ручного душа вы бы предпочли?",
	"question9.option1.text": "На душевую штангу с возможностью регулировки высоты фиксации душа",
	"question9.option2.text": "На минималистичный душевой держатель",
	"question10.question": "Вы бы хотели установить ваш верхний душ на стену или на потолок?",
	"question10.option1.text": "Верхний душ, установленный на стену",
	"question10.option2.text": "Верхний душ, установленный на потолок",
	"results.title": "Ваш результат",
	"results.proposal.title": "предложение {number}",
	"results.proposal.title.single": "предложение",
	"results.bundle.title": "Для правильной установки вам также потребуется:",
	"results.newConfiguration.title": "Вы хотите подобрать другую душевую систему?",
	"results.newConfiguration.buttonText": "Начать подбор заново",
	"results.product.number": "Артикул товара: #{number}",
	"results.product.button.productInformation": "Информация о товаре",
	"results.product.button.dealerLocator": "Найти магазин",
	"results.product.button.buyNow": "Купить онлайн",
	"results.product.button.downloadPDF": "Скачать PDF",
	"results.product.information": "Информация о товаре",
	"results.product.dealer": "Найти магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.sk/sk_sk/spolocnost/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.sk/sk_sk/spolocnost/legal-info.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Konfigurátor GROHE SmartControl",
	"homepage.introtext": "Jednoducho odpovedzte na pár otázok nižšie a získajte takú konfiguráciu sprchového systému GROHE SmartControl, aká bude dokonale vyhovovať vašim požiadavkám.",
	"homepage.buttonStart": "Spustiť",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobraziť výsledky",
	"question1.question": "Pre ktorý priestor vašej kúpeľne hľadáte sprchovú konfiguráciu?",
	"question1.option1.text": "Do sprchového kúta",
	"question1.option2.text": "Do vane, t j. vrátane vaňového výpustu",
	"question2.question": "Aký typ inštalácie uprednostňujete? Nástennú, podomietkovú alebo kombináciu oboch?",
	"question2.option1.text": "Nástenná: najjednoduchšie riešenie pre rýchle vylepšenie",
	"question2.option2.text": "Kombinácia: zatiaľ čo potrubie bude ukryté v stene, termostatická batéria s priehradkou budú nástenné",
	"question2.option3.text": "Podomietková: čistý, minimalistický vzhľad, pri ktorom bude všetka technológia ukrytá v stene",
	"question3.question": "Ako by ste chceli svoju sprchu ovládať?",
	"question3.option1.text": "Ovládačom SmartControl s termostatickou batériou",
	"question3.option2.text": "Štandardnou termostatickou batériou",
	"question3.option3.text": "Štandardnou pákovou batériou",
	"question3.option4.text": "Pomocou prepínača (chcem si ponechať súčasnú batériu)",
	"question4.question": "Čo si prajete v rámci sprchy ovládať?",
	"question4.option1.text": "Iba ručnú sprchu",
	"question4.option2.text": "Veľkú hlavovú sprchu (150 – 250 mm) a ručnú sprchu",
	"question4.option3.text": "Extra veľkú hlavovú sprchu (250 – 400 mm) a ručnú sprchu",
	"question4.option4.text": "Veľkú hlavovú sprchu (150 – 250 mm), ručnú sprchu a vaňový výpust",
	"question4.option5.text": "Extra veľkú hlavovú sprchu (250 – 400 mm), ručnú sprchu a vaňový výpust",
	"question5.question": "Aký tvar preferujete?",
	"question5.option1.text": "Štvorcový",
	"question5.option2.text": "Kruhový",
	"question6.question": "Čo si prajete ovládať pomocou vášho nového ovládača SmartControl?",
	"question6.option1.text": "Hlavovú sprchu s dvoma režimami prúdu a ručnú sprchu",
	"question6.option2.text": "Hlavovú sprchu s dvoma režimami prúdu a ručnú sprchu",
	"question6.option3.text": "Iba ručnú sprchu",
	"question6.option4.text": "Hlavovú sprchu a ručnú sprchu",
	"question6.option5.text": "Hlavovú sprchu, dve bočné sprchy a ručnú sprchu",
	"question6.option6.text": "Hlavovú sprchu, ručnú sprchu a vaňový výpust",
	"question6.option7.text": "Ručnú sprchu a vaňový výpust",
	"question6.option8.text": "Iba vaňový výpust",
	"question7.question": "Vyberte si farbu",
	"question7.option1.text": "Chróm",
	"question7.option2.text": "Biela/chróm",
	"question7.option3.text": "Biela/chróm",
	"question8.question": "Prajete si termostatickú batériu s integrovaným držiakom ručnej sprchy?",
	"question8.option1.text": "Áno, chcem mať držiak ručnej sprchy integrovaný do batérie",
	"question8.option2.text": "Nie, držiak ručnej sprchy dokúpim zvlášť",
	"question9.question": "Kam si prajete umiestniť držiak ručnej sprchy?",
	"question9.option1.text": "Na sprchovú tyč prostredníctvom posuvného držiaka",
	"question9.option2.text": "Pomocou minimalistického držiaka ",
	"question10.question": "Prajete si pripevniť vašu hlavovú sprchu na stenu alebo na strop?",
	"question10.option1.text": "Nástenná hlavová sprcha",
	"question10.option2.text": "Stropná hlavová sprcha",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledok} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pre správnu inštaláciu budete potrebovať tiež:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Spustiť novú konfiguráciu",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informácie o produkte",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informácie o produkte",
	"results.product.dealer": "Nájsť showroom",
	"hatchModal.title": "Kúpiť online",
	"hatchModal.btnText": "Kúpiť online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE Duş Yapılandırması",
	"homepage.headline": "GROHE Duş Sistemi Yapılandırması",
	"homepage.introtext": "İhtiyaçlarınıza uygun GROHE SmartControl duş sistemini yapılandırmak için lütfen aşağıdaki birkaç soruyu yanıtlayın.",
	"homepage.buttonStart": "Başla",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Gizlilik",
	"footer.privacy.url": "https://www.grohe.com.tr/tr_tr/gizlilik.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.com.tr/tr_tr/bilgilendirme.html",
	"footer.copyright": "© 2018 GROME İÇ VE DIŞ TİC. A.Ş.",
	"configurator.button.seeResults": "Sonuçları gör",
	"question1.question": "Duşunuzu nerede kullanmak istiyorsunuz?",
	"question1.option1.text": "Duşta",
	"question1.option2.text": "Banyoda",
	"question2.question": "Ne tür bir kurulum tercih edersiniz? Duvar Üzeri mi, Yarı Ankastre mi yoksa Ankastre mi?",
	"question2.option1.text": "Duş ve termostat için duvar üzeri kurulum",
	"question2.option2.text": "Duvar Üzeri Termostat ile yarı ankastre duş kurulumu",
	"question2.option3.text": "Ankastre kurulum",
	"question3.question": "Duşunuzun nasıl çalışmasını istersiniz?",
	"question3.option1.text": "SmartControl çalışma şekli ve Termostat ile",
	"question3.option2.text": "SmartControl çalışma şekli ve Termostat ile",
	"question3.option3.text": "Geleneksel çalışma şekli ve termostat ile",
	"question3.option4.text": "Geleneksel çalışma şekli ve termostat ile",
	"question3.option5.text": "Tek kumandalı batarya ile",
	"question3.option6.text": "Tek kumandalı batarya ile",
	"question3.option7.text": "Yön değiştirici sistem ile (mevcut armatür değiştirilmeden)",
	"question4.question": "Duşunuz ile neleri kontrol etmek istersiniz?",
	"question4.option1.text": "Yalnızca el duşu",
	"question4.option2.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option3.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option4.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option5.text": "Büyük bir tepe duşu (150-250 mm) ve el duşu",
	"question4.option6.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option7.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option8.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option9.text": "Çok büyük bir tepe duşu (250-400 mm) ve el duşu",
	"question4.option10.text": "Büyük bir tepe duşu (150-250 mm), el duşu ve banyo çıkış ucu",
	"question4.option11.text": "Çok büyük bir tepe duşu (250-400 mm), el duşu ve banyo çıkış ucu",
	"question5.question": "Hangi şekli tercih edersiniz?",
	"question5.option1.text": "Kare",
	"question5.option2.text": "Yuvarlak",
	"question6.question": "Kaç adet su çıkışına ihtiyaç duyuyorsunuz?",
	"question6.option1.text": "Üç: 2 akış modelli tepe duşu ve el duşu",
	"question6.option2.text": "Üç: 2 akış modelli tepe duşu ve el duşu",
	"question6.option3.text": "Üç: Tepe duşu, el duşu ve banyo çıkış ucu",
	"question6.option4.text": "Üç: Tepe duşu, yan duş ve el duşu",
	"question6.option5.text": "İki: Tepe duşu ve el duşu",
	"question6.option6.text": "İki: El duşu ve banyo çıkış ucu",
	"question6.option7.text": "Bir: Sadece el duşu",
	"question6.option8.text": "Bir: Banyo çıkış ucu",
	"question7.question": "Renginizi seçin",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Beyaz/Krom",
	"question7.option3.text": "Beyaz",
	"question8.question": "Dış gövde içinde entegre bir duş askısı bulunmasını ister miydiniz?",
	"question8.option1.text": "Evet, entegre duş askısı bulunmasını isterim",
	"question8.option2.text": "Hayır, el duşu askısını ayrı olarak satın alacağım",
	"question9.question": "El duşu için duş sürgüsü barı mı yoksa duş askısı barı mı tercih edersiniz?",
	"question9.option1.text": "Duş sürgüsü barı",
	"question9.option2.text": "Duş askısı barı",
	"question10.question": "Tepe duşunun duvara mı yoksa tavana mı monte edilmesini tercih edersiniz?",
	"question10.option1.text": "Duvara monte edilmiş tepe duşu",
	"question10.option2.text": "Tavana monte edilmiş tepe duşu",
	"results.title": "{productGroupsCount, plural, \none {Sonucunuz} \nother {Sonuçlarınız}\n}",
	"results.bundle.title": "Doğru kurulum için ayrıca şunlar gerekmektedir:",
	"results.newConfiguration.buttonText": "Yeni yapılandırma başlat",
	"results.product.button.productInformation": "Ürün bilgisi",
	"results.product.button.dealerLocator": "Showroom bul",
	"results.product.button.buyNow": "Online Satın Al",
	"results.product.information": "Ürün bilgisi",
	"results.product.dealer": "Showroom bul",
	"results.proposal.title": "Teklif {number}",
	"results.proposal.title.single": "Teklif",
	"results.newConfiguration.title": "Yeni bir duş sistemi yapılandırmak ister misiniz?",
	"results.product.number": "Ürün Kodu: #{number}",
	"results.product.button.downloadPDF": "Teklifi indir (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "404 Sayfa bulunamadı",
	"404.link.goBack": "Ana sayfaya geri dön"
};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфіденційність",
	"footer.privacy.url": "https://www.grohe.ua/uk_ua/kompanija/novosti/bezopasnost.html",
	"footer.disclaimer.text": "Правова інформація",
	"footer.disclaimer.url": "https://www.grohe.ua/uk_ua/kompanija/novosti/juridicheskaja-infomracija.html",
	"footer.copyright": "&copy; 2017 GROHE AG",
	"homepage.headline": "Конфігуратор душових систем GROHE",
	"homepage.introtext": "Дайте відповіді на декілька запитань, щоб скомпонувати душову систему GROHE SmartControl, яка відповідатиме вашим потребам.",
	"homepage.buttonStart": "Розпочати",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Сторінку не знайдено",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Дивитися результат",
	"question1.question": "У якому місці Вашої ванної кімнати Ви  плануєте розмістити душ? ",
	"question1.option1.text": "У душовій",
	"question1.option2.text": "У ванній, включаючи вилив на ванну",
	"question2.question": "Якому виду монтажу Ви надаєте перевагу - зовнішньому,  прихованому чи напівприхованому?",
	"question2.option1.text": "Зовнішньому монтажу: просте рішення для оновлення на стіні, яке не вимагає жодних зусиль",
	"question2.option2.text": "Комбінованому  монтажу: приховані за стіної труби і видимий термостат із поличкою на стіні",
	"question2.option3.text": "Прихованому монтажу: мінімалізм завдяки прихованим за стіною технологіям",
	"question3.question": "Якому типу керування душем Ви надаєте перевагу?",
	"question3.option1.text": "За допомогою системи SmartControl і термостата",
	"question3.option2.text": "Стандартному і за допомогою  термостата",
	"question3.option3.text": "За допомогою одноважільного змішувача",
	"question3.option4.text": "За допомогою перемикача настінного монтажу (зберігаючи при цьому існуючий змішувач)",
	"question4.question": "Якими елементами Ви б хотіли керувати за допомогою душу?",
	"question4.option1.text": "Лише ручним душем",
	"question4.option2.text": "Великим верхнім душем (150-250 мм) і ручним душем",
	"question4.option3.text": "Надвеликим верхнім душем (250-400 мм) і ручним душем",
	"question4.option4.text": "Великим верхнім душем (150-250 мм), ручним душем і виливом на ванну",
	"question4.option5.text": "Надвеликим верхнім душем (250-400 мм), ручним душем і виливом на ванну",
	"question5.question": "Якій формі Ви надаєте перевагу?",
	"question5.option1.text": "Квадрат",
	"question5.option2.text": "Круг",
	"question6.question": "Якими складовими душу Ви б хотіли керувати за допомогою SmartControl?",
	"question6.option1.text": "Верхнім душем з двома режимами струменю і ручним душем",
	"question6.option2.text": "Верхнім душем з двома режимами струменю і ручним душем",
	"question6.option3.text": "Верхнім, ручним душами і змішувачем на ванну",
	"question6.option4.text": "Верхнім, двома боковими і ручним душами",
	"question6.option5.text": "Верхнім та ручним душем",
	"question6.option6.text": "Ручним душем і змішувачем на ванну",
	"question6.option7.text": "Лише ручним душем",
	"question6.option8.text": "Лише змішувачем на ванну",
	"question7.question": "Оберіть колір",
	"question7.option1.text": "Хром",
	"question7.option2.text": "Білий/Хром",
	"question7.option3.text": "Білий/Хром",
	"question8.question": "Ви б хотіли термостат із вбудованим тримачем для душу?",
	"question8.option1.text": "Ні, я куплю окремий тримач для ручного душу",
	"question8.option2.text": "Так, із вбудованим тримачем для душу",
	"question9.question": "Як Ви б хотіли кріпити свій ручний душ?",
	"question9.option1.text": "За допомогою тримача, вбудованого у душовий кронштейн, з можливістю регулювання по висоті",
	"question9.option2.text": "За допомогою душового тримача у стилі мінімалізм",
	"question10.question": "Ви надаєте перевагу верхньому душу з настінним чи настельним монтажем?",
	"question10.option1.text": "З настінним монтажем",
	"question10.option2.text": "З настельним монтажу",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваші результати}\n}",
	"results.proposal.title": "Пропозиція {number}",
	"results.proposal.title.single": "ПРОПОЗИЦІЯ",
	"results.bundle.title": "Для правильного проведення монтажу Вам також знадобляться:",
	"results.newConfiguration.title": "Хотіли б скомпонувати нову душову систему?",
	"results.newConfiguration.buttonText": "Розпочати новий підбір",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Інформація про продукт",
	"results.product.button.dealerLocator": "Знайти салон-магазин",
	"results.product.button.buyNow": "Купити онлайн",
	"results.product.button.downloadPDF": "Завантажити пропозицію (PDF)",
	"results.product.information": "Інформація про продукт",
	"results.product.dealer": "Знайти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "الخصوصية",
	"footer.privacy.url": "https://www.grohe-gcc.com/ar_sa/company/privacy.html",
	"footer.disclaimer.text": "إخلاء المسؤولية",
	"footer.disclaimer.url": "https://www.grohe-gcc.com/ar_sa/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "معدّ أنظمة المياه من GROHE",
	"homepage.introtext": "أجب على بضعة أسئلة أدناه لتعدّ نظام المياه من GROHE الذي يلائم إحتياجاتك.",
	"homepage.buttonStart": "إبدأ",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "لم يتم العثور على الصفحة",
	"404.link.goBack": "العودة إلى الصفحة الرئيسية",
	"configurator.button.seeResults": "See results",
	"question1.question": " هل لديك إمدادات للمياه الباردة والساخنة في مطبخك؟",
	"question1.option1.text": "لدي إمدادات للمياه الباردة والساخنة في مطبخي",
	"question1.option2.text": "لدي إمدادات للمياه الباردة فقط",
	"question2.question": "ما هو نوع المياه الذي تبحث عنه؟",
	"question2.option1.text": "مياه ساخنة مغلية لتحضير الطعام والمشروبات",
	"question2.option2.text": "مياه مبرّدة وفوارة صالحة للشرب",
	"question2.option3.text": "مياه مبرّدة وفوارة إضافة إلى مياه ساخنة مغلية",
	"question3.question": "هل تريد الإحتفاظ بحنفية المطبخ الخاصة بك؟",
	"question3.option1.text": "أريد الإحتفاظ بها",
	"question3.option2.text": "أريد تركيب نموذجاً جديداً",
	"question4.question": "ماذا يجب أن تكون حنفيتك الأساسية؟",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "ما هو تصميم الفتحة المفضل لديك؟",
	"question5.option1.text": "فتحة على شكل L",
	"question5.option2.text": "فتحة على شكل U",
	"question5.option3.text": "فتحة على شكل C",
	"question6.question": "ما هو تصميم الفتحة المفضل لديك؟",
	"question6.option1.text": "فتحة على شكل L",
	"question6.option2.text": "فتحة على شكل U",
	"question6.option3.text": "فتحة على شكل C",
	"question7.question": "ما هي اللمسة النهائية المفضلة لديك؟",
	"question7.option1.text": "كروم",
	"question7.option2.text": "فولاذ صلب",
	"question8.question": "ما هو حجم سخان المياه الذي تحتاجه؟",
	"question8.option1.text": "حجم وسط (٣ لترات)",
	"question8.option2.text": "حجم كبير (٥,٥ لترات)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {نتيجتك} \nother {نتائجك}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "للحصول على التركيب الملائم، تحتاج إلى:",
	"results.newConfiguration.title": "هل تريد إعداد نظام مياه جديد؟",
	"results.newConfiguration.buttonText": "قم بإعداد نظام مياه جديد",
	"results.product.number": "{number} :رقم المنتج",
	"results.product.button.productInformation": "معلومات عن المنتج",
	"results.product.button.dealerLocator": "قم بإيجاد صالة عرض",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "-غير متوفر-",
	"hatchModal.btnText": "-غير متوفر-",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.bg/bg_bg/company/privacy/",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.bg/bg_bg/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Отговорете на няколко въпроса и открийте най-подходящата за вас GROHE Watersystem, която ще отговори на вашите нужди.",
	"homepage.buttonStart": "Начало",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Обратно към началото",
	"configurator.button.seeResults": "Към резултата",
	"question1.question": "Имате ли водоснабдяване с топла и студена вода в кухнята си?",
	"question1.option1.text": "Имам студена и топла вода в кухнята си.",
	"question1.option2.text": "Имам само студена вода в кухнята си.",
	"question2.question": "Какъв вид вода желаете?",
	"question2.option1.text": "Вряла вода за приготвяне на храна и напитки",
	"question2.option2.text": "Охладена и газирана вода за пиене",
	"question2.option3.text": "Охладелна и газирана, както и вряла вода",
	"question3.question": "Искате ли да запазите настоящия си кухненски смесител?",
	"question3.option1.text": "Искам да го запазя",
	"question3.option2.text": "Искам да инсталирам нов модел",
	"question4.question": "Кой бихте искали да е главният ви смесител?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Какъв дизайн на чучура предпочитате?",
	"question5.option1.text": "L-образен чучур",
	"question5.option2.text": "U-образен чучур",
	"question5.option3.text": "C-образен чучур",
	"question6.question": "Какво покритие предпочитате?",
	"question6.option1.text": "Хром",
	"question6.option2.text": "Supersteel",
	"question7.question": "Какъв размер бойлер бихте желали?",
	"question7.option1.text": "Размер M (3 литра)",
	"question7.option2.text": "Размер L (5.5 литра)",
	"results.title": "{productGroupsCount, plural, \none {Вашият резултат} \nother {Вашият резултат}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "За правилна инсталация ще ви трябват още:",
	"results.newConfiguration.title": "Искате ли да конфигурирате нова система?",
	"results.newConfiguration.buttonText": "Конфигурирай нова сисмтема",
	"results.product.number": "Артикулен номер: #{number}",
	"results.product.button.productInformation": "Информация за продукта",
	"results.product.button.dealerLocator": "Намерете шоурум",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Информация за продукта",
	"results.product.dealer": "Намерете шоурум",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Soukromí",
	"footer.privacy.url": "https://www.grohe.cz/cs_cz/spolecnost/privacy.html",
	"footer.disclaimer.text": "Prohlášení",
	"footer.disclaimer.url": "https://www.grohe.cz/cs_cz/spolecnost/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurátor vodních systémů GROHE",
	"homepage.introtext": "Jednoduše odpovězte na pár otázek níže a získejte takovou konfiguraci vodního systému GROHE, jaká bude dokonale vyhovovat vašim požadavkům.",
	"homepage.buttonStart": "Spustit",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404: stránka nebyla nalezena",
	"404.link.goBack": "Přejít zpět na domovskou stránku",
	"configurator.button.seeResults": "Zobrazit výsledky",
	"question1.question": "Máte v kuchyni přípojku studené a teplé vody?",
	"question1.option1.text": "Ano, v kuchyni mám přípojku studené i teplé vody",
	"question1.option2.text": "V kuchyni mám pouze přípojku studené vody",
	"question2.question": "Jaký typ vody od vodního systému očekáváte?",
	"question2.option1.text": "vařící vodu pro přípravu pokrmů a horkých nápojů",
	"question2.option2.text": "Vychlazenou, perlivou vodu k pití",
	"question2.option3.text": "Vychlazenou a perlivou vodu, ale také vodu vařící",
	"question3.question": "Chcete si ponechat vaši stávající dřezovou baterii?",
	"question3.option1.text": "Chci si ji ponechat",
	"question3.option2.text": "Chci pořídit nový model",
	"question4.question": "Jaká by měla být vaše hlavní dřezová baterie?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Jaký tvar výpusti preferujete?",
	"question5.option1.text": "Výpusť ve tvaru písmene L",
	"question5.option2.text": "Výpusť ve tvaru písmene U",
	"question5.option3.text": "Výpusť ve tvaru písmene C",
	"question6.question": "Jaká povrchová úprava se vám líbí nejvíce?",
	"question6.option1.text": "Chromová",
	"question6.option2.text": "SuperSteel",
	"question7.question": "Jak velký bojler potřebujete?",
	"question7.option1.text": "Velikost M (3 litry)",
	"question7.option2.text": "Velikost L (5,5 litru)",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledek} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pro správnou instalaci budete potřebovat také:",
	"results.newConfiguration.title": "Chcete spustit konfiguraci nového vodního systému od začátku?",
	"results.newConfiguration.buttonText": "Spustit konfiguraci nového systému",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informace o produktu",
	"results.product.button.dealerLocator": "Najít showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Najít showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "Find det GROHE vandsystem til køkkenet som passer dig",
	"footer.privacy.text": "Personlige oplysninger",
	"footer.privacy.url": "https://www.grohe.dk/da_dk/databeskyttelse.html",
	"footer.disclaimer.text": "Juridisk information",
	"footer.disclaimer.url": "https://www.grohe.dk/da_dk/aftryk.html",
	"footer.copyright": "&copy; 2017 GROHE A/S",
	"homepage.headline": "Se  det vandsystem som passer til dine behov",
	"homepage.introtext": "Besvar et par spørgsmål herunder og find frem til det GROHE vandsystem til køkkenet som passer til dine behov.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 siden blev desværre ikke fundet",
	"404.link.goBack": "Gå til hjemmeside",
	"configurator.button.seeResults": "Se dit resultat",
	"question1.question": "Har du kun koldt vand tilkoblet i dit køkken og ønsker at bruge din RED som varmtvandsbeholder?",
	"question1.option1.text": "Nej",
	"question1.option2.text": "Ja",
	"question2.question": "Ønsker du filtreret, kogende vand eller filtreret, afkølet vand med brus i din vandhane?",
	"question2.option1.text": "Kognede vand",
	"question2.option2.text": "Afkølet vand med brus",
	"question2.option3.text": "Jeg ønsker muligheden for begge dele",
	"question3.question": "Ønsker du dette som supplement til din nuværende vandhane?",
	"question3.option1.text": "Ja, jeg vil gerne beholde min nuværende vandhane",
	"question3.option2.text": "Nej, jeg vil montere en ny vandhane",
	"question4.question": "Ønsker du kogende vand eller vand med brus i din primære vandhane?",
	"question4.option1.text": "Afkølet vand med brus",
	"question4.option2.text": "Kognede vand",
	"question5.question": "Hvilket design ønsker du?",
	"question5.option1.text": "L-tud",
	"question5.option2.text": "U-tud",
	"question5.option3.text": "C-tud",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap? (not applicable for DK)",
	"question6.option1.text": "L-tud",
	"question6.option2.text": "C-tud",
	"question7.question": "Hvilken farve foretrækker du?",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Supersteel",
	"question8.question": "Hvor meget kogende vand har du behov for at tappe på en gang?",
	"question8.option1.text": "3 liter",
	"question8.option2.text": "5,5 liter",
	"question8.option3.text": "Ingen billeder",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Har du kun koldt vand tilkoblet i dit køkken og ønsker at bruge din RED som varmtvandsbeholder?",
	"question10.option1.text": "Ja",
	"question10.option2.text": "Nej",
	"results.title": "{productGroupsCount, plural, \none {Dit resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For at installere vandsystemet skal du også bruge:",
	"results.newConfiguration.title": "Ønsker du at besvare spørgsmålene igen?",
	"results.newConfiguration.buttonText": "Start konfiguratoren igen",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Productinformation",
	"results.product.button.dealerLocator": "Find nærmeste showroom",
	"results.product.button.buyNow": "Køb online",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Productinformation",
	"results.product.dealer": "Find nærmeste showroom",
	"hatchModal.title": "Køb online",
	"hatchModal.btnText": "Køb online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Køb online"
};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.at/de_at/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.at/de_at/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 GROHE Gesellschaft m.b.H.",
	"homepage.headline": "Konfigurator für GROHE Wassersysteme",
	"homepage.introtext": "GROHE Blue oder GROHE Red? Bitte beantworten Sie ein paar Fragen, um herauszufinden, welches Produkt genau Ihren persönlichen Bedürfnissen entspricht.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Schauen Sie sich die Ergebnisse an.",
	"question1.question": "Verfügen Sie in Ihrer Küche über eine Versorgung mit kaltem und warmem Wasser?",
	"question1.option1.text": "Ich verfüge über eine Kalt- und Warmwasserversorgung  in meiner Küche.",
	"question1.option2.text": "Ich habe eine reine Kaltwasserversorgung mit installiertem Durchlauferhitzer.",
	"question2.question": "Welche Art von Wasser benötigen Sie?",
	"question2.option1.text": "Kochend heißes Wasser für die Zubereitung von Mahlzeiten und Getränken.",
	"question2.option2.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser",
	"question2.option3.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser ebenso wie kochend heißes Wasser.",
	"question3.question": "Möchten Sie Ihre bestehende Küchenarmatur behalten?",
	"question3.option1.text": "Ja, ich möchte sie behalten.",
	"question3.option2.text": "Nein, ich möchte eine neue Armatur installieren lassen.",
	"question4.question": "Welche Armatur möchten Sie hauptsächlich nutzen?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wählen Sie Ihre bevorzugte Auslauf-Form",
	"question5.option1.text": "L-förmiger Auslauf",
	"question5.option2.text": "U-förmiger Auslauf",
	"question5.option3.text": "C-förmiger Auslauf",
	"question6.question": "Welche Auslauf-Form gefällt Ihnen bei der Mono-Armatur am besten?",
	"question6.option1.text": "L-förmiger Auslauf",
	"question6.option2.text": "C-förmiger Auslauf",
	"question7.question": "Wählen Sie Ihre gewünschte Oberfläche aus",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Supersteel",
	"question8.question": "In welcher Größe benötigen Sie den Boiler?",
	"question8.option1.text": "M-Size (für 3 Liter kochendes Wasser)",
	"question8.option2.text": "L-Size (für 5,5 Liter kochendes Wasser)",
	"question9.question": "Möchten Sie zusätzlich einen Filter verwenden, der das Wasser weicher macht und weiter verbessert? (nur anwendbar in NL)",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nein",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die vollständige Installation benötigen Sie außerdem:",
	"results.newConfiguration.title": "Möchten Sie ein weiteres Wassersystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Produktnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellung finden",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellung finden",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.ch/de_ch/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Haftungsausschluss",
	"footer.disclaimer.url": "https://www.grohe.ch/de_ch/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Konfigurator für GROHE Wassersysteme",
	"homepage.introtext": "Beantworten Sie bitte die folgenden Fragen, um das GROHE Wassersystem ganz nach Ihren persönlichen Bedürfnissen zu konfigurieren.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Schauen Sie sich die Ergebnisse an.",
	"question1.question": "Verfügen Sie in Ihrer Küche über eine Versorgung mit kaltem und warmem Wasser?",
	"question1.option1.text": "Ich verfüge über eine Kalt- und Warmwasserversorgung  in meiner Küche.",
	"question1.option2.text": "Ich habe eine reine Kaltwasserversorgung mit installiertem Durchlauferhitzer.",
	"question2.question": "Welche Art von Wasser benötigen Sie?",
	"question2.option1.text": "Kochend heißes Wasser für die Zubereitung von Mahlzeiten und Getränken.",
	"question2.option2.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser.",
	"question2.option3.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser ebenso wie kochend heißes Wasser.",
	"question3.question": "Möchten Sie Ihre bestehende Küchenarmatur behalten?",
	"question3.option1.text": "Ja, ich möchte sie behalten.",
	"question3.option2.text": "Nein, ich möchte eine neue Armatur installieren lassen.",
	"question4.question": "Welche Armatur möchten Sie hauptsächlich nutzen?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wählen Sie Ihre bevorzugte Auslauf-Form",
	"question5.option1.text": "L-förmiger Auslauf",
	"question5.option2.text": "U-förmiger Auslauf",
	"question5.option3.text": "C-förmiger Auslauf",
	"question6.question": "Welche Auslauf-Form gefällt Ihnen bei der Mono-Armatur am besten?",
	"question6.option1.text": "L-förmiger Auslauf",
	"question6.option2.text": "C-förmiger Auslauf",
	"question7.question": "Wählen Sie Ihre gewünschte Oberfläche aus",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "In welcher Größe benötigen Sie den Boiler?",
	"question8.option1.text": "M-Size (für 3 Liter kochendes Wasser)",
	"question8.option2.text": "L-Size (für 5,5 Liter kochendes Wasser)",
	"question9.question": "Möchten Sie zusätzlich einen Filter verwenden, der das Wasser weicher macht und weiter verbessert?",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nein",
	"results.title": "{productGroupsCount, plural, \none {Ihre Ergebnisse} \nother {Ihr Ergebnis}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Für die vollständige Installation benötigen Sie außerdem:",
	"results.newConfiguration.title": "Möchten Sie ein weiteres Wassersystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Produktnummer: #{number}",
	"results.product.button.productInformation": "Produktinformation",
	"results.product.button.dealerLocator": "Ausstellung finden",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produktinformation",
	"results.product.dealer": "Ausstellung finden",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.de/de_de/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.de/de_de/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 Grohe Deutschland Vertriebs GmbH",
	"homepage.headline": "Konfigurator für GROHE Wassersysteme",
	"homepage.introtext": "GROHE Blue oder GROHE Red? Bitte beantworten Sie ein paar Fragen, um herauszufinden, welches Produkt genau Ihren persönlichen Bedürfnissen entspricht.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Schauen Sie sich die Ergebnisse an.",
	"question1.question": "Verfügen Sie in Ihrer Küche über eine Versorgung mit kaltem und warmem Wasser?",
	"question1.option1.text": "Ich verfüge über eine Kalt- und Warmwasserversorgung  in meiner Küche.",
	"question1.option2.text": "Ich habe eine reine Kaltwasserversorgung mit installiertem Durchlauferhitzer.",
	"question2.question": "Welche Art von Wasser benötigen Sie?",
	"question2.option1.text": "Kochend heißes Wasser für die Zubereitung von Mahlzeiten und Getränken.",
	"question2.option2.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser",
	"question2.option3.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser ebenso wie kochend heißes Wasser.",
	"question3.question": "Möchten Sie Ihre bestehende Küchenarmatur behalten?",
	"question3.option1.text": "Ja, ich möchte sie behalten.",
	"question3.option2.text": "Nein, ich möchte eine neue Armatur installieren lassen.",
	"question4.question": "Welche Armatur möchten Sie hauptsächlich nutzen?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wählen Sie Ihre bevorzugte Auslauf-Form",
	"question5.option1.text": "L-förmiger Auslauf",
	"question5.option2.text": "U-förmiger Auslauf",
	"question5.option3.text": "C-förmiger Auslauf",
	"question6.question": "Welche Auslauf-Form gefällt Ihnen bei der Mono-Armatur am besten?",
	"question6.option1.text": "L-förmiger Auslauf",
	"question6.option2.text": "C-förmiger Auslauf",
	"question7.question": "Wählen Sie Ihre gewünschte Oberfläche aus",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Supersteel",
	"question8.question": "In welcher Größe benötigen Sie den Boiler?",
	"question8.option1.text": "M-Size (für 3 Liter kochendes Wasser)",
	"question8.option2.text": "L-Size (für 5,5 Liter kochendes Wasser)",
	"question9.question": "Möchten Sie zusätzlich einen Filter verwenden, der das Wasser weicher macht und weiter verbessert?",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nein",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die vollständige Installation benötigen Sie außerdem:",
	"results.newConfiguration.title": "Möchten Sie ein weiteres Wassersystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Produktnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellung finden",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellung finden",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your preferred finish?",
	"question6.option1.text": "Chrome",
	"question6.option2.text": "Supersteel",
	"question7.question": "Which boiler size do you need?",
	"question7.option1.text": "M Size (3 Litres)",
	"question7.option2.text": "L Size (5.5 Litres)",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "What's your preferred finish?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M Size (3 Litres)",
	"question8.option2.text": "L Size (5.5 Litres)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your preferred finish?",
	"question6.option1.text": "Chrome",
	"question6.option2.text": "Supersteel",
	"question7.question": "Which boiler size do you need?",
	"question7.option1.text": "M Size (3 Litres)",
	"question7.option2.text": "L Size (5.5 Litres)",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ee/et_ee/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.ee/et_ee/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "What's your preferred finish?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M Size (3 Litres)",
	"question8.option2.text": "L Size (5.5 Litres)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Do you have a cold and warm water supply in your kitchen?",
	"question10.option1.text": "I have cold and warm water supply in my kitchen",
	"question10.option2.text": "I have cold water supply only",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.be/fr_be/entreprise-grohe/protections-des-donnees.html",
	"footer.copyright": "&copy; Grohe N.V. - S.A.",
	"homepage.headline": "Configurateur système sanitaire GROHE",
	"homepage.introtext": "Répondez à quelques questions simples dans l'aide à la décision et découvrez le système sanitaire de GROHE qui s'accorde le mieux à vos souhaits ou bien quelle combinaison vous pouvez réaliser.",
	"homepage.buttonStart": "Commencer",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page non trouvée",
	"404.link.goBack": "Voir les résultats",
	"configurator.button.seeResults": "Voir les résultats",
	"question1.question": "Avez-vous une arrivée d'eau froide et d'eau chaude dans votre cuisine ?",
	"question1.option1.text": "J'ai une arrivée d'eau chaude dans ma cuisine",
	"question1.option2.text": "J'ai uniquement une arrivée d'eau froide dans ma cuisine",
	"question2.question": "Quelle solution pour votre cuisine cherchez-vous?",
	"question2.option1.text": "De l'eau bouillante pour la préparation d'aliments et de boissons",
	"question2.option2.text": "De l'eau réfrigérée et pétillante à boire",
	"question2.option3.text": "Aussi bien de l'eau réfrigérée et pétillante que de l'eau bouillante",
	"question3.question": "Voulez-vous conserver votre mitigeur de cuisine existant?",
	"question3.option1.text": "Je veux conserver mon mitigeur actuel",
	"question3.option2.text": "Je veux remplacer mon mitigeur actuel par un nouveau",
	"question4.question": "Quel devrait être le mitigeur le plus important?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quel est votre type d'écoulement préféré?",
	"question5.option1.text": "Forme L",
	"question5.option2.text": "Forme U",
	"question5.option3.text": "Forme C",
	"question6.question": "What´s your prefered spout design for the Mono faucet?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Quelle est la finition que vous préférez?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "De combien de litres d'eau bouillante avez-vous besoin?",
	"question8.option1.text": "Taille M (3 litres)",
	"question8.option2.text": "Taille L (5,5 litres)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water? (only applicable for NL)",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {Vos résultats} \nother {Votre résultat}\n}",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.bundle.title": "Pour une installation correcte, il vous faut encore ce qui suit",
	"results.newConfiguration.title": "Vous souhaitez faire une nouvelle configuration ?",
	"results.newConfiguration.buttonText": "Configurez un nouveau système sanitaire",
	"results.product.number": "Référence: #{number}",
	"results.product.button.productInformation": "Information produit",
	"results.product.button.dealerLocator": "Trouvez une salle d'exposition",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Télécharger le PDF",
	"results.product.information": "Information produit",
	"results.product.dealer": "Trouvez une salle d'exposition",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Politique de confidentialité",
	"footer.privacy.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Mentions légales",
	"footer.disclaimer.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/mentions-legales.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Configurateur de systèmes d'eau GROHE",
	"homepage.introtext": "Il vous suffit de répondre aux quelques questions ci-après pour configurer le système d'eau GROHE qui répondra à vos besoins. ",
	"homepage.buttonStart": "Commencer",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Retour à l'accueil",
	"configurator.button.seeResults": "Voir les résultats",
	"question1.question": "Votre cuisine est-elle équipée d'une arrivée d'eau chaude et d'eau froide?",
	"question1.option1.text": "J'ai une alimentation d'eau chaude dans ma cuisine",
	"question1.option2.text": "J'ai l'eau froide dans la cuisine avec un chauffe-eau instantané installé",
	"question2.question": "Quel type d'eau recherchez-vous?",
	"question2.option1.text": "De l'eau bouillante pour la préparation des repas et des boissons",
	"question2.option2.text": "De l'eau fraîche et pétillante à boire",
	"question2.option3.text": "De l'eau fraîche pétillante et de l'eau bouillante",
	"question3.question": "Souhaitez-vous conserver votre robinet de cuisine actuel?",
	"question3.option1.text": "Je souhaite le garder",
	"question3.option2.text": "Je veux installer un nouveau modèle",
	"question4.question": "Quel sera votre robinet principal?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quel design préférez-vous pour le bec du robinet?",
	"question5.option1.text": "Bec en L",
	"question5.option2.text": "Bec en U",
	"question5.option3.text": "Bec en C",
	"question6.question": "Quel design préférez-vous pour le bec de la robinetterie Mono?",
	"question6.option1.text": "Bec en L",
	"question6.option2.text": "Bec en C",
	"question7.question": "Quelle finition préférez-vous?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "Quelle taille de chauffe-eau instantané correspond à vos besoins?",
	"question8.option1.text": "Taille M",
	"question8.option2.text": "Taille L",
	"question9.question": "Souhaitez-vous installer un filtre supplémentaire pour adoucir et améliorer l'eau?",
	"question9.option1.text": "Oui",
	"question9.option2.text": "Non",
	"results.title": "{productGroupsCount, plural, \none {Vos résultats} \nother {Votre résultat}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pour l'installation, vous aurez également besoin de:",
	"results.newConfiguration.title": "Voulez-vous configurer un nouveau système d'eau?",
	"results.newConfiguration.buttonText": "Configurer un nouveau système d'eau",
	"results.product.number": "Référence produit: #{number}",
	"results.product.button.productInformation": "Information sur le produit",
	"results.product.button.dealerLocator": "Trouvez un showroom",
	"results.product.button.buyNow": "Acheter en ligne",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Information sur le produit",
	"results.product.dealer": "Trouvez un showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privatnost",
	"footer.privacy.url": "https://www.grohe.hr/hr_hr/company/privacy/",
	"footer.disclaimer.text": "Odricanje",
	"footer.disclaimer.url": "https://www.grohe.hr/hr_hr/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Grohe Watersystems konfigurator",
	"homepage.introtext": "Samo odgovorite na nekoliko pitanja kako biste konfigurirali GROHE Water System koji će odgovarati vašim potrebama.",
	"homepage.buttonStart": "Početak",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 stranica nije pronađena",
	"404.link.goBack": " Vratite se na početnu stranicu",
	"configurator.button.seeResults": "Vidi rezultate",
	"question1.question": "Imate li hladnu i toplu vodu u svojoj kuhinji?",
	"question1.option1.text": "Imam hladnu i toplu vodu u mojoj kuhinji",
	"question1.option2.text": "Imam samo hladnu vodu",
	"question2.question": "Koju vrstu vode tražite?",
	"question2.option1.text": "vrelu vodu za pripremu hrane i pića",
	"question2.option2.text": "Rashlađena i pjenušava voda za piće",
	"question2.option3.text": "Rashlađena i pjenušava, ali i vrela voda",
	"question3.question": "Želite li zadržati postojeću kuhinjsku slavinu?",
	"question3.option1.text": "Želim je zadržati",
	"question3.option2.text": "Želim instalirati novi model",
	"question4.question": "Koja bi bila vaša glavna mješalica?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Koji je vaš željeni oblik izljeva?",
	"question5.option1.text": "Izljev u obliku slova L",
	"question5.option2.text": "Izljev u obliku slova U",
	"question5.option3.text": "Izljev u obliku slova C",
	"question6.question": "Koja je vaša željena završna obrada??",
	"question6.option1.text": "krom",
	"question6.option2.text": "Mat krom",
	"question7.question": "Koju veličinu bojlera trebate?",
	"question7.option1.text": "M veličina(3 litre)",
	"question7.option2.text": "Veličina L (5,5 litara)",
	"results.title": "{productGroupsCount, plural, \none {vaši rezultati} \nother {vaši rezultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Za ispravnu instalaciju također ćete trebati:",
	"results.newConfiguration.title": "Želite li konfigurirati novi vodeni sustav?",
	"results.newConfiguration.buttonText": "Konfiguriraj novi vodeni sistem",
	"results.product.number": "Broj proizvoda: #{number}",
	"results.product.button.productInformation": "Informacije o proizvodu",
	"results.product.button.dealerLocator": "Pronađite izložbeni prostor",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": " Informacije o proizvodu",
	"results.product.dealer": "Pronađite izložbeni prostor",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Jogi Információk",
	"footer.privacy.url": "http://www.grohe.hu/hu_hu/company/privacy/",
	"footer.disclaimer.text": "Impresszum",
	"footer.disclaimer.url": "http://www.grohe.hu/hu_hu/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems konfigurátor",
	"homepage.introtext": "Válaszoljon néhány egyszerű kérdésre és tudja meg, melyik termékünk szolgálja ki a legjobban az Ön igényeit.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Vissza a címlapra",
	"configurator.button.seeResults": "Eredmények megtekintése",
	"question1.question": "Elérhető meleg és hideg víz is a konyhájában?",
	"question1.option1.text": "Igen, mindkettő elérhető",
	"question1.option2.text": "Csak hideg víz",
	"question2.question": "Milyen jellegű vízellátással egészítené ki konyháját?",
	"question2.option1.text": "Forró vízzel, élelmiszerek és meleg italok elkészítéséhez",
	"question2.option2.text": "Hűtött, szűrt és szénsavas vízzel",
	"question2.option3.text": "Mindkettővel",
	"question3.question": "Megtartaná jelenlegi konyhai csapját?",
	"question3.option1.text": "Igen",
	"question3.option2.text": "Szeretnék új modellt választani",
	"question4.question": "Melyi legyen az elsőszámú csaptelep?",
	"question4.option1.text": "GROHE Blue Home vízszűrő",
	"question4.option2.text": "GROHE Red vízforraló",
	"question5.question": "Melyik csaptelep formát kedveli?",
	"question5.option1.text": "L-alakú kifolyó",
	"question5.option2.text": "U-alakú kifolyó",
	"question5.option3.text": "C-alakú kifolyó",
	"question6.question": "Milyen bevonatú csapot választana?",
	"question6.option1.text": "Króm",
	"question6.option2.text": "Szálcsiszolt acél",
	"question7.question": "A vízmelegítőhoz, mekkora bojler méretet választana?",
	"question7.option1.text": "M (3 Literes)",
	"question7.option2.text": "L (5.5 Literes)",
	"results.title": "{productGroupsCount, plural, \none {Javaslatunk Önnek} \nother {Javaslatunk Önnek}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "A megfelelő beszereléshez az alábbiakra is szüksége lesz:",
	"results.newConfiguration.title": "Szeretne újrakezdeni a konfigurátort?",
	"results.newConfiguration.buttonText": "Újrakezdem",
	"results.product.number": "Cikkszám: #{number}",
	"results.product.button.productInformation": "Termékinformáció",
	"results.product.button.dealerLocator": "Bemutatóterem kereső",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Termékinformáció",
	"results.product.dealer": "Bemutatóterem kereső",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ch/it_ch/azienda/privacy.html",
	"footer.disclaimer.text": "Dichiarazione di non responsabilità",
	"footer.disclaimer.url": "https://www.grohe.ch/it_ch/azienda/note-legali.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Configuratore di sistemi per la fornitura di acqua GROHE",
	"homepage.introtext": "Per configurare il sistema per la fornitura di acqua GROHE che soddisfi le tue esigenze, rispondi ad alcune domande di seguito. ",
	"homepage.buttonStart": "Inizia",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina non trovata",
	"404.link.goBack": "Torna alla homepage ",
	"configurator.button.seeResults": "Visualizza i risultati",
	"question1.question": "Hai una fornitura di acqua calda e fredda nella tua cucina?",
	"question1.option1.text": "Ho una fornitura di acqua calda nella mia cucina",
	"question1.option2.text": "Ho una fornitura di acqua fredda con uno scaldaacqua istantaneo installato",
	"question2.question": "Che tipo di acqua cerchi?",
	"question2.option1.text": "Acqua bollente per preparare cibi e bevande",
	"question2.option2.text": "Acqua fresca e frizzante da bere",
	"question2.option3.text": "Acqua fresca e frizzante e acqua bollente",
	"question3.question": "Vuoi tenere il tuo rubinetto della cucina?",
	"question3.option1.text": "Voglio tenerlo",
	"question3.option2.text": "Voglio installare un nuovo modello",
	"question4.question": "Quale rubinetto principale desideri?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Qual è il tuo design della bocca preferito?",
	"question5.option1.text": "Bocca a L",
	"question5.option2.text": "Bocca a U",
	"question5.option3.text": "Bocca a C",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "Bocca a L",
	"question6.option2.text": "Bocca a C",
	"question7.question": "Qual è la tua finitura preferita?",
	"question7.option1.text": "Cromato",
	"question7.option2.text": "Supersteel",
	"question8.question": "Di che dimensioni dev’essere il tuo bollitore?",
	"question8.option1.text": "Dimensione M",
	"question8.option2.text": "Dimensione L",
	"question9.question": "Desideri avere un filtro aggiuntivo per ammorbidire l’acqua e migliorarne la qualità?",
	"question9.option1.text": "Si",
	"question9.option2.text": "No",
	"results.title": "Your {productGroupsCount, plural, \none {Il tuo risultato} \nother {I tuoi risultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione, avrai bisogno anche di:",
	"results.newConfiguration.title": "Vuoi configurare un nuovo sistema di fornitura dell’acqua?",
	"results.newConfiguration.buttonText": "Configura un nuovo sistema di fornitura dell’acqua",
	"results.product.number": "Codice prodotto: #{number}",
	"results.product.button.productInformation": "Informazioni sul prodotto",
	"results.product.button.dealerLocator": "Trova uno showroom",
	"results.product.button.buyNow": "Acquista online",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informazioni sul prodotto",
	"results.product.dealer": "Trova uno showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.it/it_it/azienda/privacy.html",
	"footer.disclaimer.text": "Company Info",
	"footer.disclaimer.url": "https://www.grohe.it/it_it/azienda/note-legali.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Configuratore di soluzioni per l’acqua GROHE",
	"homepage.introtext": "Rispondi ad alcune semplici domande e trova il sistema per il trattamento dell'acqua GROHE che soddisfa le tue necessità.",
	"homepage.buttonStart": "Vai al configuratore di soluzioni per l’acqua GROHE",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Homa Page",
	"configurator.button.seeResults": "Visualizza i risultatis",
	"question1.question": "Hai una fornitura di acqua calda e fredda nella tua cucina?",
	"question1.option1.text": "Ho una fornitura di acqua calda nella mia cucina",
	"question1.option2.text": "Ho una fornitura di acqua fredda con uno scaldabagno stantaneo installato",
	"question2.question": "Quale tipo di acqua stai cercando?",
	"question2.option1.text": "Acqua bollente filtrata per preparare cibi e bevande",
	"question2.option2.text": "Acqua fresca filtrata, naturale, leggermente frizzante e frizzante da bere",
	"question2.option3.text": "Acqua fresca filtrata, naturale, leggermente frizzante e frizzante e acqua bollente",
	"question3.question": "Desideri continuare ad utilizzare il tuo attuale miscelatore da cucina?",
	"question3.option1.text": "Desidero continuare ad utilizzare il mio attuale miscelatore da cucina",
	"question3.option2.text": "Desidero sostituirlo con un nuovo miscelatore da cucina",
	"question4.question": "Quale dovrebbe essere il tuo miscelatore principale?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quale design preferici?",
	"question5.option1.text": "Bocca di erogazione a \"L\"",
	"question5.option2.text": "Bocca di erogazione a \"U\"",
	"question5.option3.text": "Bocca di erogazione a \"C\"",
	"question6.question": "Quale tipo di finitura preferisci?",
	"question6.option1.text": "Cromata",
	"question6.option2.text": "Satinata - SuperSteel",
	"question7.question": "Quale capacità d'acqua deve avere il tuo boiler?",
	"question7.option1.text": "Taglia M (3 litri)",
	"question7.option2.text": "Taglia L (5,5 litri)",
	"results.title": "{productGroupsCount, plural, \none {Il tuo risultato} \nother {I tuoi risultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione avrai bisogno anche di:",
	"results.newConfiguration.title": "Vuoi configurare un nuovo sistema per il trattamento dell’acqua?",
	"results.newConfiguration.buttonText": "Configura un nuovo sistema per il trattamento dell’acqua",
	"results.product.number": "Codice prodotto: #{number}",
	"results.product.button.productInformation": "Informazioni sul prodotto",
	"results.product.button.dealerLocator": "Trova una showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informazioni sul prodotto",
	"results.product.dealer": "Trova una showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privatumo nuostatos",
	"footer.privacy.url": "https://www.grohe.lt/lt_lt/company/privacy.html",
	"footer.disclaimer.text": "Atsakomybė",
	"footer.disclaimer.url": "https://www.grohe.lt/lt_lt/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems konfigūratorius",
	"homepage.introtext": "Atsakykite į keletą klausimų ir sužinokite, kuri GROHE vandens sistema Jums tinkamiausia.",
	"homepage.buttonStart": "Pradėti",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 klaida: puslapis nerastas",
	"404.link.goBack": "Grįžti į pradinį puslapį",
	"configurator.button.seeResults": "Rodyti rezultatus",
	"question1.question": "Ar savo virtuvėje turite šalto ir karšto vandens tiekimą?",
	"question1.option1.text": "Virtuvėje turiu šaltą ir karštą vandenį",
	"question1.option2.text": "Virtuvėje turiu tik šaltą vandenį",
	"question2.question": "Koks vanduo virtuvėje Jums reikalingas?",
	"question2.option1.text": "Verdantis vanduo maisto ir gėrimų ruošimui",
	"question2.option2.text": "Atvėsintas ir gazuotas vanduo",
	"question2.option3.text": "Atvėsintas, gazuotas bei verdantis vanduo",
	"question3.question": "Ar norėtumėte palikti savo turimą virtuvės maišytuvą?",
	"question3.option1.text": "Noriu palikti",
	"question3.option2.text": "Noriu pakeisti į naują modelį",
	"question4.question": "Kuris būtų Jūsų pagrindinis maišytuvas?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Kuris maišytuvo snapo dizainas patinka?",
	"question5.option1.text": "L formos snapas",
	"question5.option2.text": "U formos snapas",
	"question5.option3.text": "C formos snapas",
	"question6.question": "Kuris maišytuvo snapo dizainas patinka?",
	"question6.option1.text": "L formos snapas",
	"question6.option2.text": "U formos snapas",
	"question6.option3.text": "C formos snapas",
	"question7.question": "Kokio paviršiaus maišytuvo pageidaujate?",
	"question7.option1.text": "Chromuoto paviršiaus",
	"question7.option2.text": "Nerūdijančio plieno paviršiaus",
	"question8.question": "Koks boilerio dydis Jums reikalingas?",
	"question8.option1.text": "M dydis (3 litrai)",
	"question8.option2.text": "L dydis (5.5 litrai)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Ar savo virtuvėje turite šalto ir karšto vandens tiekimą?",
	"question10.option1.text": "Virtuvėje turiu šaltą ir karštą vandenį",
	"question10.option2.text": "Virtuvėje turiu tik šaltą vandenį",
	"results.title": "Jūsų {productGroupsCount, plural, \none {rezultatai} \nother {rezultatas}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pilnam maišytuvo sumontavimui taip pat reikės:",
	"results.newConfiguration.title": "Ar norite koreguoti savo pasirinkimą?",
	"results.newConfiguration.buttonText": "Konfigūruoti naują vandens sistemą.",
	"results.product.number": "Produkto numeris: #{number}",
	"results.product.button.productInformation": "Produkto informacija",
	"results.product.button.dealerLocator": "Ieškoti artimiausios pardavimo vietos",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produkto informacija",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.lv/lv_lv/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.lv/lv_lv/company/legal-info.html",
	"footer.copyright": "&copy; 2018 GROHE AG Eesti filiaal",
	"homepage.headline": "GROHE WaterSystems Configurator",
	"homepage.introtext": "Just answer a few questions below to configurate the GROHE Watersystem that will fit your needs.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "I have cold and warm water supply in my kitchen",
	"question1.option2.text": "I have cold water supply only",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Kettle hot water for preparing food and beverages",
	"question2.option2.text": "Chilled and sparkling water for drinking",
	"question2.option3.text": "Chilled and sparkling as well as kettle hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it.",
	"question3.option2.text": "I want to install a new model",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What's your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "U-shaped spout",
	"question5.option3.text": "C-shaped spout",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "What's your preferred finish?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M Size (3 Litres)",
	"question8.option2.text": "L Size (5.5 Litres)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Do you have a cold and warm water supply in your kitchen?",
	"question10.option1.text": "I have cold and warm water supply in my kitchen",
	"question10.option2.text": "I have cold water supply only",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will also need:",
	"results.newConfiguration.title": "Do you want to configurate a new water system?",
	"results.newConfiguration.buttonText": "Configure a new water system",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product Information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.copyright": "&copy; Grohe N.V. - S.A.",
	"homepage.headline": "GROHE Watersystemen Configurator",
	"homepage.introtext": "Beantwoord een paar simpele vragen in de keuzehulp en ontdek welk GROHE watersysteem het beste bij jouw wensen past of welke combinatie je kan maken.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Ga terug naar de homepagina",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Heb je koud en warm water voorziening in jouw keuken?",
	"question1.option1.text": "Ik heb warm water toevoer in mijn keuken",
	"question1.option2.text": "Ik heb enkel koud water toevoer in mijn keuken",
	"question2.question": "Naar wat voor water oplossing ben je op zoek?",
	"question2.option1.text": "Kokend heet water voor het bereiden van voedsel en dranken",
	"question2.option2.text": "Gekoeld en bruisend water om te drinken",
	"question2.option3.text": "Zowel gekoeld en bruisend water als kokend heet water",
	"question3.question": "Wil je jouw bestaande keukenkraan houden?",
	"question3.option1.text": "Ik wil mijn huidige kraan houden",
	"question3.option2.text": "Ik wil mijn huidige kraan vervangen door een nieuwe",
	"question4.question": "Wat zou de belangrijkste kraan moeten zijn?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wat is jouw favoriete uitloop?",
	"question5.option1.text": "L-vorm",
	"question5.option2.text": "U-vorm",
	"question5.option3.text": "C-vorm",
	"question6.question": "What´s your prefered spout design for the Mono faucet?",
	"question6.option1.text": "L-vorm",
	"question6.option2.text": "C-vorm",
	"question7.question": "Naar welke afwerking gaat jouw voorkeur uit?",
	"question7.option1.text": "Chroom",
	"question7.option2.text": "Supersteel",
	"question8.question": "Hoeveel liter kokend water heb je nodig?",
	"question8.option1.text": "M Size (3 liter)",
	"question8.option2.text": "L Size (5,5 liter)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water? (only applicable for NL)",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "Jouw {productGroupsCount, plural, \none {resultaat} \nother {resultaten}\n}",
	"results.proposal.title": "Voorstel {number}",
	"results.proposal.title.single": "Voorstel",
	"results.bundle.title": "Voor een correcte installatie heb je ook het volgende nodig",
	"results.newConfiguration.title": "Wil je een nieuwe configuratie maken?",
	"results.newConfiguration.buttonText": "Configureer een nieuw watersysteem",
	"results.product.number": "Referentie: #{number}",
	"results.product.button.productInformation": "Product informatie",
	"results.product.button.dealerLocator": "Vind showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product informatie",
	"results.product.dealer": "Vind showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE SmartControl douche-keuzehulp",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.nl/nl_nl/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.nl/nl_nl/privacybeleid.html",
	"footer.copyright": "© 2017 Grohe Nederland B.V.",
	"homepage.headline": "GROHE Blue voor gekoeld en/of bruisend water of GROHE Red voor kokend heet water?",
	"homepage.introtext": "Beantwoord een paar eenvoudige vragen en ontdek welk GROHE product het beste bij jouw individuele behoeften past.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Wat voor watervoorziening heb je nu in de keuken. Koud of warm?",
	"question1.option1.text": "Ik heb zowel koud en warm water",
	"question1.option2.text": "Ik heb alleen koud water",
	"question2.question": "Naar wat voor oplossing ben je op zoek?",
	"question2.option1.text": "Kokend heet water voor het bereiden van voedsel en dranken",
	"question2.option2.text": "Gekoeld en bruisend water om te drinken",
	"question2.option3.text": "Zowel gekoeld en bruisend water als kokend heet water",
	"question3.question": "Wil je jouw bestaande keukenkraan houden?",
	"question3.option1.text": "Ik wil mijn huidige kraan houden",
	"question3.option2.text": "Ik wil mijn huidige kraan vervangen door een nieuwe",
	"question4.question": "Welke keukenkraan wordt de mengkraan?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wat is jouw favoriete uitloop?",
	"question5.option1.text": "Ik wil graag een L-uitloop",
	"question5.option2.text": "Ik wil graag een U-uitloop",
	"question5.option3.text": "Ik wil graag een C-uitloop",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Naar welke kleur gaat jouw voorkeur uit?",
	"question7.option1.text": "Ik kies voor Chroom",
	"question7.option2.text": "Ik kies voor Supersteel",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M Size (3 Litres)",
	"question8.option2.text": "L Size (5.5 Litres)",
	"question9.question": "Bij een waterhardheid hoger dan 10 dH heb je de optie om een filter toevoegen voor optimale bescherming tegen kalkafzetting en onzuiverheden? Wil je deze toevoegen?",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nee",
	"results.title": "{productGroupsCount, plural, \none {Jouw resultaat} \nother {Jouw resultaten}\n}",
	"results.bundle.title": "Voor een correcte installatie heb je ook nodig:",
	"results.newConfiguration.buttonText": "Begin opnieuw",
	"results.product.button.productInformation": "Productinformatie",
	"results.product.button.dealerLocator": "Zoek verkooppunt",
	"results.product.button.buyNow": "Koop online",
	"results.product.information": "Productinformatie",
	"results.product.dealer": "Zoek verkooppunt",
	"results.proposal.title": "Advies {number}",
	"results.proposal.title.single": "Advies",
	"results.newConfiguration.title": "Wil je opnieuw beginnen?",
	"results.product.number": "Artikelnummer: #{number}",
	"results.product.button.downloadPDF": "Download advies (PDF)",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Terug naar de homepage",
	"hatchModal.title": "Koop online",
	"hatchModal.btnText": "Nu kopen",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Niet op voorraat} \nother {Op voorraad}\n}",
	"hatchModal.buyNow": "Nu kopen",
	"app.components.HomePage.header": "GROHE SmartControl douche-keuzehulp"
};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Personvern",
	"footer.privacy.url": "https://www.grohe.no/no_no/personvaern.html",
	"footer.disclaimer.text": "Juridisk informasjon",
	"footer.disclaimer.url": "https://www.grohe.no/no_no/imprint.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE Vannsystemkonfigurator",
	"homepage.introtext": "Svar på noen få spørsmål under for å konfigurere hvilket GROHE vannsystem som passer deg og dine behov best.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Side ikke funnet",
	"404.link.goBack": "Gå tilbake til hjemmesiden",
	"configurator.button.seeResults": "Se resultater",
	"question1.question": "Har du kaldtvann- eller varmtvannstilførsel på ditt kjøkken?",
	"question1.option1.text": "Jeg har kaldt og varmt vanntilførsel på mitt kjøkken.",
	"question1.option2.text": "Jeg har kaldtvannstilførsel på mitt kjøkken.",
	"question2.question": "Hva slags vann er du ute etter??",
	"question2.option1.text": "Kokende varmt vann for forberedelse av mat og drikke.",
	"question2.option2.text": "Nedkjølt vann med kullsyre til å drikke.",
	"question2.option3.text": "Nedkjølt vann med kullsyre, men også kokende varmt vann.",
	"question3.question": "Ønsker du å beholde din allerede eksisterende kjøkkenkran?",
	"question3.option1.text": "Jeg ønsker å beholde den",
	"question3.option2.text": "Jeg ønsker å installere en ny modell",
	"question4.question": "Hvilken bør være din primære kjøkkenkran?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Hvilket tut-design foretrekker du?",
	"question5.option1.text": "L-formet tut",
	"question5.option2.text": "U-formet tut",
	"question5.option3.text": "C-formet tut",
	"question6.question": "Hvilket tut-design foretrekker du?",
	"question6.option1.text": "L-formet tut",
	"question6.option2.text": "U-formet tut",
	"question6.option3.text": "C-formet tut",
	"question7.question": "Hvilken er din foretrukne overflate??",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Supersteel",
	"question8.question": "Hvilken størrelse trenger du på berederen?",
	"question8.option1.text": "M Størrelse (3 Liter)",
	"question8.option2.text": "L Størrelse (5.5 Liter)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Har du kaldtvann- eller varmtvannstilførsel på ditt kjøkken?",
	"question10.option1.text": "Jeg har kaldt og varmt vanntilførsel på mitt kjøkken.",
	"question10.option2.text": "Jeg har kaldtvannstilførsel på mitt kjøkken.",
	"results.title": "{productGroupsCount, plural, \none {Ditt resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For riktig installasjon trenger du også:",
	"results.newConfiguration.title": "Ønsker du å konfigurere et nytt vannsystem?",
	"results.newConfiguration.buttonText": "Konfigurer et nytt vannsystem",
	"results.product.number": "Produktnummer: #{number}",
	"results.product.button.productInformation": "Produktinformasjon",
	"results.product.button.dealerLocator": "Finn et showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produktinformasjon",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Polityka prywatności",
	"footer.privacy.url": "https://www.grohe.pl/pl_pl/grohe/ochrona-prywatnosci.html",
	"footer.disclaimer.text": "Zastrzeżenia prawne",
	"footer.disclaimer.url": "https://www.grohe.pl/pl_pl/grohe/zastrzezenia-prawne.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurator systemów kuchennych GROHE",
	"homepage.introtext": "Wystarczy, że odpowiesz na kilka pytań, a konfigurator dopasuje najlepszy dla Ciebie system kuchenny z oferty GROHE.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Wróć  do strony głównej",
	"configurator.button.seeResults": "Zobacz wyniki",
	"question1.question": "Czy posiadasz doprowadzenie zimnej i ciepłej wody w swojej kuchni?",
	"question1.option1.text": "Posiadam doprowadzenie zarówno zimnej jak i ciepłej wody w mojej kuchni.",
	"question1.option2.text": "Posiadam doprowadzenie tylko zimnej wody",
	"question2.question": "Jakiego rodzaju wody poszukujesz?",
	"question2.option1.text": "Wrzącej wody do przygotowywania posiłków i napojów.",
	"question2.option2.text": "Schłodzonej i gazowanej wody do picia ",
	"question2.option3.text": "Zarówno schłodzonej i gazowanej, jak i wrzącej wody",
	"question3.question": "Czy chcesz zatrzymać istniejącą baterię kuchenną?",
	"question3.option1.text": "Tak, chcę ją zatrzymać.",
	"question3.option2.text": "Chcę zainstalować nową baterię",
	"question4.question": "Co powinno być Twoją główną baterią kuchenną?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Jaki design wylewki wolisz?",
	"question5.option1.text": "Wylewka w kształcie litery L",
	"question5.option2.text": "Wylewka w kształcie U",
	"question5.option3.text": "Wylewka w kształcie C",
	"question6.question": "Jaką powłoką powinna być pokryta Twoja bateria?",
	"question6.option1.text": "Chromem",
	"question6.option2.text": "Supersteel",
	"question7.question": "Który rozmiar bojlera wybierasz? ",
	"question7.option1.text": "W rozmiarze M (3 litry wody)",
	"question7.option2.text": "W rozmiarze L (5.5 litra wody)",
	"results.title": "{productGroupsCount, plural, \none {Twój wynik} \nother {Twoje wyniki}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "W celu przeprowadzenia prawidłowej instalacji, będzie potrzebować również:",
	"results.newConfiguration.title": "Czy chcesz skonfigurować nowy system?",
	"results.newConfiguration.buttonText": "Skonfiguruj nowy system",
	"results.product.number": "Nr produktu: #{number}",
	"results.product.button.productInformation": "Informacja o produkcie",
	"results.product.button.dealerLocator": "Znajdź salon sprzedaży",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informacja o produkcie",
	"results.product.dealer": "Znajdź salon sprzedaży",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacidade",
	"footer.privacy.url": "https://www.grohe.pt/pt_pt/privacidade.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.pt/pt_pt/imprimir.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Configurador GROHE WaterSystems",
	"homepage.introtext": "Responda às perguntas abaixo e configure o Watersystem GROHE que melhor se ajusta às suas necessidades",
	"homepage.buttonStart": "Iniciar",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Página não encontrada",
	"404.link.goBack": "Volte para a página principal",
	"configurator.button.seeResults": "Veja os resultados",
	"question1.question": "Dispõe de um fornecimento de água quente e fria na sua cozinha?",
	"question1.option1.text": "Eu tenho um fornecimento de água quente e fria na minha cozinha",
	"question1.option2.text": "Eu tenho apenas um fornecimento de água fria",
	"question2.question": "Qual é o tipo de água que procura?",
	"question2.option1.text": "água a ferver para preparar comidas e bebidas",
	"question2.option2.text": "Água fresca e gaseificada para beber",
	"question2.option3.text": "Água fresca e gaseificada, assim como água a ferver",
	"question3.question": "Deseja manter a sua torneira de cozinha?",
	"question3.option1.text": "Sim, eu quero mantê-la",
	"question3.option2.text": "Eu quero instalar uma nova",
	"question4.question": "Qual deve ser a sua torneira principal?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Qual é o tipo de bica que prefere?",
	"question5.option1.text": "Bica em L",
	"question5.option2.text": "Bica em U",
	"question5.option3.text": "Bica em C",
	"question6.question": "Qual é tipo de acabamento que prefere?",
	"question6.option1.text": "Cromado",
	"question6.option2.text": "Supersteel",
	"question7.question": "Selecione o tamanho do boiler que precisa",
	"question7.option1.text": "Tamanho M (3 Litros)",
	"question7.option2.text": "Tamanho L (5.5 Litros)",
	"results.title": "{productGroupsCount, plural, \none {O seu resultado} \nother {Os seus resultados}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Para uma correta instalação também irá precisar de:",
	"results.newConfiguration.title": "Deseja configurar um novo water system?",
	"results.newConfiguration.buttonText": "Configure um novo water system",
	"results.product.number": "Número do produto: #{number}",
	"results.product.button.productInformation": "Informação acerca do produto",
	"results.product.button.dealerLocator": "Encontrar um showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informação acerca do produto",
	"results.product.dealer": "Encontrar um showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Confidențialitate",
	"footer.privacy.url": "https://www.grohe.ro/ro_ro/compania/confidentialitate.html",
	"footer.disclaimer.text": "Informații juridice",
	"footer.disclaimer.url": "https://www.grohe.ro/ro_ro/compania/informatii-juridice.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Configuratorul Sisteme Pentru Apă GROHE",
	"homepage.introtext": "Răspunde doar la câteva întrebări de mai jos pentru a configura sistemul pentru apă GROHE care se va potrivi perfect nevoilor tale.",
	"homepage.buttonStart": "Începe",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina nu a fost găsită",
	"404.link.goBack": "Înapoi la pagina de pornire",
	"configurator.button.seeResults": "Vezi rezultatele",
	"question1.question": "Ai o sursă de apă rece și caldă în bucătăria ta?",
	"question1.option1.text": "Da, am o sursă de apă rece și caldă în bucătăria mea",
	"question1.option2.text": "Am doar o sursă de apă rece în bucătărie",
	"question2.question": "Ce tip de apă dorești?",
	"question2.option1.text": "Apă fierbinte pentru prepararea alimentelor și a băuturilor",
	"question2.option2.text": "Apă răcită și carbogazoasă pentru băut",
	"question2.option3.text": "Apă răcită și carbogazoasă, precum și apă caldă fierbinte",
	"question3.question": "Dorești să menții robinetul de bucătărie existent?",
	"question3.option1.text": "Vreau să-l păstrez",
	"question3.option2.text": "Vreau să instalez un model nou",
	"question4.question": "Care ar trebui să fie bateria de bucătărie principală?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Care este designul tău preferat pentru pipa bateriei?",
	"question5.option1.text": "Pipă formă L",
	"question5.option2.text": "Pipă formă U",
	"question5.option3.text": "Pipă formă C",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Care este finisajul tău preferat?",
	"question7.option1.text": "Cromat",
	"question7.option2.text": "Supersteel",
	"question8.question": "Care să fie capacitatea boilerului de care ai nevoie?",
	"question8.option1.text": "Mărime M (3 litri)",
	"question8.option2.text": "Mărime L (5.5 litri)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "{productGroupsCount, plural, \none {Rezultatul tău} \nother {Rezultatele tale}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pentru o instalare corectă vei avea nevoie și de:",
	"results.newConfiguration.title": "Dorești să configurezi un nou sistem pentru apă?",
	"results.newConfiguration.buttonText": "Configurează un nou sistem pentru apă",
	"results.product.number": "Codul produsului: #{number}",
	"results.product.button.productInformation": "Informații despre produs",
	"results.product.button.dealerLocator": "Caută un showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informații despre produs",
	"results.product.dealer": "Caută un showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфиденциальность",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Правовая оговорка",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Подбор конфигурации водных систем GROHE",
	"homepage.introtext": "GROHE Blue или Red? Ответьте на несколько простых вопросов, и Вы узнаете, какое оборудование GROHE лучше всего удовлетворит Вашим потребностям.",
	"homepage.buttonStart": "Начать",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "Ошибка 404: страница не найдена",
	"404.link.goBack": "Вернуться на главную страницу",
	"configurator.button.seeResults": "Посмотреть результаты",
	"question1.question": "Есть ли на Вашей кухне и холодное, и горячее водоснабжение?",
	"question1.option1.text": "На моей кухне есть и холодное, и горячее водоснабжение",
	"question1.option2.text": "Есть только холодное водоснабжение",
	"question2.question": "Какая вода Вам необходима?",
	"question2.option1.text": "Кипящая вода для приготовления пищи и напитков",
	"question2.option2.text": "Охлажденная и газированная питьевая вода",
	"question2.option3.text": "Охлажденная и газированная, а также кипящая вода",
	"question3.question": "Вы хотите оставить имеющийся кухонный смеситель?",
	"question3.option1.text": "Я хочу его оставить",
	"question3.option2.text": "Я хочу установить новую модель",
	"question4.question": "Каким должен быть Ваш основной смеситель?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Какую форму излива Вы предпочитаете?",
	"question5.option1.text": "L-образный излив",
	"question5.option2.text": "U-образный излив",
	"question5.option3.text": "С-образный излив",
	"question6.question": "Какое покрытие Вы предпочитаете?",
	"question6.option1.text": "Хромированное",
	"question6.option2.text": "Суперсталь",
	"question7.question": "Какой объем бойлера Вам необходим?",
	"question7.option1.text": "Неприменимо",
	"question7.option2.text": "Объем L (5,5 литров)",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваши результаты}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Для надлежащего монтажа Вам также потребуется:",
	"results.newConfiguration.title": "Хотели бы Вы подобрать еще одну водную систему?",
	"results.newConfiguration.buttonText": "Подобрать конфигурацию для еще одной водной системы",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Описание модели",
	"results.product.button.dealerLocator": "Найти салон-магазин",
	"results.product.button.buyNow": "Неприменимо",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Описание модели",
	"results.product.dealer": "Найти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Súkromie",
	"footer.privacy.url": "https://www.grohe.sk/sk_sk/spolocnost/privacy.html",
	"footer.disclaimer.text": "Vyhlásenie",
	"footer.disclaimer.url": "https://www.grohe.sk/sk_sk/spolocnost/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurátor vodných systémov GROHE",
	"homepage.introtext": "Jednoducho odpovedzte na pár otázok nižšie a získajte takú konfiguráciu vodného systému GROHE, aká bude dokonale vyhovovať vašim požiadavkám.",
	"homepage.buttonStart": "Spustiť",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404: stránka sa nenašla",
	"404.link.goBack": "Prejsť späť na domovskú stránku",
	"configurator.button.seeResults": "Zobraziť výsledky",
	"question1.question": "Máte v kuchyni prípojku studenej a teplej vody?",
	"question1.option1.text": "Áno, v kuchyni mám prípojku studenej aj teplej vody",
	"question1.option2.text": "V kuchyni mám iba prípojku studenej vody",
	"question2.question": "Aký typ vody od vodného systému očakávate?",
	"question2.option1.text": "vriacu vodu na prípravu pokrmov a horúcich nápojov",
	"question2.option2.text": "Vychladenú, perlivú vodu na pitie",
	"question2.option3.text": "Vychladenú a perlivú vodu, ale taktiež vodu vriacu",
	"question3.question": "Chcete si ponechať svoju súčasnú drezovú batériu?",
	"question3.option1.text": "Chcem si ju ponechať",
	"question3.option2.text": "Chcem si kúpiť nový model",
	"question4.question": "Aká by mala byť vaša hlavná drezová batéria?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Aký tvar výpustu preferujete?",
	"question5.option1.text": "Výpust v tvare písmena L",
	"question5.option2.text": "Výpust v tvare písmena U",
	"question5.option3.text": "Výpust v tvare písmena C",
	"question6.question": "Aká povrchová úprava sa vám páči najviac?",
	"question6.option1.text": "Chrómová",
	"question6.option2.text": "SuperSteel",
	"question7.question": "Aký veľký bojler potrebujete?",
	"question7.option1.text": "Veľkosť M (3 litre)",
	"question7.option2.text": "Veľkosť L (5,5 litra)",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledok} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Na správnu inštaláciu budete potrebovať taktiež:",
	"results.newConfiguration.title": "Chcete spustiť konfiguráciu nového vodného systému od začiatku?",
	"results.newConfiguration.buttonText": "Spustiť konfiguráciu nového systému",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informácie o produkte",
	"results.product.button.dealerLocator": "Nájsť showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informácie o produkte",
	"results.product.dealer": "Nájsť showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Gizlilik",
	"footer.privacy.url": "https://www.grohe.com.tr/tr_tr/gizlilik.html",
	"footer.disclaimer.text": "Yasal Uyarı",
	"footer.disclaimer.url": "https://www.grohe.com.tr/tr_tr/bilgilendirme.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE Su Sistemleri Yapılandırıcısı",
	"homepage.introtext": "İhtiyaçlarınıza uygun GROHESu  Sistemini yapılandırmak için aşağıdaki soruları cevaplayın.",
	"homepage.buttonStart": "Başla",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Sayfa Bulunamadı",
	"404.link.goBack": "Giriş sayfasına dön",
	"configurator.button.seeResults": "Sonuçları göster",
	"question1.question": "Nasıl bir su arıyorsunuz?",
	"question1.option1.text": "Yiyecek ve içecekleri hazırlamak için kaynar sıcak su",
	"question1.option2.text": "İçmek için soğutulmuş ve sodalı su",
	"question1.option3.text": "Kaynar sıcak suyun yanında soğutulmuş ve sodalı su",
	"question2.question": "Ana bataryanız hangisi olmalı?",
	"question2.option1.text": "GROHE Blue Home",
	"question2.option2.text": "GROHE Red",
	"question3.question": "Hangi su çıkış ucu tasarımını tercih edersiniz?",
	"question3.option1.text": "L şeklinde çıkış ucu",
	"question3.option2.text": "U şeklinde çıkış ucu",
	"question3.option3.text": "C şeklinde çıkış ucu",
	"question4.question": "Hangi kaplamayı tercih edersiniz?",
	"question4.option1.text": "Krom",
	"question4.option2.text": "Paslanmaz Çelik",
	"question5.question": "Isıtıcınızın hangi boyutta olmasını istersiniz?",
	"question5.option1.text": "M Boyutu (3 Litre)",
	"question5.option2.text": "L Boyutu (5,5 Litre)",
	"results.title": "{productGroupsCount, plural, \none {Sonucunuz} \nother {Sonuçlarınız}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Doğru kurulum için şunlara da ihtiyaç duyabilirsiniz:",
	"results.newConfiguration.title": "Yeni bir su sistemi yapılandırmak ister misiniz?",
	"results.newConfiguration.buttonText": "Yeni bir su sistemi yapılandır",
	"results.product.number": "Ürün numarası: #{number}",
	"results.product.button.productInformation": "Ürün bilgisi",
	"results.product.button.dealerLocator": "Showroom arayın",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Showroom arayın",
	"hatchModal.title": "'Bilinmiyor",
	"hatchModal.btnText": "'Bilinmiyor",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Конфіденційність",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Відмова",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Конфігуратор GROHE WaterSystems",
	"homepage.introtext": "Дайте відповіді на декілька запитань нижче, щоб скомпонувати систему води GROHE, яка задовольнить Ваші потреби.",
	"homepage.buttonStart": "Розпочати",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Сторінку не знайдено",
	"404.link.goBack": "Повернутися на стартову сторінку",
	"configurator.button.seeResults": "Дивитися результат",
	"question1.question": "Чи є у Вас холодне та гаряче водопостачання на кухні?",
	"question1.option1.text": "У мене є холодне та гаряче водопостачання на кухні",
	"question1.option2.text": "У мене є лише холодне водопостачання",
	"question2.question": "Яка саме вода Вам необхідна?",
	"question2.option1.text": "Кипляча вода для приготування іжі та напоїв",
	"question2.option2.text": "Прохолодна та газована питна вода",
	"question2.option3.text": "Прохолодна, газована, а також кипляча вода",
	"question3.question": "Ви хочете залишити існуючий кухонний змішувач?",
	"question3.option1.text": "Хочу залишити існуючий",
	"question3.option2.text": "Хочу встановити новий",
	"question4.question": "Який із змішувачів має бути основним?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Якій формі виливу Ви надаєте перевагу?",
	"question5.option1.text": "L-подібний вилив",
	"question5.option2.text": "U-подібний вилив",
	"question5.option3.text": "C-подібний вилив",
	"question6.question": "Якому типу покриття поверхні змішувача Ви надаєте перевагу?",
	"question6.option1.text": "Хром",
	"question6.option2.text": "Дамаська сталь",
	"question7.question": "Який розмір бойлер Вам необхіден?",
	"question7.option1.text": "Розмір М (3 літри)",
	"question7.option2.text": "Розмір L (5.5 літри)",
	"results.title": "{productGroupsCount, plural, \none {Ваш результат} \nother {Ваші результати}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Для правильного проведення монтажу Вам також знадобляться:",
	"results.newConfiguration.title": "Хотіли б скомпонувати нову систему води?",
	"results.newConfiguration.buttonText": "Розпочати новий підбір системи води",
	"results.product.number": "Артикул: #{number}",
	"results.product.button.productInformation": "Інформація про продукт",
	"results.product.button.dealerLocator": "Знайти салон-магазин",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Інформація про продукт",
	"results.product.dealer": "Знайти салон-магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"26370000",
					"28364000",
					"26483000",
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34283001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"28364000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26062000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34283001"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					"47790000"
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27888000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26063000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"47790000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23058003"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23061002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27911000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27696000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"19468000",
					"27134000",
					"28576000",
					"28628000",
					"27265000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19355001",
					"28576000",
					"27765000",
					"28679000",
					"27661000",
					"28364000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19567000",
					"28368000",
					"28576000",
					"27265000",
					"28628000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2 && !control"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23058003"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23061002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27911000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27696000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"19468000",
					"27134000",
					"28576000",
					"28628000",
					"27265000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19355001",
					"28576000",
					"27765000",
					"28679000",
					"27661000",
					"28364000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19567000",
					"28368000",
					"28576000",
					"27265000",
					"28628000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2 && !control"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23058003"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23061002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27911000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27696000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"19468000",
					"27134000",
					"28576000",
					"28628000",
					"27265000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19355001",
					"28576000",
					"27765000",
					"28679000",
					"27661000",
					"28364000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19567000",
					"28368000",
					"28576000",
					"27265000",
					"28628000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			},
			{
				"products": [
					"26452000"
				],
				"bundle": []
			},
			{
				"products": [
					"26453000"
				],
				"bundle": []
			},
			{
				"products": [
					"27389001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27635000",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27635000",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26475000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"27420001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26475000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26477000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			},
			{
				"products": [
					"26452000"
				],
				"bundle": []
			},
			{
				"products": [
					"26453000"
				],
				"bundle": []
			},
			{
				"products": [
					"27389001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27635000",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27635000",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26475000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"27420001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26475000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26477000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			},
			{
				"products": [
					"26452000"
				],
				"bundle": []
			},
			{
				"products": [
					"26453000"
				],
				"bundle": []
			},
			{
				"products": [
					"27389001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27635000",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27635000",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26475000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26484000 "
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"27420001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26475000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26477000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27709000",
					"27479000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27709000",
					"27705000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27711000",
					"27479000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27709000",
					"27479000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27709000",
					"27705000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27711000",
					"27479000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"27488000",
					"27271000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"27485000",
					"27271000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27477000",
					"26146000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"28368000",
					"28576000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"28368000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27477000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"28368000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27477000",
					"26146000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"28368000",
					"28576000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"28368000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27477000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"28368000",
					"28724000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26146LS0",
					"28368LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"28724LS0",
					"28368LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt1 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt1 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"28778000",
					"26146000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"28778000",
					"28724000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"27479000",
					"27709000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"27705000",
					"27709000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"27479000",
					"27711000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"27477000",
					"26146000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"28368000",
					"28576000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"28368000",
					"28724000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"27477000",
					"28724000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"28368000",
					"28724000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26146LS0",
					"28368LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"28724LS0",
					"28368LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27699000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27699000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"27492000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28576000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23058003"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23061002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27911000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27696000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"19468000",
					"27134000",
					"28576000",
					"28628000",
					"27265000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19355001",
					"28576000",
					"27765000",
					"28679000",
					"27661000",
					"28364000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19567000",
					"28368000",
					"28576000",
					"27265000",
					"28628000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2 && !control"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"27922001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26259000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27271000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"27488000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26259000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27271000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000",
					"27488000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26259000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"27271000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"27488000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27742000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26066000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26067000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26066000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26171000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26067000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34614001"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"26223001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26259000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26171000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			},
			{
				"products": [
					"34321002"
				],
				"bundle": []
			},
			{
				"products": [
					"34256004"
				],
				"bundle": []
			},
			{
				"products": [
					"34151004"
				],
				"bundle": []
			},
			{
				"products": [
					"34565001"
				],
				"bundle": []
			},
			{
				"products": [
					"34566001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26363000"
				],
				"bundle": []
			},
			{
				"products": [
					"27922001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34614001"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": []
			},
			{
				"products": [
					"23409000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"26223001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"27367000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23058003"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23061002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27911000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27696000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"26405000"
				],
				"bundle": [
					"35600000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"26405000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"19468000",
					"27134000",
					"28576000",
					"28628000",
					"27265000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19355001",
					"28576000",
					"27765000",
					"28679000",
					"27661000",
					"28364000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			},
			{
				"products": [
					"19567000",
					"28368000",
					"28576000",
					"27265000",
					"28628000"
				],
				"bundle": [
					"35500000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2 && !control"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					"29121000",
					"26477000",
					"27367000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34283001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && !rail-holder"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1 && !rail-holder"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0 && !with-holder"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1 && !with-holder"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt1 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt1 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27699000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27699000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27369000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"27492000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28576000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34283001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27890000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27890000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"28362000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26070000",
					"27251000",
					"27251000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27888000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"28347000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27742000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"28347000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26066000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29119000",
					"26062000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26067000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26063000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26461000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26066000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26062000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26459000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26067000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26063000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26461000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27400000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27890000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27890000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27888000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27888000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27890000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27890000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27888000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27888000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"28347000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"28347000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27400000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27400000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"28347000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"28347000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27400000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26062000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26459000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26063000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26461000",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"27400000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			},
			{
				"products": [
					"34321002"
				],
				"bundle": []
			},
			{
				"products": [
					"34256004"
				],
				"bundle": []
			},
			{
				"products": [
					"34151004"
				],
				"bundle": []
			},
			{
				"products": [
					"34565001"
				],
				"bundle": []
			},
			{
				"products": [
					"34566001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26363000"
				],
				"bundle": []
			},
			{
				"products": [
					"27922001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"27297001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34614001"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": []
			},
			{
				"products": [
					"23409000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"26223001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001",
					"34286002",
					"34321002",
					"34256004",
					"34151004",
					"34565001",
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000",
					"27374000",
					"27032001",
					"27967000",
					"27964000",
					"26363000",
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001",
					"27968000",
					"27966000",
					"26075000",
					"27296002",
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001",
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001",
					"27058000",
					"26452001",
					"26453001",
					"26454001",
					"27389002",
					"27394002",
					"27399002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"28364000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt0 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt0 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt1 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt1 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34614001"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": []
			},
			{
				"products": [
					"23409000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"26223001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34286002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34321002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34256004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34151004"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34565001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27374000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27032001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27967000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27964000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26363000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27968000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27966000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26075000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27296002"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"27058000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27744000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27732000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"26370000",
					"28364000",
					"26483000",
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27748000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27736000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34283001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34408000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34614001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34631000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34506000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"34630000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"23409000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": [
					""
				]
			},
			{
				"products": [
					"26223001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"28364000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			},
			{
				"products": [
					"26452000"
				],
				"bundle": []
			},
			{
				"products": [
					"26453000"
				],
				"bundle": []
			},
			{
				"products": [
					"27389001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27635000",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27635000",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26475000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"27420001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26475000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26477000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26361000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26361LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001",
					"34286002",
					"34321002",
					"34256004",
					"34151004",
					"34565001",
					"34566001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000",
					"27374000",
					"27032001",
					"27967000",
					"27964000",
					"26363000",
					"27922001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001",
					"27968000",
					"27966000",
					"26075000",
					"27296002",
					"27615001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001",
					"26224001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001",
					"27058000",
					"26452001",
					"26453001",
					"26454001",
					"27389002",
					"27394002",
					"27399002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26446000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt1 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26446LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27746000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"26174000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27838000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"28364000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"26073000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26065000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26060000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26061000",
					"27251000",
					"27251000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27673LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt0 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt0 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt1 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26458000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && with-holder_opt1 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26460000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26255000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26256000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34614001"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt2"
		],
		"groups": [
			{
				"products": [
					"25183001"
				],
				"bundle": []
			},
			{
				"products": [
					"23409000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"26223001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26450LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26458000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26460000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "27389001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath safety mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Podomítkové těleso pro nástěnné kombinace/varianty",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Kombinace proti zpětnému toku (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ruční sprcha",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Box pro set s hlavovou sprchou 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "Sprchový systém GROHE Eurosmart Cosmopolitan Perfect s pákovou baterií určený pro podomítkovou instalaci, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch.  Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vanová napouštěcí, odtoková a přepadová souprava",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Rameno sprchové výpusti Eurocube, chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Sprchový set vhodný pro Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm Cube Perfect s hlavovou sprchou Rainshower Allure 230 mm, ruční sprchou Euphoria Cube a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 360 MONO. Chromová, vyrobená v Německu: 360mm hlavová sprcha a 450mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 360 MONO. Chromová, vyrobená v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 450mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set stropní 154 mm, 1 proud",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vanová napouštěcí, odtoková a přepadová souprava",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií a vanovou výpustí",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ruční sprcha 4+ proudy",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, ruční sprcha, 4+ režimů proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (130 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (160 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (160 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (115 mm), tyčí (900 mm) a hadicí (1 750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria Cube XXL 230 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (115 mm), hadicí (1 250 mm) a držákem sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (115 mm), hadicí (1 250 mm) a držákem sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnný držák sprchy",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ruční sprcha",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem a bočními sprchami",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií a tělovými tryskami",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, set hlavové sprchy, stropní rameno sprchy 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, set s nástěnnou hlavovou sprchou, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s termostatickou baterií, chromový povrch, vyrobeno v Německu, obsahuje kovovou, 310mm hlavovou sprchu a 110mm ruční sprchu se třemi režimy proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 400 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s přepínacím ventilem",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnný držák sprchy",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Boční sprcha s jendím proudem",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Sprchový set s termostatickou baterií Grohtherm SmartControl Perfect, pro podomítkovou instalaci se třemi ventily, hlavová sprcha, ruční sprcha, sprchové rameno, hadice. Kruhový tvar. Chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Sprchový set s termostatickou baterií Grohtherm SmartControl Perfect, pro podomítkovou instalaci se třemi ventily, hlavová sprcha, ruční sprcha, sprchové rameno, hadice. Čtvercový tvar. Chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, nástěnná hlavová sprcha se 400mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, nástěnná hlavová sprcha se 400mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set s držákem 4+ proudy",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Komfortní sprchový set GROHE Grohtherm 3000 Cosmopolitan včetně podomítkové sprchové baterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 210 mm, ruční sprchou Euphoria 110 mm a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set vhodný pro Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 2000 Perfect, včetně termostatické baterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Termostatická sprchová baterie GROHE Grohtherm 1000 Cosmopolitan M se sprchovým setem GROHE Euphoria 110 Massage, 600mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "Termostatická sprchová baterie GROHE Grohtherm 1000 Cosmopolitan M se sprchovým setem GROHE Euphoria 110 Massage, 900 mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s pákovou baterií, chromový povrch, vyrobeno v Německu, obsahuje kovovou, 230mm hlavovou sprchu a ruční sprchu s jedním režimem proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Exposed s termostatickou sprchovou baterií. Chromový, ekologický, precizně vyrobený v Německu, 360mm hlavová sprcha s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (600 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (600 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Sprchový set s Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ruční sprchou Sena a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ruční sprchou Sena a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 2000 Perfect s hlavovou sprchou Rainshower Cosmopolitan 210 mm, ruční sprchou Euphoria Cosmopolitan a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie s 2 ventily, nástěná",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Sprchová termostatická baterie GROHE Grohtherm SmartControl Combi se dvěma ventily. Chromová barva s bílou přihrádkou, německá kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie se 3 ventily, nástěnná",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Sprchová termostatická baterie GROHE Grohtherm SmartControl Combi se třemi ventily. Chromová barva s bílou přihrádkou, německá kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma <br />ventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma <br />ventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ruční sprcha 2 proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ruční sprcha 4+ proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Sprchový systém GROHE Grohtherm 1000 Perfect, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch.  Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou baterií, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Vanový/sprchový systém GROHE Euphoria 260 Shower System s termostatickou vanovou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s pákovou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s přepínačem. Úsporná, 260mm hlavová sprcha SmartControl se třemi režimy proudu a 110mm, chromová ruční sprcha se třemi režimy proudu. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set ceiling 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Euphoria 260 SmartControl se třemi režimy proudu. 260mm hlavová sprcha GROHE Rainshower se stropním ramenem (142 mm) a chromovou povrchovou úpravou. Snadná instalace a údržba. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Euphoria 260 SmartControl se třemi režimy proudu. 260mm hlavová sprcha GROHE Rainshower se sprchovým ramenem (380 mm) a chromovou povrchovou úpravou. Snadná instalace a údržba. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s pákovou baterií, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou baterií určený pro vany, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Nástěnný Flex sprchový systém s přepínačem",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Tilslutningsbøjning til væg",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Beskyttelse mod tilbageløb (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "47790000",
		"image": "//cdn.cloud.grohe.com/prod/40/47/47790000/640/47790000.jpg",
		"headline": "",
		"subheadline": "Lækagesikring",
		"textblock_1st_text": "47790000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/47790000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Skjult del for synlige/skjulte varianter",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal indbygningsboks, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Håndbruser 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Indbygningsbox til brusesystem 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hovedbruser sæt 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hovedbruser sæt til loft 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hovedbruser sæt 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26062000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26062000/640/26062000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26062000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26062000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Brusesæt med Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect brusesæt med Rainshower Allure 230-mm-hovedbruser, Euphoria Cube håndbruser og Rapido T termostatbatteri til indbygget installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Hovedbruser sæt 450 mm, 1 spray",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Hovedbruser sæt 450 mm, 1 spray",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower SmartControl 360 MONO System",
		"subheadline": "Kombi brusesystem med termostat, synlig/skjult",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower SmartControl 360 MONO System",
		"subheadline": "Kombi brusesystem med termostat, synlig/skjult",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower SmartControl 360 DUO System",
		"subheadline": "Kombi brusesystem med termostat, synlig/skjult",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower SmartControl 360 DUO System",
		"subheadline": "Kombi brusesystem med termostat, synlig/skjult",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Tilslutningsbøjning til væg",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Håndbruserholder til væg",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26063000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26063000/640/26063000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26063000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26063000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfekt brusesæt med Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 New Perfect Shower Set, inklusive termostatarmatur",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M brusetermostat med GROHE Euphoria 110 Massage brusesæt, 600-mm-brusestang",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Karudløb",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube 230",
		"subheadline": "Etgrebs brusesystem til vægmontering",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Hovedbruser sæt 422 mm, 1 spray",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Tilslutningsbøjning til væg",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Brusesystem med diverter <br />til vægmontage",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Håndbruserholder til væg",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Håndbruser 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Brusesystem med termostat og sidebrusere",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Brusestangsæt 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27400000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27400000/640/27400000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Håndbruser 1 spray",
		"textblock_1st_text": "27400000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27400000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Brusestangsæt 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Sidebruser 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria 310",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube 230",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27736000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27748000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Vægholdersæt 2 sprays",
		"textblock_1st_text": "27838000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Bruseslange 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silver Flex slange med drejekonus til TwistFree funktion, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Bruseslange 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silver Flex slange med drejekonus til TwistFree funktion, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Bruseslange 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silver Flex slange med drejekonus til TwistFree funktion, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Karudløb",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Karpåfyldnings-, af- og overløbsgarnitur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower SmartControl 360 DUO System",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower SmartControl 360 MONO System",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 MONO brusesystem med termostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfekt brusesæt med Rainshower 210 hovedbruser",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect brusesæt med Rainshower Cosmopolitan 210-mm-hovedbruser af metal, Euphoria 110-mm-håndbruser og Rapido T termostatbatteri til indbygget installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfekt brusesæt med Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfekt brusesæt med Rainshower Cosmopolitan 310 brusehoved",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 1 spray",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Håndbruser 4+ sprays",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Vægholdersæt 4+ sprays",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfekt brusesæt med Rainshower Cosmopolitan 160 brusehoved",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan komfortbrusesæt, indbygget termostat medfølger",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27746000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Brusestangsæt 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brusestang, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfekt brusesæt med Rainshower Cosmopolitan 310 brusehoved",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect brusesæt med Rainshower Cosmopolitan 310-mm-hovedbruser af metal, Sena håndbruser og Rapido T termostatbatteri til indbygget installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med 3 ventiler",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombi termostat med 3 ventiler, synlig/ indbygget",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombotermostat med 3 ventiler, synlig/ indbygget",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med 3 ventiler",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med 3 ventiler",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med to ventiler",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med en ventil",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med to ventiler",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med en ventil",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat med indbygget installation med 2 ventiler og integreret bruseholder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med to ventiler",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med en ventil",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med 3 ventiler",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat med indbygget installation med 2 ventiler og integreret bruseholder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med to ventiler",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat til indbygning med en ventil",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Karpåfyldnings-, af- og overløbsgarnitur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Vægholdersæt 2 sprays",
		"textblock_1st_text": "27839000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brusestang, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Brusestangsæt 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brusestangsæt 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal indbygningsboks, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hovedbruser sæt 430 mm, 2 sprays",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hovedbruser sæt 430 mm, 2 sprays",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower SmartControl 360 MONO System",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower SmartControl 360 DUO System",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hovedbruser sæt 286 mm, 1 spray",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Karudløb",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfekt brusesæt med Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfekt brusesæt med Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Håndbruser 4+ sprays, hvid sprayplade",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Håndbruser 2 sprays, sprayplade hvid",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hovedbruser sæt til loft 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hovedbruser sæt 360 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Brusesystem med diverter <br />til vægmontage",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Etgrebs brusesystem til vægmontering",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan 210",
		"subheadline": "Etgrebs brusesystem til vægmontering",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan 210",
		"subheadline": "Brusesystem med termostat til vægmontering",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfekt brusesæt med Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatbatteri til brus, DN 15 med brusegarniture",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta 210",
		"subheadline": "Flex brusesystem med omskifter til vægmontering",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfekt brusesæt med Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Perfekt brusesæt med Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27888000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27888000/640/27888000.jpg",
		"headline": "Euphoria Cube+ Stick",
		"subheadline": "Håndbruser 1 spray",
		"textblock_1st_text": "27888000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/27888000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G349",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hovedbruser sæt 360 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 600-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 900-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset Deckenauslass 154 mm ",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Kopfbrause 4 Strahlarten",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 150",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27696000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal Unterputz-Einbaukörper, DN 15",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Sicherungseinrichtung (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Unterputz-Einbaukörper für Thermostat Auf-/Unterputz Kombination",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal Unterputz-Einbaukörper, DN 15",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie 1/2\" mit Brausegarnitur",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Flex Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Wanneneinlauf",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Handbrause, 115 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Seitenbrause 1 Strahlart",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27265000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie und Seitenbrausen für die Wandmontage",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Seitenbrausen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Kopfbrause 4+ Strahlarten",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Kopfbrause, 190 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem  mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-, <br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Unterputz-Universal-Thermostatbatterie",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "GROHE Rapido T Unterputz-Universal-Thermostatbatterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wandhalterset 4+ Strahlarten",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandbrausehalter",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Umstellung",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandbrausehalter",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 DUO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 MONO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower® 360 DUO\nKopfbrauseset, 2 Strahlarten",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-, <br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrause 1 Strahlart",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brausearm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Duschsystem mit Thermostatbatterie,<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rohbauset für Kopfbrause-Set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset 380 mm, 3 Strahlarten",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 3 Strahlarten",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Duschsystem Unterputz mit Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "23061002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 3 Absperrventilen<br /> Auf-/Unterputz Kombination",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 2 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Wandhalterset 1 Strahlart",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 152",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27696000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 600-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Handbrausehalter",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset Deckenauslass 154 mm ",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Kopfbrause 4 Strahlarten",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Handbrause, 115 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wandhalterset 4+ Strahlarten",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Handbrausehalter",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brausearm<br />Ausladung 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal Unterputz-Einbaukörper, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Flex Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Sicherungseinrichtung (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen<br />und integriertem Brausehalter",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen<br />und integriertem Brausehalter",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie, Auf-/Unterputz Kombination",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 3 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 2 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Unterputz-Einbaukörper<br />für Thermostat Auf-/Unterputz Kombination",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Wandhalterset 1 Strahlart",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rohbauset für Kopfbrause-Set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal Unterputz-Einbaukörper, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Duschsystem Unterputz mit Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 3 Strahlarten",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset 380 mm, 3 Strahlarten",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "23061002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 DUO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Wanneneinlauf",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Umstellung",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie und Seitenbrausen für die Wandmontage",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Seitenbrausen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower® 360 DUO\nKopfbrauseset, 2 Strahlarten",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrause",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Seitenbrause",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27265000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Kopfbrause 4+ Strahlarten",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Kopfbrause, 190 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Thermostat-Brausebatterie 1/2\"<br />mit Brausegarnitur",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 900-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-,<br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-,<br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Unterputz-Universal-Thermostatbatterie",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "GROHE Rapido T Unterputz-Universal-Thermostatbatterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23058003",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23058003/640/23058003.jpg",
		"headline": "Euphoria Eurodisc Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "23058003",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/23058003",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem  mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 MONO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 152",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, DN 15",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Seitenbrause",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27265000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie und Seitenbrausen für die Wandmontage",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset Deckenauslass 154 mm",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wandhalterset 4+ Strahlarten",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Wanneneinlauf",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Handbrause, 115 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 152",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27696000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Kopfbrause 4+ Strahlarten",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Kopfbrause, 190 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem  mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-,<br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Wanneneinlauf",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower® 360 DUO\nKopfbrauseset, 2 Strahlarten",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 DUO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 MONO Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, DN 15",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandanschlussbogen, DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Handbrausehalter",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Umstellung",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Handbrausehalter",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Kopfbrause 4 Strahlarten",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrause",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brausearm<br />Ausladung 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, DN 15",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-,<br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Unterputz-Einbaukörper<br />für Thermostat Auf-/Unterputz Kombination",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 152",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Unterputz-Einbaukörper, DN 15",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Sicherungseinrichtung (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rohbauset für Kopfbrause-Set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 3 Strahlarten",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset 380 mm, 3 Strahlarten",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Duschsystem mit Einhandmischer für die Wandmontage",
		"textblock_1st_text": "23061002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Unterputz-Einbaukörper, DN 15",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Flex Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 600-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Thermostat-Brausebatterie DN 15 mit Brausegarnitur",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 900-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Duschsystem Unterputz mit Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Unterputz-Universal-Thermostatbatterie",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "GROHE Rapido T Unterputz-Universal-Thermostatbatterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 3 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Duschsystem mit Thermostatbatterie<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 2 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Wandhalterset 1 Strahlart",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Duschsystem Unterputz mit Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath safety mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "27389001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube XXL System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 360 mm x 220 mm",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria XXL System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube XXL System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 360 mm x 220 mm",
		"textblock_1st_text": "26254000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Head shower set 286 mm",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower set 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set 422 mm",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set ceiling 142 mm",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath safety mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Hand shower 2 sprays, spray plate white",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate white",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wall holder set 2 sprays",
		"textblock_1st_text": "27839000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria XXL System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28995000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28995000/640/28995000.jpg",
		"headline": "Talentofill",
		"subheadline": "Connection set 3/4\"",
		"textblock_1st_text": "28995000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/28995000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34399000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set with Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-africa.com/en_eg/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-africa.com/en_eg/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath safety mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "27389001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray<br />",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays<br />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/en_sa/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/en_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Conjunto de ducha mural con brazo 450 mm, 1 chorro",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Conjunto de ducha mural con brazo 450 mm, 1 chorro",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combinación termostática de ducha con 3 salidas, visto/empotrado",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combinación termostática de ducha con 2 salidas, visto/empotrado",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Cuerpo empotrado para variants vistas/empotradas",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Teleducha 1 chorro",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Conjunto de barra de ducha 1 chorro",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27709000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27709000/640/27709000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 286 mm",
		"textblock_1st_text": "27709000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27709000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27711000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27711000/640/27711000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo 154 mm",
		"textblock_1st_text": "27711000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27711000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con  teleducha (130 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha(130 mm), barra de ducha (600 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (130 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con teleducha (160 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (130 mm), barra de ducha (600 mm)y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (160 mm), barra de ducha (900 mm)  y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Conjunto de ducha 2 chorros",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Conjunto de ducha 2 chorros",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (115 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barra de ducha de 60 cm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barra de ducha de 90 cm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Soporte mural",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Soporte mural",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Ducha lateral 1 chorro",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27271000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27271000/640/27271000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27271000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27271000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Conjunto de barra de ducha 1 chorro",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Teleducha 1 chorro",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha con termostato <br />y duchas laterales",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27477000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27477000/640/27477000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27479000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27479000/640/27479000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27479000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27479000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27485000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27485000/640/27485000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo 151 mm",
		"textblock_1st_text": "27485000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27485000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27488000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27488000/640/27488000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 275 mm",
		"textblock_1st_text": "27488000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27488000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Conjunto de ducha con soporte, teleducha 2 chorros",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con  teleducha (115 mm), flexo de ducha (1,250 mm) y soporte para teleducha",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Conjunto de ducha con soporte, teleducha 2 chorros",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha  (115 mm), flexo de ducha (1,250 mm) y soporte para teleducha",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha 1,5 m.",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Conjunto de ducha con termostato de ducha 1/2\"",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Set de ducha con Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Combinación perfecta de ducha con Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26146LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26146LS0/640/26146LS0.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha 422 mm",
		"textblock_1st_text": "26146LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26146LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Teleducha 4 chorros",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368LS0/640/28368LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28368LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28368LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28724LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28724LS0/640/28724LS0.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo de 142 mm",
		"textblock_1st_text": "28724LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28724LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Desagüe automático con caño integrado",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sistema de ducha con termostato",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema de ducha con termostato",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Conjunto de ducha con soporte 4 chorros",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26146000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26146000/640/26146000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha 422 mm",
		"textblock_1st_text": "26146000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26146000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28724000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28724000/640/28724000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo de 142 mm",
		"textblock_1st_text": "28724000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28724000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28778000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28778000/640/28778000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28778000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28778000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Desagüe automático con caño integrado",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Conjunto de ducha con brazo mural 380 mm, 1 chorro",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Conjunto de ducha con brazo de techo 142 mm, 1 chorro",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Cuerpo empotrado Universal, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves y soporte de ducha integrado",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves y soporte de ducha integrado",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Combinación para la protección antiretorno (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Conjunto de ducha Perfect con Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Conjunto de ducha mural Perfect <br />con Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Teleducha 2 chorros, cabezal en blanco",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Teleducha 4+ chorros, cabezal en blanco",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Caja empotrada para duchas murales 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Perfecto Set de ducha con Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Conjunto de ducha mural 430 mm, 2 chorros",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Conjunto de ducha mural 430 mm, 2 chorros",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Cuerpo empotrado Universal, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Conjunto de ducha con Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con inversor",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Sistema de ducha Flexible con inversor",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Conjunto de ducha mural con brazo 380 mm, 3 chorros",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Conjunto de ducha con brazo de techo 142 mm, 3 chorros",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Conjunto de ducha con Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Conjunto de ducha con termostato de ducha 1/2\"",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Conjunto de ducha con termostato de ducha 1/2\"",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Rainshower SmartControl corps encastré pour des références avec montage mural/encastré",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "corps encastré universel 1/2\\'\\'",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Protection DB (DIN EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douche à main, 1 jet",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Système de douche encastré Cube 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm Cube Perfect avec douche de tête Rainshower Allure 230 mm, douchette Euphoria Cube et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Set de douche de tête 450 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Set de douche de tête 450 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corps encastré pour douche de tête 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"textblock_2nd_text": "GROHE Rainshower® SmartControlboîtier d\\'encastrement pour ensemble de douche de tête GROHE Rainshower® 360 DUO (26254000)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Coude à encastrer Eurocube avec support mural, finition chromée et de conception allemande.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set de douche de tête plafond 154 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set de douche de tête, 286 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Set de douche de tête, 286 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set de douche de tête 380 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set de douche de tête 380 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set de douche de tête, 142 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set de douche de tête 422 mm, 1 jet",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "pour garniture de remplissage, de vidage et de trop-plein",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Set de douche 1 jet",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "pour garniture de remplissage, de vidage et de trop-plein",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set de douche 1 jet",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Flex Système de douche avec inverseur, montage mural",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "corps encastré universel 1/2\\'\\'",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Mitigeur de lavabo GROHE Eurostyle Cosmopolitan, corps lisse, bec standard, GROHE EcoJoy, GROHE SilkMove ES",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Mitigeur de lavabo GROHE Eurosmart Cosmopolitan, garniture de vidage, bec standard",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Douche à main",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, douchette, 4+ types de jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Système de douche avec mitigeur",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL avec mitigeur monocommande ; finition chromée et conception allemande, doté d\\'une douche de tête métallique 230 mm et d\\'une douchette à un seul jet.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set de douche de tête, 142 mm, 1 jet<br type=\"_moz\"  />",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Système de douche thermostatique pour montage mural",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria XXL avec thermostatique ; chromé et de conception allemande, doté d\\'une douche de tête métallique de 310 mm et d\\'une douchette 110 mm à trois jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Système de douche thermostatique pour montage mural",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL 230 avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1500 <br type=\"_moz\"  />",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1250<br type=\"_moz\"  />",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1750<br type=\"_moz\"  />",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set de douche, 2 jets",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set de douche, 2 jets",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Ensemble dec douchette à main (115 mm), flexible de douche (1 250 mm) et support de douchette à main GROHE Power&Soul",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Système avec inverseur manuel",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec jets de corps et inverseur",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douche à main",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower F-Series 10\" avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douche à main",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Douche latérale",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Système avec thermostatique et douches latérales",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "Douche de tête GROHE Euphoria Cosmopolitan 180",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douche à main, 1 jet",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, douchette, 1 jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Système de douche avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Set de douche avec Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 Perfect avec douche de tête Rainshower Cosmopolitan 210 mm métallique, douchette Euphoria Cosmopolitan et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower F-Series 10\" avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Douche à main, 1 jet",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set de douche, 4+ jets",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Douchette 2 jets, blanc",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties avec support de douche integré",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set de douche, 4+ jets",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Douchette à main GROHE Power&Soul, 115 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Douchette 4+ jets, blanc",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties avec support de douche integré",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set avec Rainshower 310 SmartActive<br type=\"_moz\"  />",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set avec Rainshower 310 SmartActive Cube<br type=\"_moz\"  />",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set de douche de tête, 380 mm, 3 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfect Shower Set Tempesta<br type=\"_moz\"  />",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfect Shower Set Tempesta<br type=\"_moz\"  />",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Système avec inverseur manuel",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête 142 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête 142 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set de douche de tête 430 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479000/640/26479000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set de douche de tête 430 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26479000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26479000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête 142 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête 142 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set de douche de tête 430 mm, 2 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set de douche de tête, 142 mm, 3 jets<br type=\"_moz\"  />",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ensemble douche de tête et bras 286 mm , 1 jet",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ensemble douche de tête et bras 380 mm, 1 jet",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Système de douche avec inverseur",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 152",
		"subheadline": "Système de douche avec inverseur",
		"textblock_1st_text": "27696000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ensemble de douche complet 1 jet",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 152",
		"subheadline": "Ensemble douche de tête et bras 286 mm , 1 jet",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Ensemble douche de tête et bras 286 mm , 1 jet",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Douche de tête 4 jets",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Système de douche combiné avec thermostatique, apparent/encastré",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Mitigeur de douche thermostatique combiné à 3 vannes, apparent/encastré",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Mitigeur de douche thermostatique combiné <br />à 2 vannes, apparent/encastré",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Corps encastré pour variantes apparentes/encastrées",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "<strong>Ensemble douche de tête et bras 450 mm, 2 jets</strong>",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Douchette 4+ jets, blanc",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corps encastré pour douche de tête 1/2",
		"textblock_1st_text": "26264001",
		"textblock_2nd_text": "GROHE Rainshower® SmartControlboîtier d\\'encastrement pour ensemble de douche de tête GROHE Rainshower® 360 DUO (26254000)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Douchette 2 jets",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Ensemble de douchette à main (115 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ensemble de douche complet 1 jet",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1750 mm <br />",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 Perfect avec douche de tête Rainshower Cosmopolitan 210 mm métallique, douchette Euphoria Cosmopolitan et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Façade pour mitigeur thermostatique 2 sorties",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Dispositif de sécurité (selon DIN EN 1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23058003",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23058003/640/23058003.jpg",
		"headline": "Euphoria Eurodisc Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "23058003",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/23058003",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL avec mitigeur monocommande ; finition chromée et conception allemande, doté d\\'une douche de tête métallique 230 mm et d\\'une douchette à un seul jet.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Mitigeur de lavabo GROHE Eurosmart Cosmopolitan, garniture de vidage, bec standard",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 Mono",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Mitigeur de lavabo GROHE Eurostyle Cosmopolitan, corps lisse, bec standard, GROHE EcoJoy®, GROHE SilkMove® ES",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 Duo",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower® SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower F-Series 10\" avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Système de douche avec inverseur",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec jets de corps et inverseur",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Système de douche avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique <br />et douchettes latérales",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower F-Series 10\" avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Colonne de douche avec thermostatique pour montage mural",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL 230 avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Colonne de douche avec thermostatique pour montage mural",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria XXL avec thermostatique ; chromé et de conception allemande, doté d\\'une douche de tête métallique de 310 mm et d\\'une douchette 110 mm à trois jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower SmartControl 360 Duo",
		"subheadline": "<strong>Ensemble douche de tête et bras 450 mm, 2 jets</strong>",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "Ensemble de douche de tête GROHE Rainshower® 360 DUO, 2 types de jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ensemble douche de tête et bras 380 mm, 1 jet",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Ensemble douche de tête et bras 286 mm , 1 jet",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "Ensemble de douche de tête suspendu GROHE Euphoria Cosmopolitan 180, avec bras de douche de 286 mm de long, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Ensemble douche de tête et bras 286 mm , 1 jet",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Support de douche mural 1 jet",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Mitigeur thermostatique encastré",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "Mitigeur thermostatique universel encastré GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Douchette latérale 1 jet",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27265000",
		"textblock_2nd_text": "GROHE Euphoria 110 Mono, douchette, 1 jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Douchette à main GROHE Power&Soul Cosmopolitan, 115 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Douchette à main GROHE Power&Soul, 115 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Support de douche mural 2 jets",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Douche de tête GROHE Power&Soul, 190 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Douche de tête 4 jets",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "Ensemble de douchette à main (160 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ensemble de douche complet 2 jets",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Ensemble dec douchette à main (115 mm), flexible de douche (1 250 mm) et support de douchette à main GROHE Power&Soul",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Support de douche mural 2 jets",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Douche de tête GROHE Power&Soul Cosmopolitan, 190 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Douchette 2 jets",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "Douchette à main GROHE Power&Soul Cosmopolitan, 130 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Douchette 4 jets",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, douchette, 4+ types de jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Ensemble de douche complet 2 jets",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Support de douche mural 4 jets",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Coude à encastrer Eurocube avec support mural, finition chromée et de conception allemande.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Façade pour mitigeur thermostatique 2 sorties",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "Façade thermostatique GROHE Grohtherm 3000 Cosmopolitan équipée d\\'un inverseur 2 voies (pour baignoires ou douches possédant plus d\\'une sortie) pour thermostat encastré GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Façade pour mitigeur thermostatique 2 sorties",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "Façade thermostatique GROHE Grohtherm 3000 Cosmopolitan équipée d\\'un inverseur 2 voies (pour baignoires ou douches possédant plus d\\'une sortie) pour thermostat encastré GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Thermostat de douche GROHE Grohtherm 1000 Cosmopolitan M avec ensemble de douche GROHE Euphoria 110 Massage, barre de douche 600 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Ensemble de douche avec Rainshower® Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm Cube Perfect avec douche de tête Rainshower Allure 230 mm, douchette Euphoria Cube et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "Thermostat de douche GROHE Grohtherm 1000 Cosmopolitan M avec ensemble de douche GROHE Euphoria 110 Massage, barre de douche 900 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Ensemble de douchette à main (115 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Set de douche avec Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Système de douche avec inverseur",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 3 jets",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 380 mm, 3 jets</strong>",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "23061002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête bras 430 mm, 2 jets",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête bras 400 mm, 2 jets",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête bras 400 mm, 2 jets",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête bras 430 mm, 2 jets",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête bras 400 mm, 2 jets",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête bras 400 mm, 2 jets",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set de douche Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Set de douche Rainshower 310 SmartActive Cube</strong>",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26170000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26170000/640/26170000.jpg",
		"headline": "Rainshower Veris 300 x 150",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26170000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26170000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171000/640/26171000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26171000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26171000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27488000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27488000/640/27488000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 275 mm",
		"textblock_1st_text": "27488000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27488000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique et bec de bain",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Douchette 4 jets",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, douchette, 4+ types de jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 400 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27271000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27271000/640/27271000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "27271000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27271000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ensemble de douche complet 1 jet",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique <br />et douchettes latérales",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ensemble de douche complet 1 jet",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Ensemble de douchette à main (160 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27742000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27742000/640/27742000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Support de douche mural 4 jets",
		"textblock_1st_text": "27742000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27742000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Ensemble de douchette à main (160 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Set de douche Rainshower 310 SmartActive Cube</strong>",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set de douche Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corps encastré pour douche de tête 1/2",
		"textblock_1st_text": "26264001",
		"textblock_2nd_text": "GROHE Rainshower® SmartControlboîtier d\\'encastrement pour ensemble de douche de tête GROHE Rainshower® 360 DUO (26254000)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Rupteur atmosphérique pour Rapido SmartBox",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Système de douche avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1250 mm<br type=\"_moz\" />",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche 1750 mm <br />",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Colonne de douche avec thermostatique pour montage mural",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria XXL avec thermostatique ; chromé et de conception allemande, doté d\\'une douche de tête métallique de 310 mm et d\\'une douchette 110 mm à trois jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Colonne de douche avec thermostatique pour montage mural",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL 230 avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26170LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26170LS0/640/26170LS0.jpg",
		"headline": "Rainshower Veris 300 x 150",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26170LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26170LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 1 jet</strong>",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec inverseur",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Douchette latérale 1 jet",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Ensemble de douche avec Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 New Perfect, incluant un robinet thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Thermostat de douche GROHE Grohtherm 1000 Cosmopolitan M avec ensemble de douche GROHE Euphoria 110 Massage, barre de douche 600 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Ensemble de douche confort GROHE Grohtherm 3000 Cosmopolitan, thermostat encastré inclus",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Ensemble de douche confort GROHE Grohtherm 3000 Cosmopolitan, thermostat encastré inclus",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Ensemble de douche avec Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm Cube Perfect avec douche de tête Rainshower Allure 230 mm, douchette Euphoria Cube et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Set de douche avec Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Set de douche avec Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Coude à encastrer Eurocube avec support mural, finition chromée et de conception allemande.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ensemble de douche complet 2 jets",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Ensemble de douchette à main (115 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Ensemble de douche complet 2 jets",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (600 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ensemble douche de tête et bras 380 mm, 1 jet",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Douchette 4+ jets, blanc",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Douchette 2 jets, surface de jets blanche<br />",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Support de douche mural 4 jets",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26259000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26259000/640/26259000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "<strong>Ensemble douche de tête et bras 422 mm, 1 jet </strong>",
		"textblock_1st_text": "26259000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26259000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set douche de tête et bras 430 mm, 2 jets",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set douche de tête et bras 430 mm, 2 jets",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 142 mm, 3 jets</strong>",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "<strong>Ensemble douche de tête et bras plafonnier 380 mm, 3 jets</strong>",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower® SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Colonne de douche thermostatique",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 Perfect avec douche de tête Rainshower Cosmopolitan 210 mm métallique, douchette Euphoria Cosmopolitan et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "fali csatlakozó könyök, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "fali csatlakozó könyök, 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Zuhanyrudas garnitúra, 1 funkciós",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with thermostatic mixer for wall mountins",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with thermostatic mixer for wall mountins",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Zuhanyrudas garnitúra, 1 funkciós",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26072000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set with Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "kádkifolyó",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi shower system with thermostat, exposed/concealed",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "kádtöltő, le- és túlfolyógarnitúra",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "kádtöltő, le- és túlfolyógarnitúra",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27736000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27748000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wall holder set 2 sprays",
		"textblock_1st_text": "27839000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27746000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wall holder set 2 sprays",
		"textblock_1st_text": "27838000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Hand shower 4+ sprays",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "fali csatlakozó könyök, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "fali kézizuhany tartó",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "fali kézizuhany tartó",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "kádkifolyó",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "kádkifolyó",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "falra szerelhető zuhanyváltós zuhanyrendszer",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat and side showers",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set ceiling 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi thermostatic shower mixer with 3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Shower system with thermostat for wall mounting",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Hand shower 2 sprays, spray plate white",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate white",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi thermostatic shower mixer with 2 valves, exposed/concealed",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "http://www.grohe.hu/hu_hu/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "http://www.grohe.hu/hu_hu/our-service/showrooms-installer/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL 230 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Soffione doccia",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, set soffione con installazione a parete con braccio di 286 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Soffione doccia laterale",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Soffione doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "Soffione GROHE Power&Soul Cosmopolitan, 190 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (115 mm), asta (900 mm) e flessibile (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Manopola doccia a 2 getti",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "Manopola GROHE Power&Soul Cosmopolitan, 115 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, manopola doccia, 4+ getti",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set doccia completo a 4 tipologie di getto combinabili",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Braccio a parete<br />sporgenza 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1250 mm",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo Rainshower Cosmopolitan da 310 mm, manopola Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo Rainshower Cosmopolitan da 310 mm, manopola Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Set Doccia Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 2000 Perfect con soffione in metallo Rainshower Cosmopolitan da 210 mm, manopola Euphoria Cosmopolitan e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23058003",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23058003/640/23058003.jpg",
		"headline": "Euphoria Eurodisc Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23058003",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23058003",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 MONO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 150",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27696000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e bocca per vasca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con deviatore",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico e soffioni laterali",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e getti corpo",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 400 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria XXL con termostatico, soffione da 310 mm e manopola a tre getti da 110 mm color chrome con meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower® 360 DUO, 2 tipologie di getto",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a soffitto altezza 154mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower® Cosmopolitan 310, set soffione, braccio doccia a soffitto di 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Soffione doccia a 4 getti",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27265000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Valvola di protezione antiriflusso (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico a 3 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico esterno a 2 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Corpo incasso per varianti<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili,<br />disco getti bianco",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set doccia completo",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 3 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a parete sporgenza 380mm, 3 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23061002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Sistema doccia FLEX<br />con deviatore",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27748000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 422mm, 1 getto",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set soffione doccia a parete sporgenza 422mm, 1 getto",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Uscita doccia a gomito Eurocube con supporto a parete, finitura cromata e meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Set doccia Tempesta 210<br type=\"_moz\" />",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL con miscelatore monocomando, soffione in metallo da 230 mm e manopola monogetto in colore chrome e con meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 DUO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Corpo incasso universale per miscelatori termostatici",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "Miscelatore termostatico universale GROHE Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (600 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Manopola doccia a 2 getti,<br /> disco getti bianco",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corpo incasso per set soffione doccia 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "Pannello termostatico GROHE Grohtherm 3000 Cosmopolitan con deviatore a 2 vie (per vasche o docce con più di un\\'uscita) per termostatico da incasso GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "Pannello termostatico GROHE Grohtherm 3000 Cosmopolitan con deviatore a 2 vie (per vasche o docce con più di un\\'uscita) per termostatico da incasso GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Set Doccia Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm Cube Perfect con soffione Rainshower Allure da 230 mm, manopola Euphoria Cube e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower 310 SmartActive<br type=\"_moz\" />",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower 310 SmartActive Cube<br type=\"_moz\" />",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL con miscelatore monocomando, soffione in metallo da 230 mm e manopola monogetto in colore chrome e con meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1250 mm",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Set doccia",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (115 mm), asta (900 mm) e flessibile (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a soffitto altezza 154mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower® Cosmopolitan 310, set soffione, braccio doccia a soffitto di 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, set soffione con installazione a parete con braccio di 286 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL 230 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 422mm, 1 getto",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set doccia completo a 4 tipologie di getto combinabili",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con deviatore",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 400 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Soffione doccia laterale",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corpo incasso per set soffione doccia 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico e soffioni laterali",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e getti corpo",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e bocca per vasca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, manopola doccia, 4+ getti",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (600 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27748000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Corpo incasso per varianti<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Valvola di protezione antiriflusso (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Sistema doccia FLEX<br />con deviatore",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Set Doccia Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 New Perfect Shower Set, con rubinetto termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo Rainshower Cosmopolitan da 310 mm, manopola Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo Rainshower Cosmopolitan da 310 mm, manopola Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Set Doccia Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 2000 Perfect con soffione in metallo Rainshower Cosmopolitan da 210 mm, manopola Euphoria Cosmopolitan e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower<sup>®</sup> 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Set doccia comfort GROHE Grohtherm 3000 Cosmopolitan, termostatico da incasso incluso",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Set Doccia Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm Cube Perfect con soffione Rainshower Allure da 230 mm, manopola Euphoria Cube e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 DUO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 MONO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Uscita doccia a gomito Eurocube con supporto a parete, finitura cromata e meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria XXL con termostatico, soffione da 310 mm e manopola a tre getti da 110 mm color chrome con meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico esterno a 2 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico a 3 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower 310 SmartActive Cube<br type=\"_moz\" />",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower 310 SmartActive<br type=\"_moz\" />",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili,<br />disco getti bianco",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Manopola doccia a 2 getti,<br /> disco getti bianco",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 1 getto<br type=\"_moz\" />",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 3 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a parete sporgenza 380mm, 3 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Set doccia Tempesta 210<br type=\"_moz\" />",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Set doccia Tempesta 210<br type=\"_moz\" />",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti<br type=\"_moz\" />",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Terugstroombeveiligingscombinatie voor Talentofill (DIN EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Rainshower SmartControl inbouwunit voor inbouw/opbouw-varianten",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Inbouwbox voor hoofddoucheset 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube wandaansluitbocht voor douche met muurhouder, chromen afwerking en in Duitsland ontwikkeld.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Hoofddoucheset 450 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360mm hoofddouche en een 450mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Hoofddoucheset 450 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 450mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Inbouwdouchesysteem Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect Shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset, 142 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset 422 mm, 1 straal",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset 380 mm, 1 straalsoort<br type=\"_moz\"  />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset plafond 154 mm, 1 straalsoort<br type=\"_moz\"  />",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset, 286 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hoofddoucheset, 286 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatische douchekraan 1/2\" met badset",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset 380 mm, 1 straalsoort<br type=\"_moz\"  />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handdouche 2 stralen, sproeiplaat wit",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche, 9,5 l/min (130 mm), glijstang (900 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handdouche 4+ stralen, sproeiplaat wit",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower 310 SmartActive Cube<br type=\"_moz\"  />",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Vierkante vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479000/640/26479000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26479000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26479000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Flex Shower System met omsteller voor wandmontage",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostatische douchekraan 1/2\" met badset",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostatische douchekraan 1/2\" met badset",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 310 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 210 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "Euphoria Cube Stick, handdouche, 1 straal",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "glijstang 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Douchestang 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect Shower Set Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Douchesysteem met ééngreepsmengkraan",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset, 142 mm, 1 straal<br type=\"_moz\"  />",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "Rainshower Cosmopolitan 310, hoofddoucheset, plafond-douchearm 142 mm, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Douchesysteem met thermostatische kraan, wandmontage",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE  Euphoria XXL douchesysteem met thermostaat. Chroom, in Duitsland ontwikkeld met 310 mm douchekop en waterbesparende 110 mm handdouche met drie stralen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Douchesysteem met thermostatische kraan, wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 mm douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hoofddouche",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180 mm hoofddouche, 9,5 l/min.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Douche-arm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Zijdouche",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostaat en zijdouches",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower Modern douchesysteem 210 met thermostaatkraan en zijdouches",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met omsteller",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower Modern douchesysteem 210 met omstelling",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang 1500<br type=\"_moz\"  />",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang 1250<br type=\"_moz\"  />",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang 1750<br type=\"_moz\"  />",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria XXL 210 douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handdouche 4+ stralen",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "Power&Soul Cosmopolitan 130, handdouche, 4+ stralen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 400 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan wandmontage bad/douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 douchesysteem met badthermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect Shower Set Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect Shower set met Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche witte  sproeiplaat met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (356000000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen en geïntegreerde douchehouder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower 310 SmartActive<br type=\"_moz\"  />",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Ronde vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen en geïntegreerde douchehouder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset 380 mm, 3 stralen<br type=\"_moz\"  />",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten<br type=\"_moz\"  />",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 douchesysteem met thermostaat, 210 mm hoofddouche en een 100 mm handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 douchesysteem met thermostaat, waterbesparende SmartControl 260 mm hoofddouche met drie straalsoorten en een 110 mm chromen handdouche met drie straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostatische mengkraan wandmontage bad/douche",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 douchesysteem met badthermostaat, waterbesparende SmartControl 260 mm hoofddouche met drie straalsoorten en een 110 mm chromen handdouche met drie straalsoorten. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met omsteller",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset plafondmontage 142 mm, 3 stralen<br type=\"_moz\"  />",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan wandmontage bad/douche",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 douchesysteem met badthermostaat, 210 mm hoofddouche en een 100 mm  handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfect Shower Set Tempesta<br type=\"_moz\"  />",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfect Shower Set Tempesta<br type=\"_moz\"  />",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Perfect Shower set met 210 mm hoofddouche en een 100 mm chromen handdouche met twee straalsoorten. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26063000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26063000/640/26063000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset plafond 142 mm, 1 straalsoort",
		"textblock_1st_text": "26063000",
		"textblock_2nd_text": "Rainshower® Cosmopolitan 210, hoofddoucheset, plafond-douchearm 142 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26063000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Zijdouche 1 straalsoort",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower Systeem 210",
		"subheadline": "Douchesysteem met thermostaatkraan en zijdouches",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27400000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27400000/640/27400000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handdouche 1 straal",
		"textblock_1st_text": "27400000",
		"textblock_2nd_text": "Euphoria Cosmopolitan Stick, handdouche 1 straal, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27400000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower Systeem SmartControl 360 MONO",
		"subheadline": "Inbouw comfortset",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower Systeem SmartControl 360 MONO",
		"subheadline": "Inbouw comfortset",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26062000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26062000/640/26062000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset 286 mm, 1 straalsoort",
		"textblock_1st_text": "26062000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26062000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset plafond 154 mm, 1 straalsoort",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset 286 mm, 1 straalsoort",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset plafond 142 mm, 1 straalsoort",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "Rainshower® Cosmopolitan 310, hoofddoucheset, plafond-douchearm 142 mm, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset 380 mm, 1 straalsoort",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26070000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26070000/640/26070000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Hoofddoucheset 286 mm, 1 straalsoort",
		"textblock_1st_text": "26070000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26070000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hoofddoucheset 286 mm, 1 straalsoort",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "Euphoria Cosmopolitan 180, muurgemonteerde hoofddoucheset met 286 mm lange douchearm, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Hoofddoucheset plafond 142 mm, 1 straalsoort",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hoofddoucheset 286 mm, 1 straalsoort",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 mm douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandaansluitbocht",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower Systeem 210",
		"subheadline": "Douchesysteem",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower Modern douchesysteem 210 met omstelling",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower Systeem 400",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 400 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan doucheset met handdouche, 9,5 l/min (130 mm), glijstang (900 mm) en doucheslang (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche, 9,5 l/min, (130 mm), glijstang (600 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27741000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan badset met handdouche, 9,5 l/min (130 mm), wanddouchehouder en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche, 9,5 l/min (130 mm), glijstang (900 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27742000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27742000/640/27742000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27742000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27742000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan doucheset met handdouche, 9,5 l/min (160 mm), glijstang (900 mm) en doucheslang (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatische douchemengkraan 1/2\" met douchegarnituur",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche 9,5 l/min (160 mm), glijstang (600 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche 9,5 l/min (160 mm), glijstang (900 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Glijstang, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Glijstang, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27888000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27888000/640/27888000.jpg",
		"headline": "Euphoria Cube+ Stick",
		"subheadline": "Handdouche 1 straal",
		"textblock_1st_text": "27888000",
		"textblock_2nd_text": "Euphoria Cube+ Stick, handdouche, 1 straal, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27888000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G349",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27890000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27890000/640/27890000.jpg",
		"headline": "Euphoria Cube+ Stick",
		"subheadline": "Doucheset 1 straal",
		"textblock_1st_text": "27890000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27890000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G349",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria XXL 210 douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower Systeem 310",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 310 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower Systeem 210",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 210 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28347000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28347000/640/28347000.jpg",
		"headline": "Sena Stick",
		"subheadline": "Doucheset 1 straal",
		"textblock_1st_text": "28347000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/28347000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G096",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Terugstroombeveiliging combinatie",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Rainshower SmartControl inbouwunit",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Inbouwbox voor hoofddoucheset 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta systeem 210",
		"subheadline": "Flex douchesysteem met omstelkraan voor wandmontage",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostatische douchemengkraan 1/2\" met douchegarnituur",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower Systeem SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower Systeem SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handdouche 4+ stralen",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "Power&Soul® Cosmopolitan 130, handdouche, 4+ stralen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set met Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Grohtherm 2000 New Perfect Shower Set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatische douchemengkraan 1/2\" met douchegarnituur",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M thermostatische douchekraan met Euphoria doucheset",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set met Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan doucheset inclusief thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set met Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan doucheset inclusief thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set met Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect Shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE  Euphoria XXL douchesysteem met thermostaat. Chroom, in Duitsland ontwikkeld met 310 mm douchekop en waterbesparende 110 mm handdouche met drie stralen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling en houder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling en houder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (356000000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Rainshower SmartControl thermostat",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi douchemengkraan met twee afsluiters. Chroom met witte tray, gemaakt van Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Rainshower SmartControl thermostaat",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi douchemengkraan met drie afsluiters. Chroom met witte tray, gemaakt van Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handdouche 4+ stralen, sproeiplaat wit",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handdouche 2 stralen, sproeiplaat wit",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Hoofddoucheset 450 mm, 1 spray",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 450mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 MONO",
		"subheadline": "Hoofddoucheset 450 mm, 1 spray",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360mm hoofddouche en een 450mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower Systeem SmartControl 360 DUO",
		"subheadline": "Inbouw comfortset",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower Systeem SmartControl 360 DUO",
		"subheadline": "Inbouw comfortset",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower Systeem SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower Systeem SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche witte  sproeiplaat met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria Systeem 260",
		"subheadline": "Douchesysteem met badthermostaat",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 douchesysteem met badthermostaat, waterbesparende SmartControl 260 mm hoofddouche met drie straalsoorten en een 110 mm chromen handdouche met drie straalsoorten. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria Systeem 260",
		"subheadline": "Douchesysteem",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26461000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26461000/640/26461000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset plafond 142 mm, 3 straalsoorten",
		"textblock_1st_text": "26461000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl hoofddoucheset met drie straalsoorten. Waterbesparende 260 mm hoofddouche en GROHE Rainshower plafond-douchearm (142 mm) in chroom. Hij is eenvoudig te installeren en te reinigen. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26461000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset 380 mm, 3 straalsoorten",
		"textblock_1st_text": "26459000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl hoofddoucheset met drie straalsoorten. Waterbesparende 260 mm hoofddouche en GROHE Rainshower douchearm (380 mm) in chroom. Hij is eenvoudig te installeren en te reinigen. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan systeem 210",
		"subheadline": "Douchesysteem met badthermostaat",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 douchesysteem met badthermostaat, 210 mm hoofddouche en een 100 mm  handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Vierkante vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Ronde vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatische mengkraan met omstelling",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower Systeem 210",
		"subheadline": "Douchesysteem met badthermostaat",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 douchesysteem met badthermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set met Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set met Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set met Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "26363000",
		"textblock_2nd_text": "GROHE Euphoria XXL Systeem 210 douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfect shower set met Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Perfect Shower set met 210 mm hoofddouche en een 100 mm chromen handdouche met twee straalsoorten. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan systeem 210",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 douchesysteem met thermostaat, 210 mm hoofddouche en een 100 mm handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria Systeem 260",
		"subheadline": "Douchesysteem met thermostaatkraan",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 douchesysteem met thermostaat, waterbesparende SmartControl 260 mm hoofddouche met drie straalsoorten en een 110 mm chromen handdouche met drie straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostatische douchemengkraan 1/2\" met douchegarnituur",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostatische douchemengkraan 1/2\" met douchegarnituur",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "kolanko przyłączeniowe ścienne, <br />DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Element podtynkowy ",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Uniwersalny element podtynkowy 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Zabezpieczenie przed przepływem zwrotnym (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Jednostrumieniowy prysznic ręczny",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "kolanko przyłączeniowe ścienne, <br />DN 15",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "GROHE Euphoria Cube - kolanko przyłączeniowe ścienne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower system 210 - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "uchwyt prysznicowy ścienny",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "kolanko przyłączeniowe ścienne, <br />DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "System prysznicowy z przełącznikiem<br />do montażu ściennego",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Rainshower® System 210 - system natryskowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "uchwyt prysznicowy ścienny",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower System 400 - system natryskowy ze ścienna bateria termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Jednostrumieniowy prysznic boczny",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27297001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27297001/640/27297001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "System prysznicowy z przełącznikiem<br />do montażu ściennego",
		"textblock_1st_text": "27297001",
		"textblock_2nd_text": "GROHE Euphoria System 180 - system prysznicowy z przełącznikiem",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27297001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Jednostrumieniowy prysznic ręczny",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "zestaw prysznicowy z drążkiem",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Rainshower - system prysznicowy do montażu ściennego",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "System wannowo-prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower system 210 - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "zestaw prysznicowy z drążkiem",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul 130 - zestaw prysznicow",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 160 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul 160 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "zestaw prysznicowy, 2 strumienie",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "zestaw prysznicowy, 2 strumienie",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "drążek prysznicowy, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "drążek prysznicowy, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Zestaw prysznicowy 2 strumienie",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul® 115 - zestaw punktowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Zestaw prysznicowy 2 strumienie",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 115 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Bateria prysznicowa z termostatem, DN 15 z zestawem prysznicowym",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Deszczownica z ramieniem 286 mm, 1 strumień",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Deszczownica z ramieniem 380 mm, 1 strumień ",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Deszczownica z ramieniem 286 mm, 1 strumień",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Deszczownica z przepustem stropowym 154 mm, 1 strumień",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Deszczownica z ramieniem 286 mm, 1 strumień",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Deszczownica z ramieniem 380 mm, 1 strumień ",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE Euphoria XXL System 310 - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Deszczownica z ramieniem 286 mm, 1 strumień",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL System 230 - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Zestaw prysznicowy 4 strumienie",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower System SmartControl 360 DUO - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Deszczownica z ramieniem 422 mm, 1 strumień",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower System SmartControl 360 MONO - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Wylewka wannowa",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Wylewka wannowa",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Wylewka wannowa",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "zestaw napełniający,<br />odpływowy i przelewowy do wanien",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "System prysznicowy z jednouchwytową baterią ścienną",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL System 230 - system prysznicowy z jednouchwytową baterią ścienną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "zestaw napełniający,<br />odpływowy i przelewowy do wanien",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Podtynkowy zestaw prysznicowy z termostatem",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Podtynkowy zestaw prysznicowy z termostatem",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Element podtynkowy do montażu ramienia prysznicowego 26 254 000/ 26 450 000<br type=\"_moz\" />",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Podtynkowy zestaw prysznicowy z termostatem",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Podtynkowy zestaw prysznicowy z termostatem",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Deszczownica z ramieniem 450 mm, 1 strumień",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Deszczownica z ramieniem 450 mm, 1 strumień",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 1 strumień",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Deszczownica z ramieniem 422 mm, 1 strumień",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Zestaw prysznicowy Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Deszczownica 430 mm, 2 strumienie",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 2 strumienie",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 2 strumienie",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Deszczownica 430 mm, 2 strumienie",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 2 strumienie",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 2 strumienie",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 - termostatyczny system natryskowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi jednego wyjścia wody",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody, ze zintegrowanym przyłączem i uchwytem prysznicowym",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi trzech wyjść wody",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi jednego wyjścia wody",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi trzech wyjść wody",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi jednego wyjścia wody",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody, ze zintegrowanym przyłączem i uchwytem prysznicowym",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi trzech wyjść wody",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi jednego wyjścia wody",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi trzech wyjść wody",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi trzech wyjść wody",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Bateria termostatyczna do obsługi dwóch wyjść wody",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Prysznic ręczny 4 strumienie",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130 - prysznic ręczny, 4 strumienie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Grohe Euphoria XXL System 210 - system natryskowy ze ścienną baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower® System 310 - system prysznicowy z termostatem do montażu ściennego",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower® System 210 - system natryskowy z termostatem do montażu ściennego",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Rainshower® System 310 - system natryskowy z termostatem do montażu ściennego",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Wąż prysznicowy z tworzywa ",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Wąż prysznicowy z tworzywa",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul 160 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "zestaw prysznicowy, 4 strumienie",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul 130 - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Deszczownica z ramieniem 286 mm, 1 strumień",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Bateria prysznicowa z termostatem, DN 15 z zestawem prysznicowym",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Bateria prysznicowa z termostatem, DN 15 z zestawem prysznicowym",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M - zestaw prysznicowy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 - system natryskowy z podtynkową baterią termostatyczną",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Podtynkowy zestaw prysznicowy Eurocube",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Zestaw prysznicowy Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Zestaw prysznicowy Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Zestaw prysznicowy Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "System wannowo-prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "System prysznicowy z jednouchwytową baterią ścienną",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "System prysznicowy z przełącznikiem<br />do montażu ściennego",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "System prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Deszczownica z przepustem stropowym 142 mm, 3 strumienie",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Deszczownica z ramieniem 380 mm, 3 strumienie",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "System prysznicowy z jednouchwytową baterią ścienną",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "System wannowo-prysznicowy z termostatem do montażu ściennego",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Uniwersalny element podtynkowy 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Prysznic ręczny, 2 strumienie, biała tarcza prysznica",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Prysznic ręczny, 4 strumienie, biała tarcza prysznica",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Podtynkowy zestaw prysznicowy z deszczownicą <br />Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Встраиваемый механизм для настенного/скрытого монтажа",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Подключение для душевого шланга, <br />DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Набор защиты от обратного потока (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "<strong>Универсальная встроенная часть, 1/2\"</strong>",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ручной душ, 1 вид струи",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Подключение для душевого шланга, <br />DN 15",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Head shower set 450 mm, 1 spray",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi Набор для комплектации душа с термостатом, <br />внешний/встроенный монтаж",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Combi Набор для комплектации душа с термостатом, <br />внешний/встроенный монтаж",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi Набор для комплектации душа с термостатом, <br />внешний/встроенный монтаж",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi Набор для комплектации душа с термостатом, <br />внешний/встроенный монтаж",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Набор для комплектации душа с Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Встраиваемый блок для набора верхнего душа <br />с душевым кронштейном 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27922001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Душевая система с термостатом для ванны; настенный монтаж",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Душевая система с однорычажным смесителем настенного монтажа",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Душевая система с переключателем для  настенного монтажа",
		"textblock_1st_text": "27421002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Верхний душ с потолочным душевым кронштейном 142 мм, 2 режима струи",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Верхний душ и душевой кронштейн 430 мм, 2 режима струи",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set ceiling 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26454001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26454001/640/26454001.jpg",
		"headline": "New Tempesta Rustic System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "26454001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26454001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G392",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Душевая система с однорычажным смесителем настенного монтажа",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Душевая система с термостатом для ванны; настенный монтаж",
		"textblock_1st_text": "26223001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfect shower set with Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Наливной, <br />сливной и переливной гарнитур",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 310 с термостатом",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 210 с термостатом",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 310 с термостатом",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Душевой набор, 2 вида струй",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul с ручным душем (115 мм), душевым шлангом (1250 мм) и держателем для ручного душа",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Душевой набор, 2 вида струй",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul Cosmopolitan с ручным душем (115 мм), душевым шлангом (1250 мм) и держателем для ручного душа",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Душевая штанга, 600 мм",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Душевая штанга, 900 мм",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Душевая гарнитура, 2 вида струй",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul с ручным душем (115 мм), душевой штангой (900 мм) и душевым шлангом (1750 мм)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Душевая гарнитура, 2 вида струй",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Душевой гарнитур, 4 вида струй",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul с ручным душем (160 мм), душевой штангой (900 мм) и душевым шлангом (1750 мм), 9,5 л/мин",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Душевой гарнитур, 4 вида струй",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul Cosmopolitan с ручным душем (160 мм), душевой штангой (900 мм) и душевым шлангом (1750 мм), 9,5 л/мин",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Душевой гарнитур, 4 вида струй",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul Cosmopolitan с ручным душем (130 мм), душевой штангой (900 мм) и душевым шлангом (1750 мм), 9,5 л/мин",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Душевой гарнитур, 4 вида струй",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Гарнитур GROHE Power&Soul с ручным душем (130 мм), душевой штангой (900 мм) и душевым шлангом (1750 мм), 9,5 л/мин",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Душевой гарнитур с 1 режимом струи",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ручной душ, 4 вида струй",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душевая система с термостатом для ванны; настенный монтаж",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 210 с термостатом и изливом для ванны",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душея система с термостатом и боковыми душами",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ручной душ, 1 вид струи",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Душевой гарнитур с 1 режимом струи",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Боковой душ с одним режимом",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 400 с термостатом",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Настенный держатель",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душевая система с переключателем для  настенного монтажа",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 210 с переключателем",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Подключение для душевого шланга, <br />DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Настенный держатель",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Душевая система GROHE Rainshower 210 с термостатом",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набор для комплектации душа с Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набор для комплектации душа с Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Набор для комплектации душа с Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набор для комплектации душа с Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Набор для комплектации душа с Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набор для комплектации душа с Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Душевой набор 4+ режима",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Душевая система с термостатом для настенного монтажа",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Душевая система с термостатом для настенного монтажа",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Наливной, <br />сливной и переливной гарнитур",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Излив для ванны",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Излив для ванны",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Излив для ванны",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для душа на 2 выхода, внешний монтаж",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для душа на 3 выхода, наружный монтаж",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ручной душ 4+ режима струи, белая душевая поверхность",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ручной душ, 2 вида струй, белая душевая поверхность",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душевая система с термостатом для  настенного монтажа",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 3 выхода",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 3 выхода",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Термостат для встраиваемого монтажа на 1 выход</strong>",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Термостат для встраиваемого монтажа на 1 выход</strong>",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 3 выхода",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода <br />со встроенным держателем для ручного душа",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Термостат для встраиваемого монтажа на 1 выход</strong>",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 3 выхода",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода <br />со встроенным держателем для ручного душа",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат для встраиваемого монтажа на 2 выхода",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "<strong>Термостат для встраиваемого монтажа на 1 выход</strong>",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Набор для комплектации душа Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "<strong>Универсальная встроенная часть, 1/2\"</strong>",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Верхний душ с потолочным душевым кронштейном 142 мм, 2 режима струи",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Верхний душ и душевой кронштейн 430 мм, 2 режима струи",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Верхний душ с потолочным душевым кронштейном 142 мм, 2 режима струи",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Верхний душ с потолочным душевым кронштейном 142 мм, 2 режима струи",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfect shower set with Tempesta 210",
		"textblock_1st_text": "34614001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Термостат для душа, DN 15 с душевым гарнитуром",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27399002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27399002/640/27399002.jpg",
		"headline": "New Tempesta Rustic System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "27399002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27399002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G392",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27394002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27394002/640/27394002.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "27394002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27394002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389002/640/27389002.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "27389002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/27389002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453001/640/26453001.jpg",
		"headline": "New Tempesta Cosmopolitan System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "26453001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26453001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452001/640/26452001.jpg",
		"headline": "New Tempesta System 200",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "26452001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26452001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Душевая система Flex с переключателем для настенного монтажа",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Душевая система с однорычажным смесителем настенного монтажа",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástenné kolienko DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Kombinace proti zpětnému toku (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Podomítkové těleso pro nástěnné kombinace/varianty",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Sprchový set vhodný pro Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Sprchová súprava GROHE Grohtherm Cube Perfect s hlavovou sprchou Rainshower Allure 230 mm, ručnou sprchou Euphoria Cube a termostatickým telesom Rapido T určeným na podomietkovú inštaláciu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ručná sprcha",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Box pro set s hlavovou sprchou 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 360 MONO. Chrómová, vyrobená v Nemecku: 360 mm hlavová sprcha (biely sprchový disk) a 450 mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 360 MONO. Chrómová, vyrobená v Nemecku: 360 mm hlavová sprcha a 450 mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha (biely sprchový disk) a 115 mm ručná sprcha so štyrmi režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha a 115mm ručná sprcha so štyrmi režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha (biely sprchový disk) s režimom prúdu GROHE TrioMassage a 115 mm ručná sprcha s dvoma režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha s režimom prúdu GROHE TrioMassage a 115 mm ručná sprcha s dvoma režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástenné kolienko DN 15",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Rameno sprchového výpustu Eurocube, chrómový povrch, vyrobené v Nemecku.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ručná sprcha",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, súprava s nástennou hlavovou sprchou, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s pákovou batériou, chrómový povrch, vyrobené v Nemecku, obsahuje kovovú, 230 mm hlavovú sprchu a ručnú sprchu s jedným režimom prúdu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria Cube XXL 230 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Termostatická sprchová batéria GROHE Grohtherm 1000 Cosmopolitan M so sprchovou súpravou GROHE Euphoria 110 Massage, 600 mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "Termostatická sprchová batéria GROHE Grohtherm 1000 Cosmopolitan M so sprchovou súpravou GROHE Euphoria 110 Massage, 900 mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 210 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s termostatickou batériou, chrómový povrch, vyrobené v Nemecku, obsahuje kovovú, 310 mm hlavovú sprchu a 110 mm ručnú sprchu s tromi režimami prúdu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Vaňový výtok",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set vhodný pro Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Sprchová súprava GROHE Grohtherm 2000 Perfect, vrátane termostatickej batérie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Sprchová súprava GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 210 mm, ručnou sprchou Euphoria 110 mm a termostatickým telesom Rapido T určeným na podomietkovú inštaláciu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Komfortný sprchový set GROHE Grohtherm 3000 Cosmopolitan vrátane podomietkovej sprchovej batérie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Hadica GROHE SilverFlex s flexibilným konektorom TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Hadica GROHE SilverFlex s flexibilným konektorom TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástenný držiak sprchy",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástenný držiak sprchy",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástenné kolienko DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Exposed s termostatickou sprchovou batériou. Chrómový, ekologický, precízne vyrobený v Nemecku, 360 mm hlavová sprcha s režimom prúdu GROHE TrioMassage a 115 mm ručná sprcha s dvoma režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s prepínačom pre nástennú montáž",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s prepínacím ventilom",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set stropní 154 mm, 1 proud",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, súprava hlavovej sprchy, stropné rameno sprchy 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Boční sprcha s jendím proudem",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 400 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem a bočními sprchami",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou batériou a telovými dýzami",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou batériou a vaňovým výpustom",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou batériou",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha a 115mm ručná sprcha so štyrmi režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Sprchový set s Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Sprchová súprava GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ručnou sprchou Sena a termostatickým telesom Rapido T určeným na podomietkovú inštaláciu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Sprchová súprava GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ručnou sprchou Sena a termostatickým telesom Rapido T určeným na podomietkovú inštaláciu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 2000 Perfect s hlavovou sprchou Rainshower Cosmopolitan 210 mm, ručnou sprchou Euphoria Cosmopolitan a termostatickým telesom Rapido T určeným na podomietkovú inštaláciu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Vaňový výtok",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Vaňový výtok",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Hadica GROHE SilverFlex s flexibilným konektorom TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vaňová napúšťacia, odtoková a prepadová súprava",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vaňová napúšťacia, odtoková a prepadová súprava",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (115 mm), hadicou (1 250 mm) a držiakom sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (130 mm), tyčou (900 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (130 mm), tyčou (600 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (130 mm), tyčou (600 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (160 mm), tyčou (900 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ručnou sprchou (115 mm), tyčou (900 mm) a hadicou (1 750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ručnou sprchou (115 mm), hadicou (1 250 mm) a držiakom sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ruční sprcha 4+ proudy",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, ručná sprcha, 4+ režimov prúdu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set s držákem 4+ proudy",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ručnou sprchou (130 mm), tyčou (900 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ručnou sprchou (160 mm), tyčou (900 mm) a hadicou (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Termostatická sprchová alebo vaňová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 3 ventily. Štvorcový tvar, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma <br />ventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 2 ventily. Štvorcový tvar, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 1 ventil Štvorcový tvar, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Termostatická sprchová alebo vaňová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 3 ventily. Zaoblené tvary, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma <br />ventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 2 ventily. Zaoblené tvary, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 1 ventil Zaoblené tvary, chrómová povrchová úprava, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ruční sprcha 4+ proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ruční sprcha 2 proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou batériou. Chrómová, ekologická a vyrobená v Nemecku: 360 mm hlavová sprcha (biely sprchový disk) a 115 mm ručná sprcha so štyrmi režimami prúdu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Sprchový systém GROHE Grohtherm 1000 Perfect, obsahuje 210 mm hlavovú sprchu a 100 mm ručnú sprchu s dvoma režimami prúdu, chrómový povrch.  Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou batériou, obsahuje 210 mm hlavovú sprchu a 100 mm ručnú sprchu s dvoma režimami prúdu, chrómový povrch. Jednoduchá inštalácia a údržba. Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Vaňový/sprchový systém GROHE Euphoria 260 Shower System s termostatickou vaňovou batériou, obsahuje 260 mm hlavovú sprchu SmartControl s tromi režimami prúdu a 110 mm ručnú sprchu s tromi režimami prúdu, chrómový povrch. Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s pákovou batériou, obsahuje 260 mm hlavovú sprchu SmartControl s tromi režimami prúdu a 110 mm ručnú sprchu s tromi režimami prúdu, chrómový povrch. Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s prepínačom pre nástennú montáž",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s prepínačom. Úsporná, 260 mm hlavová sprcha SmartControl s tromi režimami prúdu a 110 mm chrómová ručná sprcha s tromi režimami prúdu. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set ceiling 142 mm, 3 sprays",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Euphoria 260 SmartControl s tromi režimami prúdu. 260mm hlavová sprcha GROHE Rainshower so stropným ramenom (142 mm) a chrómovou povrchovou úpravou. Jednoduchá inštalácia a údržba. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Euphoria 260 SmartControl s tromi režimami prúdu. 260 mm hlavová sprcha GROHE Rainshower so sprchovým ramenom (380 mm) a chrómovou povrchovou úpravou. Jednoduchá inštalácia a údržba. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s pákovou batériou, obsahuje 210 mm hlavovú sprchu a 100 mm ručnú sprchu s dvoma režimami prúdu, chrómový povrch. Jednoduchá inštalácia a údržba. Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou batériou určený pre vane, obsahuje 210 mm hlavovú sprchu a 100 mm ručnú sprchu s dvoma režimami prúdu, chrómový povrch. Jednoduchá inštalácia a údržba. Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Sprchová súprava s termostatickou batériou Grohtherm SmartControl Perfect, na podomietkovú inštaláciu s tromi ventilmi, hlavová sprcha, ručná sprcha, sprchové rameno, hadica. Štvorcový tvar. Chrómový povrch, vyrobené v Nemecku.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Sprchová súprava s termostatickou batériou Grohtherm SmartControl Perfect, na podomietkovú inštaláciu s tromi ventilmi, hlavová sprcha, ručná sprcha, sprchové rameno, hadica. Kruhový tvar. Chrómový povrch, vyrobené v Nemecku.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive CUBE s 2 režimami prúdu vody. 310 mm, stropná hlavová sprcha so 142 mm sprchovým ramenom, chrómová povrchová úprava s bielym diskom, štvorcový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive CUBE s 2 režimami prúdu vody. 310 mm, stropná hlavová sprcha so 142 mm sprchovým ramenom, chrómová povrchová úprava, štvorcový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive CUBE s 2 režimami prúdu vody. 310 mm nástenná hlavová sprcha so 400 mm sprchovým ramenom, chrómová povrchová úprava s bielym diskom, štvorcový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive s 2 režimami prúdu vody. 310 mm stropná hlavová sprcha so 142 mm sprchovým ramenom, chrómová povrchová úprava s bielym diskom, kruhový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive s 2 režimami prúdu vody. 310 mm, stropná hlavová sprcha so 142 mm sprchovým ramenom, chrómová povrchová úprava, kruhový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Súprava hlavovej sprchy GROHE Rainshower 310 SmartActive s 2 režimami prúdu vody. 310 mm, nástenná hlavová sprcha so 400 mm sprchovým ramenom, chrómová povrchová úprava s bielym diskom, kruhový tvar. Vyrobené v Nemecku",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "Sprchový systém GROHE Eurosmart Cosmopolitan Perfect s pákovou batériou určený na podomietkovú inštaláciu, obsahuje 210 mm hlavovú sprchu a 100 mm ručnú sprchu s dvoma režimami prúdu, chrómový povrch.  Nemecké remeselníctvo.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Nástěnný Flex sprchový systém s přepínačem",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová batéria, DN 15 so sprchovou súpravou",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie s 2 ventily, nástěná",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Sprchová termostatická batéria GROHE Grohtherm SmartControl Combi s dvoma ventilmi. Chrómová farba s bielou priehradkou, nemecká kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie se 3 ventily, nástěnná",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Sprchová termostatická batéria GROHE Grohtherm SmartControl Combi s tromi ventilmi. Chrómová farba s bielou priehradkou, nemecká kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Termostatická sprchová alebo vaňová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 3 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Termostatická sprchová alebo vaňová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 3 ventily. Štvorcové tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 2 ventily. Štvorcové tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 1 ventil Štvorcové tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 2 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Termostatická sprchová batéria Grohtherm SmartControl na podomietkovú inštaláciu, 1 ventil Zaoblené tvary, povrchová úprava Moon White, vyrobené v Nemecku spoločnosťou GROHE. Ekologická prevádzka a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Askılı duş çıkış dirseği",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox iç gövde",
		"subheadline": "Universal giriş kutusu, 1/2",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Geri tepme koruma kombinasyonu",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Açık/gizli valfli batarya için iç gövde",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Askılı duş çıkış dirseği",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Tepe duşu için iç gövde",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "çıkış ucu",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "çıkış ucu",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "çıkış ucu",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill küvet tropleni",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatik duş bataryası / duş seti dahil",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Termostatik yarı ankastre duş bataryası",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Termostatik yarı ankastre duş bataryası",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower 360 Duo",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "El duşu askısı",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Askılı duş çıkış dirseği",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte yön değiştiricili duş sistemi",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 yön değiştiricili duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "El duşu askısı",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Yan duş",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Sürgülü duş seti",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "El duşu, 4+ akışlı, gece grisi sprey plakası",
		"textblock_1st_text": "27673000",
		"textblock_2nd_text": "GROHE Power&Soul el duşu, 130 mm, 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Tepe duşu 1 akışlı",
		"textblock_1st_text": "27705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan seti: el duşu (130 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul seti: el duşu (160 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul seti: el duşu (130 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 termostatlı duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silver Flex hortum, TwistFree fonksiyonu için döner bağlantı parçası, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silver Flex hortum, TwistFree fonksiyonu için döner bağlantı parçası, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray<br />",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria Sistem 180",
		"subheadline": "Duvara monte yön değiştiricili duş sistemi",
		"textblock_1st_text": "27421001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik banyo bataryalı duş sistemi",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Sürgülü duş seti",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill küvet tropleni",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "New Tempesta Cosmopolitan Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 termostatlı duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatik duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Termostatik bataryalı ve yan jetli duş sistemi",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatlı ve vücut jetli duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, el duşu, 1 akış",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Duvardan duş  seti 4+ akışlı",
		"textblock_1st_text": "27741000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Duş sürgüsü, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "New Tempesta Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "27389001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "New Tempesta Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "26224001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26479LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26481000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26481LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27296002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27615001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik banyo bataryalı duş sistemi",
		"textblock_1st_text": "27475001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "27473001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Duvardan duş  seti 4+ akışlı",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik <br />duş bataryası, entegre duş kolu ile",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik <br />duş bataryası, entegre duş kolu ile",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü termostatik duş bataryası, açık/gizli valf",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Tepe duşu seti 380 mm, 3 akışlı",
		"textblock_1st_text": "26459000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26475000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26475LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26477LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Вбудовний механізм для настінного / прихованого монтажу",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ручний душ, 1 режим струменю",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Випускне коліно для душу, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Універсальна вбудована частина, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набір для комплектації душу із Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Набір для комплектації душу із Power&amp;Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Термостат для душу 1/2\" із душовим гарнітуром",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Набір 450 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26450000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Набір 450 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26450LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душова система з термостатом Smartcontrol Combi напівприхованого монтажу",
		"textblock_1st_text": "26446000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душова система з термостатом Smartcontrol Combi напівприхованого монтажу",
		"textblock_1st_text": "26446LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душова система з термостатом Smartcontrol Combi напівприхованого монтажу",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душова система з термостатом Smartcontrol Combi напівприхованого монтажу",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Випускне коліно для душу, 1/2\"",
		"textblock_1st_text": "26370000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Вбудований блок для верхнього душу з душовим кронштейном 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Набір для комплектації душу із Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Система впуску, переливу та зливу",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Душовий набір, 1 режим струменю",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Набір 380 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Набір верхнього душу настельного монтажу 154 мм, 1 режим струменю",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Верхній 286 мм душ, 1 режим струменю",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Набір 380 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Верхній 286 мм душ, 1 режим струменю",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Система впуску, переливу та зливу",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Набір для комплектації душу Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набір для комплектації душу із Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Душовий набір, 1 режим струменю",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Набір 422 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Набір 422 мм верхнього душу, 1 режим струменю",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "",
		"subheadline": "Вилив для ванни",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Вилив для ванни",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Вилив для ванни",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 3 кнопками керування",
		"textblock_1st_text": "29126000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tермостат прихованого монтажу з 2 кнопками керування",
		"textblock_1st_text": "29124000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 1 кнопкою керування ",
		"textblock_1st_text": "29123000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 2 кнопками керування та вбудованим душовим тримачем",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 3 кнопками керування",
		"textblock_1st_text": "29121000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 2 кнопками керування та вбудованим душовим тримачем",
		"textblock_1st_text": "29120000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tермостат прихованого монтажу з 2 кнопками керування",
		"textblock_1st_text": "29119000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 1 кнопкою керування ",
		"textblock_1st_text": "29118000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Верхній 286 мм душ, 1 режим струменю",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Душовий комплект для Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набір для комплектації душу із Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Термостат для душу 1/2\" із душовим гарнітуром",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Набір для комплектації душу Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Термостат для душу 1/2\" із душовим гарнітуром",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27174001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Настінний тримач для ручного душу",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душова система з перемикачем для настінного монтажу",
		"textblock_1st_text": "27058000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Випускне коліно для душу, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Настінний тримач для ручного душу",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27032001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душова система з термостатом і боковими душами",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ручний душ, 1 режим струменю",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Боковий душ, 1 режим струменю",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"subheadline": "Душова система із термостатом для настінного монтажу",
		"textblock_1st_text": "26087000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Душова система із термостатом для настінного монтажу",
		"textblock_1st_text": "26075000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Верхній 286 мм душ, 1 режим струменю",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Набір 142 мм верхнього&#160;душу настельного монтажу, 1 режим струменю",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27967000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27966000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27968000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "27964000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Душовий набір, 2 режими струменю",
		"textblock_1st_text": "27839000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Душовий набір, 2 режими струменю",
		"textblock_1st_text": "27838000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Душова штанга, 900 мм",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Душова штанга, 600 мм",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"subheadline": "Душова система із одноричажним змішувачем настінного монтажу",
		"textblock_1st_text": "23147001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Душовий шланг 1750",
		"textblock_1st_text": "28388000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Душовий шланг 1500",
		"textblock_1st_text": "28364000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Душовий шланг 1250",
		"textblock_1st_text": "28362000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Душовий набір, 2 режими струменю",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Душовий набір, 2 режими струменю",
		"textblock_1st_text": "27759000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Душовий набір 4+ режими струменю",
		"textblock_1st_text": "27750000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Душовий набір 4+ режими струменю",
		"textblock_1st_text": "27746000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Душовий набір 4+ режими струменю",
		"textblock_1st_text": "27738000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Душовий набір 4+ режими струменю",
		"textblock_1st_text": "27734000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ручний душ 4+ режими струменю, біла душова голівка",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ручний душ із 2 режимами струменю, біла душова голівка",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ручний душ 4+ режими струменю",
		"textblock_1st_text": "27663LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Душова система настінного монтажу з термостатом для ванни",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "26250000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Душова система з термостатом для настінного монтажу <br />",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Душовий набір 4+ режими струменю",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат із 2 кнопками керування, зовнішнього/прихованого монтажу",
		"textblock_1st_text": "34714000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат із 3 кнопками керування, зовнішнього/прихованого монтажу",
		"textblock_1st_text": "34713000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Неперевершена душова система із Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Неперевершений душовий комплект із Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 3 кнопками керування",
		"textblock_1st_text": "29904LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 3 кнопками керування",
		"textblock_1st_text": "29157LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tермостат прихованого монтажу з 2 кнопками керування",
		"textblock_1st_text": "29156LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 1 кнопкою керування ",
		"textblock_1st_text": "29153LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tермостат прихованого монтажу з 2 кнопками керування",
		"textblock_1st_text": "29151LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Термостат прихованого монтажу із 1 кнопкою керування ",
		"textblock_1st_text": "29150LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Душовий комплект із системою Tempesta 210",
		"textblock_1st_text": "25183001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ua/uk_ua/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ua/uk_ua/nash-servis/shou-rumy-installjatory.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"DELETE LATER"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0 && !boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"DELETE LATER"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt2 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt2 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && !mono-spout && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && !mono-spout && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	}
];

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0 && !boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0 && !boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"125608",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30091DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"DELETE LATER"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"DELETE LATER"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && mono-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt2 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt2 && duo-spout_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && !mono-spout && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && !mono-spout && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31456000",
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt0 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && mono-spout_opt1 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	}
];

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30032001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30032001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30032DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30032DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30144001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30144001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30144DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30144DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30338001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498000"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC0"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30338001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454DC0",
					"30338DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0",
					"30338DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30032001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30032001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31455DC0",
					"30032DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0",
					"30032DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498000"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC0"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"DELETE LATER"
		],
		"groups": [
			{
				"products": [
					"30328DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31301001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31301DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"33249001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"33249DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31345002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31345DC2"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31299001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt3 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31299DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31301001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31301DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"33249001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"33249DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31345002"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31345DC2"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31299001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt3 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31299DC1"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31299001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31299001/640/31299001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "31299001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Pure s vodním filtrem, výpusť ve tvaru písmene U, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31299001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost L<br type=\"_moz\" />",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene L, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene L a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene U, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene U a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249001",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249001/640/33249001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "33249001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Pure s vodním filtrem, výpusť ve tvaru písmene C, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/33249001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249DC1/640/33249DC1.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "33249DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Pure s vodním filtrem, výpusť ve tvaru písmene C, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/33249DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345002",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345002/640/31345002.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "31345002",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Minta Pure s vodním filtrem, výpusť ve tvaru L, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31345002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345DC2",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345DC2/640/31345DC2.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "31345DC2",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Minta Pure s vodním filtrem, výpusť ve tvaru L, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31345DC2",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301001/640/31301001.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "31301001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Mono Pure s vodním filtrem, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31301001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301DC1/640/31301DC1.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Startovní sada",
		"textblock_1st_text": "31301DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE Blue Mono Pure s vodním filtrem, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31301DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Blandingsventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i størrelse M<br />",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L<br />",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L<br />",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i størrelse M<br />",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i strørrelse L<br />",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L<br />",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L<br />",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tud starter kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til kulsyretilsætning. Høj L-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tud starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tud starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tud starter kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj L-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tud starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj U-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tud starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj U-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono startsæt",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono startsæt: søjlearmatur til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono startsæt",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono startsæt: søjlearmatur til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe M",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mischventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "125608",
		"image": "//cdn.cloud.grohe.com/prod/10/12/125608/640/125608.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "125608",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/125608",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091001/640/30091001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/30091001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091DC1/640/30091DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/30091DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mischventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter Kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter Kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/de_ch/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/de_ch/service/ausstellungen-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe M",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mischventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-Auslauf Starter Kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher L-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter Kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-Auslauf Starter Kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter Kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-Auslauf Starter Kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterpaket: Einhand-Küchenarmatur für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher U-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter Kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Chromoberfläche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter Kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterpaket: Standventil für gefiltertes, gekühltes und sprudelndes Wasser. Enthält: Kühlereinheit, Filter und CO2-Flasche. Hoher C-Auslauf, Edelstahloptik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Standventil und Boiler Größe M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono Küchenarmatur (C-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe M für kochend heißes Wasser auf Knopfdruck. Chromoberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Küchenarmatur (L-Auslauf) mit Filterset und Boiler Größe L für kochend heißes Wasser auf Knopfdruck. Supersteel Oberfläche, Energieeffizienzklasse A und TÜV-geprüfte Kindersicherung.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.de/de_de/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.de/de_de/service/showrooms-fachinstallateure.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and L size boiler",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en L",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en C",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en C",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en U",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en U",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit caño en L",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Grifo de fregadero y calentador Tamaño L",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Grifo de fregadero y calentador Tamaño M",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño L",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Monomando de fregadero y Calentador Tamaño M",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mitigeur pour GROHE RED",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "Mitigeur pour GROHE RED",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono : robinet sur colonnette fournissant une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono: robinet sur colonnette fournissant une eau filtrée, réfrigérée et pétillante. Inclut une unite réfrigérante, un filter et une bouteille de CO2 pour la gazéfication. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filtre et boiler de taille M pour l\\'eau bouillante instantanée. Finition supersteel. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filter et boiler de taille M pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filter et boiler de taille L pour l\\'eau bouillante instantanée. Finition supersteel. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en L) avec filter et boiler de taille L pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Robinetterie Mono et boiler taille M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Mono (bec en C) avec filtre et boiler de taille L pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filter et boiler de taille M pour l\\'eau bouillante instantanée. Finition supersteel. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet + Chauffe-eau taille M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filter et boiler de taille M pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Robinetterie Mono et boiler taille L<br type=\"_moz\"  />",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Mono (bec en C) avec filtre et boiler de taille L pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filter et boiler de taille L pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi système de douche avec thermostat, montage mural/encastré",
		"textblock_1st_text": "26443LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Robinet et chauffe-eau taille L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Robinet de cuisine GROHE RED Duo (bec en C) avec filter et boiler de taille L pour l\\'eau bouillante instantanée. Finition chromée. Classification énergétique A et des mesures de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "Douche de tête GROHE Euphoria Cosmopolitan 180",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douche à main, 1 jet",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, douchette, 1 jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26361LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Système de douche avec thermostatique mural",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/fr_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/fr_be/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "125608",
		"image": "//cdn.cloud.grohe.com/prod/10/12/125608/640/125608.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "125608",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/125608",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091001/640/30091001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/30091001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091DC1/640/30091DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/30091DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mixing valve",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono : robinet sur colonnette fournissant une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31299001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31299001/640/31299001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "31299001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31299001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301001/640/31301001.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "31301001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31301001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345002",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345002/640/31345002.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "31345002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31345002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249001",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249001/640/33249001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "33249001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/33249001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249DC1/640/33249DC1.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "33249DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/33249DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345DC2",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345DC2/640/31345DC2.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "31345DC2",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31345DC2",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301DC1/640/31301DC1.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Start paket",
		"textblock_1st_text": "31301DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31301DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hu/hu_hu/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hu/hu_hu/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "125608",
		"image": "//cdn.cloud.grohe.com/prod/10/12/125608/640/125608.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia M",
		"textblock_1st_text": "125608",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/125608",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091DC1/640/30091DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30091DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/30091DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Valvola di miscelazione",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "per GROHE Blue Home Duo: un unico miscelatore da cucina per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e un bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a L, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello<br /> GROHE Blue Home Mono rubinetto con sistema  filtrante dell\\'acqua",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Starter kit per GROHE Blue Home Duo: rubinetto a colonna per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e una bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello<br /> GROHE Blue Home Mono rubinetto con sistema  filtrante dell\\'acqua",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "per GROHE Blue Home Duo: rubinetto a colonna per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e una bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091001/640/30091001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30091001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/30091001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Rubinetto a colonna e boiler taglia M",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Valvola di miscelazione",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Rubinetto a colonna e boiler taglia L",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia L",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello<br /> GROHE Blue Home Mono rubinetto con sistema  filtrante dell\\'acqua",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "per GROHE Blue Home Duo: rubinetto a colonna per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e una bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello<br /> GROHE Blue Home Mono rubinetto con sistema  filtrante dell\\'acqua",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Starter kit per GROHE Blue Home Duo: rubinetto a colonna per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e una bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Rubinetto per lavello",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "per GROHE Blue Home Duo: un unico miscelatore da cucina per ottenere acqua filtrata, refrigerata e frizzante. Comprende un’unità di refrigerazione, un filtro e un bombola di CO2 per l’aggiunta di anidride carbonica. Bocca alta a L, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia M",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia M",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Rubinetto a colonna e boiler taglia M",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia M",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miscelatore e boiler taglia M",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and L size boiler",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and L size boiler",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout Starter kit",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout Starter kit",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout Starter kit",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "External mixing valve for GROHE Red",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.lv/lv_lv/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.lv/lv_lv/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mengventiel voor GROHE RED",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "Mengventiel voor GROHE Red",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: fonteinkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: fonteinkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gezuiverd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE Red Mono keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kraan en L-size boiler<br type=\"_moz\"  />",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE Red Mono keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (C-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en M-size boiler",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en M size boiler voor onmiddellijk kokend water. Chroom afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan en L-size boiler",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE Red Duo keukenkraan (L-uitloop) met filter en L size boiler voor onmiddellijk kokend water. Supersteel afwerking. Energie efficiëntieklasse A en veiligheidsvoorzieningen\r\n",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "Euphoria Cube Stick, handdouche, 1 straal",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hoofddouche",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180 mm hoofddouche, 9,5 l/min.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Douche-arm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Douchesysteem met thermostaat",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche witte  sproeiplaat met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "30031001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30031001/640/30031001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30031001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (C uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chroom afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30031001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30031DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30031DC1/640/30031DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30031DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (C uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30031DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30144001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30144001/640/30144001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30144001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (U uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking.. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30144001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30144DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30144DC1/640/30144DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30144DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (U uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30144DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30324001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30324001/640/30324001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30324001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30324001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30324DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30324DC1/640/30324DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30324DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30324DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30338001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30338001/640/30338001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30338001",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30338001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30338DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30338DC1/640/30338DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30338DC1",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30338DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30032001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30032001/640/30032001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30032001",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (C- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30032DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30032DC1/640/30032DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30032DC1",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (C- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30032DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40438001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40438001/640/40438001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Filter met filterhouder",
		"textblock_1st_text": "40438001",
		"textblock_2nd_text": "GROHE Red Filter geschikt voor een waterhardheid hoger dan 10 dH voor gebruik van de GROHE RED keukenkraan met L-size boiler en mengventiel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/40438001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G286",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: keukenkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: keukenkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Zawór mieszający",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze w rozmiarze M",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze w rozmiarze M",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze w rozmiarze M",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze w rozmiarze M",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy z bojlerem w rozmiarze L",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zawór sztorcowy Mono",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zawór sztorcowy Mono",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home - zestaw startowy z baterią filtrującą wodę i jednostką chłodzącą",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, C-излив",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, L-излив",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, U-излив",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, C-излив",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, L-излив",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Стартовый комплект, U-излив",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345DC2",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345DC2/640/31345DC2.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31345DC2",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31345DC2",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345002",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345002/640/31345002.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31345002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31345002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31299DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31299DC1/640/31299DC1.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31299DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31299DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301001/640/31301001.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31301001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31301001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31299001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31299001/640/31299001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31299001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31299001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249001",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249001/640/33249001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "33249001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/33249001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249DC1/640/33249DC1.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "33249DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/33249DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Смешивающее устройство",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Стартовый комплект",
		"textblock_1st_text": "31498DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Стартовый комплект",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер M-size",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер M-size",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер L-size",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер L-size",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Вертикальный вентиль и бойлер M-size",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер M-size",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер M-size",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Вертикальный вентиль и бойлер L-size",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер L-size",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Смеситель и бойлер L-size",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Вертикальный вентиль и бойлер M-size",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301DC1/640/31301DC1.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Стартовый комплект",
		"textblock_1st_text": "31301DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ru/ru_ru/product/31301DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ru/ru_ru/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "31301001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301001/640/31301001.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "31301001",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Mono Pure s vodným filtrom, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31301001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249001",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249001/640/33249001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "33249001",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Pure s vodným filtrom, výpust v tvare písmena C, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/33249001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31299001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31299001/640/31299001.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "31299001",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Pure s vodným filtrom, výpust v tvare písmena U, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31299001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "33249DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/33/33249DC1/640/33249DC1.jpg",
		"headline": "GROHE Blue Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "33249DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Pure s vodným filtrom, výpust v tvare písmena C, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/33249DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345002",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345002/640/31345002.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "31345002",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Minta Pure s vodným filtrom, výpust v tvare L, GROHE StarLight",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31345002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31345DC2",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31345DC2/640/31345DC2.jpg",
		"headline": "GROHE Blue Minta Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "31345DC2",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Minta Pure s vodným filtrom, výpust v tvare L, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31345DC2",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost L<br type=\"_moz\" />",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena L, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena U a povrchová úprava z antikorovej ocele.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena U, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C a povrchová úprava z antikorovej ocele.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena L a povrchová úprava z antikorovej ocele.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Mono: stojančeková batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Mono: stojančeková batéria pre filtrovanú, chladenú a perlivú vodu. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C a povrchová úprava z antikorovej ocele.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31301DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31301DC1/640/31301DC1.jpg",
		"headline": "GROHE Blue Mono Pure",
		"subheadline": "Štartovacia súprava",
		"textblock_1st_text": "31301DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE Blue Mono Pure s vodným filtrom, GROHE SuperSteel",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31301DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nash-servis/shou-rumy-installjatory.html#productline=G227",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"conditions": " ",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt1 && tap && duo-spout",
				"water-type_opt0 && tap_opt1 && duo-spout",
				"main-faucet && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1",
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && finish",
				"water-type_opt0 && finish",
				"water-type_opt0 && duo-spout_opt2"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location-old",
			"additionalClass": "",
			"conditions": "!da_dk",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "da_dk",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"abc"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish && !water-type_opt1",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0",
						"water-type_opt2 && main-faucet_opt0 && finish_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt2 && duo-spout_opt2",
						"tap_opt0 && duo-spout_opt2"
					]
				},
				{
					"text": "question8.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": []
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question10.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && boiler",
				"water-type_opt1 && finish",
				"water-type_opt2 && boiler"
			],
			"options": [
				{
					"text": "question10.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"main-faucet_opt0 && duo-spout_opt2 && boiler",
						"main-faucet_opt1 && duo-spout_opt2 && boiler",
						"boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question10.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"!boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1",
						"!water-type_opt2"
					]
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && tap"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap_opt1",
				"water-type_opt0 && tap_opt0",
				"water-type_opt1 && tap_opt1",
				"water-type_opt1 && tap_opt0",
				"main-faucet_opt0",
				"main-faucet_opt1"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt2 && main-faucet_opt0",
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"image": "ZZH_T31456B05_000_01.jpg",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!de_at"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt1",
						"water-type_opt2 && !main-faucet_opt0",
						"water-type_opt1 && tap_opt0 && duo-spout_opt2",
						"water-type_opt0 && tap_opt0 && !duo-spout",
						"water-type_opt0 && tap_opt1 && duo-spout",
						"water-type_opt2 && main-faucet_opt0 && tap_opt1 && !duo-spout",
						"water-type_opt1 && tap_opt1 && duo-spout"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt0",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && !duo-spout_opt0"
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "asdfghjkl",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": "!nl_nl",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "water-type_opt1"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "lkjgfdr",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "iuhb",
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && finish",
				"water-type_opt2 && finish"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !finish_opt1",
						"water-type_opt0 && finish_opt0",
						"water-type_opt2 && !finish_opt1",
						"water-type_opt2 && finish_opt0",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "jhzte",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1",
						"!water-type_opt2"
					]
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && tap"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap_opt1",
				"water-type_opt0 && tap_opt0",
				"water-type_opt1 && tap_opt1",
				"water-type_opt1 && tap_opt0",
				"main-faucet_opt0",
				"main-faucet_opt1"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt2 && main-faucet_opt0",
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"image": "ZZH_T31456B05_000_01.jpg",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!de_de"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt1",
						"water-type_opt2 && !main-faucet_opt0",
						"water-type_opt1 && tap_opt0 && duo-spout_opt2",
						"water-type_opt0 && tap_opt0 && !duo-spout",
						"water-type_opt0 && tap_opt1 && duo-spout",
						"water-type_opt2 && main-faucet_opt0 && tap_opt1 && !duo-spout",
						"water-type_opt1 && tap_opt1 && duo-spout"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt0",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"water-type_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && !duo-spout_opt0"
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "asdfghjkl",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"conditions": " ",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt1 && tap && duo-spout",
				"water-type_opt0 && tap_opt1 && duo-spout",
				"main-faucet && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1",
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && finish",
				"water-type_opt0 && finish",
				"water-type_opt0 && duo-spout_opt2"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": "!en_gb",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap_opt1",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt2 && main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt2 && main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && duo-spout",
				"tap_opt0"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt2 && main-faucet_opt0 && duo-spout",
						"water-type_opt0 && tap_opt0"
					],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt0",
						"water-type_opt2 && main-faucet_opt0 && duo-spout",
						"water-type_opt2 && main-faucet_opt1 && duo-spout",
						"water-type_opt1 && tap_opt0"
					],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"mono-spout",
				"duo-spout",
				"water-type_opt2 && mono-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt0",
						"water-type_opt0 && mono-spout",
						"water-type_opt1 && mono-spout",
						"water-type_opt1 && duo-spout",
						"water-type_opt0 && duo-spout",
						"water-type_opt2 && mono-spout"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt1 && mono-spout",
						"water-type_opt1 && duo-spout",
						"water-type_opt2 && main-faucet_opt1 && mono-spout"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && finish_opt0 && mono-spout",
						"water-type_opt0 && duo-spout && finish",
						"water-type_opt2 && mono-spout && finish"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && duo-spout && finish",
						"water-type_opt2 && main-faucet_opt1 && finish"
					]
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "asdfghjkl",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"conditions": " ",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap_opt1",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt1 && tap && duo-spout",
				"water-type_opt0 && tap_opt1 && duo-spout",
				"main-faucet && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1",
						"water-type_opt0 && tap_opt1",
						"main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2 && finish",
				"water-type_opt0 && finish",
				"water-type_opt0 && duo-spout_opt2 && finish",
				"water-type_opt0 && tap_opt0"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"duo-spout_opt2",
						"water-type_opt0 && tap_opt0"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location-old",
			"additionalClass": "",
			"conditions": "!et_ee",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "et_ee",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"abc"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish && !water-type_opt1",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0",
						"water-type_opt2 && main-faucet_opt0 && finish_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt2 && duo-spout_opt2",
						"tap_opt0 && duo-spout_opt2"
					]
				},
				{
					"text": "question8.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": []
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question10.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && boiler",
				"water-type_opt1 && finish",
				"water-type_opt2 && boiler"
			],
			"options": [
				{
					"text": "question10.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"main-faucet_opt0 && duo-spout_opt2 && boiler",
						"main-faucet_opt1 && duo-spout_opt2 && boiler",
						"boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question10.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"!boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "!water-type_opt2"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2 && tap",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt2 && tap",
				"main-faucet"
			],
			"options": [
				{
					"_comment": "L",
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "U",
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "C",
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !tap_opt0",
						"water-type_opt1 && tap_opt0 && !location_opt1",
						"water-type_opt2 && tap_opt0",
						"tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"location_opt1 && !water-type_opt2 && tap_opt0",
				"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": "abc",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout_opt0 && !main-faucet_opt0",
				"duo-spout_opt1 && !main-faucet_opt0",
				"location_opt0 && duo-spout_opt2 && main_faucet_opt1",
				"mono-spout_opt1",
				"duo-spout_opt2 && !main-faucet_opt0"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"location_opt0",
						"!water-type_opt0",
						"tap_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt1 && finish",
				"main-faucet_opt0 && duo-spout",
				"location_opt0 && water-type_opt0 && tap_opt0"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": "!nl_nl",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "water-type_opt1"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "lkjgfdr",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "iuhb",
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && finish",
				"water-type_opt2 && finish"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !finish_opt1",
						"water-type_opt0 && finish_opt0",
						"water-type_opt2 && !finish_opt1",
						"water-type_opt2 && finish_opt0",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "jhzte",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": "!nl_nl",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "water-type_opt1"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "lkjgfdr",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "iuhb",
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && finish",
				"water-type_opt2 && finish"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !finish_opt1",
						"water-type_opt0 && finish_opt0",
						"water-type_opt2 && !finish_opt1",
						"water-type_opt2 && finish_opt0",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "jhzte",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location-old",
			"additionalClass": "",
			"conditions": "!lt_ltu",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "lt_ltu",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"abc"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish && !water-type_opt1",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0",
						"water-type_opt2 && main-faucet_opt0 && finish_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt2 && duo-spout_opt2",
						"tap_opt0 && duo-spout_opt2"
					]
				},
				{
					"text": "question8.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": []
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question10.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && boiler",
				"water-type_opt1 && finish",
				"water-type_opt2 && boiler"
			],
			"options": [
				{
					"text": "question10.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"main-faucet_opt0 && duo-spout_opt2 && boiler",
						"main-faucet_opt1 && duo-spout_opt2 && boiler",
						"boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question10.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"!boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location-old",
			"additionalClass": "",
			"conditions": "!lv_lv",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "lv_lv",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"abc"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish && !water-type_opt1",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0",
						"water-type_opt2 && main-faucet_opt0 && finish_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt2 && duo-spout_opt2",
						"tap_opt0 && duo-spout_opt2"
					]
				},
				{
					"text": "question8.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": []
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question10.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && boiler",
				"water-type_opt1 && finish",
				"water-type_opt2 && boiler"
			],
			"options": [
				{
					"text": "question10.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"main-faucet_opt0 && duo-spout_opt2 && boiler",
						"main-faucet_opt1 && duo-spout_opt2 && boiler",
						"boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question10.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"!boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "!water-type_opt2"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2 && tap",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt2 && tap",
				"main-faucet"
			],
			"options": [
				{
					"_comment": "L",
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "U",
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"_comment": "C",
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && !tap_opt0",
						"water-type_opt1 && tap_opt0 && !location_opt1",
						"water-type_opt2 && tap_opt0",
						"tap_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"location_opt1 && !water-type_opt2 && tap_opt0",
				"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": "abc",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout_opt0 && !main-faucet_opt0",
				"duo-spout_opt1 && !main-faucet_opt0",
				"location_opt0 && duo-spout_opt2 && main_faucet_opt1",
				"mono-spout_opt1",
				"duo-spout_opt2 && !main-faucet_opt0"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"location_opt0",
						"!water-type_opt0",
						"tap_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt1 && finish",
				"main-faucet_opt0 && duo-spout",
				"location_opt0 && water-type_opt0 && tap_opt0"
			],
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": "!nl_nl",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": "water-type",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing",
					"conditions": "!water-type_opt2"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2 && tap",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt2 && tap",
				"water-type_opt2 && main-faucet"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1 && !main-faucet_opt1",
						"water-type_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1",
						"water-type_opt0 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type && !main-faucet_opt1",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"!water-type_opt2 && duo-spout",
				"water-type_opt2 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": [
				"main-faucet && finish",
				"water-type_opt0 && finish",
				"water-type_opt2 && finish"
			],
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location-old",
			"additionalClass": "",
			"conditions": "!no_no",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "no_no",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0",
				"water-type_opt1"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "water-type_opt2",
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap_opt1",
						"water-type_opt2 && main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T31456B05_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!water-type_opt2 && tap",
						"main-faucet"
					],
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "mono-spout",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"abc"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "ZZH_30338001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30338001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				},
				{
					"text": "question6.option2.text",
					"image": "ZZH_30080001_001_02.jpg",
					"buttonIcon": "",
					"conditions": [],
					"images": [
						{
							"image": "ZZH_30080001_001_02.jpg",
							"conditions": "main-faucet_opt0"
						}
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet"
					]
				},
				{
					"text": "question7.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt1 && tap",
						"water-type_opt2 && main-faucet_opt1"
					]
				}
			]
		},
		{
			"question": "question8.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": "finish && !water-type_opt1",
			"options": [
				{
					"text": "question8.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"main-faucet_opt1",
						"main-faucet_opt0 && duo-spout_opt2",
						"location_opt1 && main-faucet_opt0 && duo-spout_opt0",
						"water-type_opt2 && main-faucet_opt0 && finish_opt0"
					]
				},
				{
					"text": "question8.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0 && tap_opt1",
						"water-type_opt2 && duo-spout_opt2",
						"tap_opt0 && duo-spout_opt2"
					]
				},
				{
					"text": "question8.option3.text",
					"image": "",
					"buttonIcon": "",
					"conditions": []
				}
			]
		},
		{
			"question": "question9.question",
			"slug": "filter",
			"swipeable": false,
			"additionalClass": "",
			"conditions": "abc",
			"options": [
				{
					"text": "question9.option1.text",
					"image": "",
					"buttonIcon": ""
				},
				{
					"text": "question9.option2.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question10.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && boiler",
				"water-type_opt1 && finish",
				"water-type_opt2 && boiler"
			],
			"options": [
				{
					"text": "question10.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"main-faucet_opt0 && duo-spout_opt2 && boiler",
						"main-faucet_opt1 && duo-spout_opt2 && boiler",
						"boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				},
				{
					"text": "question10.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": "",
					"conditions": [
						"main-faucet_opt0 && duo-spout_opt0 && boiler_opt0",
						"!boiler_opt2",
						"water-type_opt0 && boiler",
						"water-type_opt1 && finish"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				},
				{
					"text": "question2.option4.text",
					"image": "",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"water-type_opt3 && tap_opt1",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1",
						"water-type_opt3 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout",
				"water-type_opt3 && tap_opt0",
				"water-type_opt3 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2",
						"water-type_opt3 && tap_opt0"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question1.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question1.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question2.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question2.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question2.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question3.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0",
				"water-type_opt1",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt0",
						"water-type_opt1",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0"
							]
						}
					]
				},
				{
					"text": "question3.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0"
							]
						}
					]
				},
				{
					"text": "question3.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"water-type_opt0"
							]
						}
					]
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"duo-spout",
				"water-type_opt1 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"!main-faucet_opt0"
					]
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && finish",
				"water-type_opt0 && duo-spout && finish",
				"water-type_opt0 && finish",
				"main-faucet && finish",
				"main-faucet && !duo-spout_opt0 && finish",
				"water-type_opt0 && duo-spout_opt2",
				"water-type_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question5.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"!(main-faucet_opt0 && duo-spout_opt0)"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = {
	"questions": [
		{
			"question": "question1.question",
			"swipeable": false,
			"slug": "location",
			"additionalClass": "",
			"options": [
				{
					"text": "question1.option1.text",
					"image": "ZZH_T22037A05_001_01_A.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question1.option2.text",
					"image": "ZZH_T22037A05_001_01_B.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question2.question",
			"swipeable": true,
			"slug": "water-type",
			"additionalClass": "",
			"conditions": "location",
			"options": [
				{
					"text": "question2.option1.text",
					"image": "ZZH_T30325C05_000.jpg",
					"buttonIcon": "icon-answer-boiling"
				},
				{
					"text": "question2.option2.text",
					"buttonIcon": "icon-answer-chill-and-spark",
					"image": "ZZH_T31454B10_000_01.jpg"
				},
				{
					"text": "question2.option3.text",
					"image": "ZZH_T30079C05_000_01.jpg",
					"buttonIcon": "icon-answer-chill-and-spark-and-boiling"
				}
			]
		},
		{
			"question": "question3.question",
			"swipeable": false,
			"slug": "tap",
			"additionalClass": "",
			"conditions": [
				"water-type && !water-type_opt2"
			],
			"options": [
				{
					"text": "question3.option1.text",
					"image": "ZZH_T30032C01_000_01.jpg",
					"buttonIcon": "icon-answer-existing"
				},
				{
					"text": "question3.option2.text",
					"image": "ZZH_T30325C19_000_01.jpg",
					"buttonIcon": "icon-answer-new-required"
				}
			]
		},
		{
			"question": "question4.question",
			"slug": "main-faucet",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt2"
			],
			"options": [
				{
					"text": "question4.option1.text",
					"image": "BlueHome_Red_NL_Watersys.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question4.option2.text",
					"image": "Red_BlueHome_NL_Watersys.jpg",
					"buttonIcon": ""
				}
			]
		},
		{
			"question": "question5.question",
			"slug": "duo-spout",
			"swipeable": true,
			"conditions": [
				"water-type_opt0 && tap",
				"water-type_opt1 && tap",
				"main-faucet"
			],
			"additionalClass": "",
			"options": [
				{
					"text": "question5.option1.text",
					"image": "ZZH_T31454B09_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"water-type_opt0 && tap_opt0",
						"main-faucet_opt0"
					],
					"images": [
						{
							"image": "ZZH_30325001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option2.text",
					"buttonIcon": "",
					"conditions": [
						"water-type_opt1 && tap_opt1"
					],
					"image": "ZZH_T31456B05_000_01.jpg",
					"images": [
						{
							"image": "ZZH_30144001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				},
				{
					"text": "question5.option3.text",
					"image": "ZZH_T31455B21_000_01.jpg",
					"buttonIcon": "",
					"images": [
						{
							"image": "ZZH_30079001_001_01.jpg",
							"conditions": [
								"main-faucet_opt1",
								"water-type_opt0 && tap_opt1",
								"water-type_opt0 && tap_opt1"
							]
						}
					]
				}
			]
		},
		{
			"question": "question6.question",
			"slug": "finish",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"tap_opt1 && duo-spout",
				"water-type_opt1 && tap_opt0 && duo-spout",
				"main-faucet_opt1 && duo-spout",
				"main-faucet_opt0 && duo-spout_opt2",
				"location_opt0 && main-faucet_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question6.option1.text",
					"image": "q04_colour_a01_chrome.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question6.option2.text",
					"image": "q04_colour_a02_steel.jpg",
					"buttonIcon": "",
					"conditions": [
						"duo-spout_opt1",
						"tap_opt1",
						"main-faucet_opt1",
						"water-type_opt1 && duo-spout_opt2"
					]
				}
			]
		},
		{
			"question": "question7.question",
			"slug": "boiler",
			"swipeable": true,
			"additionalClass": "",
			"conditions": [
				"water-type_opt0 && tap_opt1 && finish",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout && finish",
				"location_opt1 && water-type_opt0 && tap_opt1 && finish",
				"location_opt0 && main-faucet && finish",
				"location_opt1 && main-faucet && !duo-spout_opt0 && finish",
				"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2",
				"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout"
			],
			"options": [
				{
					"text": "question7.option1.text",
					"image": "ZZH_T40830C04_000_01.jpg",
					"buttonIcon": ""
				},
				{
					"text": "question7.option2.text",
					"image": "ZZH_T40831C01_000_01.jpg",
					"buttonIcon": "",
					"conditions": [
						"tap_opt1",
						"main-faucet_opt1",
						"duo-spout_opt2"
					]
				}
			]
		}
	],
	"conditions": []
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shower_questions.json": 293,
	"./water_questions.json": 296
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shower_products_en_gb.json": 292,
	"./water_products_en_gb.json": 295
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(51);

var _reactIntl = __webpack_require__(18);

__webpack_require__(189);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'homepage.buttonStart' });

var _ref2 = _react2.default.createElement(
  'div',
  { className: 'row' },
  _react2.default.createElement(
    'div',
    { className: 'col' },
    _react2.default.createElement(
      'h1',
      { className: 'text-uppercase headline headline--centerOnMD headline--h1' },
      _react2.default.createElement(
        'span',
        { className: 'headline__inner' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'homepage.headline' })
      )
    ),
    _react2.default.createElement(
      'p',
      { className: 'text text--centerOnMD' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'homepage.introtext' })
    )
  )
);

var _ref3 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'homepage.buttonStart' });

var Start = function (_React$Component) {
  _inherits(Start, _React$Component);

  function Start(props) {
    _classCallCheck(this, Start);

    var _this = _possibleConstructorReturn(this, (Start.__proto__ || Object.getPrototypeOf(Start)).call(this, props));

    console.log('props: ', props);

    _this.handleStart = _this.handleStart.bind(_this);
    return _this;
  }

  _createClass(Start, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // eslint-disable-next-line no-undef
      picturefill();
    }
  }, {
    key: 'handleStart',
    value: function handleStart() {
      var trackingPage = _i18n.configuratorType === 'water' ? 'watersystem-configurator/start' : 'showersystem-configurator/start';
      _Tracking2.default.page(trackingPage);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          null,
          _i18n.configuratorType === 'shower' && _react2.default.createElement(
            'picture',
            { className: 'picture picture--keyVisual' },
            _react2.default.createElement('source', { media: '(min-width: 768px)', srcSet: __webpack_require__(914) }),
            _react2.default.createElement('img', { src: __webpack_require__(915), alt: '', className: 'w-100' })
          ),
          _i18n.configuratorType === 'water' && _react2.default.createElement(
            'picture',
            { className: 'picture picture--keyVisual' },
            _react2.default.createElement('source', { media: '(min-width: 768px)', srcSet: __webpack_require__(916) }),
            _react2.default.createElement('img', { src: __webpack_require__(917), alt: '', className: 'w-100' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/lv_lv/watersystems/configurator', onClick: this.handleStart, className: 'btn btn-primary button button--start1' },
            _ref
          )
        ),
        _ref2,
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col text-center' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/lv_lv/watersystems/configurator', onClick: this.handleStart, className: 'btn btn-primary button button--start2' },
              _ref3
            )
          )
        )
      );
    }
  }]);

  return Start;
}(_react2.default.Component);

exports.default = Start;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "start_m_shower.jpg";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "start_s_shower.jpg";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "start_m_water.jpg";

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "start_s_water.jpg";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Configurator = __webpack_require__(919);

var _Configurator2 = _interopRequireDefault(_Configurator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfiguratorPage = function ConfiguratorPage(props) {

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(_Configurator2.default, { reset: props.params.reset })
  );
};

exports.default = ConfiguratorPage;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(68);

__webpack_require__(189);

var _redux = __webpack_require__(85);

var _actions = __webpack_require__(98);

var actions = _interopRequireWildcard(_actions);

var _SelectButtonGroup = __webpack_require__(920);

var _SelectButtonGroup2 = _interopRequireDefault(_SelectButtonGroup);

var _ScrollIndicator = __webpack_require__(932);

var _ScrollIndicator2 = _interopRequireDefault(_ScrollIndicator);

var _SeeResultsButton = __webpack_require__(933);

var _SeeResultsButton2 = _interopRequireDefault(_SeeResultsButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_ScrollIndicator2.default, null);

var _ref2 = _react2.default.createElement(_SeeResultsButton2.default, null);

var Configurator = function (_React$Component) {
  _inherits(Configurator, _React$Component);

  function Configurator(props) {
    _classCallCheck(this, Configurator);

    return _possibleConstructorReturn(this, (Configurator.__proto__ || Object.getPrototypeOf(Configurator)).call(this, props));
  }

  _createClass(Configurator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var saveSelected = this.props.saveSelected;
      // trigger action initially to apply conditions of first question

      saveSelected({ id: undefined });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var resetConfigurator = this.props.resetConfigurator;


      resetConfigurator();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // eslint-disable-next-line no-undef
      picturefill();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          state = _props.state;


      if (!state || !state.questions || !data) {
        return null;
      }

      var questions = state.questions;


      return _react2.default.createElement(
        'div',
        { className: 'configurator' },
        questions.filter(function (question) {
          return question.visible;
        }).map(function (obj, i) {
          return _react2.default.createElement(
            'div',
            { className: 'configurator__question', key: i },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col' },
                _react2.default.createElement(_SelectButtonGroup2.default, { index: i, configData: obj })
              )
            )
          );
        }),
        _ref,
        _ref2
      );
    }
  }]);

  return Configurator;
}(_react2.default.Component);

function mapStateToProps(state) {
  return {
    state: state.configurator,
    data: state.data
  };
}

function mapDispatchToProps(dispatch) {
  return _extends({}, (0, _redux.bindActionCreators)({ resetConfigurator: _actions.resetConfigurator }, dispatch), {
    saveSelected: function saveSelected(payload) {
      return actions.saveSelected(payload)(dispatch);
    }
  });
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Configurator);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _reactRedux = __webpack_require__(68);

var _actions = __webpack_require__(98);

var actions = _interopRequireWildcard(_actions);

var _SelectButton = __webpack_require__(921);

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _Image = __webpack_require__(922);

var _Image2 = _interopRequireDefault(_Image);

var _reactResponsiveCarousel = __webpack_require__(297);

__webpack_require__(191);

var _reactScroll = __webpack_require__(192);

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactResponsive = __webpack_require__(121);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectButtonGroup = function (_React$Component) {
  _inherits(SelectButtonGroup, _React$Component);

  function SelectButtonGroup(props) {
    _classCallCheck(this, SelectButtonGroup);

    var _this = _possibleConstructorReturn(this, (SelectButtonGroup.__proto__ || Object.getPrototypeOf(SelectButtonGroup)).call(this, props));

    _this.handleOptionChange = _this.handleOptionChange.bind(_this);
    _this.handleCarouselChange = _this.handleCarouselChange.bind(_this);

    _this.state = {
      currentSlide: 0
    };

    _this.isMobile = !window.matchMedia("(min-width: 768px)").matches;
    return _this;
  }

  _createClass(SelectButtonGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          index = _props.index,
          slug = _props.configData.slug,
          isScrollIndicatorVisible = _props.isScrollIndicatorVisible,
          setLastQuestionId = _props.setLastQuestionId;


      setLastQuestionId(slug);

      if (index > 0 && !isScrollIndicatorVisible) {
        this.scrollIntoView();
      }
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      var _props2 = this.props,
          slug = _props2.configData.slug,
          isScrollIndicatorVisible = _props2.isScrollIndicatorVisible,
          hideScrollIndicator = _props2.hideScrollIndicator;


      if (this.isMobile && isScrollIndicatorVisible) {
        hideScrollIndicator();
      }
      setTimeout(function () {
        var element = document.querySelector('[name=question_' + slug + ']');
        if (element) {
          _reactScroll.scroller.scrollTo('question_' + slug, {
            smooth: true,
            offset: element.getBoundingClientRect().height - window.innerHeight + 50,
            duration: 900
          });
        }
      }, 500);
    }
  }, {
    key: 'handleOptionChange',
    value: function handleOptionChange(buttonIndex, changeEvent) {
      var _this2 = this;

      var _props3 = this.props,
          configData = _props3.configData,
          showScrollIndicator = _props3.showScrollIndicator,
          saveSelected = _props3.saveSelected;
      var options = configData.options,
          swipeable = configData.swipeable;


      var answer = options[buttonIndex];
      if (answer) {
        _Tracking2.default.event(answer.text, this.props.configData.slug);
      }

      if (swipeable) {
        this.setState({
          currentSlide: buttonIndex
        });
        if (this.isMobile) {
          showScrollIndicator();
        }
      }

      //check if selected product leads to an result
      var _changeEvent$target = changeEvent.target,
          id = _changeEvent$target.id,
          value = _changeEvent$target.value,
          name = _changeEvent$target.name;

      options.map(function (element) {
        if (element.id == id) {
          _this2.setState({
            selectedOption: id
          });
          //selection has a result - push result in store and show results button
          saveSelected({
            group: name,
            id: id
          });
        }
      });
    }
  }, {
    key: 'handleCarouselChange',
    value: function handleCarouselChange(currentSlide) {
      var _props4 = this.props,
          _props4$configData = _props4.configData,
          swipeable = _props4$configData.swipeable,
          options = _props4$configData.options,
          showScrollIndicator = _props4.showScrollIndicator,
          saveSelected = _props4.saveSelected;


      var compareArray = options.filter(function (option) {
        return option.visible;
      }).map(function (compare) {
        return compare.id;
      });

      this.setState({
        selectedOption: compareArray[currentSlide],
        currentSlide: currentSlide
      });

      if (this.isMobile && swipeable) {
        if (this.isMobile) {
          showScrollIndicator();
        }
      }

      var id = options[currentSlide].id;
      if (document.getElementById(id)) {
        var group = document.getElementById(id).name;

        saveSelected({
          group: group,
          id: id
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          configData = _props5.configData,
          index = _props5.index;


      if (configData === undefined) {
        console.warn('data undefined: ', configData); // eslint-disable-line no-console
        return null;
      }

      var currentSlide = this.state.currentSlide;
      var slug = configData.slug,
          question = configData.question,
          value = configData.value,
          swipeable = configData.swipeable,
          additionalClassnames = configData.additionalClass;


      var options = configData.options.filter(function (option) {
        return option.visible;
      });
      // define col width
      var colWidth = 12 / options.length;

      return _react2.default.createElement(
        _reactScroll2.default.Element,
        { name: 'question_' + slug, className: 'element' },
        _react2.default.createElement(
          'div',
          { className: 'question ' + additionalClassnames },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              _react2.default.createElement(
                'h1',
                { className: 'text-uppercase headline headline--centerOnMD headline--h1 headline--question' },
                _react2.default.createElement(
                  'span',
                  { className: 'headline__inner' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: question, defaultMessage: question })
                )
              )
            )
          ),
          swipeable ? _react2.default.createElement(
            'div',
            { className: '' },
            _react2.default.createElement(
              _reactResponsive2.default,
              { maxWidth: 767, className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col' },
                  _react2.default.createElement(
                    _reactResponsiveCarousel.Carousel,
                    {
                      axis: 'horizontal',
                      showThumbs: false,
                      showArrows: true,
                      showStatus: false,
                      showIndicators: true,
                      selectedItem: currentSlide,
                      onChange: this.handleCarouselChange },
                    options.map(function (answer, j) {
                      return _react2.default.createElement(
                        'div',
                        { key: j },
                        answer.image && _react2.default.createElement(_Image2.default, { data: answer, swipeable: swipeable, buttonIndex: j, name: index + 1, id: answer.id, onClick: _this3.handleOptionChange })
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactResponsive2.default,
              { minWidth: 768, className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                options.map(function (answer, j) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 col-md-' + colWidth, key: j },
                    answer.image && _react2.default.createElement(_Image2.default, { data: answer, swipeable: swipeable, buttonIndex: j, name: index + 1, id: answer.id, onClick: _this3.handleOptionChange })
                  );
                })
              )
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'row' },
            options.map(function (answer, j) {
              return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 col-md-' + colWidth, key: j },
                answer.image && _react2.default.createElement(_Image2.default, { data: answer, swipeable: swipeable, buttonIndex: j, name: index + 1, id: answer.id, onClick: _this3.handleOptionChange })
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            options.map(function (answer, j) {
              return _react2.default.createElement(
                'div',
                { className: 'col-sm-12 col-md-' + colWidth, key: j },
                _react2.default.createElement(_SelectButton2.default, {
                  buttonIndex: j,
                  buttonText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: answer.text, defaultMessage: answer.text }),
                  id: answer.id,
                  name: index + 1,
                  icon: answer.buttonIcon,
                  selected: value,
                  onChange: _this3.handleOptionChange })
              );
            })
          )
        )
      );
    }
  }]);

  return SelectButtonGroup;
}(_react2.default.Component);

function mapStateToProps(state) {
  return {
    showResults: state.configurator.showResults,
    isScrollIndicatorVisible: state.configurator.showScrollIndicator
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showScrollIndicator: function showScrollIndicator() {
      return actions.setScrollIndicator(true)(dispatch);
    },
    hideScrollIndicator: function hideScrollIndicator() {
      return actions.setScrollIndicator(false)(dispatch);
    },
    setLastQuestionId: function setLastQuestionId(id) {
      return actions.setLastQuestionId(id)(dispatch);
    },
    saveSelected: function saveSelected(payload) {
      return actions.saveSelected(payload)(dispatch);
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectButtonGroup);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(120);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(190);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectButton = function (_React$Component) {
  _inherits(SelectButton, _React$Component);

  function SelectButton(props) {
    _classCallCheck(this, SelectButton);

    // Enable debugging via 'localStorage.setItem('debug', true)' on the dev tools
    var _this = _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).call(this, props));

    _this.debugEnabled = localStorage.getItem('debug');
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    return _this;
  }

  _createClass(SelectButton, [{
    key: 'handleOnChange',
    value: function handleOnChange(e) {
      var _props = this.props,
          onChange = _props.onChange,
          buttonIndex = _props.buttonIndex;


      onChange(buttonIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          icon = _props2.icon,
          id = _props2.id,
          selected = _props2.selected,
          buttonIndex = _props2.buttonIndex,
          buttonText = _props2.buttonText;


      var hasIcon = !icon || icon.length === 0;
      var classes = (0, _classnames2.default)('btn btn-outline-primary btn-block button button--question', {
        'active button--active': selected === true || id === selected,
        'button--no-icon': hasIcon,
        'button--icon': !hasIcon
      });

      return _react2.default.createElement(
        'div',
        { className: 'button--wrapper', 'data-toggle': 'buttons' },
        _react2.default.createElement(
          'label',
          { className: classes },
          icon && _react2.default.createElement(_Icon2.default, { name: icon }),
          _react2.default.createElement('input', {
            key: buttonIndex,
            type: 'radio',
            name: 'group' + name,
            id: id,
            value: id,
            onChange: this.handleOnChange
          }),
          buttonText,
          this.debugEnabled && _react2.default.createElement(
            'div',
            { className: 'button__debug' },
            id
          )
        )
      );
    }
  }]);

  return SelectButton;
}(_react2.default.Component);

exports.default = SelectButton;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResponsive = __webpack_require__(121);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _classnames = __webpack_require__(120);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_React$PureComponent) {
  _inherits(Image, _React$PureComponent);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.handleOnChange = _this.handleOnChange.bind(_this);
    return _this;
  }

  _createClass(Image, [{
    key: 'handleOnChange',
    value: function handleOnChange(e) {
      var _props = this.props,
          onClick = _props.onClick,
          buttonIndex = _props.buttonIndex;


      onClick(buttonIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          imgData = _props2.data,
          swipeable = _props2.swipeable,
          id = _props2.id,
          name = _props2.name;


      var imgSrc = '/lv_lv/watersystems/assets/images/questions/' + imgData.image;
      var classes = (0, _classnames2.default)('picture picture--question', {
        'picture--swipeable': swipeable
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'picture',
          { className: classes, id: id, name: 'group' + name },
          _react2.default.createElement('source', { srcSet: imgSrc }),
          _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: 767 },
            _react2.default.createElement('img', { src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==', id: id, name: 'group' + name, value: id, onClick: this.handleOnChange, alt: '' })
          ),
          _react2.default.createElement(
            _reactResponsive2.default,
            { minWidth: 768 },
            _react2.default.createElement('img', { src: imgSrc, alt: '', id: id, name: 'group' + name, value: id, onClick: this.handleOnChange })
          )
        )
      );
    }
  }]);

  return Image;
}(_react2.default.PureComponent);

Image.defaultProps = {
  swipeable: false
};

exports.default = Image;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cssClasses = __webpack_require__(298);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _CSSTranslate = __webpack_require__(299);

var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);

var _reactEasySwipe = __webpack_require__(300);

var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);

var _Thumbs = __webpack_require__(301);

var _Thumbs2 = _interopRequireDefault(_Thumbs);

var _customPropTypes = __webpack_require__(926);

var customPropTypes = _interopRequireWildcard(_customPropTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop = function noop() {};

var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
    return current + ' of ' + total;
};

var Carousel = function (_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.autoPlay = function () {
            if (!_this.props.autoPlay) {
                return;
            }

            _this.timer = setTimeout(function () {
                _this.increment();
            }, _this.props.interval);
        };

        _this.clearAutoPlay = function () {
            if (!_this.props.autoPlay) {
                return;
            }

            clearTimeout(_this.timer);
        };

        _this.resetAutoPlay = function () {
            _this.clearAutoPlay();
            _this.autoPlay();
        };

        _this.stopOnHover = function () {
            _this.setState({ isMouseEntered: true });
            _this.clearAutoPlay();
        };

        _this.startOnLeave = function () {
            _this.setState({ isMouseEntered: false });
            _this.autoPlay();
        };

        _this.navigateWithKeyboard = function (e) {
            var axis = _this.props.axis;

            var isHorizontal = axis === 'horizontal';

            var nextKey = isHorizontal ? 'ArrowRight' : 'ArrowDown';
            var prevKey = isHorizontal ? 'ArrowLeft' : 'ArrowUp';

            if (nextKey === e.key) {
                _this.increment();
            } else if (prevKey === e.key) {
                _this.decrement();
            }
        };

        _this.updateSizes = function () {
            if (!_this.state.initialized) {
                return;
            }

            var isHorizontal = _this.props.axis === 'horizontal';
            var firstItem = _this.refs.item0;
            var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

            _this.setState({
                itemSize: itemSize,
                wrapperSize: isHorizontal ? itemSize * _this.props.children.length : itemSize
            });
        };

        _this.setMountState = function () {
            _this.setState({ hasMount: true });
            _this.updateSizes();
        };

        _this.handleClickItem = function (index, item) {
            if (_this.state.cancelClick) {
                _this.setState({
                    cancelClick: false
                });

                return;
            }

            _this.props.onClickItem(index, item);

            if (index !== _this.state.selectedItem) {
                _this.setState({
                    selectedItem: index
                });
            }
        };

        _this.handleOnChange = function (index, item) {
            _this.props.onChange(index, item);
        };

        _this.handleClickThumb = function (index, item) {
            _this.props.onClickThumb(index, item);

            _this.selectItem({
                selectedItem: index
            });
        };

        _this.onSwipeStart = function () {
            _this.setState({
                swiping: true
            });
            _this.clearAutoPlay();
        };

        _this.onSwipeEnd = function () {
            _this.resetPosition();
            _this.setState({
                swiping: false
            });
            _this.autoPlay();
        };

        _this.onSwipeMove = function (delta) {
            var isHorizontal = _this.props.axis === 'horizontal';

            var initialBoundry = 0;

            var currentPosition = -_this.state.selectedItem * 100;
            var finalBoundry = -(_this.props.children.length - 1) * 100;

            var axisDelta = isHorizontal ? delta.x : delta.y;
            var handledDelta = axisDelta;

            // prevent user from swiping left out of boundaries
            if (currentPosition === initialBoundry && axisDelta > 0) {
                handledDelta = 0;
            }

            // prevent user from swiping right out of boundaries
            if (currentPosition === finalBoundry && axisDelta < 0) {
                handledDelta = 0;
            }

            var position = currentPosition + 100 / (_this.state.itemSize / handledDelta) + '%';

            _this.setPosition(position);

            // allows scroll if the swipe was within the tolerance
            var hasMoved = Math.abs(axisDelta) > _this.props.swipeScrollTolerance;

            if (hasMoved && !_this.state.cancelClick) {
                _this.setState({
                    cancelClick: true
                });
            }

            return hasMoved;
        };

        _this.resetPosition = function () {
            var currentPosition = -_this.state.selectedItem * 100 + '%';
            _this.setPosition(currentPosition);
        };

        _this.setPosition = function (position) {
            var list = _reactDom2.default.findDOMNode(_this.refs.itemList);
            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
                list.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
            });
        };

        _this.decrement = function (positions) {
            _this.moveTo(_this.state.selectedItem - (typeof positions === 'Number' ? positions : 1));
        };

        _this.increment = function (positions) {
            _this.moveTo(_this.state.selectedItem + (typeof positions === 'Number' ? positions : 1));
        };

        _this.moveTo = function (position) {
            var lastPosition = _this.props.children.length - 1;

            if (position < 0) {
                position = _this.props.infiniteLoop ? lastPosition : 0;
            }

            if (position > lastPosition) {
                position = _this.props.infiniteLoop ? 0 : lastPosition;
            }

            _this.selectItem({
                // if it's not a slider, we don't need to set position here
                selectedItem: position
            });

            // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
            // and will result in the interval function not being cleared correctly.
            if (_this.props.autoPlay && _this.state.isMouseEntered === false) {
                _this.resetAutoPlay();
            }
        };

        _this.changeItem = function (e) {
            var newIndex = e.target.value;

            _this.selectItem({
                selectedItem: newIndex
            });
        };

        _this.selectItem = function (state) {
            _this.setState(state);
            _this.handleOnChange(state.selectedItem, _this.props.children[state.selectedItem]);
        };

        _this.getInitialImage = function () {
            var selectedItem = _this.props.selectedItem;
            var item = _this.refs['item' + selectedItem];
            var images = item && item.getElementsByTagName('img');
            return images && images[selectedItem];
        };

        _this.getVariableImageHeight = function (position) {
            var item = _this.refs['item' + position];
            var images = item && item.getElementsByTagName('img');
            if (_this.state.hasMount && images.length > 0) {
                var image = images[0];

                if (!image.complete) {
                    // if the image is still loading, the size won't be available so we trigger a new render after it's done
                    var onImageLoad = function onImageLoad() {
                        _this.forceUpdate();
                        image.removeEventListener('load', onImageLoad);
                    };

                    image.addEventListener('load', onImageLoad);
                }

                var height = image.clientHeight;
                return height > 0 ? height : null;
            }

            return null;
        };

        _this.state = {
            initialized: false,
            selectedItem: props.selectedItem,
            hasMount: false,
            isMouseEntered: false
        };
        return _this;
    }

    _createClass(Carousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.children) {
                return;
            }

            this.setupCarousel();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.selectedItem !== this.state.selectedItem) {
                this.updateSizes();
                this.moveTo(nextProps.selectedItem);
            }

            if (nextProps.autoPlay !== this.props.autoPlay) {
                if (nextProps.autoPlay) {
                    this.setupAutoPlay();
                } else {
                    this.destroyAutoPlay();
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.children && this.props.children && !this.state.initialized) {
                this.setupCarousel();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.destroyCarousel();
        }
    }, {
        key: 'setupCarousel',
        value: function setupCarousel() {
            this.bindEvents();

            if (this.props.autoPlay) {
                this.setupAutoPlay();
            }

            this.setState({
                initialized: true
            });

            var initialImage = this.getInitialImage();
            if (initialImage) {
                // if it's a carousel of images, we set the mount state after the first image is loaded
                initialImage.addEventListener('load', this.setMountState);
            } else {
                this.setMountState();
            }
        }
    }, {
        key: 'destroyCarousel',
        value: function destroyCarousel() {
            if (this.state.initialized) {
                this.unbindEvents();
                this.destroyAutoPlay();
            }
        }
    }, {
        key: 'setupAutoPlay',
        value: function setupAutoPlay() {
            this.autoPlay();
            var carouselWrapper = this.refs['carouselWrapper'];

            if (this.props.stopOnHover && carouselWrapper) {
                carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
                carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
            }
        }
    }, {
        key: 'destroyAutoPlay',
        value: function destroyAutoPlay() {
            this.clearAutoPlay();
            var carouselWrapper = this.refs['carouselWrapper'];

            if (this.props.stopOnHover && carouselWrapper) {
                carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
                carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
            }
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            // as the widths are calculated, we need to resize
            // the carousel when the window is resized
            window.addEventListener("resize", this.updateSizes);
            // issue #2 - image loading smaller
            window.addEventListener("DOMContentLoaded", this.updateSizes);

            if (this.props.useKeyboardArrows) {
                document.addEventListener("keydown", this.navigateWithKeyboard);
            }
        }
    }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
            // removing listeners
            window.removeEventListener("resize", this.updateSizes);
            window.removeEventListener("DOMContentLoaded", this.updateSizes);

            var initialImage = this.getInitialImage();
            if (initialImage) {
                initialImage.removeEventListener("load", this.setMountState);
            }

            if (this.props.useKeyboardArrows) {
                document.removeEventListener("keydown", this.navigateWithKeyboard);
            }
        }
    }, {
        key: 'renderItems',
        value: function renderItems() {
            var _this2 = this;

            return _react2.default.Children.map(this.props.children, function (item, index) {
                var hasMount = _this2.state.hasMount;
                var itemClass = _cssClasses2.default.ITEM(true, index === _this2.state.selectedItem);

                return _react2.default.createElement(
                    'li',
                    { ref: "item" + index, key: "itemKey" + index, className: itemClass,
                        onClick: _this2.handleClickItem.bind(_this2, index, item) },
                    item
                );
            });
        }
    }, {
        key: 'renderControls',
        value: function renderControls() {
            var _this3 = this;

            if (!this.props.showIndicators) {
                return null;
            }

            return _react2.default.createElement(
                'ul',
                { className: 'control-dots' },
                _react2.default.Children.map(this.props.children, function (item, index) {
                    return _react2.default.createElement('li', { className: _cssClasses2.default.DOT(index === _this3.state.selectedItem), onClick: _this3.changeItem, value: index, key: index });
                })
            );
        }
    }, {
        key: 'renderStatus',
        value: function renderStatus() {
            if (!this.props.showStatus) {
                return null;
            }

            return _react2.default.createElement(
                'p',
                { className: 'carousel-status' },
                this.props.statusFormatter(this.state.selectedItem + 1, this.props.children.length)
            );
        }
    }, {
        key: 'renderThumbs',
        value: function renderThumbs() {
            if (!this.props.showThumbs || this.props.children.length === 0) {
                return null;
            }

            return _react2.default.createElement(
                _Thumbs2.default,
                { onSelectItem: this.handleClickThumb, selectedItem: this.state.selectedItem, transitionTime: this.props.transitionTime },
                this.props.children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.children || this.props.children.length === 0) {
                return null;
            }

            var itemsLength = this.props.children.length;

            var isHorizontal = this.props.axis === 'horizontal';

            var canShowArrows = this.props.showArrows && itemsLength > 1;

            // show left arrow?
            var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop);
            // show right arrow
            var hasNext = canShowArrows && (this.state.selectedItem < itemsLength - 1 || this.props.infiniteLoop);
            // obj to hold the transformations and styles
            var itemListStyles = {};

            var currentPosition = -this.state.selectedItem * 100 + '%';
            // if 3d is available, let's take advantage of the performance of transform
            var transformProp = (0, _CSSTranslate2.default)(currentPosition, this.props.axis);

            var transitionTime = this.props.transitionTime + 'ms';

            itemListStyles = {
                'WebkitTransform': transformProp,
                'MozTransform': transformProp,
                'MsTransform': transformProp,
                'OTransform': transformProp,
                'transform': transformProp,
                'msTransform': transformProp
            };

            if (!this.state.swiping) {
                itemListStyles = _extends({}, itemListStyles, {
                    'WebkitTransitionDuration': transitionTime,
                    'MozTransitionDuration': transitionTime,
                    'MsTransitionDuration': transitionTime,
                    'OTransitionDuration': transitionTime,
                    'transitionDuration': transitionTime,
                    'msTransitionDuration': transitionTime
                });
            }

            var swiperProps = {
                selectedItem: this.state.selectedItem,
                className: _cssClasses2.default.SLIDER(true, this.state.swiping),
                onSwipeMove: this.onSwipeMove,
                onSwipeStart: this.onSwipeStart,
                onSwipeEnd: this.onSwipeEnd,
                style: itemListStyles,
                tolerance: this.props.swipeScrollTolerance,
                ref: 'itemList'
            };

            var containerStyles = {};

            if (isHorizontal) {
                swiperProps.onSwipeLeft = this.increment;
                swiperProps.onSwipeRight = this.decrement;

                if (this.props.dynamicHeight) {
                    var itemHeight = this.getVariableImageHeight(this.state.selectedItem);
                    swiperProps.style.height = itemHeight || 'auto';
                    containerStyles.height = itemHeight || 'auto';
                }
            } else {
                swiperProps.onSwipeUp = this.decrement;
                swiperProps.onSwipeDown = this.increment;
                swiperProps.style.height = this.state.itemSize;
                containerStyles.height = this.state.itemSize;
            }

            return _react2.default.createElement(
                'div',
                { className: this.props.className, ref: 'carouselWrapper' },
                _react2.default.createElement(
                    'div',
                    { className: _cssClasses2.default.CAROUSEL(true), style: { width: this.props.width } },
                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.decrement }),
                    _react2.default.createElement(
                        'div',
                        { className: _cssClasses2.default.WRAPPER(true, this.props.axis), style: containerStyles, ref: 'itemsWrapper' },
                        _react2.default.createElement(
                            _reactEasySwipe2.default,
                            _extends({ tagName: 'ul' }, swiperProps, { allowMouseEvents: this.props.emulateTouch }),
                            this.renderItems()
                        )
                    ),
                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.increment }),
                    this.renderControls(),
                    this.renderStatus()
                ),
                this.renderThumbs()
            );
        }
    }]);

    return Carousel;
}(_react.Component);

Carousel.displayName = 'Carousel';
Carousel.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    showArrows: _propTypes2.default.bool,
    showStatus: _propTypes2.default.bool,
    showIndicators: _propTypes2.default.bool,
    infiniteLoop: _propTypes2.default.bool,
    showThumbs: _propTypes2.default.bool,
    selectedItem: _propTypes2.default.number,
    onClickItem: _propTypes2.default.func.isRequired,
    onClickThumb: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    axis: _propTypes2.default.oneOf(['horizontal', 'vertical']),
    width: customPropTypes.unit,
    useKeyboardArrows: _propTypes2.default.bool,
    autoPlay: _propTypes2.default.bool,
    stopOnHover: _propTypes2.default.bool,
    interval: _propTypes2.default.number,
    transitionTime: _propTypes2.default.number,
    swipeScrollTolerance: _propTypes2.default.number,
    dynamicHeight: _propTypes2.default.bool,
    emulateTouch: _propTypes2.default.bool,
    statusFormatter: _propTypes2.default.func.isRequired
};
Carousel.defaultProps = {
    showIndicators: true,
    showArrows: true,
    showStatus: true,
    showThumbs: true,
    infiniteLoop: false,
    selectedItem: 0,
    axis: 'horizontal',
    width: '100%',
    useKeyboardArrows: false,
    autoPlay: false,
    stopOnHover: true,
    interval: 3000,
    transitionTime: 350,
    swipeScrollTolerance: 5,
    dynamicHeight: false,
    emulateTouch: false,
    onClickItem: noop,
    onClickThumb: noop,
    onChange: noop,
    statusFormatter: defaultStatusFormatter
};
exports.default = Carousel;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.reactSwipe = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener("test", null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {}

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          this.props.tagName,
          {
            ref: function ref(node) {
              return _this2.swiper = node;
            },
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: this.props.className,
            style: this.props.style
          },
          this.props.children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var outerWidth = exports.outerWidth = function outerWidth(el) {
	var width = el.offsetWidth;
	var style = getComputedStyle(el);

	width += parseInt(style.marginLeft) + parseInt(style.marginRight);
	return width;
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var unit = exports.unit = function unit(props, propName, componentName) {
    if (!/(pt|px|em|rem|vw|vh|%)$/.test(props[propName])) {
        return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed. It needs to be a size unit like pt, px, em, rem, vw, %');
    }
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var Helpers = __webpack_require__(122);

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'a',
        this.props,
        this.props.children
      );
    }
  }]);

  return Link;
}(React.Component);

;

module.exports = Helpers.Scroll(Link);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addPassiveEventListener = __webpack_require__(302);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

module.exports = {
	register: function register(cancelEvent) {
		if (typeof document === 'undefined') {
			return;
		}

		for (var i = 0; i < events.length; i = i + 1) {
			addPassiveEventListener(document, events[i], cancelEvent);
		}
	}
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var Helpers = __webpack_require__(122);

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return Button;
}(React.Component);

;

module.exports = Helpers.Scroll(Button);

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var Helpers = __webpack_require__(122);

var Element = function (_React$Component) {
  _inherits(Element, _React$Component);

  function Element() {
    _classCallCheck(this, Element);

    return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).apply(this, arguments));
  }

  _createClass(Element, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return React.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return Element;
}(React.Component);

;

module.exports = Helpers.Element(Element);

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(68);

var _reactScroll = __webpack_require__(192);

var _classnames = __webpack_require__(120);

var _classnames2 = _interopRequireDefault(_classnames);

var _actions = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', width: '72', height: '26', viewBox: '0 0 72 26' },
  _react2.default.createElement('path', { fill: '#5C9ACA', fillRule: 'evenodd', d: 'M224,632 L188,658 L152,632 L224,632 Z M221,632 L155,632 L188,656 L221,632 Z', transform: 'translate(-152 -632)' })
);

var ScrollIndicator = function (_React$Component) {
  _inherits(ScrollIndicator, _React$Component);

  function ScrollIndicator(props) {
    _classCallCheck(this, ScrollIndicator);

    var _this = _possibleConstructorReturn(this, (ScrollIndicator.__proto__ || Object.getPrototypeOf(ScrollIndicator)).call(this, props));

    _this.state = {
      fadeOut: false
    };

    _this.fadeOutTimer = null;
    _this.resetTimer = null;

    _this.handleOnClick = _this.handleOnClick.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(ScrollIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isVisible = nextProps.isVisible;


      if (isVisible) {
        this.fadeOut();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'fadeOut',
    value: function fadeOut() {
      var _this2 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
      var hideScrollIndicator = this.props.hideScrollIndicator;


      if (this.fadeOutTimer) {
        window.clearTimeout(this.fadeOutTimer);
      }

      if (this.resetTimer) {
        window.clearTimeout(this.resetTimer);
      }

      // Fade indicator out after $delay seconds
      this.fadeOutTimer = window.setTimeout(function () {
        return _this2.setState({ fadeOut: true });
      }, delay);
      // After fade out animation of 0.5s reset component state
      this.resetTimer = window.setTimeout(function () {
        _this2.setState({ fadeOut: false });
        hideScrollIndicator();
      }, delay + 500);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var isVisible = this.props.isVisible;


      if (isVisible) {
        this.fadeOut(0);
      }
    }
  }, {
    key: 'handleOnClick',
    value: function handleOnClick(e) {
      var _props = this.props,
          lastQuestionId = _props.lastQuestionId,
          isResultsButtonVisible = _props.isResultsButtonVisible,
          hideScrollIndicator = _props.hideScrollIndicator;


      e.preventDefault();
      e.stopPropagation();

      var scrollElementName = null;

      if (isResultsButtonVisible) {
        scrollElementName = 'resultButton';
      } else {
        scrollElementName = 'question_' + lastQuestionId;
      }

      _reactScroll.scroller.scrollTo(scrollElementName, {
        smooth: 'easeInQuad',
        duration: 1000,
        delay: 550
      });

      hideScrollIndicator();
    }
  }, {
    key: 'render',
    value: function render() {
      var isVisible = this.props.isVisible;
      var fadeOut = this.state.fadeOut;


      if (!isVisible) {
        return null;
      }

      var classes = (0, _classnames2.default)('scrollIndicator', {
        'scrollIndicator--hidden': fadeOut
      });

      return _react2.default.createElement(
        'a',
        { href: '#', className: classes, onClick: this.handleOnClick },
        _ref
      );
    }
  }]);

  return ScrollIndicator;
}(_react2.default.Component);

function mapStateToProps(state) {
  return {
    isVisible: state.configurator.showScrollIndicator,
    lastQuestionId: state.configurator.lastQuestionId,
    isResultsButtonVisible: state.configurator.showResults
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideScrollIndicator: function hideScrollIndicator() {
      return (0, _actions.setScrollIndicator)(false)(dispatch);
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScrollIndicator);

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(68);

var _reactRouter = __webpack_require__(51);

var _reactScroll = __webpack_require__(192);

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactIntl = __webpack_require__(18);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'configurator.button.seeResults' });

var SeeResultsButton = function (_React$Component) {
  _inherits(SeeResultsButton, _React$Component);

  function SeeResultsButton(props) {
    _classCallCheck(this, SeeResultsButton);

    var _this = _possibleConstructorReturn(this, (SeeResultsButton.__proto__ || Object.getPrototypeOf(SeeResultsButton)).call(this, props));

    _this.handleOnClick = _this.handleOnClick.bind(_this);
    return _this;
  }

  _createClass(SeeResultsButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isVisible = _props.isVisible,
          isScrollIndicatorVisible = _props.isScrollIndicatorVisible;


      if (isVisible && !isScrollIndicatorVisible) {
        this.scrollIntoView();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isVisible = nextProps.isVisible,
          isScrollIndicatorVisible = nextProps.isScrollIndicatorVisible;


      if (isVisible && !isScrollIndicatorVisible) {
        this.scrollIntoView();
      }
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      setTimeout(function () {
        var element = document.querySelector('[name=resultButton]');
        if (element) {
          _reactScroll.scroller.scrollTo('resultButton', {
            smooth: true,
            offset: element.getBoundingClientRect().height - window.innerHeight + 50,
            duration: 900
          });
        }
      }, 500);
    }
  }, {
    key: 'handleOnClick',
    value: function handleOnClick() {
      _Tracking2.default.page('showersystem-configurator/finish');
    }
  }, {
    key: 'render',
    value: function render() {
      var isVisible = this.props.isVisible;


      return _react2.default.createElement(
        _reactScroll2.default.Element,
        { name: 'resultButton' },
        isVisible && _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col text-center' },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: '/lv_lv/watersystems/result',
                onClick: this.handleOnClick,
                className: 'btn btn-primary button button--showResultPage'
              },
              _ref
            )
          )
        )
      );
    }
  }]);

  return SeeResultsButton;
}(_react2.default.Component);

SeeResultsButton.defaultProps = {
  isVisible: false,
  isScrollIndicatorVisible: false
};

function mapStateToProps(state) {
  return {
    isVisible: state.configurator.showResults,
    isScrollIndicatorVisible: state.configurator.showScrollIndicator
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SeeResultsButton);

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Result = __webpack_require__(935);

var _Result2 = _interopRequireDefault(_Result);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(_Result2.default, null);

var ResultPage = function ResultPage() {
  return _ref;
};

exports.default = ResultPage;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(68);

var _redux = __webpack_require__(85);

var _reactRouter = __webpack_require__(51);

var _ProductGroup = __webpack_require__(936);

var _ProductGroup2 = _interopRequireDefault(_ProductGroup);

var _ProductGroupsMobile = __webpack_require__(953);

var _ProductGroupsMobile2 = _interopRequireDefault(_ProductGroupsMobile);

var _ProductTile = __webpack_require__(955);

var _ProductTile2 = _interopRequireDefault(_ProductTile);

var _ProductTileWater = __webpack_require__(956);

var _ProductTileWater2 = _interopRequireDefault(_ProductTileWater);

var _reactResponsive = __webpack_require__(121);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _reactResponsiveCarousel = __webpack_require__(297);

var _actions = __webpack_require__(98);

var _find = __webpack_require__(957);

var _find2 = _interopRequireDefault(_find);

__webpack_require__(191);

var _fetchJsonp = __webpack_require__(309);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

__webpack_require__(189);

var _qwest = __webpack_require__(1037);

var qwest = _interopRequireWildcard(_qwest);

var _i18n = __webpack_require__(34);

var _reactIntl = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

console.log('configuratorType result: ', _i18n.configuratorType);
var imageSKUMap = {
  "27744000": "27743000",
  "27748000": "27745000",
  "27732000": "27731000",
  "27334000": "27733000",
  "27704000": "27653000",
  "27746000": "27745000",
  "26062000": "26052000",
  "26063000": "26053000",
  "26064000": "26054000",
  "26065000": "26055000",
  "26066000": "26056000",
  "26070000": "26060000",
  "26071000": "26061000",
  "27734000": "27733000",
  "27736000": "27735000",
  "27738000": "27737000",
  "27750000": "27749000",
  "27265000": "27224000"
};

var _ref = _react2.default.createElement(
  'div',
  { className: 'separator' },
  _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col' },
        _react2.default.createElement(
          'h1',
          { className: 'text-uppercase headline headline--centerOnMD headline--h1 headline--result' },
          _react2.default.createElement(
            'span',
            { className: 'headline__inner' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.bundle.title' })
          )
        )
      )
    )
  )
);

var _ref2 = _react2.default.createElement(
  'div',
  { className: 'col-sm-12 col-md-6' },
  _react2.default.createElement(
    'h2',
    { className: 'headline headline--h2' },
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.newConfiguration.title' })
  )
);

var _ref3 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.newConfiguration.buttonText' });

var Result = function (_React$Component) {
  _inherits(Result, _React$Component);

  function Result() {
    _classCallCheck(this, Result);

    var _this = _possibleConstructorReturn(this, (Result.__proto__ || Object.getPrototypeOf(Result)).call(this));

    _this.state = {
      currentSlide: 0,
      productGroups: {},
      bundle: [],
      showModal: false
    };
    return _this;
  }

  _createClass(Result, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          results = _props.results,
          products = _props.products;


      if (!results.length > 0) {
        _reactRouter.browserHistory.push('/lv_lv/watersystems/configurator');
        return false;
      }

      // eslint-disable-next-line no-undef
      picturefill();

      if (products) {
        this.initState(results, products);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var results = nextProps.results,
          products = nextProps.products;


      this.initState(results, products);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // eslint-disable-next-line no-undef
      picturefill();
    }
  }, {
    key: 'initState',
    value: function initState(results, products) {
      var _this2 = this;

      if (products.length > 0 && results.length > 0) {
        var productGroups = results[0].map(function (group) {
          return {
            bundle: group.bundle.map(function (id) {
              return (0, _find2.default)(products, { id: id });
            }).filter(function (product) {
              return product !== undefined;
            }).map(_this2.addImages),
            products: group.products.map(function (id) {
              return (0, _find2.default)(products, { id: id });
            }).filter(function (product) {
              return product !== undefined;
            }).map(_this2.addImages)
          };
        });

        this.setState({
          productGroups: productGroups,
          bundle: productGroups[this.state.currentSlide] ? productGroups[this.state.currentSlide].bundle : []
        });
      }
    }
  }, {
    key: 'addImages',
    value: function addImages(product) {
      var imageCode = imageSKUMap[product.id] ? imageSKUMap[product.id] : product.id;
      if (imageSKUMap[product.id]) {
        console.log('mapped', product.id, 'to', imageCode); // eslint-disable-line no-console
      }
      var images = {
        image: '//cdn.cloud.grohe.com/prod/' + imageCode.substr(0, 1) + '0/' + imageCode.substr(0, 2) + '/' + imageCode + '/640/' + imageCode + '.jpg',
        imageMedium: '//cdn.cloud.grohe.com/prod/' + imageCode.substr(0, 1) + '0/' + imageCode.substr(0, 2) + '/' + imageCode + '/480/' + imageCode + '.jpg',
        imageSmall: '//cdn.cloud.grohe.com/prod/' + imageCode.substr(0, 1) + '0/' + imageCode.substr(0, 2) + '/' + imageCode + '/320/' + imageCode + '.jpg'
      };
      return Object.assign({}, product, images);
    }
  }, {
    key: 'onChangeSlide',
    value: function onChangeSlide(i) {
      this.setState({
        currentSlide: i,
        bundle: this.state.productGroups[i].bundle
      });
    }
  }, {
    key: 'downloadPDF',
    value: function downloadPDF() {
      var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['26053000'];


      _Tracking2.default.event(products.join('|'), 'prepare download', 'notepad');
      var url = 'https://application.grohe.com/gateway/specification/' + _i18n.localeFormatted + '/';
      qwest.post(url, {
        catalogue: {
          input: {
            timestamp: Date.now() / 1000 | 0
          },
          products: products
        }
      }, {
        cache: true,
        headers: {
          "Accept": "application/json"
        }
      }).then(function (xhr, response) {
        var json = JSON.parse(unescape(response));
        if (json.file) {
          var interval = setInterval(function () {
            (0, _fetchJsonp2.default)('https://specification.grohe.com/check/?callback=jQuery17105124361561611295_1416404594521&file=' + encodeURIComponent(json.file), {
              jsonpCallbackFunction: 'jQuery17105124361561611295_1416404594521'
            }).then(function (response) {
              return response.json();
            }).then(function (responseJSON) {
              if (responseJSON.status === 'file-ready') {
                clearInterval(interval);
                window.location = 'https://specification.grohe.com/delivery/?file=' + json.file;
              }
            }).catch(function () {
              clearInterval(interval);
            });
          }, 500);
        }
      }).catch(function (e, xhr, response) {
        console.log(e, xhr, response); // eslint-disable-line no-console
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state) {
        return null;
      }

      var _state = this.state,
          bundle = _state.bundle,
          productGroups = _state.productGroups;
      // TODO Only used once, never changed. Make const instead.
      // But ProductGroupsMobile doesn't use index prop. So maybe obsolete.

      var tmpi = 0;

      // check if swiper indicators needs to be shown
      var showResultIndicators = productGroups.length > 1 ? true : false;

      return _react2.default.createElement(
        'div',
        { className: 'result' },
        productGroups.length > 0 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col' },
                _react2.default.createElement(
                  'h1',
                  { className: 'text-uppercase headline headline--centerOnMD headline--h1 headline--result' },
                  _react2.default.createElement(
                    'span',
                    { className: 'headline__inner' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.title', values: { productGroupsCount: productGroups.length } })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: 767 },
            _react2.default.createElement(_ProductGroupsMobile2.default, { index: tmpi, data: productGroups, onClickDownload: this.downloadPDF })
          ),
          _react2.default.createElement(
            _reactResponsive2.default,
            { minWidth: 768 },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                _reactResponsiveCarousel.Carousel,
                {
                  axis: 'horizontal',
                  showThumbs: false,
                  showArrows: true,
                  showStatus: false,
                  showIndicators: showResultIndicators,
                  selectedItem: this.state.currentSlide,
                  onChange: function onChange(i) {
                    return _this3.onChangeSlide(i);
                  }
                },
                productGroups.map(function (productGroup, i) {
                  return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_ProductGroup2.default, { index: i, data: productGroup, productGroupsLength: productGroups.length, onClickDownload: _this3.downloadPDF })
                  );
                })
              )
            )
          )
        ),
        bundle.length > 0 && _react2.default.createElement(
          _reactResponsive2.default,
          { minWidth: 768 },
          _ref,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _i18n.configuratorType === 'shower' && _react2.default.createElement(
              'div',
              { className: 'row' },
              bundle.map(function (product, i) {
                return _react2.default.createElement(
                  'div',
                  { key: i, className: 'col-md-3' },
                  _react2.default.createElement(_ProductTile2.default, { data: product })
                );
              })
            ),
            _i18n.configuratorType === 'water' && _react2.default.createElement(
              'div',
              null,
              bundle.map(function (product, i) {
                return _react2.default.createElement(
                  'div',
                  { key: i },
                  _react2.default.createElement(_ProductTileWater2.default, { data: product })
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container result-reset' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _ref2,
            _react2.default.createElement(
              'div',
              { className: 'col-sm-12 col-md-5' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/lv_lv/watersystems/configurator', onClick: function onClick() {
                    return _Tracking2.default.event('', 'restart');
                  }, className: 'btn btn-block btn-primary button button--result' },
                _ref3
              )
            )
          )
        )
      );
    }
  }]);

  return Result;
}(_react2.default.Component);

function mapStateToProps(state) {
  return {
    results: state.configurator.results,
    products: state.data.products
  };
}

var actions = { saveSelected: _actions.saveSelected, getSelected: _actions.getSelected, restartConfigurator: _actions.restartConfigurator };
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(actions, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Result);

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _Flap = __webpack_require__(305);

var _Flap2 = _interopRequireDefault(_Flap);

var _Product = __webpack_require__(306);

var _Product2 = _interopRequireDefault(_Product);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement('div', { className: 'col-md-6' });

var _ref2 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.proposal.title.single' });

var _ref3 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.button.downloadPDF' });

var ProductGroup = function (_React$Component) {
  _inherits(ProductGroup, _React$Component);

  function ProductGroup(props) {
    _classCallCheck(this, ProductGroup);

    var _this = _possibleConstructorReturn(this, (ProductGroup.__proto__ || Object.getPrototypeOf(ProductGroup)).call(this, props));

    _this.state = {
      products: []
    };
    return _this;
  }

  _createClass(ProductGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = this.props.data;


      if (data) {
        this.initState(data);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data;

      // TODO this only compares object equality, but not a deep comparison of nested values

      if (data !== this.props.data) {
        // TODO Is here the data param missing by mistake?
        this.initState(data);
      }
    }
  }, {
    key: 'chooseProduct',
    value: function chooseProduct(currentProduct) {
      this.setState({
        products: this.state.products.map(function (product) {
          return product.id == currentProduct.id ? _extends({}, product, { open: true }) : _extends({}, product, {
            open: false
          });
        })
      });
    }
  }, {
    key: 'initState',
    value: function initState(data) {
      this.setState({ products: data.products.map(function (product, i) {
          return _extends({}, product, { open: i === 0 });
        }) });
    }
  }, {
    key: 'onClickDownload',
    value: function onClickDownload() {
      var onClickDownload = this.props.onClickDownload;


      if (typeof onClickDownload === 'function') {
        onClickDownload([].concat(_toConsumableArray(this.props.data.products.map(function (p) {
          return p.id;
        })), _toConsumableArray(this.props.data.bundle.map(function (p) {
          return p.id;
        }))));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var index = this.props.index;
      var productGroupsLength = this.props.productGroupsLength;
      var products = this.state.products;


      if (!products || products.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'product' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _ref,
          _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
              'h2',
              { className: 'headline headline--h2 text-uppercase' },
              productGroupsLength > 1 && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.proposal.title', values: { number: index + 1 } }),
              productGroupsLength <= 1 && _ref2
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'product-image' },
              products.filter(function (p) {
                return p.open;
              }).map(function (product, i) {
                return _react2.default.createElement(
                  'span',
                  { key: i, className: 'picture picture--result' },
                  _react2.default.createElement('img', { src: product.imageMedium, alt: '' })
                );
              })
            ),
            products.length > 1 && _react2.default.createElement(
              'div',
              { className: 'product-nav' },
              products.map(function (product, i) {
                return _react2.default.createElement(
                  'button',
                  { key: i, className: product.open ? 'product-nav__item product-nav__item--selected' : 'product-nav__item', onClick: function onClick() {
                      return _this2.chooseProduct(product);
                    } },
                  _react2.default.createElement(
                    'div',
                    { className: 'product-nav__item-inner' },
                    _react2.default.createElement('span', { className: 'product-nav__img', style: { backgroundImage: 'url(' + product.imageSmall + ')' } })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-5' },
            _react2.default.createElement(
              'div',
              { className: 'flap-group' },
              products.map(function (product, i) {
                return _react2.default.createElement(
                  _Flap2.default,
                  { key: i, index: i, headline: product.headline, open: product.open, onChange: function onChange() {
                      return _this2.chooseProduct(product);
                    } },
                  _react2.default.createElement(_Product2.default, { data: product })
                );
              })
            ),
            _i18n.configuratorType === 'shower' && _react2.default.createElement(
              'a',
              { className: 'btn btn-block btn-primary button button--result ', href: 'javascript:void(0);', onClick: function onClick() {
                  return _this2.onClickDownload();
                } },
              _ref3
            )
          )
        )
      );
    }
  }]);

  return ProductGroup;
}(_react2.default.Component);

exports.default = ProductGroup;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _reactDynamicModal = __webpack_require__(307);

var _fetchJsonp = __webpack_require__(309);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _Icon = __webpack_require__(190);

var _Icon2 = _interopRequireDefault(_Icon);

var _HatchModal = __webpack_require__(951);

var _HatchModal2 = _interopRequireDefault(_HatchModal);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _hatchConfig = __webpack_require__(952);

var _hatchConfig2 = _interopRequireDefault(_hatchConfig);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_Icon2.default, { name: 'icon-result-button-online-shop' });

var _ref2 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.button.buyNow' });

var HatchBuyButton = function (_React$PureComponent) {
  _inherits(HatchBuyButton, _React$PureComponent);

  function HatchBuyButton(props) {
    _classCallCheck(this, HatchBuyButton);

    var _this = _possibleConstructorReturn(this, (HatchBuyButton.__proto__ || Object.getPrototypeOf(HatchBuyButton)).call(this, props));

    _this.state = {
      visible: false,
      retailers: []
    };

    _this.openModal = _this.openModal.bind(_this);
    return _this;
  }

  _createClass(HatchBuyButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (_hatchConfig.HATCH_ENABLED && (_i18n.localeFormatted === 'nl_NL' || _i18n.localeFormatted === 'da_DK')) {

        var hatchConfig_cid = _i18n.configuratorType === 'water' ? _hatchConfig2.default.cid_water : _hatchConfig2.default.cid_shower;

        var data = this.props.data;


        var apiRequest = _hatchConfig2.default.baseUrl + '/' + _hatchConfig2.default.apiKey + '/json?region=' + _hatchConfig2.default.region + '&mpn=' + data.id + '&CID=' + hatchConfig_cid + '&direct=bypass&sort=group_name';

        (0, _fetchJsonp2.default)(apiRequest).then(function (response) {
          return response.json();
        }).then(function (json) {
          _this2.setState({
            visible: true,
            retailers: json.iceleads_interface.retailers.retailer
          });
        }).catch(function (ex) {
          console.log('parsing failed', ex); // eslint-disable-line no-console
        });
      }
    }
  }, {
    key: 'openModal',
    value: function openModal(event) {
      var data = this.props.data;
      var retailers = this.state.retailers;


      _Tracking2.default.event(data.headline, 'buy-now');

      event.stopPropagation();
      event.preventDefault();

      _reactDynamicModal.ModalManager.open(_react2.default.createElement(_HatchModal2.default, { retailers: retailers, onRequestClose: function onRequestClose() {
          return true;
        } }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          additionalClass = _props.additionalClass;
      var visible = this.state.visible;


      if (!visible || !_hatchConfig.HATCH_ENABLED) {
        return null;
      }

      var classNames = 'btn btn-block btn-primary button button--result ' + additionalClass;

      var ComponentName = tag;

      return _react2.default.createElement(
        ComponentName,
        {
          target: '_blank',
          onClick: this.openModal,
          className: classNames,
          href: '#'
        },
        _ref,
        _ref2
      );
    }
  }]);

  return HatchBuyButton;
}(_react2.default.PureComponent);

HatchBuyButton.defaultProps = {
  tag: 'a',
  additionalClass: ''
};

exports.default = HatchBuyButton;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.ModalManager = exports.Modal = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__(939);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prefix = __webpack_require__(949);

var defaultStyles = {
   overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflow: 'hidden',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
   },

   content: {
      position: 'relative',
      margin: '15% auto',
      width: '60%',
      border: '1px solid rgba(0, 0, 0, .2)',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)'
   }
};

var defaultTransition = {
   property: 'all',
   duration: 300,
   timingfunction: 'linear'
};

var stopPropagation = function stopPropagation(e) {
   return e.stopPropagation();
};

var onClose = void 0;

var Modal = exports.Modal = function (_Component) {
   _inherits(Modal, _Component);

   function Modal(props) {
      _classCallCheck(this, Modal);

      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Modal).call(this, props));

      _this.state = {
         open: false
      };
      return _this;
   }

   _createClass(Modal, [{
      key: 'close',
      value: function close() {
         if (!this.props.onRequestClose || this.props.onRequestClose()) {
            ModalManager.close();
         }
      }
   }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
         if (event.keyCode == 27 /*esc*/) this.close();
      }
   }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
         var _this2 = this;

         var transitionTimeMS = this.getTransitionDuration();
         setTimeout(function () {
            return _this2.setState({ open: true });
         }, 0);
         onClose = function onClose(callback) {
            _this2.setState({ open: false }, function () {
               _this2.closeTimer = setTimeout(callback, transitionTimeMS);
            });
         };
      }
   }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
         onClose = null;
         clearTimeout(this.closeTimer);
      }
   }, {
      key: 'getTransitionDuration',
      value: function getTransitionDuration() {
         var effect = this.props.effect;

         if (!effect.transition) {
            return defaultTransition.duration;
         }
         return effect.transition.duration || defaultTransition.duration;
      }
   }, {
      key: 'render',
      value: function render() {
         var _props = this.props;
         var style = _props.style;
         var effect = _props.effect;
         var open = this.state.open;


         var transition = effect.transition;
         if (!transition) {
            transition = defaultTransition;
         } else {
            transition = (0, _lodash2.default)({}, defaultTransition, transition);
         }
         var transition_style = {
            'transition': transition.property + ' ' + transition.duration / 1000 + 's' + ' ' + transition.timingfunction
         };

         return _react2.default.createElement(
            'div',
            {
               ref: 'overlay',
               style: prefix((0, _lodash2.default)({}, defaultStyles.overlay, style ? style.overlay ? style.overlay : {} : {}, { transition: 'opacity ' + transition.duration / 1000 + 's' + ' linear', opacity: open ? 1 : 0 })),
               onClick: this.close.bind(this) },
            _react2.default.createElement(
               'div',
               {
                  ref: 'content',
                  style: prefix((0, _lodash2.default)({}, defaultStyles.content, style ? style.content ? style.content : {} : {}, transition_style, open ? effect.end : effect.begin)),
                  onClick: stopPropagation,
                  onKeyDown: this.handleKeyDown.bind(this) },
               this.props.children
            )
         );
      }
   }]);

   return Modal;
}(_react.Component);

var node;
var modals = [];

var renderModal = function renderModal() {
   if (modals.length == 0) return;

   var component = modals.shift();
   if (!node) {
      node = document.createElement('div');
      document.body.appendChild(node);
   }
   _reactDom2.default.render(component, node);
};

var ModalManager = exports.ModalManager = {
   open: function open(component) {
      modals.push(component);
      if (modals.length == 1) {
         // render the modal only if there is no other showing modals
         renderModal();
      }
   },
   close: function close() {
      onClose && onClose(function () {
         _reactDom2.default.unmountComponentAtNode(node);
         renderModal(); // render the other modals which are waiting.
      });
   }
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseAssign = __webpack_require__(940),
    createAssigner = __webpack_require__(945),
    keys = __webpack_require__(308);

/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */
function assignWith(object, source, customizer) {
  var index = -1,
      props = keys(source),
      length = props.length;

  while (++index < length) {
    var key = props[index],
        value = object[key],
        result = customizer(value, source[key], key, object, source);

    if ((result === result ? (result !== value) : (value === value)) ||
        (value === undefined && !(key in object))) {
      object[key] = result;
    }
  }
  return object;
}

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it is invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var assign = createAssigner(function(object, source, customizer) {
  return customizer
    ? assignWith(object, source, customizer)
    : baseAssign(object, source);
});

module.exports = assign;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCopy = __webpack_require__(941),
    keys = __webpack_require__(308);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 941 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var bindCallback = __webpack_require__(946),
    isIterateeCall = __webpack_require__(947),
    restParam = __webpack_require__(948);

/**
 * Creates a function that assigns properties of source object(s) to a given
 * destination object.
 *
 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 947 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isIterateeCall;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var el;

if(!!global.document){
  el = global.document.createElement('div');
}

var prefixes = ["ms", "Moz", "Webkit", "O"];
var properties = [
  'userSelect',
  'transform',
  'transition',
  'transformOrigin',
  'transformStyle',
  'transitionProperty',
  'transitionDuration',
  'transitionTimingFunction',
  'transitionDelay',
  'borderImage',
  'borderImageSlice',
  'boxShadow',
  'backgroundClip',
  'backfaceVisibility',
  'perspective',
  'perspectiveOrigin',
  'animation',
  'animationDuration',
  'animationName',
  'animationDelay',
  'animationDirection',
  'animationIterationCount',
  'animationTimingFunction',
  'animationPlayState',
  'animationFillMode',
  'appearance'
];

function GetVendorPrefix(property) {
  if(properties.indexOf(property) == -1 || !global.document || typeof el.style[property] !== 'undefined'){
    return property;
  }

  property = property[0].toUpperCase() + property.slice(1);
  var temp;

  for(var i = 0; i < prefixes.length; i++){
    temp = prefixes[i] + property;
    if(typeof el.style[temp] !== 'undefined'){
      prefixes = [prefixes[i]]; // we only need to check this one prefix from now on.
      return temp;
    }
  }
  return property[0].toLowerCase() + property.slice(1);
}


module.exports = (function(){
  var cache = {};
  return function(obj){
    if(!global.document){
      return obj;
    }

    var result = {};

    for(var key in obj){
      if(cache[key] === undefined){
        cache[key] = GetVendorPrefix(key);
      }
      result[cache[key]] = obj[key];
    }

    return result;
  };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ScaleUp = exports.ScaleUp = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transform': 'scale(0.7)',
    'opacity': 0
  },
  end: {
    'transform': 'scale(1)',
    'opacity': 1
  }
};

var SlideFromRight = exports.SlideFromRight = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'cubic-bezier(0.25, 0.5, 0.5, 0.9)'
  },
  begin: {
    'transform': 'translateX(35%)',
    'opacity': 0
  },
  end: {
    'transform': 'translateX(0)',
    'opacity': 1
  }
};

var SlideFromBottom = exports.SlideFromBottom = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transform': 'translateY(35%)',
    'opacity': 0
  },
  end: {
    'transform': 'translateY(0)',
    'opacity': 1
  }
};

var Newspaper = exports.Newspaper = {
  transition: {
    property: 'all',
    duration: 500,
    timingfunction: 'linear'
  },
  begin: {
    'transform': 'scale(0) rotate(720deg)',
    'opacity': 0
  },
  end: {
    'transform': 'scale(1) rotate(0deg)',
    'opacity': 1
  }
};

var Fall = exports.Fall = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'ease-in'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transform': 'translateZ(600px) rotateX(20deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transform': 'translateZ(0px) rotateX(0deg)',
    'opacity': 1
  }
};

var SideFall = exports.SideFall = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transform': 'translate(30%) translateZ(600px) rotate(10deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transform': 'translate(0%) translateZ(0) rotate(0deg)',
    'opacity': 1
  }
};

var FlipHorizontal3D = exports.FlipHorizontal3D = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transform': 'rotateY(-70deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transform': 'rotateY(0deg)',
    'opacity': 1
  }
};

var FlipVertical3D = exports.FlipVertical3D = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transform': 'rotateX(-70deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transform': 'rotateX(0deg)',
    'opacity': 1
  }
};

var Sign3D = exports.Sign3D = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '50% 0',
    'transform': 'rotateX(-60deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '50% 0',
    'transform': 'rotateX(0deg)',
    'opacity': 1
  }
};

var SuperScaled = exports.SuperScaled = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transform': 'scale(2)',
    'opacity': 0
  },
  end: {
    'transform': 'scale(1)',
    'opacity': 1
  }
};

var RotateFromBottom3D = exports.RotateFromBottom3D = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'ease-out'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '0 100%',
    'transform': 'translateY(100%) rotateX(90deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '0 100%',
    'transform': 'translateY(0%) rotateX(0deg)',
    'opacity': 1
  }
};

var RotateFromLeft3D = exports.RotateFromLeft3D = {
  transition: {
    property: 'all',
    duration: 300,
    timingfunction: 'linear'
  },
  begin: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '0 100%',
    'transform': 'translateZ(100px) translateX(-30%) rotateY(90deg)',
    'opacity': 0
  },
  end: {
    'transformStyle': 'preserve-3d',
    'transformOrigin': '0 100%',
    'transform': 'translateZ(0px) translateX(0%) rotateY(0deg)',
    'opacity': 1
  }
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(191);

var _reactDynamicModal = __webpack_require__(307);

var _Tracking = __webpack_require__(69);

var _Tracking2 = _interopRequireDefault(_Tracking);

var _reactIntl = __webpack_require__(18);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import i18n messages


var _ref = _react2.default.createElement(
  'h2',
  { className: 'modal-headline' },
  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hatchModal.title' })
);

var _ref2 = _react2.default.createElement(
  'span',
  { className: 'hatch-retailer-button' },
  _react2.default.createElement(
    'span',
    { className: 'gui-button' },
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hatchModal.buyNow' })
  )
);

var HatchModal = function (_React$Component) {
  _inherits(HatchModal, _React$Component);

  function HatchModal() {
    _classCallCheck(this, HatchModal);

    return _possibleConstructorReturn(this, (HatchModal.__proto__ || Object.getPrototypeOf(HatchModal)).apply(this, arguments));
  }

  _createClass(HatchModal, [{
    key: 'onClickLink',
    value: function onClickLink(retailer) {
      _Tracking2.default.event(retailer.name, 'buy-now-hatch');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          retailers = _props.retailers,
          onRequestClose = _props.onRequestClose;

      return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: _i18n.lang, key: _i18n.lang, messages: _i18n.translationMessages.current },
        _react2.default.createElement(
          _reactDynamicModal.Modal,
          {
            onRequestClose: onRequestClose,
            effect: _reactDynamicModal.Effect.RotateFromBottom3D },
          _ref,
          retailers.map(function (retailer, i) {
            return _react2.default.createElement(
              'div',
              { className: 'hatch-retailer', key: i },
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.onClickLink(retailer);
                  }, href: retailer.purchase_link, 'data-retailer': retailer.name, target: '_blank' },
                _ref2,
                _react2.default.createElement(
                  'span',
                  { className: 'hatch-retailer-logo' },
                  _react2.default.createElement('img', { src: retailer.logo, alt: retailer.name })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'hatch-retailer-stockinfo' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hatchModal.stockInfo', values: { stockQuantity: retailer.stock_qty } })
                )
              )
            );
          }),
          _react2.default.createElement('button', { className: 'modal-close', onClick: _reactDynamicModal.ModalManager.close })
        )
      );
    }
  }]);

  return HatchModal;
}(_react2.default.Component);

exports.default = HatchModal;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HATCH_ENABLED = exports.HATCH_ENABLED = true;

var hatchConfig = {
  apiKey: '52431',
  baseUrl: 'https://gethatch.com/iceleads_rest/affiliate',
  additionalParams: '&sort=group_name',
  cid_water: 'watersystems',
  cid_shower: 'showerconfigurator',
  region: 'NL'
};

exports.default = hatchConfig;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _Flap = __webpack_require__(305);

var _Flap2 = _interopRequireDefault(_Flap);

var _Product = __webpack_require__(306);

var _Product2 = _interopRequireDefault(_Product);

var _ProductTileMobile = __webpack_require__(954);

var _ProductTileMobile2 = _interopRequireDefault(_ProductTileMobile);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.button.downloadPDF' });

var _ref2 = _react2.default.createElement(
  'div',
  { className: 'separator' },
  _react2.default.createElement(
    'h3',
    { className: 'text-uppercase headline headline--center headline--h3 headline--result' },
    _react2.default.createElement(
      'span',
      { className: 'headline__inner' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.bundle.title' })
    )
  )
);

var ProductGroupsMobile = function (_React$Component) {
  _inherits(ProductGroupsMobile, _React$Component);

  function ProductGroupsMobile(props) {
    _classCallCheck(this, ProductGroupsMobile);

    var _this = _possibleConstructorReturn(this, (ProductGroupsMobile.__proto__ || Object.getPrototypeOf(ProductGroupsMobile)).call(this, props));

    _this.state = {
      productGroups: []
    };
    return _this;
  }

  _createClass(ProductGroupsMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = this.props.data;


      if (data) {
        this.initState(data);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data;

      // TODO this only compares object equality, but not a deep comparison of nested values

      if (data !== this.props.data) {
        // TODO Shouldn't here used the nextProps.data as parameter?
        this.initState(this.props.data);
      }
    }
  }, {
    key: 'onClickDownload',
    value: function onClickDownload(productGroup) {
      var onClickDownload = this.props.onClickDownload;


      if (typeof onClickDownload === 'function') {
        onClickDownload([].concat(_toConsumableArray(productGroup.products.map(function (p) {
          return p.id;
        })), _toConsumableArray(productGroup.bundle.map(function (p) {
          return p.id;
        }))));
      }
    }
  }, {
    key: 'chooseGroup',
    value: function chooseGroup(currentGroup) {
      this.setState({
        productGroups: this.state.productGroups.map(function (group) {
          return _extends({}, group, { open: group.id == currentGroup.id ? !group.open : group.open });
        })
      });
    }
  }, {
    key: 'initState',
    value: function initState(data) {
      this.setState({ productGroups: data.map(function (group, i) {
          return _extends({}, group, { open: i === 0, id: i });
        }) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var productGroups = this.state.productGroups;


      if (!productGroups || productGroups.length === 0) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'product' },
        _react2.default.createElement(
          'div',
          { className: 'flap-group' },
          productGroups.map(function (productGroup, i) {
            return _react2.default.createElement(
              _Flap2.default,
              { key: i, index: i, headline: 'Proposal ' + (i + 1), resetHeight: true, open: productGroup.open, onChange: function onChange() {
                  return _this2.chooseGroup(productGroup);
                } },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'container' },
                  productGroup.products.map(function (product, j) {
                    return _react2.default.createElement(_Product2.default, { key: j, data: product });
                  })
                ),
                _i18n.configuratorType === 'shower' && _react2.default.createElement(
                  'div',
                  { className: 'container' },
                  _react2.default.createElement(
                    'a',
                    { className: 'btn btn-block btn-primary button button--download ', href: 'javascript:void(0);', onClick: function onClick() {
                        return _this2.onClickDownload(productGroup);
                      } },
                    _ref
                  )
                ),
                productGroup.bundle.length > 0 && _ref2,
                _react2.default.createElement(
                  'div',
                  { className: 'container' },
                  productGroup.bundle.map(function (product, j) {
                    return _react2.default.createElement(_ProductTileMobile2.default, { key: j, data: product });
                  })
                )
              )
            );
          })
        )
      );
    }
  }]);

  return ProductGroupsMobile;
}(_react2.default.Component);

exports.default = ProductGroupsMobile;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductTileMobile = function ProductTileMobile(_ref) {
  var data = _ref.data;
  return _react2.default.createElement(
    'div',
    { className: 'product-tile' },
    _react2.default.createElement(
      'a',
      { className: 'product-tile__link', target: '_blank', href: data.links[0].deeplink },
      _react2.default.createElement('div', { className: 'product-tile__image', style: { backgroundImage: 'url(' + data.imageSmall + ')' } }),
      _react2.default.createElement(
        'div',
        { className: 'product-tile__head' },
        _react2.default.createElement('span', { className: 'product-tile__headline', dangerouslySetInnerHTML: { __html: data.headline ? data.headline : '' } })
      )
    )
  );
};

exports.default = ProductTileMobile;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement('br', null);

var _ref3 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.button.productInformation' });

var _ref4 = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.button.downloadPDF' });

var _ref5 = _react2.default.createElement('div', null);

var ProductTile = function ProductTile(_ref) {
  var data = _ref.data;
  return _react2.default.createElement(
    'div',
    { className: 'product-tile' },
    _react2.default.createElement(
      'div',
      { className: 'product-tile__head' },
      _react2.default.createElement('span', { className: 'product-tile__headline', dangerouslySetInnerHTML: { __html: data.headline ? data.headline : '' } })
    ),
    _react2.default.createElement('div', { className: 'product-tile__image', style: { backgroundImage: 'url(' + data.imageSmall + ')' } }),
    _react2.default.createElement(
      'div',
      { className: 'product-tile__body' },
      _react2.default.createElement(
        'div',
        { className: 'product-tile__description' },
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: data.subheadline } }),
        _ref2,
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'results.product.number', values: { number: data.textblock_1st_text } })
      ),
      _react2.default.createElement(
        'a',
        { className: 'product-tile__link', target: '_blank', href: data.links[0].deeplink },
        _ref3
      )
    ),
    _i18n.configuratorType === 'shower' && _react2.default.createElement(
      'a',
      { className: 'btn btn-block btn-primary button button--result ', href: 'javascript:void(0);', onClick: function onClick() {
          return undefined.onClickDownload();
        } },
      _ref4
    ),
    _i18n.configuratorType === 'water' && _ref5
  );
};

exports.default = ProductTile;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement('img', { className: 'w-100', src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==', alt: '' });

var _ref3 = _react2.default.createElement('br', null);

var ProductTileWater = function ProductTileWater(_ref) {
  var data = _ref.data;
  return _react2.default.createElement(
    'div',
    { className: 'product' },
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-md-6' },
        _react2.default.createElement(
          'div',
          { className: 'product-image' },
          _react2.default.createElement(
            'picture',
            { className: 'picture picture--result' },
            _react2.default.createElement('source', { srcSet: data.image }),
            _ref2
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-md-5' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            { className: 'headline headline--h2 text-uppercase' },
            data.headline
          ),
          _react2.default.createElement(
            'h3',
            { className: 'headline headline--h3' },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: data.subheadline } }),
            _ref3,
            data.textblock_1st_text
          ),
          data.textblock_list && _react2.default.createElement(
            'ul',
            { className: 'list list--mb' },
            data.textblock_list.map(function (item, j) {
              return _react2.default.createElement(
                'li',
                { key: j },
                item.item
              );
            })
          ),
          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.textblock_2nd_text }, className: 'text text--mbButtonsFollow' }),
          data.links.map(function (link, j) {
            return _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return tracking.event(data.headline, link.track_action);
                }, key: j },
              _react2.default.createElement(
                'a',
                { target: '_blank', onClick: link.applyHatch ? function (event) {
                    return undefined.openModal(product, event);
                  } : null, className: 'btn btn-block btn-primary button button--result ' + link.additionalClass, href: link.deeplink },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: link.text, defaultMessage: link.text })
              )
            );
          })
        )
      )
    )
  );
};

exports.default = ProductTileWater;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(958),
    findIndex = __webpack_require__(1033);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(310),
    isArrayLike = __webpack_require__(200),
    keys = __webpack_require__(198);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(960),
    getMatchData = __webpack_require__(1019),
    matchesStrictComparable = __webpack_require__(327);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    baseIsEqual = __webpack_require__(316);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 961 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 968 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123),
    Map = __webpack_require__(196),
    MapCache = __webpack_require__(197);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(313),
    isMasked = __webpack_require__(974),
    isObject = __webpack_require__(126),
    toSource = __webpack_require__(315);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(975);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(978),
    ListCache = __webpack_require__(123),
    Map = __webpack_require__(196);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(979),
    hashDelete = __webpack_require__(980),
    hashGet = __webpack_require__(981),
    hashHas = __webpack_require__(982),
    hashSet = __webpack_require__(983);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(127);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(127);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(127);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(127);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(128);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 985 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(128);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(128);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(128);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    equalArrays = __webpack_require__(317),
    equalByTag = __webpack_require__(993),
    equalObjects = __webpack_require__(997),
    getTag = __webpack_require__(1014),
    isArray = __webpack_require__(48),
    isBuffer = __webpack_require__(321),
    isTypedArray = __webpack_require__(324);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 992 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(125),
    Uint8Array = __webpack_require__(994),
    eq = __webpack_require__(312),
    equalArrays = __webpack_require__(317),
    mapToArray = __webpack_require__(995),
    setToArray = __webpack_require__(996);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(47);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 995 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 996 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(998);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(999),
    getSymbols = __webpack_require__(1001),
    keys = __webpack_require__(198);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1000),
    isArray = __webpack_require__(48);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1002),
    stubArray = __webpack_require__(1003);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1005),
    isArguments = __webpack_require__(320),
    isArray = __webpack_require__(48),
    isBuffer = __webpack_require__(321),
    isIndex = __webpack_require__(323),
    isTypedArray = __webpack_require__(324);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isLength = __webpack_require__(199),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(314);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(322)(module)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1011),
    nativeKeys = __webpack_require__(1012);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1013);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1015),
    Map = __webpack_require__(196),
    Promise = __webpack_require__(1016),
    Set = __webpack_require__(1017),
    WeakMap = __webpack_require__(1018),
    baseGetTag = __webpack_require__(86),
    toSource = __webpack_require__(315);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70),
    root = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(326),
    keys = __webpack_require__(198);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(316),
    get = __webpack_require__(1021),
    hasIn = __webpack_require__(1027),
    isKey = __webpack_require__(201),
    isStrictComparable = __webpack_require__(326),
    matchesStrictComparable = __webpack_require__(327),
    toKey = __webpack_require__(130);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(328);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1023);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1024);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(197);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1026);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(125),
    arrayMap = __webpack_require__(202),
    isArray = __webpack_require__(48),
    isSymbol = __webpack_require__(129);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1028),
    hasPath = __webpack_require__(1029);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(329),
    isArguments = __webpack_require__(320),
    isArray = __webpack_require__(48),
    isIndex = __webpack_require__(323),
    isLength = __webpack_require__(199),
    toKey = __webpack_require__(130);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1031),
    basePropertyDeep = __webpack_require__(1032),
    isKey = __webpack_require__(201),
    toKey = __webpack_require__(130);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(328);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(330),
    baseIteratee = __webpack_require__(310),
    toInteger = __webpack_require__(1034);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1035);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1036);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(126),
    isSymbol = __webpack_require__(129);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

/*! qwest 4.5.0 (https://github.com/pyrsmk/qwest) */

module.exports = function() {

    var global = typeof window != 'undefined' ? window : self,
        pinkyswear = __webpack_require__(1038),
        jparam = __webpack_require__(1041),
        defaultOptions = {},
        // Default response type for XDR in auto mode
        defaultXdrResponseType = 'json',
        // Default data type
        defaultDataType = 'post',
        // Variables for limit mechanism
        limit = null,
        requests = 0,
        request_stack = [],
        // Get XMLHttpRequest object
        getXHR = global.XMLHttpRequest? function(){
            return new global.XMLHttpRequest();
        }: function(){
            return new ActiveXObject('Microsoft.XMLHTTP');
        },
        // Guess XHR version
        xhr2 = (getXHR().responseType===''),

    // Core function
    qwest = function(method, url, data, options, before) {
        // Format
        method = method.toUpperCase();
        data = data === undefined ? null : data;
        options = options || {};
        for(var name in defaultOptions) {
            if(!(name in options)) {
                if(typeof defaultOptions[name] == 'object' && typeof options[name] == 'object') {
                    for(var name2 in defaultOptions[name]) {
                        options[name][name2] = defaultOptions[name][name2];
                    }
                }
                else {
                    options[name] = defaultOptions[name];
                }
            }
        }

        // Define variables
        var nativeResponseParsing = false,
            crossOrigin,
            xhr,
            xdr = false,
            timeout,
            aborted = false,
            attempts = 0,
            headers = {},
            mimeTypes = {
                text: '*/*',
                xml: 'text/xml',
                json: 'application/json',
                post: 'application/x-www-form-urlencoded',
                document: 'text/html'
            },
            accept = {
                text: '*/*',
                xml: 'application/xml; q=1.0, text/xml; q=0.8, */*; q=0.1',
                json: 'application/json; q=1.0, text/*; q=0.8, */*; q=0.1'
            },
            i, j,
            response,
            sending = false,

        // Create the promise
        promise = pinkyswear(function(pinky) {
            pinky.abort = function() {
                if(!aborted) {
                    if(xhr && xhr.readyState != 4) { // https://stackoverflow.com/questions/7287706/ie-9-javascript-error-c00c023f
                        xhr.abort();
                    }
                    if(sending) {
                        --requests;
                        sending = false;
                    }
                    aborted = true;
                }
            };
            pinky.send = function() {
                // Prevent further send() calls
                if(sending) {
                    return;
                }
                // Reached request limit, get out!
                if(requests == limit) {
                    request_stack.push(pinky);
                    return;
                }
                // Verify if the request has not been previously aborted
                if(aborted) {
                    if(request_stack.length) {
                        request_stack.shift().send();
                    }
                    return;
                }
                // The sending is running
                ++requests;
                sending = true;
                // Get XHR object
                xhr = getXHR();
                if(crossOrigin) {
                    if(!('withCredentials' in xhr) && global.XDomainRequest) {
                        xhr = new XDomainRequest(); // CORS with IE8/9
                        xdr = true;
                        if(method != 'GET' && method != 'POST') {
                            method = 'POST';
                        }
                    }
                }
                // Open connection
                if(xdr) {
                    xhr.open(method, url);
                }
                else {
                    xhr.open(method, url, options.async, options.user, options.password);
                    if(xhr2 && options.async) {
                        xhr.withCredentials = options.withCredentials;
                    }
                }
                // Set headers
                if(!xdr) {
                    for(var i in headers) {
                        if(headers[i]) {
                            xhr.setRequestHeader(i, headers[i]);
                        }
                    }
                }
                // Verify if the response type is supported by the current browser
                if(xhr2 && options.responseType != 'auto') {
                    try {
                        xhr.responseType = options.responseType;
                        nativeResponseParsing = (xhr.responseType == options.responseType);
                    }
                    catch(e) {}
                }
                // Plug response handler
                if(xhr2 || xdr) {
                    xhr.onload = handleResponse;
                    xhr.onerror = handleError;
                    // http://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
                    if(xdr) {
                        xhr.onprogress = function() {};
                    }
                }
                else {
                    xhr.onreadystatechange = function() {
                        if(xhr.readyState == 4) {
                            handleResponse();
                        }
                    };
                }
                // Plug timeout
                if(options.async) {
                    if('timeout' in xhr) {
                        xhr.timeout = options.timeout;
                        xhr.ontimeout = handleTimeout;
                    }
                    else {
                        timeout = setTimeout(handleTimeout, options.timeout);
                    }
                }
                // http://cypressnorth.com/programming/internet-explorer-aborting-ajax-requests-fixed/
                else if(xdr) {
                    xhr.ontimeout = function() {};
                }
                // Override mime type to ensure the response is well parsed
                if(options.responseType != 'auto' && 'overrideMimeType' in xhr) {
                    xhr.overrideMimeType(mimeTypes[options.responseType]);
                }
                // Run 'before' callback
                if(before) {
                    before(xhr);
                }
                // Send request
                if(xdr) {
                    // https://developer.mozilla.org/en-US/docs/Web/API/XDomainRequest
                    setTimeout(function() {
                        xhr.send(method != 'GET'? data : null);
                    }, 0);
                }
                else {
                    xhr.send(method != 'GET' ? data : null);
                }
            };
            return pinky;
        }),

        // Handle the response
        handleResponse = function() {
            var i, responseType;
            // Stop sending state
            sending = false;
            clearTimeout(timeout);
            // Launch next stacked request
            if(request_stack.length) {
                request_stack.shift().send();
            }
            // Verify if the request has not been previously aborted
            if(aborted) {
                return;
            }
            // Decrease the number of requests
            --requests;
            // Handle response
            try{
                // Process response
                if(nativeResponseParsing) {
                    if('response' in xhr && xhr.response === null) {
                        throw 'The request response is empty';
                    }
                    response = xhr.response;
                }
                else {
                    // Guess response type
                    responseType = options.responseType;
                    if(responseType == 'auto') {
                        if(xdr) {
                            responseType = defaultXdrResponseType;
                        }
                        else {
                            var ct = xhr.getResponseHeader('Content-Type') || '';
                            if(ct.indexOf(mimeTypes.json)>-1) {
                                responseType = 'json';
                            }
                            else if(ct.indexOf(mimeTypes.xml) > -1) {
                                responseType = 'xml';
                            }
                            else {
                                responseType = 'text';
                            }
                        }
                    }
                    // Handle response type
                    switch(responseType) {
                        case 'json':
                            if(xhr.responseText.length) {
                                try {
                                    if('JSON' in global) {
                                        response = JSON.parse(xhr.responseText);
                                    }
                                    else {
                                        response = new Function('return (' + xhr.responseText + ')')();
                                    }
                                }
                                catch(e) {
                                    throw "Error while parsing JSON body : "+e;
                                }
                            }
                            break;
                        case 'xml':
                            // Based on jQuery's parseXML() function
                            try {
                                // Standard
                                if(global.DOMParser) {
                                    response = (new DOMParser()).parseFromString(xhr.responseText,'text/xml');
                                }
                                // IE<9
                                else {
                                    response = new ActiveXObject('Microsoft.XMLDOM');
                                    response.async = 'false';
                                    response.loadXML(xhr.responseText);
                                }
                            }
                            catch(e) {
                                response = undefined;
                            }
                            if(!response || !response.documentElement || response.getElementsByTagName('parsererror').length) {
                                throw 'Invalid XML';
                            }
                            break;
                        default:
                            response = xhr.responseText;
                    }
                }
                // Late status code verification to allow passing data when, per example, a 409 is returned
                // --- https://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
                if('status' in xhr && !/^2|1223/.test(xhr.status)) {
                    throw xhr.status + ' (' + xhr.statusText + ')';
                }
                // Fulfilled
                promise(true, [xhr, response]);
            }
            catch(e) {
                // Rejected
                promise(false, [e, xhr, response]);
            }
        },

        // Handle errors
        handleError = function(message) {
            if(!aborted) {
                message = typeof message == 'string' ? message : 'Connection aborted';
                promise.abort();
                promise(false, [new Error(message), xhr, null]);
            }
        },

        // Handle timeouts
        handleTimeout = function() {
            if(!aborted) {
                if(!options.attempts || ++attempts != options.attempts) {
                    xhr.abort();
                    sending = false;
                    promise.send();
                }
                else {
                    handleError('Timeout (' + url + ')');
                }
            }
        };

        // Normalize options
        options.async = 'async' in options ? !!options.async : true;
        options.cache = 'cache' in options ? !!options.cache : false;
        options.dataType = 'dataType' in options ? options.dataType.toLowerCase() : defaultDataType;
        options.responseType = 'responseType' in options ? options.responseType.toLowerCase() : 'auto';
        options.user = options.user || '';
        options.password = options.password || '';
        options.withCredentials = !!options.withCredentials;
        options.timeout = 'timeout' in options ? parseInt(options.timeout, 10) : 30000;
        options.attempts = 'attempts' in options ? parseInt(options.attempts, 10) : 1;

        // Guess if we're dealing with a cross-origin request
        i = url.match(/\/\/(.+?)\//);
        crossOrigin = i && (i[1] ? i[1] != location.host : false);

        // Prepare data
        if('ArrayBuffer' in global && data instanceof ArrayBuffer) {
            options.dataType = 'arraybuffer';
        }
        else if('Blob' in global && data instanceof Blob) {
            options.dataType = 'blob';
        }
        else if('Document' in global && data instanceof Document) {
            options.dataType = 'document';
        }
        else if('FormData' in global && data instanceof FormData) {
            options.dataType = 'formdata';
        }
        if(data !== null) {
            switch(options.dataType) {
                case 'json':
                    data = JSON.stringify(data);
                    break;
                case 'post':
                case 'queryString':
                    data = jparam(data);
            }
        }

        // Prepare headers
        if(options.headers) {
            var format = function(match,p1,p2) {
                return p1 + p2.toUpperCase();
            };
            for(i in options.headers) {
                headers[i.replace(/(^|-)([^-])/g,format)] = options.headers[i];
            }
        }
        if(!('Content-Type' in headers) && method!='GET') {
            if(options.dataType in mimeTypes) {
                if(mimeTypes[options.dataType]) {
                    headers['Content-Type'] = mimeTypes[options.dataType];
                }
            }
        }
        if(!headers.Accept) {
            headers.Accept = (options.responseType in accept) ? accept[options.responseType] : '*/*';
        }
        if(!crossOrigin && !('X-Requested-With' in headers)) { // (that header breaks in legacy browsers with CORS)
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        if(!options.cache && !('Cache-Control' in headers)) {
            headers['Cache-Control'] = 'no-cache';
        }

        // Prepare URL
        if((method == 'GET' || options.dataType == 'queryString') && data && typeof data == 'string') {
            url += (/\?/.test(url)?'&':'?') + data;
        }

        // Start the request
        if(options.async) {
            promise.send();
        }

        // Return promise
        return promise;

    };

    // Define external qwest object
    var getNewPromise = function(q) {
            // Prepare
            var promises = [],
                loading = 0,
                values = [];
            // Create a new promise to handle all requests
            return pinkyswear(function(pinky) {
                // Basic request method
                var method_index = -1,
                    createMethod = function(method) {
                        return function(url, data, options, before) {
                            var index = ++method_index;
                            ++loading;
                            promises.push(qwest(method, pinky.base + url, data, options, before).then(function(xhr, response) {
                                values[index] = arguments;
                                if(!--loading) {
                                    pinky(true, values.length == 1 ? values[0] : [values]);
                                }
                            }, function() {
                                pinky(false, arguments);
                            }));
                            return pinky;
                        };
                    };
                // Define external API
                pinky.get = createMethod('GET');
                pinky.post = createMethod('POST');
                pinky.put = createMethod('PUT');
                pinky['delete'] = createMethod('DELETE');
                pinky['catch'] = function(f) {
                    return pinky.then(null, f);
                };
                pinky.complete = function(f) {
                    var func = function() {
                        f(); // otherwise arguments will be passed to the callback
                    };
                    return pinky.then(func, func);
                };
                pinky.map = function(type, url, data, options, before) {
                    return createMethod(type.toUpperCase()).call(this, url, data, options, before);
                };
                // Populate methods from external object
                for(var prop in q) {
                    if(!(prop in pinky)) {
                        pinky[prop] = q[prop];
                    }
                }
                // Set last methods
                pinky.send = function() {
                    for(var i=0, j=promises.length; i<j; ++i) {
                        promises[i].send();
                    }
                    return pinky;
                };
                pinky.abort = function() {
                    for(var i=0, j=promises.length; i<j; ++i) {
                        promises[i].abort();
                    }
                    return pinky;
                };
                return pinky;
            });
        },
        q = {
            base: '',
            get: function() {
                return getNewPromise(q).get.apply(this, arguments);
            },
            post: function() {
                return getNewPromise(q).post.apply(this, arguments);
            },
            put: function() {
                return getNewPromise(q).put.apply(this, arguments);
            },
            'delete': function() {
                return getNewPromise(q)['delete'].apply(this, arguments);
            },
            map: function() {
                return getNewPromise(q).map.apply(this, arguments);
            },
            xhr2: xhr2,
            limit: function(by) {
                limit = by;
                return q;
            },
            setDefaultOptions: function(options) {
                defaultOptions = options;
                return q;
            },
            setDefaultXdrResponseType: function(type) {
                defaultXdrResponseType = type.toLowerCase();
                return q;
            },
            setDefaultDataType: function(type) {
                defaultDataType = type.toLowerCase();
                return q;
            },
            getOpenRequests: function() {
                return requests;
            }
        };

    return q;

}();


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, process) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * PinkySwear.js 2.2.2 - Minimalistic implementation of the Promises/A+ spec
 * 
 * Public Domain. Use, modify and distribute it any way you like. No attribution required.
 *
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 *
 * PinkySwear is a very small implementation of the Promises/A+ specification. After compilation with the
 * Google Closure Compiler and gzipping it weighs less than 500 bytes. It is based on the implementation for 
 * Minified.js and should be perfect for embedding. 
 *
 *
 * PinkySwear has just three functions.
 *
 * To create a new promise in pending state, call pinkySwear():
 *         var promise = pinkySwear();
 *
 * The returned object has a Promises/A+ compatible then() implementation:
 *          promise.then(function(value) { alert("Success!"); }, function(value) { alert("Failure!"); });
 *
 *
 * The promise returned by pinkySwear() is a function. To fulfill the promise, call the function with true as first argument and
 * an optional array of values to pass to the then() handler. By putting more than one value in the array, you can pass more than one
 * value to the then() handlers. Here an example to fulfill a promsise, this time with only one argument: 
 *         promise(true, [42]);
 *
 * When the promise has been rejected, call it with false. Again, there may be more than one argument for the then() handler:
 *         promise(true, [6, 6, 6]);
 *         
 * You can obtain the promise's current state by calling the function without arguments. It will be true if fulfilled,
 * false if rejected, and otherwise undefined.
 * 		   var state = promise(); 
 * 
 * https://github.com/timjansen/PinkySwear.js
 */
(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory();
	} else {
		root.pinkySwear = factory();
	}
}(this, function() {
	var undef;

	function isFunction(f) {
		return typeof f == 'function';
	}
	function isObject(f) {
		return typeof f == 'object';
	}
	function defer(callback) {
		if (typeof setImmediate != 'undefined')
			setImmediate(callback);
		else if (typeof process != 'undefined' && process['nextTick'])
			process['nextTick'](callback);
		else
			setTimeout(callback, 0);
	}

	return function pinkySwear(extend) {
		var state;           // undefined/null = pending, true = fulfilled, false = rejected
		var values = [];     // an array of values as arguments for the then() handlers
		var deferred = [];   // functions to call when set() is invoked

		var set = function(newState, newValues) {
			if (state == null && newState != null) {
				state = newState;
				values = newValues;
				if (deferred.length)
					defer(function() {
						for (var i = 0; i < deferred.length; i++)
							deferred[i]();
					});
			}
			return state;
		};

		set['then'] = function (onFulfilled, onRejected) {
			var promise2 = pinkySwear(extend);
			var callCallbacks = function() {
	    		try {
	    			var f = (state ? onFulfilled : onRejected);
	    			if (isFunction(f)) {
		   				function resolve(x) {
						    var then, cbCalled = 0;
		   					try {
				   				if (x && (isObject(x) || isFunction(x)) && isFunction(then = x['then'])) {
										if (x === promise2)
											throw new TypeError();
										then['call'](x,
											function() { if (!cbCalled++) resolve.apply(undef,arguments); } ,
											function(value){ if (!cbCalled++) promise2(false,[value]);});
				   				}
				   				else
				   					promise2(true, arguments);
		   					}
		   					catch(e) {
		   						if (!cbCalled++)
		   							promise2(false, [e]);
		   					}
		   				}
		   				resolve(f.apply(undef, values || []));
		   			}
		   			else
		   				promise2(state, values);
				}
				catch (e) {
					promise2(false, [e]);
				}
			};
			if (state != null)
				defer(callCallbacks);
			else
				deferred.push(callCallbacks);
			return promise2;
		};
        if(extend){
            set = extend(set);
        }
		return set;
	};
}));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1039).setImmediate, __webpack_require__(118)))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1040);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(118)))

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @preserve jquery-param (c) 2015 KNOWLEDGECODE | MIT
 */
/*global define */
(function (global) {
    'use strict';

    var param = function (a) {
        var add = function (s, k, v) {
            v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        }, buildParams = function (prefix, obj, s) {
            var i, len, key;

            if (Object.prototype.toString.call(obj) === '[object Array]') {
                for (i = 0, len = obj.length; i < len; i++) {
                    buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i], s);
                }
            } else if (obj && obj.toString() === '[object Object]') {
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (prefix) {
                            buildParams(prefix + '[' + key + ']', obj[key], s, add);
                        } else {
                            buildParams(key, obj[key], s, add);
                        }
                    }
                }
            } else if (prefix) {
                add(s, prefix, obj);
            } else {
                for (key in obj) {
                    add(s, key, obj[key]);
                }
            }
            return s;
        };
        return buildParams('', a, []).join('&').replace(/%20/g, '+');
    };

    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = param;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return param;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        global.param = param;
    }

}(this));


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(51);

var _reactIntl = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
  'div',
  { className: 'container' },
  _react2.default.createElement(
    'div',
    { className: 'row' },
    _react2.default.createElement(
      'div',
      { className: 'col' },
      _react2.default.createElement(
        'h4',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: '404.title' })
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/lv_lv/watersystems/' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: '404.link.goBack' })
      )
    )
  )
);

var NotFoundPage = function NotFoundPage() {
  return _ref;
};

exports.default = NotFoundPage;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(67);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(275);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(278);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(273);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(183);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(1044);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(181);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(96);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(97);

var _ExecutionEnvironment = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(85);

var _reduxImmutableStateInvariant = __webpack_require__(1046);

var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);

var _reduxThunk = __webpack_require__(1050);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(1051);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
var logger = function logger(store) {
  return function (next) {
    return function (action) {
      next(action);
    };
  };
};
// eslint-disable-next-line no-unused-vars
var error = function error(store) {
  return function (next) {
    return function (action) {
      try {
        next(action);
      } catch (e) {
        console.warn('AAAAHHH!', action, e); // eslint-disable-line no-console
      }
    };
  };
};

function configureStoreProd(initialState) {
  var middlewares = [
  // Add other middleware on this line...

  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument


  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  _reduxThunk2.default];

  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));
}

function configureStoreDev(initialState) {
  var middlewares = [
  // Add other middleware on this line...
  logger, error,
  // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
  (0, _reduxImmutableStateInvariant2.default)(), _reduxThunk2.default];

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // add support for Redux dev tools
  var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }
  return store;
}

var configureStore =  true ? configureStoreProd : configureStoreDev;

exports.default = configureStore;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = immutableStateInvariantMiddleware;

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _jsonStringifySafe = __webpack_require__(1047);

var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);

var _isImmutable = __webpack_require__(1048);

var _isImmutable2 = _interopRequireDefault(_isImmutable);

var _trackForMutations = __webpack_require__(1049);

var _trackForMutations2 = _interopRequireDefault(_trackForMutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BETWEEN_DISPATCHES_MESSAGE = ['A state mutation was detected between dispatches, in the path `%s`.', 'This may cause incorrect behavior.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');

var INSIDE_DISPATCH_MESSAGE = ['A state mutation was detected inside a dispatch, in the path: `%s`.', 'Take a look at the reducer(s) handling the action %s.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');

function immutableStateInvariantMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$isImmutable = options.isImmutable,
      isImmutable = _options$isImmutable === undefined ? _isImmutable2.default : _options$isImmutable,
      ignore = options.ignore;

  var track = _trackForMutations2.default.bind(null, isImmutable, ignore);

  return function (_ref) {
    var getState = _ref.getState;

    var state = getState();
    var tracker = track(state);

    var result = void 0;
    return function (next) {
      return function (action) {
        state = getState();

        result = tracker.detectMutations();
        // Track before potentially not meeting the invariant
        tracker = track(state);

        (0, _invariant2.default)(!result.wasMutated, BETWEEN_DISPATCHES_MESSAGE, (result.path || []).join('.'));

        var dispatchedAction = next(action);
        state = getState();

        result = tracker.detectMutations();
        // Track before potentially not meeting the invariant
        tracker = track(state);

        (0, _invariant2.default)(!result.wasMutated, INSIDE_DISPATCH_MESSAGE, (result.path || []).join('.'), (0, _jsonStringifySafe2.default)(action));

        return dispatchedAction;
      };
    };
  };
}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isImmutableDefault;
function isImmutableDefault(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null || typeof value === 'undefined';
}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackForMutations;
function trackForMutations(isImmutable, ignore, obj) {
  var trackedProperties = trackProperties(isImmutable, ignore, obj);
  return {
    detectMutations: function detectMutations() {
      return _detectMutations(isImmutable, ignore, trackedProperties, obj);
    }
  };
}

function trackProperties(isImmutable) {
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var obj = arguments[2];
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var tracked = { value: obj };

  if (!isImmutable(obj)) {
    tracked.children = {};

    for (var key in obj) {
      var childPath = path.concat(key);
      if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
        continue;
      }

      tracked.children[key] = trackProperties(isImmutable, ignore, obj[key], childPath);
    }
  }
  return tracked;
}

function _detectMutations(isImmutable) {
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var trackedProperty = arguments[2];
  var obj = arguments[3];
  var sameParentRef = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var path = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  var prevObj = trackedProperty ? trackedProperty.value : undefined;

  var sameRef = prevObj === obj;

  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return { wasMutated: true, path: path };
  }

  if (isImmutable(prevObj) || isImmutable(obj)) {
    return { wasMutated: false };
  }

  // Gather all keys from prev (tracked) and after objs
  var keysToDetect = {};
  Object.keys(trackedProperty.children).forEach(function (key) {
    keysToDetect[key] = true;
  });
  Object.keys(obj).forEach(function (key) {
    keysToDetect[key] = true;
  });

  var keys = Object.keys(keysToDetect);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var childPath = path.concat(key);
    if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
      continue;
    }

    var result = _detectMutations(isImmutable, ignore, trackedProperty.children[key], obj[key], sameRef, childPath);

    if (result.wasMutated) {
      return result;
    }
  }
  return { wasMutated: false };
}

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(85);

var _reactRouterRedux = __webpack_require__(331);

var _selectionReducer = __webpack_require__(1054);

var _selectionReducer2 = _interopRequireDefault(_selectionReducer);

var _dataReducer = __webpack_require__(1074);

var _dataReducer2 = _interopRequireDefault(_dataReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set up your root reducer here...
var rootReducer = (0, _redux.combineReducers)({
  configurator: _selectionReducer2.default,
  data: _dataReducer2.default,
  routing: _reactRouterRedux.routerReducer
});

exports.default = rootReducer;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(332);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(333);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _objectAssign = __webpack_require__(11);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _initialState = __webpack_require__(334);

var _initialState2 = _interopRequireDefault(_initialState);

var _intersection = __webpack_require__(1055);

var _intersection2 = _interopRequireDefault(_intersection);

var _isString = __webpack_require__(1072);

var _isString2 = _interopRequireDefault(_isString);

var _i18n = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var productConditions = function () {
  try {
    return __webpack_require__(188)("./" + _i18n.configuratorType + '_conditions' + (_i18n.locale ? '_' + _i18n.locale : '') + '.json');
  } catch (error) {
    // return require(`../data/shower_conditions_en_gb.json`);
    return __webpack_require__(1073)("./" + _i18n.configuratorType + '_conditions_en_gb.json');
  }
}();

/**
 *  checks if scenario/condition props (requires; preset etc.) are being fulfilled by current selected items
 */
var matchConditions = function matchConditions(conditions, selectedItems) {
  if ((0, _isString2.default)(conditions)) {
    conditions = [conditions];
  }
  return conditions.reduce(function (prev, block) {
    // break out of iteration if prev is true
    if (prev) {
      return true;
    }
    // iterate through sections seperated by semicolon
    var requireMatches = block.split(' && ').reduce(function (prev, current) {
      // break out of iteration when previous section returned false
      if (!prev) {
        return false;
      }
      // get negative require matches to current section
      var negativeRequires = current.split(',').filter(function (item) {
        return item.indexOf('!') > -1;
      }).map(function (item) {
        return item.replace('!', '');
      });
      var negativeRequiresMatches = negativeRequires.length > 0 ? (0, _intersection2.default)(negativeRequires, selectedItems).length === 0 : true;
      // get positive require matches to current section
      var positiveRequires = current.split(',').filter(function (item) {
        return item.indexOf('!') === -1;
      });
      var positiveRequireMatches = positiveRequires.length > 0 ? (0, _intersection2.default)(positiveRequires, selectedItems).length > 0 : true;

      // return combined matches
      var anyRequiresMatches = positiveRequireMatches && negativeRequiresMatches;
      return anyRequiresMatches;
    }, true);
    return requireMatches;
  }, false);
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.configurator;
  var action = arguments[1];

  var newState = void 0;
  newState = (0, _objectAssign2.default)({}, state);

  switch (action.type) {
    case 'SAVE_SELECTED':
      {
        // reset results
        var results = [];
        //  newState.selected = [ ...new Set(objectAssign(newState.selected))];
        //check if new element to add is in array already
        var id = action.payload.id;
        var slug = id ? action.payload.id.substr(0, action.payload.id.indexOf('_')) : false;
        //44rg0cc newState.questions =[ ...new Set(objectAssign(newState.questions))];
        var questions = [].concat(_toConsumableArray(newState.questions));
        var currentQuestionIndex = !slug ? 0 : questions.findIndex(function (question) {
          return question.slug === slug;
        });
        var currentQuestion = questions[currentQuestionIndex];
        console.log('currentQuestion', currentQuestion);
        questions[currentQuestionIndex] = _extends({}, currentQuestion, {
          value: id
        });

        for (var i = currentQuestionIndex + 1; i < questions.length; i++) {
          questions[i] = _extends({}, questions[i], {
            value: false,
            visible: false
          });
        }
        var selectedItems = [_i18n.locale].concat(_toConsumableArray(questions
        // values "question-slug_opt1" etc.
        .filter(function (question) {
          return question.value && question.visible;
        }).map(function (question) {
          return question.value;
        })), _toConsumableArray(questions.filter(function (question) {
          return question.value && question.visible;
        }).map(function (question) {
          return question.slug;
        })));

        // match conditions of items and options
        questions = questions.map(function (question) {
          var visible = question.conditions ? matchConditions(question.conditions, selectedItems) : true;
          var options = question.options.map(function (option) {
            var visible = option.conditions ? matchConditions(option.conditions, selectedItems) : true;
            // override default image
            if (visible && option.images) {
              var newImage = option.images.find(function (img) {
                return matchConditions(img.conditions, selectedItems);
              });
              option = _extends({}, option, {
                image: newImage ? newImage.image : option.imageDefault
              });
            }
            return _extends({}, option, {
              visible: visible
            });
          });

          var showInvisibleQuestions = window.localStorage.getItem('debug');
          var hasMoreThanOneOption = showInvisibleQuestions ? options.filter(function (option) {
            return option.visible;
          }).length > 0 : options.filter(function (option) {
            return option.visible;
          }).length > 1;
          var hasOneOption = options.filter(function (option) {
            return option.visible;
          }).length === 1;
          if (visible && hasOneOption) {
            // if question has only one question, automatically set its value
            question.value = options.filter(function (option) {
              return option.visible;
            })[0].id;
            selectedItems.push(question.value);
            selectedItems.push(question.slug);
          }

          return _extends({}, question, {
            visible: visible ? hasMoreThanOneOption : visible,
            options: options
          });
        });

        console.log('selectedItems', selectedItems);
        // done?
        newState.showResults = questions.filter(function (question) {
          return question.visible && !question.value;
        }).length === 0;
        if (newState.showResults) {
          results = productConditions.reduce(function (prev, current) {
            if (matchConditions(current.conditions, selectedItems)) {
              prev = [].concat(_toConsumableArray(prev), [current.groups]);
            }
            return prev;
          }, []);
        }

        return _extends({}, newState, {
          questions: questions,
          selectedItems: selectedItems,
          results: results
        });
      }
    case 'INIT_STATE':
      {
        // eslint-disable-next-line no-unused-vars
        var _questions = action.payload.questions;
        _questions = _questions.map(function (question, i) {
          if (i === 0) {
            question.visible = true;
          }
          question.options = question.options.map(function (option, i) {
            option.id = option.id ? option.id : question.slug + '_opt' + i;
            option.selected = false;
            if (option.images && option.image) {
              option.imageDefault = option.image;
            }
            option.visible = true;
            return option;
          });
        });
        return (0, _objectAssign2.default)(newState, action.payload);
      }
    case 'GET_SELECTED':
      {
        return newState;
      }
    case 'RESET_CONFIGURATOR':
      {
        return _extends({}, newState, {
          showResults: false,
          questions: newState.questions.map(function (question, i) {
            return _extends({}, question, {
              value: false,
              visible: i === 0
            });
          })
        });
      }
    case 'PUSH_RESULT':
      {
        newState.results = [].concat(_toConsumableArray(new Set((0, _objectAssign2.default)(newState.results.concat(action.payload[0])))));
        newState.bundles = [].concat(_toConsumableArray(new Set((0, _objectAssign2.default)(newState.bundles.concat(action.payload[1])))));
        return newState;
      }
    case 'SET_SCROLL_INDICATOR':
      {
        newState.showScrollIndicator = action.payload;
        return newState;
      }
    case 'SET_LAST_QUESTION_ID':
      {
        newState.lastQuestionId = action.payload;
        return newState;
      }
  }
  return newState;
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(202),
    baseIntersection = __webpack_require__(1056),
    baseRest = __webpack_require__(1062),
    castArrayLikeObject = __webpack_require__(1070);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(318),
    arrayIncludes = __webpack_require__(1057),
    arrayIncludesWith = __webpack_require__(1061),
    arrayMap = __webpack_require__(202),
    baseUnary = __webpack_require__(325),
    cacheHas = __webpack_require__(319);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1058);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(330),
    baseIsNaN = __webpack_require__(1059),
    strictIndexOf = __webpack_require__(1060);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(203),
    overRest = __webpack_require__(1063),
    setToString = __webpack_require__(1065);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1064);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1066),
    shortOut = __webpack_require__(1069);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1067),
    defineProperty = __webpack_require__(1068),
    identity = __webpack_require__(203);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(70);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(1071);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(200),
    isObjectLike = __webpack_require__(71);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isArray = __webpack_require__(48),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shower_conditions_en_gb.json": 291,
	"./water_conditions_en_gb.json": 294
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1073;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;

var _objectAssign = __webpack_require__(11);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _initialState = __webpack_require__(334);

var _initialState2 = _interopRequireDefault(_initialState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.data;
  var action = arguments[1];

  var newState = void 0;
  newState = (0, _objectAssign2.default)({}, state);
  switch (action.type) {
    case 'INIT_DATA':
      {
        return (0, _objectAssign2.default)({}, action.payload);
      }
  }
  return newState;
}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * requestAnimationFrame version: "0.0.23" Copyright (c) 2011-2012, Cyril Agosta ( cyril.agosta.dev@gmail.com) All Rights Reserved.
 * Available via the MIT license.
 * see: http://github.com/cagosta/requestAnimationFrame for details
 *
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 *
 */


( function( global ) {


    ( function() {


        if ( global.requestAnimationFrame ) {

            return;

        }

        if ( global.webkitRequestAnimationFrame ) { // Chrome <= 23, Safari <= 6.1, Blackberry 10

            global.requestAnimationFrame = global[ 'webkitRequestAnimationFrame' ];
            global.cancelAnimationFrame = global[ 'webkitCancelAnimationFrame' ] || global[ 'webkitCancelRequestAnimationFrame' ];
            return;

        }

        // IE <= 9, Android <= 4.3, very old/rare browsers

        var lastTime = 0;

        global.requestAnimationFrame = function( callback ) {

            var currTime = new Date().getTime();

            var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );

            var id = global.setTimeout( function() {

                callback( currTime + timeToCall );

            }, timeToCall );

            lastTime = currTime + timeToCall;

            return id; // return the id for cancellation capabilities

        };

        global.cancelAnimationFrame = function( id ) {

            clearTimeout( id );

        };

    } )();

    if ( true ) {

        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {

            return global.requestAnimationFrame;

        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    }

} )( window );

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(1079);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(1080);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.0c48cba4be62cb08bef8.js